// This file is auto-generated by @hey-api/openapi-ts

import { type Options, AppStatus, Auth, Oauth, Users, TouchEvents, AppInstalls, AdminBillingIdentity, AdminRevenuecatImport, AdminInsights, AdminCheckpoints, AdminActivation, AdminJourneyHealth, AdminPricing, AdminPayments, AdminVitalSigns, AdminCustomers, AdminFunnelLeads, AdminHardshipOffer, AdminConsent, AdminPushLists, AdminStoreReview, AdminCommunity, AdminBeehiiv, UsersV2, Metrics, Utils, Notifications, Public, Stripe, WebOnboarding, Payments, StripeWebhook, Revenuecat, RevenuecatWebhook, PromoCodes, Feedback, AgentConfigs, Exercises, AmisExercises, DailyLessons, Banners, Walk, LiveActivity, Sim, JourneyDev, BookInterest, QuizResult, CoachingWaitlist, ContactCapture, FeatureFlags, Insights, Secrets, Media, Reviews, PromoCodesAdmin, EmailTemplates, EmailLayouts, EmailDeliverability, EmailSuppressions, EmailCampaigns, EmailFlows, EmailCampaignSteps, EmailSends, EmailControls, EmailExecutions, EmailComeback, Newsletter, EmailPeople, EmailEnrollments, MailMedia, Campaigns, PostmarkWebhook, UserSegments, Ota, DbSchema, Ops, DbMigrations, TherapistWaitlist, Conversations, HealthEntries, Prepare, SupportRelationships, Supporter, Community, UserState, PaywallEvents, ActiveDays, Private } from '../sdk.gen';
import { queryOptions, type UseMutationOptions, type DefaultError, infiniteQueryOptions, type InfiniteData } from '@tanstack/react-query';
import type { AppStatusGetAppStatusData, AuthCancelDeletionData, AuthCancelDeletionError, AuthCancelDeletionResponse, AuthLoginData, AuthLoginError, AuthLoginResponse, AuthRefreshAccessTokenData, AuthRefreshAccessTokenError, AuthRefreshAccessTokenResponse, AuthLogoutData, AuthLogoutResponse, AuthTestTokenData, AuthTestTokenResponse, AuthPasswordRecoveryData, AuthPasswordRecoveryError, AuthPasswordRecoveryResponse, AuthResetPasswordData, AuthResetPasswordError, AuthResetPasswordResponse, AuthRequestMagicLinkData, AuthRequestMagicLinkError, AuthRequestMagicLinkResponse, AuthRequestLinkEmailData, AuthRequestLinkEmailError, AuthRequestLinkEmailResponse, AuthConfirmLinkEmailData, AuthConfirmLinkEmailError, AuthConfirmLinkEmailResponse, AuthVerifyMagicLinkData, AuthVerifyMagicLinkError, AuthVerifyMagicLinkResponse, AuthCloudflareAccessLoginData, AuthCloudflareAccessLoginError, AuthCloudflareAccessLoginResponse, AuthRedeemLoginCodeData, AuthRedeemLoginCodeError, AuthRedeemLoginCodeResponse, AuthSetupTotpData, AuthSetupTotpResponse, AuthGetTotpQrcodeData, AuthVerifyTotpSetupData, AuthVerifyTotpSetupError, AuthVerifyTotpSetupResponse, AuthVerifyTotpData, AuthVerifyTotpError, AuthVerifyTotpResponse, AuthRegisterUserData, AuthRegisterUserError, AuthRegisterUserResponse, AuthDisableTotpData, AuthDisableTotpError, AuthDisableTotpResponse, AuthRegisterBiometricTokenData, AuthRegisterBiometricTokenError, AuthRegisterBiometricTokenResponse, AuthRevokeBiometricTokenData, AuthRevokeBiometricTokenResponse, AuthLoginWithBiometricData, AuthLoginWithBiometricError, AuthLoginWithBiometricResponse, AuthPingAuthData, AuthDeviceAuthData, AuthDeviceAuthError, AuthDeviceAuthResponse, AuthDeviceBindData, AuthDeviceBindError, AuthDeviceBindResponse, AuthDeviceConvertData, AuthDeviceConvertError, AuthDeviceConvertResponse, OauthGoogleLoginData, OauthGoogleCallbackData, OauthGoogleMobileCallbackData, OauthGoogleMobileCallbackError, OauthGoogleMobileCallbackResponse, OauthAppleCallbackData, OauthAppleCallbackError, OauthAppleCallbackResponse, OauthGetOauthConfigData, OauthTestOauthConfigData, UsersDeleteUserMeData, UsersDeleteUserMeResponse, UsersReadUserMeData, UsersUpdateUserMeData, UsersUpdateUserMeError, UsersUpdateUserMeResponse, UsersGetMyBillingIdData, UsersGetUserAccessData, UsersUpdatePasswordMeData, UsersUpdatePasswordMeError, UsersUpdatePasswordMeResponse, UsersUpdateDeviceMetadataData, UsersUpdateDeviceMetadataError, UsersUpdateDeviceMetadataResponse, UsersRecordInstallAttributionData, UsersRecordInstallAttributionError, UsersRecordInstallAttributionResponse, UsersReportPermissionChangeData, UsersReportPermissionChangeError, UsersReportPermissionChangeResponse, UsersMarkWidgetUsedData, UsersMarkWidgetUsedResponse, UsersUpdateAbTestVariantData, UsersUpdateAbTestVariantError, UsersUpdateAbTestVariantResponse, UsersUpdateJourneyPaceData, UsersUpdateJourneyPaceError, UsersUpdateJourneyPaceResponse, UsersReadMyEmailPreferencesData, UsersUpdateMyEmailPreferenceData, UsersUpdateMyEmailPreferenceError, UsersUpdateMyEmailPreferenceResponse, UsersReadMyHealthDataConsentData, UsersRecordMyHealthDataConsentData, UsersRecordMyHealthDataConsentError, UsersRecordMyHealthDataConsentResponse, UsersReadMyResearchConsentData, UsersRecordMyResearchConsentData, UsersRecordMyResearchConsentError, UsersRecordMyResearchConsentResponse, UsersReadUserAuthProfileData, UsersDeleteAllPushTokensData, UsersDeleteAllPushTokensResponse, UsersGetUserPushTokensData, UsersRegisterPushTokenData, UsersRegisterPushTokenError, UsersRegisterPushTokenResponse, UsersDeletePushTokenData, UsersDeletePushTokenError, UsersDeletePushTokenResponse, UsersGetOctopusTokenData, UsersGetOctopusTokenResponse, UsersReadUserByIdData, UsersReadUsersData, UsersReadUsersError, UsersReadUsersResponse, UsersCreateUserData, UsersCreateUserError, UsersExportUsersCsvData, UsersDeleteUserData, UsersDeleteUserError, UsersDeleteUserResponse, UsersUpdateUserData, UsersUpdateUserError, UsersUpdateUserResponse, UsersCreateUserFeedbackData, UsersCreateUserFeedbackError, UsersCreateUserFeedbackResponse, UsersUpdateUserStaffFlagData, UsersUpdateUserStaffFlagError, UsersUpdateUserStaffFlagResponse, UsersUpdateUserRolesData, UsersUpdateUserRolesError, UsersUpdateUserRolesResponse, UsersCheckRevenuecatCustomerStatusData, UsersGetRevenuecatRawCustomerInfoData, UsersDeleteRevenuecatCustomerData, UsersDeleteRevenuecatCustomerError, UsersDeleteRevenuecatCustomerResponse, UsersGetMyEntitlementData, UsersGrantMyPurchasePendingData, UsersGrantMyPurchasePendingError, UsersGrantMyPurchasePendingResponse, TouchEventsRecordAppTouchesData, TouchEventsRecordAppTouchesError, TouchEventsRecordAppTouchesResponse, AppInstallsRecordAppInstallData, AppInstallsRecordAppInstallError, AppInstallsRecordAppInstallResponse, AppInstallsLinkAppInstallData, AppInstallsLinkAppInstallError, AppInstallsLinkAppInstallResponse, UsersGetMyHardshipRequestData, UsersCreateMyHardshipRequestData, UsersCreateMyHardshipRequestError, UsersCreateMyHardshipRequestResponse, UsersScheduleMyBillingReminderData, UsersScheduleMyBillingReminderError, UsersScheduleMyBillingReminderResponse, AdminBillingIdentityResolveBillingIdData, AdminRevenuecatImportImportRevenuecatCsvData, AdminRevenuecatImportImportRevenuecatCsvError, AdminRevenuecatImportImportRevenuecatCsvResponse, AdminInsightsEventCountsData, AdminInsightsActiveUsersData, AdminInsightsNewUsersData, AdminInsightsChurnScreensData, AdminInsightsVersionBreakdownData, AdminInsightsUsageBreakdownData, AdminInsightsWebFunnelData, AdminInsightsEmailCoverageData, AdminCheckpointsReachByVersionData, AdminCheckpointsTimeToMomentData, AdminCheckpointsHealthEntryVolumeData, AdminCheckpointsBackendReachData, AdminActivationActivationOverviewData, AdminActivationActivationOverviewError, AdminActivationActivationOverviewResponse, AdminJourneyHealthJourneySummaryData, AdminJourneyHealthJourneyLadderData, AdminJourneyHealthJourneyFunnelData, AdminJourneyHealthJourneyFunnelError, AdminJourneyHealthJourneyFunnelResponse, AdminJourneyHealthJourneyCohortsData, AdminJourneyHealthJourneyRetentionData, AdminPricingGetPricingGridData, AdminPricingGetStorePricesData, AdminPricingListStripePricesData, AdminPricingAdoptEnvPricesData, AdminPricingAdoptEnvPricesResponse, AdminPricingRotatePriceData, AdminPricingRotatePriceError, AdminPricingRotatePriceResponse, AdminPricingGetPriceHistoryData, AdminPricingListExperimentsData, AdminPricingUpsertExperimentData, AdminPricingUpsertExperimentError, AdminPricingUpsertExperimentResponse, AdminPricingSetExperimentActiveData, AdminPricingSetExperimentActiveError, AdminPricingSetExperimentActiveResponse, AdminPricingListPublicOffersData, AdminPricingGetPlanDisplayData, AdminPricingSetPlanDisplayData, AdminPricingSetPlanDisplayError, AdminPricingSetPlanDisplayResponse, AdminPaymentsPaymentsOverviewData, AdminPaymentsPaymentsOverviewError, AdminPaymentsPaymentsOverviewResponse, AdminPaymentsPaymentsGrowthData, AdminPaymentsPaymentsRetentionData, AdminPaymentsPaymentDimensionsData, AdminPaymentsPaymentsChartData, AdminPaymentsPaymentsChartError, AdminPaymentsPaymentsChartResponse, AdminPaymentsPaymentsChartsBatchData, AdminPaymentsPaymentsChartsBatchError, AdminPaymentsPaymentsChartsBatchResponse, AdminPaymentsPaymentsReleaseMarkersData, AdminPaymentsPaymentsReleaseMarkersError, AdminPaymentsPaymentsReleaseMarkersResponse, AdminPaymentsListSubscriptionsData, AdminPaymentsListSubscriptionsError, AdminPaymentsListSubscriptionsResponse, AdminPaymentsSubscriptionEventsData, AdminPaymentsHealthDetailData, AdminPaymentsPipelineHealthData, AdminPaymentsListAnomaliesData, AdminPaymentsTriageAnomaliesData, AdminPaymentsTriageAnomaliesError, AdminPaymentsTriageAnomaliesResponse, AdminPaymentsAttributeAnomalyData, AdminPaymentsAttributeAnomalyError, AdminPaymentsAttributeAnomalyResponse, AdminPaymentsLookupProviderProfileData, AdminPaymentsRecentTransactionsData, AdminPaymentsRecentTransactionsError, AdminPaymentsRecentTransactionsResponse, AdminPaymentsGroupCoachingCampaignsData, AdminPaymentsGroupCoachingCampaignsError, AdminPaymentsGroupCoachingCampaignsResponse, AdminPaymentsCoachingBuyersData, AdminPaymentsCoachingBuyersError, AdminPaymentsCoachingBuyersResponse, AdminVitalSignsVitalSignsData, AdminCustomersLookupCustomerData, AdminCustomersCustomerLandingData, AdminCustomersGetCustomerData, AdminCustomersGetCustomerActivityData, AdminCustomersGetCustomerEmailsData, AdminCustomersGetCustomerEmailsError, AdminCustomersGetCustomerEmailsResponse, AdminCustomersGetCustomerEmailDataData, AdminCustomersGetCustomerDevicesData, AdminCustomersGetCustomerReleaseStateData, AdminCustomersCreateGrantData, AdminCustomersCreateGrantError, AdminCustomersCreateGrantResponse, AdminCustomersRevokeGrantData, AdminCustomersRevokeGrantError, AdminCustomersRevokeGrantResponse, AdminCustomersSetCustomerPaymentsV2Data, AdminCustomersSetCustomerPaymentsV2Error, AdminCustomersSetCustomerPaymentsV2Response, AdminCustomersGetCustomerSegmentsData, AdminCustomersRemoveCustomerFromSegmentData, AdminCustomersRemoveCustomerFromSegmentError, AdminCustomersRemoveCustomerFromSegmentResponse, AdminCustomersAddCustomerToSegmentData, AdminCustomersAddCustomerToSegmentError, AdminCustomersAddCustomerToSegmentResponse, AdminCustomersRevokeStaticLoginCodeData, AdminCustomersRevokeStaticLoginCodeError, AdminCustomersRevokeStaticLoginCodeResponse, AdminCustomersGetStaticLoginCodeData, AdminCustomersCreateStaticLoginCodeData, AdminCustomersCreateStaticLoginCodeError, AdminCustomersCreateStaticLoginCodeResponse, AdminFunnelLeadsListFunnelLeadsData, AdminFunnelLeadsListFunnelLeadsError, AdminFunnelLeadsListFunnelLeadsResponse, AdminFunnelLeadsExportFunnelLeadsCsvData, AdminHardshipOfferGetHardshipOfferData, AdminHardshipOfferRemoveHardshipEmailData, AdminHardshipOfferRemoveHardshipEmailError, AdminHardshipOfferRemoveHardshipEmailResponse, AdminHardshipOfferAddHardshipEmailsData, AdminHardshipOfferAddHardshipEmailsError, AdminHardshipOfferAddHardshipEmailsResponse, AdminHardshipOfferSendHardshipOfferEmailData, AdminHardshipOfferSendHardshipOfferEmailError, AdminHardshipOfferSendHardshipOfferEmailResponse, AdminHardshipOfferTestSendHardshipOfferEmailData, AdminHardshipOfferTestSendHardshipOfferEmailResponse, AdminConsentConsentDashboardData, AdminCustomersGetPushReadinessData, AdminCustomersCheckPushReceiptsData, AdminCustomersCheckPushReceiptsError, AdminCustomersCheckPushReceiptsResponse, AdminCustomersSendTestPushData, AdminCustomersSendTestPushError, AdminCustomersSendTestPushResponse, AdminPushListsPreviewPushListData, AdminPushListsPreviewPushListError, AdminPushListsPreviewPushListResponse, AdminPushListsSendPushListData, AdminPushListsSendPushListError, AdminPushListsSendPushListResponse, AdminPushListsPreviewScheduleData, AdminPushListsPreviewScheduleError, AdminPushListsPreviewScheduleResponse, AdminPushListsCreateScheduleData, AdminPushListsCreateScheduleError, AdminPushListsCreateScheduleResponse, AdminPushListsListScheduledData, AdminPushListsCancelScheduledData, AdminPushListsCancelScheduledError, AdminPushListsCancelScheduledResponse, AdminStoreReviewGetStoreReviewOverviewData, AdminStoreReviewLookupStoreReviewEmailData, AdminStoreReviewProvisionStoreReviewAccountData, AdminStoreReviewProvisionStoreReviewAccountError, AdminStoreReviewProvisionStoreReviewAccountResponse, AdminCommunityListCommunityPostsData, AdminCommunityListCommunityPostsError, AdminCommunityListCommunityPostsResponse, AdminCommunityCreateCommunityPostData, AdminCommunityCreateCommunityPostError, AdminCommunityCreateCommunityPostResponse, AdminCommunityCancelScheduledCommunityPostData, AdminCommunityCancelScheduledCommunityPostError, AdminCommunityCancelScheduledCommunityPostResponse, AdminCommunityGetCommunityPostData, AdminCommunityUpdateScheduledCommunityPostData, AdminCommunityUpdateScheduledCommunityPostError, AdminCommunityUpdateScheduledCommunityPostResponse, AdminCommunityArchiveCommunityPostData, AdminCommunityArchiveCommunityPostError, AdminCommunityArchiveCommunityPostResponse, AdminCommunityRestoreCommunityPostData, AdminCommunityRestoreCommunityPostError, AdminCommunityRestoreCommunityPostResponse, AdminCommunitySetCommunityPostTopicData, AdminCommunitySetCommunityPostTopicError, AdminCommunitySetCommunityPostTopicResponse, AdminCommunityBoostCommunityPostData, AdminCommunityBoostCommunityPostError, AdminCommunityBoostCommunityPostResponse, AdminCommunityUnboostCommunityPostData, AdminCommunityUnboostCommunityPostError, AdminCommunityUnboostCommunityPostResponse, AdminCommunityHighlightCommunityPostData, AdminCommunityHighlightCommunityPostError, AdminCommunityHighlightCommunityPostResponse, AdminCommunityHeroCommunityPostData, AdminCommunityHeroCommunityPostError, AdminCommunityHeroCommunityPostResponse, AdminCommunityGetCommunityIdentityData, AdminCommunitySetCommunityNameData, AdminCommunitySetCommunityNameError, AdminCommunitySetCommunityNameResponse, AdminCommunityListCommunityPostCommentsData, AdminCommunityCreateCommunityPostCommentData, AdminCommunityCreateCommunityPostCommentError, AdminCommunityCreateCommunityPostCommentResponse, AdminCommunityArchiveCommunityCommentData, AdminCommunityArchiveCommunityCommentError, AdminCommunityArchiveCommunityCommentResponse, AdminCommunityRestoreCommunityCommentData, AdminCommunityRestoreCommunityCommentError, AdminCommunityRestoreCommunityCommentResponse, AdminCommunitySetCommunityCommentReactionData, AdminCommunitySetCommunityCommentReactionError, AdminCommunitySetCommunityCommentReactionResponse, AdminCommunitySetCommunityPostReactionData, AdminCommunitySetCommunityPostReactionError, AdminCommunitySetCommunityPostReactionResponse, AdminCommunityPublishScheduledCommunityPostData, AdminCommunityPublishScheduledCommunityPostError, AdminCommunityPublishScheduledCommunityPostResponse, AdminCommunityCommunityStatsData, AdminCommunityCommunityStatsError, AdminCommunityCommunityStatsResponse, AdminBeehiivGetSubscriptionByEmailData, AdminBeehiivListCustomFieldsData, AdminBeehiivGetPublicationData, AdminBeehiivListPostsData, AdminBeehiivListPostsError, AdminBeehiivListPostsResponse, AdminBeehiivGetPostsAggregateStatsData, AdminBeehiivListSubscriptionsData, AdminBeehiivListSubscriptionsError, AdminBeehiivListSubscriptionsResponse, AdminBeehiivListSegmentsData, AdminBeehiivListSegmentsError, AdminBeehiivListSegmentsResponse, AdminBeehiivRecalculateSegmentData, AdminBeehiivRecalculateSegmentError, AdminBeehiivRecalculateSegmentResponse, UsersV2ListUsersV2Data, UsersV2ListUsersV2Error, UsersV2ListUsersV2Response, UsersV2GetUserV2Data, UsersV2GetUserEventsV2Data, UsersV2GetUserEventsV2Error, UsersV2GetUserEventsV2Response, UsersV2GetUserStatsV2Data, MetricsGetUserCountsData, MetricsGetNewUsersChartData, MetricsGetNewUsersChartError, MetricsGetNewUsersChartResponse, MetricsGetUserCountOverTimeData, MetricsListUserGrowthEventsData, MetricsCreateUserGrowthEventData, MetricsCreateUserGrowthEventError, MetricsCreateUserGrowthEventResponse, MetricsDeleteUserGrowthEventData, MetricsDeleteUserGrowthEventError, MetricsDeleteUserGrowthEventResponse, MetricsGetDistinctProductIdentifiersData, MetricsGetUserRetentionData, MetricsGetCohortRetentionData, UtilsHealthCheckData, NotificationsDeleteAllNotificationPreferencesData, NotificationsDeleteAllNotificationPreferencesResponse, NotificationsGetNotificationPreferencesData, NotificationsCreateNotificationPreferenceData, NotificationsCreateNotificationPreferenceError, NotificationsCreateNotificationPreferenceResponse, NotificationsDeleteNotificationPreferenceData, NotificationsDeleteNotificationPreferenceError, NotificationsDeleteNotificationPreferenceResponse, NotificationsUpdateNotificationPreferenceData, NotificationsUpdateNotificationPreferenceError, NotificationsUpdateNotificationPreferenceResponse, NotificationsReadAllNotificationPreferencesData, NotificationsReadNotificationHistoryData, NotificationsReadUserNotificationHistoryData, NotificationsReadNotificationHistoryByIdData, NotificationsRecordNotificationOpenedData, NotificationsRecordNotificationOpenedError, NotificationsRecordNotificationOpenedResponse, PublicGetCommunityStatsData, PublicGetCohortMoodProgressionData, PublicGetEmailPreferencesData, PublicUpdateEmailPreferenceData, PublicUpdateEmailPreferenceError, PublicUpdateEmailPreferenceResponse, PublicOneClickUnsubscribeData, PublicOneClickUnsubscribeError, PublicOneClickUnsubscribeResponse, PublicUnsubscribeFromEmailsData, PublicUnsubscribeFromEmailsError, PublicUnsubscribeFromEmailsResponse, StripeRefundEligibilityData, StripeRefundData, StripeRefundResponse, StripeGetStripePricesData, StripeCreateBillingPortalSessionData, StripeCreateBillingPortalSessionResponse, WebOnboardingIngestWebOnboardingData, WebOnboardingIngestWebOnboardingError, WebOnboardingIngestWebOnboardingResponse, WebOnboardingFunnelTouchData, WebOnboardingFunnelTouchError, WebOnboardingFunnelTouchResponse, WebOnboardingFunnelOfferData, WebOnboardingFunnelOfferError, WebOnboardingFunnelOfferResponse, WebOnboardingWebOnboardingConfigData, WebOnboardingWebOnboardingCheckoutData, WebOnboardingWebOnboardingCheckoutError, WebOnboardingWebOnboardingCheckoutResponse, WebOnboardingWebOnboardingCompleteData, WebOnboardingWebOnboardingCompleteError, WebOnboardingWebOnboardingCompleteResponse, WebOnboardingWebOnboardingResendData, WebOnboardingWebOnboardingResendError, WebOnboardingWebOnboardingResendResponse, PaymentsPaymentWebhookData, PaymentsPaymentWebhookError, PaymentsPaymentWebhookResponse, StripeWebhookStripeWebhookData, RevenuecatSyncRevenuecatSubscriptionData, RevenuecatSyncRevenuecatSubscriptionError, RevenuecatSyncRevenuecatSubscriptionResponse, RevenuecatWebhookRevenuecatWebhookData, PromoCodesValidatePromoCodeData, PromoCodesValidatePromoCodeError, PromoCodesValidatePromoCodeResponse, FeedbackReadFeedbackListData, FeedbackCreateFeedbackData, FeedbackCreateFeedbackError, FeedbackCreateFeedbackResponse, FeedbackDeleteFeedbackData, FeedbackDeleteFeedbackError, FeedbackDeleteFeedbackResponse, FeedbackReadFeedbackData, FeedbackUpdateFeedbackData, FeedbackUpdateFeedbackError, FeedbackUpdateFeedbackResponse, AgentConfigsGetAgentConfigBySlugData, AgentConfigsCreateElevenlabsSignedUrlData, AgentConfigsCreateElevenlabsSignedUrlError, AgentConfigsCreateElevenlabsSignedUrlResponse, AgentConfigsListAgentConfigsData, AgentConfigsListAgentConfigsError, AgentConfigsListAgentConfigsResponse, AgentConfigsCreateAgentConfigData, AgentConfigsCreateAgentConfigError, AgentConfigsCreateAgentConfigResponse, AgentConfigsDeleteAgentConfigData, AgentConfigsDeleteAgentConfigError, AgentConfigsDeleteAgentConfigResponse, AgentConfigsGetAgentConfigByIdData, AgentConfigsUpdateAgentConfigData, AgentConfigsUpdateAgentConfigError, AgentConfigsUpdateAgentConfigResponse, AgentConfigsInvalidateAgentCacheData, AgentConfigsInvalidateAgentCacheError, AgentConfigsInvalidateAgentCacheResponse, ExercisesGetDailyFlowBehaviorsData, ExercisesGetDailyFlowRecommendationData, ExercisesListExercisesData, ExercisesListExercisesError, ExercisesListExercisesResponse, ExercisesCreateExerciseData, ExercisesCreateExerciseError, ExercisesCreateExerciseResponse, ExercisesDeleteExerciseData, ExercisesDeleteExerciseError, ExercisesDeleteExerciseResponse, ExercisesGetExerciseByIdAdminData, ExercisesUpdateExerciseData, ExercisesUpdateExerciseError, ExercisesUpdateExerciseResponse, ExercisesPromoteExerciseFromStagingData, ExercisesPromoteExerciseFromStagingError, ExercisesPromoteExerciseFromStagingResponse, ExercisesPublishExerciseData, ExercisesPublishExerciseError, ExercisesPublishExerciseResponse, ExercisesUnpublishExerciseData, ExercisesUnpublishExerciseError, ExercisesUnpublishExerciseResponse, ExercisesSyncExercisesFromProductionData, ExercisesSyncExercisesFromProductionResponse, ExercisesListExerciseCategoriesData, ExercisesGetExercisesByCategoryData, ExercisesGetExercisesByCategoryError, ExercisesGetExercisesByCategoryResponse, ExercisesGetExerciseBySlugData, ExercisesGetExerciseBySlugAndVersionData, AmisExercisesListAmisExercisesData, AmisExercisesListAmisExercisesError, AmisExercisesListAmisExercisesResponse, AmisExercisesCreateAmisExerciseData, AmisExercisesCreateAmisExerciseError, AmisExercisesCreateAmisExerciseResponse, AmisExercisesGetDailyFlowRecommendationData, AmisExercisesDeleteAmisExerciseData, AmisExercisesDeleteAmisExerciseError, AmisExercisesDeleteAmisExerciseResponse, AmisExercisesGetAmisExerciseByIdData, AmisExercisesUpdateAmisExerciseData, AmisExercisesUpdateAmisExerciseError, AmisExercisesUpdateAmisExerciseResponse, AmisExercisesPublishAmisExerciseData, AmisExercisesPublishAmisExerciseError, AmisExercisesPublishAmisExerciseResponse, AmisExercisesGetAmisExerciseHistoryData, AmisExercisesDeleteAmisExerciseVersionData, AmisExercisesDeleteAmisExerciseVersionError, AmisExercisesDeleteAmisExerciseVersionResponse, AmisExercisesGetAmisExerciseVersionByIdData, AmisExercisesDeleteOldDraftVersionsData, AmisExercisesDeleteOldDraftVersionsError, AmisExercisesDeleteOldDraftVersionsResponse, DailyLessonsGetAvailableLessonsData, DailyLessonsGetSavedLessonsData, DailyLessonsGetDailyLessonData, DailyLessonsDismissLessonData, DailyLessonsDismissLessonError, DailyLessonsDismissLessonResponse, DailyLessonsLikeLessonData, DailyLessonsLikeLessonError, DailyLessonsLikeLessonResponse, DailyLessonsListDailyLessonsAdminData, DailyLessonsListDailyLessonsAdminError, DailyLessonsListDailyLessonsAdminResponse, DailyLessonsCreateDailyLessonAdminData, DailyLessonsCreateDailyLessonAdminError, DailyLessonsCreateDailyLessonAdminResponse, DailyLessonsBulkUpsertDailyLessonsAdminData, DailyLessonsBulkUpsertDailyLessonsAdminError, DailyLessonsBulkUpsertDailyLessonsAdminResponse, DailyLessonsDeleteDailyLessonAdminData, DailyLessonsDeleteDailyLessonAdminError, DailyLessonsDeleteDailyLessonAdminResponse, DailyLessonsGetDailyLessonAdminData, DailyLessonsUpdateDailyLessonAdminData, DailyLessonsUpdateDailyLessonAdminError, DailyLessonsUpdateDailyLessonAdminResponse, DailyLessonsPromoteDailyLessonFromStagingData, DailyLessonsPromoteDailyLessonFromStagingError, DailyLessonsPromoteDailyLessonFromStagingResponse, DailyLessonsPublishDailyLessonData, DailyLessonsPublishDailyLessonError, DailyLessonsPublishDailyLessonResponse, DailyLessonsUnpublishDailyLessonData, DailyLessonsUnpublishDailyLessonError, DailyLessonsUnpublishDailyLessonResponse, DailyLessonsSyncDailyLessonsFromProductionData, DailyLessonsSyncDailyLessonsFromProductionResponse, BannersGetEligibleBannersData, BannersGetBannerHistoryData, BannersRecordBannerShownData, BannersRecordBannerShownError, BannersRecordBannerShownResponse, BannersRecordBannerClickData, BannersRecordBannerClickError, BannersRecordBannerClickResponse, BannersRecordBannerCompleteData, BannersRecordBannerCompleteError, BannersRecordBannerCompleteResponse, BannersRecordBannerDeliveredData, BannersRecordBannerDeliveredError, BannersRecordBannerDeliveredResponse, BannersDismissBannerData, BannersDismissBannerError, BannersDismissBannerResponse, BannersListBannersAdminData, BannersListBannersAdminError, BannersListBannersAdminResponse, BannersGetBannerStatsAdminData, BannersCreateBannerAdminData, BannersCreateBannerAdminError, BannersCreateBannerAdminResponse, BannersCreateDraftBannerAdminData, BannersCreateDraftBannerAdminError, BannersCreateDraftBannerAdminResponse, BannersDeleteBannerAdminData, BannersDeleteBannerAdminError, BannersDeleteBannerAdminResponse, BannersGetBannerAdminData, BannersUpdateBannerAdminData, BannersUpdateBannerAdminError, BannersUpdateBannerAdminResponse, BannersGetBannerDistributionAdminData, BannersPublishBannerAdminData, BannersPublishBannerAdminError, BannersPublishBannerAdminResponse, BannersForceDeliverBannerAdminData, BannersForceDeliverBannerAdminError, BannersForceDeliverBannerAdminResponse, BannersGetBannerContentAdminData, BannersUpsertBannerContentAdminData, BannersUpsertBannerContentAdminError, BannersUpsertBannerContentAdminResponse, BannersUpsertDraftContentAdminData, BannersUpsertDraftContentAdminError, BannersUpsertDraftContentAdminResponse, BannersPinContextualBannerData, BannersPinContextualBannerError, BannersPinContextualBannerResponse, BannersResetPersonalClockData, BannersResetPersonalClockError, BannersResetPersonalClockResponse, BannersGetPersonalClockData, BannersAdvancePersonalClockData, BannersAdvancePersonalClockError, BannersAdvancePersonalClockResponse, WalkStartWalkData, WalkStartWalkError, WalkStartWalkResponse, LiveActivityGetLiveActivityData, SimSimResetData, SimSimResetError, SimSimResetResponse, SimSimTickData, SimSimTickError, SimSimTickResponse, SimSimStepData, SimSimStepError, SimSimStepResponse, SimSimPublishData, SimSimPublishError, SimSimPublishResponse, SimSimStateData, SimSimUserDetailData, JourneyDevResetOwnJourneyData, JourneyDevResetOwnJourneyError, JourneyDevResetOwnJourneyResponse, JourneyDevSeedOwnJourneyData, JourneyDevSeedOwnJourneyError, JourneyDevSeedOwnJourneyResponse, BookInterestCaptureBookInterestData, BookInterestCaptureBookInterestError, BookInterestCaptureBookInterestResponse, QuizResultCaptureQuizResultData, QuizResultCaptureQuizResultError, QuizResultCaptureQuizResultResponse, CoachingWaitlistCaptureCoachingWaitlistData, CoachingWaitlistCaptureCoachingWaitlistError, CoachingWaitlistCaptureCoachingWaitlistResponse, ContactCaptureCaptureContactData, ContactCaptureCaptureContactError, ContactCaptureCaptureContactResponse, QuizResultDownloadQuizResultData, FeatureFlagsGetFeatureFlagsData, FeatureFlagsListFeatureFlagsAdminData, FeatureFlagsListFeatureFlagsAdminError, FeatureFlagsListFeatureFlagsAdminResponse, FeatureFlagsCreateFeatureFlagData, FeatureFlagsCreateFeatureFlagError, FeatureFlagsCreateFeatureFlagResponse, FeatureFlagsGetStoreVersionsData, FeatureFlagsDeleteFeatureFlagData, FeatureFlagsDeleteFeatureFlagError, FeatureFlagsDeleteFeatureFlagResponse, FeatureFlagsGetFeatureFlagAdminData, FeatureFlagsUpdateFeatureFlagData, FeatureFlagsUpdateFeatureFlagError, FeatureFlagsUpdateFeatureFlagResponse, FeatureFlagsEstimateFeatureFlagReachData, FeatureFlagsEstimateFeatureFlagReachError, FeatureFlagsEstimateFeatureFlagReachResponse, FeatureFlagsExplainFeatureFlagData, FeatureFlagsListFeatureFlagRevisionsData, FeatureFlagsListFeatureFlagRevisionsByKeyData, FeatureFlagsListUserFeatureFlagOverridesData, FeatureFlagsListUserFeatureFlagOverridesError, FeatureFlagsListUserFeatureFlagOverridesResponse, FeatureFlagsCreateUserFeatureFlagOverrideData, FeatureFlagsCreateUserFeatureFlagOverrideError, FeatureFlagsCreateUserFeatureFlagOverrideResponse, FeatureFlagsDeleteUserFeatureFlagOverrideData, FeatureFlagsDeleteUserFeatureFlagOverrideError, FeatureFlagsDeleteUserFeatureFlagOverrideResponse, FeatureFlagsListSegmentFeatureFlagOverridesData, FeatureFlagsSetSegmentFeatureFlagOverrideData, FeatureFlagsSetSegmentFeatureFlagOverrideError, FeatureFlagsSetSegmentFeatureFlagOverrideResponse, FeatureFlagsClearSegmentFeatureFlagOverrideData, FeatureFlagsClearSegmentFeatureFlagOverrideError, FeatureFlagsClearSegmentFeatureFlagOverrideResponse, FeatureFlagsProposeFeatureFlagChangeData, FeatureFlagsProposeFeatureFlagChangeError, FeatureFlagsProposeFeatureFlagChangeResponse, FeatureFlagsListFeatureFlagChangesData, FeatureFlagsGetFeatureFlagChangeData, FeatureFlagsApplyFeatureFlagChangeData, FeatureFlagsApplyFeatureFlagChangeError, FeatureFlagsApplyFeatureFlagChangeResponse, FeatureFlagsApproveFeatureFlagChangeData, FeatureFlagsApproveFeatureFlagChangeError, FeatureFlagsApproveFeatureFlagChangeResponse, FeatureFlagsRejectFeatureFlagChangeData, FeatureFlagsRejectFeatureFlagChangeError, FeatureFlagsRejectFeatureFlagChangeResponse, InsightsGetPeerInsightsData, InsightsGetBehaviorInsightsData, SecretsListSecretsData, SecretsListSecretsError, SecretsListSecretsResponse, SecretsCreateSecretData, SecretsCreateSecretError, SecretsCreateSecretResponse, SecretsGetLatestSecretData, SecretsGetSecretVersionsData, SecretsDeleteSecretData, SecretsDeleteSecretError, SecretsDeleteSecretResponse, SecretsUpdateSecretData, SecretsUpdateSecretError, SecretsUpdateSecretResponse, SecretsGetSecretAgentConfigsData, MediaListMediaData, MediaListMediaError, MediaListMediaResponse, MediaUploadMediaData, MediaUploadMediaError, MediaUploadMediaResponse, MediaCheckFilenameConflictData, MediaDeleteMediaData, MediaDeleteMediaError, MediaDeleteMediaResponse, MediaGetMediaData, MediaUpdateMediaData, MediaUpdateMediaError, MediaUpdateMediaResponse, MediaUploadMediaBatchData, MediaUploadMediaBatchError, MediaUploadMediaBatchResponse, ReviewsListReviewsData, ReviewsListReviewsError, ReviewsListReviewsResponse, ReviewsCreateReviewData, ReviewsCreateReviewError, ReviewsCreateReviewResponse, ReviewsListReviewsAdminData, ReviewsListReviewsAdminError, ReviewsListReviewsAdminResponse, ReviewsDeleteReviewAdminData, ReviewsDeleteReviewAdminError, ReviewsDeleteReviewAdminResponse, ReviewsGetReviewAdminData, ReviewsUpdateReviewAdminData, ReviewsUpdateReviewAdminError, ReviewsUpdateReviewAdminResponse, ReviewsGetReviewData, PromoCodesAdminListPromoCodesData, PromoCodesAdminListPromoCodesError, PromoCodesAdminListPromoCodesResponse, PromoCodesAdminCreatePromoCodeData, PromoCodesAdminCreatePromoCodeError, PromoCodesAdminCreatePromoCodeResponse, PromoCodesAdminDeletePromoCodeData, PromoCodesAdminDeletePromoCodeError, PromoCodesAdminDeletePromoCodeResponse, PromoCodesAdminGetPromoCodeByIdData, PromoCodesAdminUpdatePromoCodeData, PromoCodesAdminUpdatePromoCodeError, PromoCodesAdminUpdatePromoCodeResponse, PromoCodesAdminGetRevenuecatProductsData, PromoCodesAdminGetRevenuecatOfferingsData, PromoCodesAdminGetRevenuecatAppData, PromoCodesAdminClearRevenuecatCacheData, PromoCodesAdminClearRevenuecatCacheError, PromoCodesAdminClearRevenuecatCacheResponse, EmailTemplatesListEmailTemplatesData, EmailTemplatesListEmailTemplatesError, EmailTemplatesListEmailTemplatesResponse, EmailTemplatesCreateEmailTemplateData, EmailTemplatesCreateEmailTemplateError, EmailTemplatesCreateEmailTemplateResponse, EmailTemplatesListSystemEmailsData, EmailTemplatesSystemEmailBuiltInData, EmailTemplatesCustomizeSystemEmailData, EmailTemplatesCustomizeSystemEmailError, EmailTemplatesCustomizeSystemEmailResponse, EmailTemplatesUseBuiltInSystemEmailData, EmailTemplatesUseBuiltInSystemEmailError, EmailTemplatesUseBuiltInSystemEmailResponse, EmailTemplatesDeleteEmailTemplateData, EmailTemplatesDeleteEmailTemplateError, EmailTemplatesDeleteEmailTemplateResponse, EmailTemplatesGetEmailTemplateData, EmailTemplatesUpdateEmailTemplateData, EmailTemplatesUpdateEmailTemplateError, EmailTemplatesUpdateEmailTemplateResponse, EmailTemplatesPreviewEmailTemplateData, EmailTemplatesPreviewEmailTemplateError, EmailTemplatesPreviewEmailTemplateResponse, EmailTemplatesTestSendEmailTemplateData, EmailTemplatesTestSendEmailTemplateError, EmailTemplatesTestSendEmailTemplateResponse, EmailTemplatesListTemplateVersionsData, EmailTemplatesDiscardTemplateDraftData, EmailTemplatesDiscardTemplateDraftError, EmailTemplatesDiscardTemplateDraftResponse, EmailTemplatesSaveTemplateDraftData, EmailTemplatesSaveTemplateDraftError, EmailTemplatesSaveTemplateDraftResponse, EmailTemplatesReviewTemplateVersionData, EmailTemplatesPublishTemplateVersionData, EmailTemplatesPublishTemplateVersionError, EmailTemplatesPublishTemplateVersionResponse, EmailTemplatesTemplateStatsData, EmailLayoutsListLayoutsData, EmailLayoutsGetSenderIdentityData, EmailLayoutsUpdateSenderIdentityData, EmailLayoutsUpdateSenderIdentityError, EmailLayoutsUpdateSenderIdentityResponse, EmailLayoutsLayoutUsageData, EmailLayoutsDuplicateLayoutData, EmailLayoutsDuplicateLayoutError, EmailLayoutsDuplicateLayoutResponse, EmailLayoutsDeleteLayoutData, EmailLayoutsDeleteLayoutError, EmailLayoutsDeleteLayoutResponse, EmailLayoutsUpdateLayoutData, EmailLayoutsUpdateLayoutError, EmailLayoutsUpdateLayoutResponse, EmailLayoutsPreviewLayoutData, EmailLayoutsPreviewLayoutError, EmailLayoutsPreviewLayoutResponse, EmailLayoutsCompileBodyData, EmailLayoutsCompileBodyError, EmailLayoutsCompileBodyResponse, EmailDeliverabilityDeliverabilityData, EmailDeliverabilityRatesData, EmailDeliverabilityListHealthData, EmailDeliverabilityDeliveryMethodsComparedData, EmailDeliverabilityPipelineData, EmailSuppressionsListSuppressionsData, EmailSuppressionsListSuppressionsError, EmailSuppressionsListSuppressionsResponse, EmailSuppressionsAddSuppressionData, EmailSuppressionsAddSuppressionError, EmailSuppressionsAddSuppressionResponse, EmailSuppressionsLiftSuppressionData, EmailSuppressionsLiftSuppressionError, EmailSuppressionsLiftSuppressionResponse, EmailSuppressionsRequestPostmarkLiftData, EmailSuppressionsRequestPostmarkLiftError, EmailSuppressionsRequestPostmarkLiftResponse, EmailCampaignsGetTriggerEventsData, EmailCampaignsGetFlowConditionsData, EmailCampaignsGetEnrollmentCountsData, EmailCampaignsListEmailCampaignsData, EmailCampaignsListEmailCampaignsError, EmailCampaignsListEmailCampaignsResponse, EmailCampaignsCreateEmailCampaignData, EmailCampaignsCreateEmailCampaignError, EmailCampaignsCreateEmailCampaignResponse, EmailCampaignsDeleteEmailCampaignData, EmailCampaignsDeleteEmailCampaignError, EmailCampaignsDeleteEmailCampaignResponse, EmailCampaignsGetEmailCampaignData, EmailCampaignsUpdateEmailCampaignData, EmailCampaignsUpdateEmailCampaignError, EmailCampaignsUpdateEmailCampaignResponse, EmailCampaignsMoveCampaignData, EmailCampaignsMoveCampaignError, EmailCampaignsMoveCampaignResponse, EmailCampaignsCancelRestData, EmailCampaignsCancelRestError, EmailCampaignsCancelRestResponse, EmailCampaignsEnrollSegmentInCampaignData, EmailCampaignsEnrollSegmentInCampaignError, EmailCampaignsEnrollSegmentInCampaignResponse, EmailCampaignsGetCampaignEngagementData, EmailCampaignsCampaignOverviewData, EmailFlowsDiscardFlowDraftData, EmailFlowsDiscardFlowDraftError, EmailFlowsDiscardFlowDraftResponse, EmailFlowsGetFlowDraftData, EmailFlowsSaveFlowDraftData, EmailFlowsSaveFlowDraftError, EmailFlowsSaveFlowDraftResponse, EmailFlowsReviewFlowDraftData, EmailFlowsPublishFlowDraftData, EmailFlowsPublishFlowDraftError, EmailFlowsPublishFlowDraftResponse, EmailFlowsPreviewFlowDraftData, EmailFlowsPreviewFlowDraftError, EmailFlowsPreviewFlowDraftResponse, EmailFlowsTestFlowDraftData, EmailFlowsTestFlowDraftError, EmailFlowsTestFlowDraftResponse, EmailFlowsArchiveFlowData, EmailFlowsArchiveFlowError, EmailFlowsArchiveFlowResponse, EmailFlowsFlowPreviewPeopleData, EmailFlowsDuplicateFlowData, EmailFlowsDuplicateFlowError, EmailFlowsDuplicateFlowResponse, EmailCampaignStepsListCampaignStepsData, EmailCampaignStepsCreateCampaignStepData, EmailCampaignStepsCreateCampaignStepError, EmailCampaignStepsCreateCampaignStepResponse, EmailCampaignStepsDeleteCampaignStepData, EmailCampaignStepsDeleteCampaignStepError, EmailCampaignStepsDeleteCampaignStepResponse, EmailCampaignStepsGetCampaignStepData, EmailCampaignStepsUpdateCampaignStepData, EmailCampaignStepsUpdateCampaignStepError, EmailCampaignStepsUpdateCampaignStepResponse, EmailCampaignStepsReorderCampaignStepsData, EmailCampaignStepsReorderCampaignStepsError, EmailCampaignStepsReorderCampaignStepsResponse, EmailCampaignStepsPlanStepBackfillData, EmailCampaignStepsApplyStepBackfillData, EmailCampaignStepsApplyStepBackfillError, EmailCampaignStepsApplyStepBackfillResponse, EmailSendsPreviewEmailData, EmailSendsPreviewEmailError, EmailSendsPreviewEmailResponse, EmailSendsEnqueueEmailSendData, EmailSendsEnqueueEmailSendError, EmailSendsEnqueueEmailSendResponse, EmailSendsEnqueueEmailSendFromCsvData, EmailSendsEnqueueEmailSendFromCsvError, EmailSendsEnqueueEmailSendFromCsvResponse, EmailControlsGetMailControlsData, EmailControlsPauseMarketingData, EmailControlsPauseMarketingError, EmailControlsPauseMarketingResponse, EmailControlsResumeMarketingData, EmailControlsResumeMarketingResponse, EmailExecutionsListEmailExecutionsData, EmailExecutionsListEmailExecutionsError, EmailExecutionsListEmailExecutionsResponse, EmailExecutionsGetEmailExecutionData, EmailExecutionsGetExecutionStatsData, EmailExecutionsRetryEmailExecutionData, EmailExecutionsRetryEmailExecutionError, EmailExecutionsRetryEmailExecutionResponse, EmailExecutionsCancelEmailExecutionData, EmailExecutionsCancelEmailExecutionError, EmailExecutionsCancelEmailExecutionResponse, EmailExecutionsBulkRetryEmailExecutionsData, EmailExecutionsBulkRetryEmailExecutionsError, EmailExecutionsBulkRetryEmailExecutionsResponse, EmailExecutionsBulkCancelEmailExecutionsData, EmailExecutionsBulkCancelEmailExecutionsError, EmailExecutionsBulkCancelEmailExecutionsResponse, EmailExecutionsGetSendRunEngagementData, EmailComebackCampaignsCameBackData, EmailComebackCampaignCameBackData, EmailComebackSendRunCameBackData, EmailComebackTemplateCameBackData, NewsletterListIssuesData, NewsletterCreateIssueData, NewsletterCreateIssueError, NewsletterCreateIssueResponse, NewsletterDeleteDraftsData, NewsletterDeleteDraftsError, NewsletterDeleteDraftsResponse, NewsletterListHealthData, EmailPeopleListPeopleData, EmailPeopleListPeopleError, EmailPeopleListPeopleResponse, EmailPeopleFindPersonData, EmailPeopleGetPersonData, EmailPeopleWithdrawPersonData, EmailPeopleWithdrawPersonError, EmailPeopleWithdrawPersonResponse, EmailPeopleErasePersonData, EmailPeopleErasePersonError, EmailPeopleErasePersonResponse, EmailEnrollmentsListEmailEnrollmentsData, EmailEnrollmentsListEmailEnrollmentsError, EmailEnrollmentsListEmailEnrollmentsResponse, EmailEnrollmentsGetEmailEnrollmentData, EmailEnrollmentsPauseEmailEnrollmentData, EmailEnrollmentsPauseEmailEnrollmentError, EmailEnrollmentsPauseEmailEnrollmentResponse, EmailEnrollmentsResumeEmailEnrollmentData, EmailEnrollmentsResumeEmailEnrollmentError, EmailEnrollmentsResumeEmailEnrollmentResponse, EmailEnrollmentsCancelEmailEnrollmentData, EmailEnrollmentsCancelEmailEnrollmentError, EmailEnrollmentsCancelEmailEnrollmentResponse, MailMediaListMailImagesData, MailMediaUploadMailImageData, MailMediaUploadMailImageError, MailMediaUploadMailImageResponse, MailMediaUpdateMailImageData, MailMediaUpdateMailImageError, MailMediaUpdateMailImageResponse, CampaignsEnrollInCampaignData, CampaignsEnrollInCampaignError, CampaignsEnrollInCampaignResponse, PostmarkWebhookHandlePostmarkWebhookData, PostmarkWebhookHandlePostmarkWebhookResponse, PostmarkWebhookHandlePostmarkWebhook2Data, PostmarkWebhookHandlePostmarkWebhook2Response, PostmarkWebhookHandlePostmarkInboundData, PostmarkWebhookHandlePostmarkInboundResponse, UserSegmentsListUserSegmentsData, UserSegmentsListUserSegmentsError, UserSegmentsListUserSegmentsResponse, UserSegmentsCreateUserSegmentData, UserSegmentsCreateUserSegmentError, UserSegmentsCreateUserSegmentResponse, UserSegmentsDeleteUserSegmentData, UserSegmentsDeleteUserSegmentError, UserSegmentsDeleteUserSegmentResponse, UserSegmentsGetUserSegmentData, UserSegmentsUpdateUserSegmentData, UserSegmentsUpdateUserSegmentError, UserSegmentsUpdateUserSegmentResponse, UserSegmentsGetSegmentCountData, UserSegmentsGetSegmentCountError, UserSegmentsGetSegmentCountResponse, UserSegmentsGetSegmentSampleData, UserSegmentsGetSegmentSampleError, UserSegmentsGetSegmentSampleResponse, UserSegmentsUploadCsvToSegmentData, UserSegmentsUploadCsvToSegmentError, UserSegmentsUploadCsvToSegmentResponse, UserSegmentsClearSegmentMembersData, UserSegmentsClearSegmentMembersError, UserSegmentsClearSegmentMembersResponse, OtaOtaBundleAdoptionData, DbSchemaGetDatabaseSchemaData, OpsGetOpsStatusData, OpsGetOpsPeerStatusData, OpsGetPeerStatusData, OpsMarkBackfillRunManuallyData, OpsMarkBackfillRunManuallyError, OpsMarkBackfillRunManuallyResponse, OpsRetireBackfillData, OpsRetireBackfillError, OpsRetireBackfillResponse, OpsPreviewMigrationData, OpsLocateMigrationData, OpsMigrationRefsData, OpsListOpsJobsData, OpsRequestOpsJobData, OpsRequestOpsJobError, OpsRequestOpsJobResponse, OpsGetOpsRunnerData, OpsGetOpsJobData, OpsGetOpsJobLogData, OpsGetOpsJobLogError, OpsGetOpsJobLogResponse, OpsCancelOpsJobData, OpsCancelOpsJobError, OpsCancelOpsJobResponse, OpsApproveOpsJobData, OpsApproveOpsJobError, OpsApproveOpsJobResponse, OpsRejectOpsJobData, OpsRejectOpsJobError, OpsRejectOpsJobResponse, OpsResumeOpsJobData, OpsResumeOpsJobError, OpsResumeOpsJobResponse, OpsPauseOpsRunnerData, OpsPauseOpsRunnerError, OpsPauseOpsRunnerResponse, OpsUnpauseOpsRunnerData, OpsUnpauseOpsRunnerResponse, DbMigrationsGetCurrentRevisionData, DbMigrationsCreateApprovalRequestData, DbMigrationsCreateApprovalRequestError, DbMigrationsCreateApprovalRequestResponse, DbMigrationsGetApprovalStatusData, DbMigrationsGetApprovalRequestData, DbMigrationsApproveApprovalRequestData, DbMigrationsApproveApprovalRequestError, DbMigrationsApproveApprovalRequestResponse, DbMigrationsRejectApprovalRequestData, DbMigrationsRejectApprovalRequestError, DbMigrationsRejectApprovalRequestResponse, TherapistWaitlistGetRatesData, TherapistWaitlistRecordGroupCoachingConsentsData, TherapistWaitlistRecordGroupCoachingConsentsError, TherapistWaitlistRecordGroupCoachingConsentsResponse, TherapistWaitlistListRatesAdminData, TherapistWaitlistCreateRateData, TherapistWaitlistCreateRateError, TherapistWaitlistCreateRateResponse, TherapistWaitlistDeleteRateData, TherapistWaitlistDeleteRateError, TherapistWaitlistDeleteRateResponse, TherapistWaitlistUpdateRateData, TherapistWaitlistUpdateRateError, TherapistWaitlistUpdateRateResponse, TherapistWaitlistBulkUpsertRatesData, TherapistWaitlistBulkUpsertRatesError, TherapistWaitlistBulkUpsertRatesResponse, TherapistWaitlistListWaitlistUsersData, TherapistWaitlistListWaitlistUsersError, TherapistWaitlistListWaitlistUsersResponse, TherapistWaitlistExportWaitlistUsersCsvData, TherapistWaitlistGetWaitlistStatsData, ConversationsListConversationSessionsData, ConversationsListConversationSessionsError, ConversationsListConversationSessionsResponse, ConversationsCreateConversationSessionData, ConversationsCreateConversationSessionError, ConversationsCreateConversationSessionResponse, ConversationsCreateOrResumeConversationSessionData, ConversationsCreateOrResumeConversationSessionError, ConversationsCreateOrResumeConversationSessionResponse, ConversationsGetConversationSessionData, ConversationsUpdateConversationSessionData, ConversationsUpdateConversationSessionError, ConversationsUpdateConversationSessionResponse, ConversationsGetSessionMessagesData, ConversationsGetSessionMessagesError, ConversationsGetSessionMessagesResponse, ConversationsAddMessageData, ConversationsAddMessageError, ConversationsAddMessageResponse, HealthEntriesListHealthEntriesData, HealthEntriesListHealthEntriesError, HealthEntriesListHealthEntriesResponse, HealthEntriesCreateHealthEntryData, HealthEntriesCreateHealthEntryError, HealthEntriesCreateHealthEntryResponse, HealthEntriesUpsertHealthEntryData, HealthEntriesUpsertHealthEntryError, HealthEntriesUpsertHealthEntryResponse, HealthEntriesDeleteHealthEntryData, HealthEntriesDeleteHealthEntryError, HealthEntriesDeleteHealthEntryResponse, HealthEntriesGetHealthEntryData, HealthEntriesUpdateHealthEntryData, HealthEntriesUpdateHealthEntryError, HealthEntriesUpdateHealthEntryResponse, HealthEntriesBulkDeleteHealthEntriesData, HealthEntriesBulkDeleteHealthEntriesError, HealthEntriesBulkDeleteHealthEntriesResponse, PrepareListMomentsData, PrepareCreateMomentData, PrepareCreateMomentError, PrepareCreateMomentResponse, PrepareDeleteMomentData, PrepareDeleteMomentError, PrepareDeleteMomentResponse, PrepareGetMomentData, PrepareUpdateMomentData, PrepareUpdateMomentError, PrepareUpdateMomentResponse, SupportRelationshipsGetSupportRelationshipsData, SupportRelationshipsCreateSupportRelationshipData, SupportRelationshipsCreateSupportRelationshipError, SupportRelationshipsCreateSupportRelationshipResponse, SupportRelationshipsAcceptSupporterInvitationPageData, SupportRelationshipsAcceptSupporterInvitationData, SupportRelationshipsAcceptSupporterInvitationError, SupportRelationshipsAcceptSupporterInvitationResponse, SupportRelationshipsDeclineSupporterInvitationPageData, SupportRelationshipsDeclineSupporterInvitationData, SupportRelationshipsDeclineSupporterInvitationError, SupportRelationshipsDeclineSupporterInvitationResponse, SupportRelationshipsUnsubscribeSupporterNotificationsData, SupportRelationshipsUnsubscribeSupporterNotificationsPostData, SupportRelationshipsUnsubscribeSupporterNotificationsPostError, SupportRelationshipsUnsubscribeSupporterNotificationsPostResponse, SupportRelationshipsGetSupportingRelationshipsData, SupportRelationshipsConfirmSupportRelationshipData, SupportRelationshipsConfirmSupportRelationshipError, SupportRelationshipsConfirmSupportRelationshipResponse, SupportRelationshipsDeleteSupportRelationshipData, SupportRelationshipsDeleteSupportRelationshipError, SupportRelationshipsDeleteSupportRelationshipResponse, SupportRelationshipsUpdateSupportRelationshipData, SupportRelationshipsUpdateSupportRelationshipError, SupportRelationshipsUpdateSupportRelationshipResponse, SupporterGetSupporterDashboardData, SupporterGetUserInsightsData, SupporterDeleteSupporterAccountData, SupporterDeleteSupporterAccountResponse, SupporterGetSupporterAccountData, SupporterUpdateSupporterPreferencesData, SupporterUpdateSupporterPreferencesError, SupporterUpdateSupporterPreferencesResponse, CommunityGetFeedData, CommunityGetFeedError, CommunityGetFeedResponse, CommunityDeletePostData, CommunityDeletePostError, CommunityDeletePostResponse, CommunityGetPostData, CommunityUpdatePostData, CommunityUpdatePostError, CommunityUpdatePostResponse, CommunityGetPostCommentsData, CommunityGetPostCommentsError, CommunityGetPostCommentsResponse, CommunityCreatePostData, CommunityCreatePostError, CommunityCreatePostResponse, CommunityUploadMediaData, CommunityUploadMediaError, CommunityUploadMediaResponse, CommunityAttachYoutubeMediaData, CommunityAttachYoutubeMediaError, CommunityAttachYoutubeMediaResponse, CommunityCreateVideoUploadData, CommunityCreateVideoUploadError, CommunityCreateVideoUploadResponse, CommunityFinalizeVideoMediaData, CommunityFinalizeVideoMediaError, CommunityFinalizeVideoMediaResponse, CommunityCreateCommentData, CommunityCreateCommentError, CommunityCreateCommentResponse, CommunityBoostPostData, CommunityBoostPostError, CommunityBoostPostResponse, CommunityUnboostPostData, CommunityUnboostPostError, CommunityUnboostPostResponse, CommunityArchivePostData, CommunityArchivePostError, CommunityArchivePostResponse, CommunityRestorePostData, CommunityRestorePostError, CommunityRestorePostResponse, CommunitySetPostTopicData, CommunitySetPostTopicError, CommunitySetPostTopicResponse, CommunityArchiveCommentData, CommunityArchiveCommentError, CommunityArchiveCommentResponse, CommunityUpdateCommentData, CommunityUpdateCommentError, CommunityUpdateCommentResponse, CommunitySetPostReactionData, CommunitySetPostReactionError, CommunitySetPostReactionResponse, CommunitySetCommentReactionData, CommunitySetCommentReactionError, CommunitySetCommentReactionResponse, CommunitySetPostSavedData, CommunitySetPostSavedError, CommunitySetPostSavedResponse, CommunityGetSavedData, CommunityGetSavedError, CommunityGetSavedResponse, CommunityReportContentData, CommunityReportContentError, CommunityReportContentResponse, CommunityGetUserProfileData, CommunityGetUserPostsData, CommunityGetUserPostsError, CommunityGetUserPostsResponse, CommunityUpdateMyProfileData, CommunityUpdateMyProfileError, CommunityUpdateMyProfileResponse, CommunityListTopicsData, CommunityCreateTopicData, CommunityCreateTopicError, CommunityCreateTopicResponse, CommunityDeleteTopicData, CommunityDeleteTopicError, CommunityDeleteTopicResponse, CommunityUpdateTopicData, CommunityUpdateTopicError, CommunityUpdateTopicResponse, CommunityReorderTopicsData, CommunityReorderTopicsError, CommunityReorderTopicsResponse, CommunityListChannelVideosData, CommunitySetChannelVideosData, CommunitySetChannelVideosError, CommunitySetChannelVideosResponse, CommunityGetActivityData, CommunityDismissActivityRowData, CommunityDismissActivityRowError, CommunityDismissActivityRowResponse, CommunityDismissAllActivityData, CommunityDismissAllActivityResponse, CommunityGetPushPreferenceData, CommunitySetPushPreferenceData, CommunitySetPushPreferenceError, CommunitySetPushPreferenceResponse, UserStateReadMyStateData, UserStateWriteMyStateData, UserStateWriteMyStateError, UserStateWriteMyStateResponse, PaywallEventsRecordMyPaywallEventsData, PaywallEventsRecordMyPaywallEventsError, PaywallEventsRecordMyPaywallEventsResponse, ActiveDaysRecordMyActiveDaysData, ActiveDaysRecordMyActiveDaysError, ActiveDaysRecordMyActiveDaysResponse, PrivateSendCustomNotificationData, PrivateSendCustomNotificationError, PrivateSendCustomNotificationResponse } from '../types.gen';
import { client } from '../client.gen';

export type QueryKey<TOptions extends Options> = [
    Pick<TOptions, 'baseUrl' | 'body' | 'headers' | 'path' | 'query'> & {
        _id: string;
        _infinite?: boolean;
        tags?: ReadonlyArray<string>;
    }
];

const createQueryKey = <TOptions extends Options>(id: string, options?: TOptions, infinite?: boolean, tags?: ReadonlyArray<string>): [
    QueryKey<TOptions>[0]
] => {
    const params: QueryKey<TOptions>[0] = { _id: id, baseUrl: options?.baseUrl || (options?.client ?? client).getConfig().baseUrl } as QueryKey<TOptions>[0];
    if (infinite) {
        params._infinite = infinite;
    }
    if (tags) {
        params.tags = tags;
    }
    if (options?.body) {
        params.body = options.body;
    }
    if (options?.headers) {
        params.headers = options.headers;
    }
    if (options?.path) {
        params.path = options.path;
    }
    if (options?.query) {
        params.query = options.query;
    }
    return [
        params
    ];
};

export const appStatusGetAppStatusQueryKey = (options?: Options<AppStatusGetAppStatusData>) => createQueryKey('appStatusGetAppStatus', options);

/**
 * Get App Status
 * Checked on every app cold start and every foreground.
 *
 * Returns whether the app is operational, under maintenance, or requires an
 * update. Auth is OPTIONAL and the endpoint must keep working without it — a
 * user who cannot sign in is exactly who a maintenance notice is for. A token,
 * when present, is what makes segment targeting possible: a kill-switch rule
 * naming a segment matches only its current members, so a prompt can be
 * rehearsed on your own account before it goes to everyone.
 *
 * Every uncertainty resolves to doing nothing: no token, an archived or
 * empty segment, an unknown platform or version — the rule does not match.
 * Blocking or nagging the wrong people is the harmful failure here; showing
 * nothing is not.
 *
 * ``platform`` and ``app_version`` are OPTIONAL for the same reason. They
 * only decide the two version-gated sections; maintenance does not depend on a
 * build at all. A caller who omits them — an
 * uptime check, a curl, a client we have not written yet — gets the answer to
 * the question they can be answered, and is never told to update, because
 * there is no version to compare against. Refusing the whole request with a
 * 422 was the one behaviour this endpoint must not have: it is the endpoint
 * you reach for when everything else is broken.
 *
 * ``response_model_exclude_none=True`` keeps the common case small. When
 * everything is off this is ~130 bytes instead of 311 of nulls, on every
 * foreground of every install. The section objects are still present, so the
 * client's optional chaining is unaffected.
 */
export const appStatusGetAppStatusOptions = (options?: Options<AppStatusGetAppStatusData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await AppStatus.appStatusGetAppStatus({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: appStatusGetAppStatusQueryKey(options)
    });
};

/**
 * Cancel Deletion
 * Confirm cancellation of a pending account deletion (resurrection).
 *
 * Ownership is proven by the ``recovery_token`` — minted only after a
 * successful auth for THIS account while it had a pending deletion. We
 * re-validate the grace window server-side and clear the markers atomically.
 * Replay-safe: once cleared, the account no longer has a pending deletion, so
 * a reused token is rejected. On success the user is logged back in.
 */
export const authCancelDeletionMutation = (options?: Partial<Options<AuthCancelDeletionData>>): UseMutationOptions<AuthCancelDeletionResponse, AuthCancelDeletionError, Options<AuthCancelDeletionData>> => {
    const mutationOptions: UseMutationOptions<AuthCancelDeletionResponse, AuthCancelDeletionError, Options<AuthCancelDeletionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await Auth.authCancelDeletion({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Login
 * OAuth2 compatible token login, get an access token for future requests.
 * If 2FA is enabled, returns a two-factor token instead.
 * If email not verified, sends verification email and returns message.
 * If the account has a pending deletion within grace, returns a
 * PendingDeletionToken so the app can offer to cancel the deletion.
 */
export const authLoginMutation = (options?: Partial<Options<AuthLoginData>>): UseMutationOptions<AuthLoginResponse, AuthLoginError, Options<AuthLoginData>> => {
    const mutationOptions: UseMutationOptions<AuthLoginResponse, AuthLoginError, Options<AuthLoginData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await Auth.authLogin({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Refresh Access Token
 * Refresh access token using HTTP-only cookie (web) or request body (mobile)
 */
export const authRefreshAccessTokenMutation = (options?: Partial<Options<AuthRefreshAccessTokenData>>): UseMutationOptions<AuthRefreshAccessTokenResponse, AuthRefreshAccessTokenError, Options<AuthRefreshAccessTokenData>> => {
    const mutationOptions: UseMutationOptions<AuthRefreshAccessTokenResponse, AuthRefreshAccessTokenError, Options<AuthRefreshAccessTokenData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await Auth.authRefreshAccessToken({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Logout
 * Revoke all refresh tokens for the current user (logout from all devices)
 */
export const authLogoutMutation = (options?: Partial<Options<AuthLogoutData>>): UseMutationOptions<AuthLogoutResponse, DefaultError, Options<AuthLogoutData>> => {
    const mutationOptions: UseMutationOptions<AuthLogoutResponse, DefaultError, Options<AuthLogoutData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await Auth.authLogout({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Test Token
 * Test access token
 */
export const authTestTokenMutation = (options?: Partial<Options<AuthTestTokenData>>): UseMutationOptions<AuthTestTokenResponse, DefaultError, Options<AuthTestTokenData>> => {
    const mutationOptions: UseMutationOptions<AuthTestTokenResponse, DefaultError, Options<AuthTestTokenData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await Auth.authTestToken({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Password Recovery
 * Send password recovery email.
 * Always returns success message, even if user doesn't exist (prevents user enumeration).
 */
export const authPasswordRecoveryMutation = (options?: Partial<Options<AuthPasswordRecoveryData>>): UseMutationOptions<AuthPasswordRecoveryResponse, AuthPasswordRecoveryError, Options<AuthPasswordRecoveryData>> => {
    const mutationOptions: UseMutationOptions<AuthPasswordRecoveryResponse, AuthPasswordRecoveryError, Options<AuthPasswordRecoveryData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await Auth.authPasswordRecovery({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Reset Password
 * Reset password
 */
export const authResetPasswordMutation = (options?: Partial<Options<AuthResetPasswordData>>): UseMutationOptions<AuthResetPasswordResponse, AuthResetPasswordError, Options<AuthResetPasswordData>> => {
    const mutationOptions: UseMutationOptions<AuthResetPasswordResponse, AuthResetPasswordError, Options<AuthResetPasswordData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await Auth.authResetPassword({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Request Magic Link
 * Unified passwordless magic link. There is no separate "login" vs "sign up" —
 * the caller always sends just an email, and the intent is decided here from
 * (a) whether the email already belongs to an account and (b) whether the
 * caller is an authenticated guest (anonymous) sending their bearer token:
 *
 * - email belongs to an existing account  → LOGIN to it
 * - caller is a guest, email is free       → CONVERT the guest (keep progress)
 * - no account, no guest                   → SIGNUP (create on verify)
 *
 * The actual mutation happens in /magic-link/verify when the link is tapped.
 * The response is identical in every case (no account-existence leak), with
 * one deliberate exception: a throttled request answers 429 with Retry-After.
 * That says something about the caller's own recent requests, never about
 * whether the address has an account.
 *
 * An address holding a static login code is answered without sending anything
 * at all, and says so with `code_only` -- see the comment at that branch.
 *
 * `intent="login"` is the exception to all of the above: it needs a session,
 * and an address with no account answers 404 `no_account` and sends nothing.
 */
export const authRequestMagicLinkMutation = (options?: Partial<Options<AuthRequestMagicLinkData>>): UseMutationOptions<AuthRequestMagicLinkResponse, AuthRequestMagicLinkError, Options<AuthRequestMagicLinkData>> => {
    const mutationOptions: UseMutationOptions<AuthRequestMagicLinkResponse, AuthRequestMagicLinkError, Options<AuthRequestMagicLinkData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await Auth.authRequestMagicLink({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Request Link Email
 * Associate `email` with the signed-in caller's account. Used by the in-app
 * email asks (onboarding, post-purchase, the existing-user screen) and by the
 * recovery flow (condri://auth/link-email).
 *
 * Verification-by-construction: an email is NEVER attached here. Every
 * outcome is an email to the typed address, and the attach happens only when
 * a link (or the code) in that email is redeemed: proof the inbox is theirs.
 *
 * - email is free (or unverified on caller)  → send a magic link carrying a
 * convert intent for the
 * caller; redeeming it
 * attaches the address and
 * stamps dt_email_verified.
 * - email already verified on caller         → no-op success.
 * - email belongs to another live account    → email that address a
 * confirmation link; tapping
 * it merges the older
 * account's data into the
 * caller's account.
 *
 * We always return a generic 200 to avoid leaking which emails exist: every
 * branch that sends anything answers with the same words.
 *
 * `consents` (the marketing box, the welcome notice) are recorded against the
 * typed address with the caller's id and only take effect once that same
 * account redeems the email (`contact.confirm_app_grants`).
 */
export const authRequestLinkEmailMutation = (options?: Partial<Options<AuthRequestLinkEmailData>>): UseMutationOptions<AuthRequestLinkEmailResponse, AuthRequestLinkEmailError, Options<AuthRequestLinkEmailData>> => {
    const mutationOptions: UseMutationOptions<AuthRequestLinkEmailResponse, AuthRequestLinkEmailError, Options<AuthRequestLinkEmailData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await Auth.authRequestLinkEmail({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Confirm Link Email
 * Confirm a link-email merge.
 *
 * SECURITY (account-merge takeover fix): a merge moves the SOURCE account's
 * entire dataset into the TARGET account and then soft-deletes the source.
 * Previously this endpoint was public and any recipient tap completed the
 * merge — so an attacker (target) could name a victim's email and, on the
 * victim's single click, receive the victim's data. The click alone is not
 * consent to *donate* your data into someone else's account.
 *
 * Now the confirming party must be **authenticated as the source account**
 * (the owner of the emailed address). That is the account whose data moves,
 * so it — and only it — can authorize the move. An attacker cannot satisfy
 * this because they don't control the victim's session. The token still binds
 * (source, target) so ids can't be swapped, and it is single-use.
 */
export const authConfirmLinkEmailMutation = (options?: Partial<Options<AuthConfirmLinkEmailData>>): UseMutationOptions<AuthConfirmLinkEmailResponse, AuthConfirmLinkEmailError, Options<AuthConfirmLinkEmailData>> => {
    const mutationOptions: UseMutationOptions<AuthConfirmLinkEmailResponse, AuthConfirmLinkEmailError, Options<AuthConfirmLinkEmailData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await Auth.authConfirmLinkEmail({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Verify Magic Link
 * Verify a magic link token and return an access token.
 * If 2FA is enabled, returns a two-factor token instead.
 */
export const authVerifyMagicLinkMutation = (options?: Partial<Options<AuthVerifyMagicLinkData>>): UseMutationOptions<AuthVerifyMagicLinkResponse, AuthVerifyMagicLinkError, Options<AuthVerifyMagicLinkData>> => {
    const mutationOptions: UseMutationOptions<AuthVerifyMagicLinkResponse, AuthVerifyMagicLinkError, Options<AuthVerifyMagicLinkData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await Auth.authVerifyMagicLink({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Cloudflare Access Login
 * Admin panel sign-in on the Cloudflare Access token for the panel host.
 *
 * Stands in for the magic link only: the account must already exist and hold
 * panel scopes, and the session (TOTP step included) is the one a magic link
 * for the same account would grant. 404 until CF_ACCESS_* is configured.
 */
export const authCloudflareAccessLoginMutation = (options?: Partial<Options<AuthCloudflareAccessLoginData>>): UseMutationOptions<AuthCloudflareAccessLoginResponse, AuthCloudflareAccessLoginError, Options<AuthCloudflareAccessLoginData>> => {
    const mutationOptions: UseMutationOptions<AuthCloudflareAccessLoginResponse, AuthCloudflareAccessLoginError, Options<AuthCloudflareAccessLoginData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await Auth.authCloudflareAccessLogin({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Redeem Login Code
 * Redeem the 6-digit code from a magic-link email.
 *
 * Same grant as tapping the link — login, passwordless signup, or guest
 * conversion, whichever the email carried — for people reading the email on
 * a different device than the one signing in, and for inboxes whose
 * security scanners prefetch and burn one-time links.
 *
 * Guardrails: the stored hash is compared in constant time; a code dies
 * after 5 wrong attempts, on expiry, when its paired link is used, or when
 * a newer code is issued for the same email; failures are rate limited per
 * email and per IP off auth_events, like magic-link verification. Every
 * failure is the same generic 400 so nothing leaks about which codes exist;
 * exceeding the rate limit answers 429 with Retry-After, the one distinction
 * the client needs to stop asking someone to retype.
 *
 * One address in a thousand also carries a static code -- the permanent
 * credential we hand to App Store and Play reviewers, who cannot open the
 * inbox this email would land in. It is checked first, below the rate limits
 * and above everything else. See models.database.a.StaticLoginCode.
 */
export const authRedeemLoginCodeMutation = (options?: Partial<Options<AuthRedeemLoginCodeData>>): UseMutationOptions<AuthRedeemLoginCodeResponse, AuthRedeemLoginCodeError, Options<AuthRedeemLoginCodeData>> => {
    const mutationOptions: UseMutationOptions<AuthRedeemLoginCodeResponse, AuthRedeemLoginCodeError, Options<AuthRedeemLoginCodeData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await Auth.authRedeemLoginCode({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Setup Totp
 * Setup TOTP for the current user
 */
export const authSetupTotpMutation = (options?: Partial<Options<AuthSetupTotpData>>): UseMutationOptions<AuthSetupTotpResponse, DefaultError, Options<AuthSetupTotpData>> => {
    const mutationOptions: UseMutationOptions<AuthSetupTotpResponse, DefaultError, Options<AuthSetupTotpData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await Auth.authSetupTotp({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const authGetTotpQrcodeQueryKey = (options?: Options<AuthGetTotpQrcodeData>) => createQueryKey('authGetTotpQrcode', options);

/**
 * Get Totp Qrcode
 * Get a QR code for TOTP setup
 */
export const authGetTotpQrcodeOptions = (options?: Options<AuthGetTotpQrcodeData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await Auth.authGetTotpQrcode({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: authGetTotpQrcodeQueryKey(options)
    });
};

/**
 * Verify Totp Setup
 * Verify TOTP setup and enable it for the user
 */
export const authVerifyTotpSetupMutation = (options?: Partial<Options<AuthVerifyTotpSetupData>>): UseMutationOptions<AuthVerifyTotpSetupResponse, AuthVerifyTotpSetupError, Options<AuthVerifyTotpSetupData>> => {
    const mutationOptions: UseMutationOptions<AuthVerifyTotpSetupResponse, AuthVerifyTotpSetupError, Options<AuthVerifyTotpSetupData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await Auth.authVerifyTotpSetup({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Verify Totp
 * Verify TOTP code and complete the login process
 */
export const authVerifyTotpMutation = (options?: Partial<Options<AuthVerifyTotpData>>): UseMutationOptions<AuthVerifyTotpResponse, AuthVerifyTotpError, Options<AuthVerifyTotpData>> => {
    const mutationOptions: UseMutationOptions<AuthVerifyTotpResponse, AuthVerifyTotpError, Options<AuthVerifyTotpData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await Auth.authVerifyTotp({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Register User
 * Create new user without the need to be logged in.
 * Only allowed if ALLOW_USER_REGISTRATION is enabled.
 *
 * Flow:
 * 1. Check if user already exists -> handle duplicate signup
 * 2. Create new user
 * 3. Check email verification requirement -> return tokens or message accordingly
 * 4. Send magic link email if ENABLE_MAGIC_LINK_ON_SIGNUP is True
 * 5. Emit signup event (campaign enrollment handled by ENABLE_CAMPAIGN_EVENT_HANDLERS)
 *
 * Settings:
 * - ENABLE_MAGIC_LINK_ON_SIGNUP: Controls whether magic link email is sent.
 * - REQUIRE_EMAIL_VERIFICATION: Controls whether email verification is required before login.
 * - ENABLE_CAMPAIGN_EVENT_HANDLERS: Controls whether campaign enrollment happens via events.
 */
export const authRegisterUserMutation = (options?: Partial<Options<AuthRegisterUserData>>): UseMutationOptions<AuthRegisterUserResponse, AuthRegisterUserError, Options<AuthRegisterUserData>> => {
    const mutationOptions: UseMutationOptions<AuthRegisterUserResponse, AuthRegisterUserError, Options<AuthRegisterUserData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await Auth.authRegisterUser({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Disable Totp
 * Disable TOTP for the current user
 */
export const authDisableTotpMutation = (options?: Partial<Options<AuthDisableTotpData>>): UseMutationOptions<AuthDisableTotpResponse, AuthDisableTotpError, Options<AuthDisableTotpData>> => {
    const mutationOptions: UseMutationOptions<AuthDisableTotpResponse, AuthDisableTotpError, Options<AuthDisableTotpData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await Auth.authDisableTotp({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Register Biometric Token
 * Register a biometric token for the current user.
 */
export const authRegisterBiometricTokenMutation = (options?: Partial<Options<AuthRegisterBiometricTokenData>>): UseMutationOptions<AuthRegisterBiometricTokenResponse, AuthRegisterBiometricTokenError, Options<AuthRegisterBiometricTokenData>> => {
    const mutationOptions: UseMutationOptions<AuthRegisterBiometricTokenResponse, AuthRegisterBiometricTokenError, Options<AuthRegisterBiometricTokenData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await Auth.authRegisterBiometricToken({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Revoke Biometric Token
 * Revoke the current user's biometric token (disable biometric re-login).
 */
export const authRevokeBiometricTokenMutation = (options?: Partial<Options<AuthRevokeBiometricTokenData>>): UseMutationOptions<AuthRevokeBiometricTokenResponse, DefaultError, Options<AuthRevokeBiometricTokenData>> => {
    const mutationOptions: UseMutationOptions<AuthRevokeBiometricTokenResponse, DefaultError, Options<AuthRevokeBiometricTokenData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await Auth.authRevokeBiometricToken({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Login With Biometric
 * Login using a biometric token.
 *
 * A within-grace pending-deletion account is allowed through to token
 * verification; on success it gets a PendingDeletionToken (offer to cancel)
 * rather than a session.
 */
export const authLoginWithBiometricMutation = (options?: Partial<Options<AuthLoginWithBiometricData>>): UseMutationOptions<AuthLoginWithBiometricResponse, AuthLoginWithBiometricError, Options<AuthLoginWithBiometricData>> => {
    const mutationOptions: UseMutationOptions<AuthLoginWithBiometricResponse, AuthLoginWithBiometricError, Options<AuthLoginWithBiometricData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await Auth.authLoginWithBiometric({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const authPingAuthQueryKey = (options?: Options<AuthPingAuthData>) => createQueryKey('authPingAuth', options);

/**
 * Ping Auth
 * Ping endpoint to verify authentication token is valid.
 * Returns basic user info if token is valid, 401 if invalid.
 */
export const authPingAuthOptions = (options?: Options<AuthPingAuthData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await Auth.authPingAuth({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: authPingAuthQueryKey(options)
    });
};

/**
 * Device Auth
 * Authenticate or create an anonymous user via device credentials.
 *
 * - If device_id is not found, creates a new anonymous user and returns tokens.
 * - If device_id exists, verifies the device_secret and returns tokens.
 * - With `expected_user_id`, never creates: an unbound device, or one bound to
 * anyone else, gets 409 `device_not_bound_to_user` and nothing is written.
 */
export const authDeviceAuthMutation = (options?: Partial<Options<AuthDeviceAuthData>>): UseMutationOptions<AuthDeviceAuthResponse, AuthDeviceAuthError, Options<AuthDeviceAuthData>> => {
    const mutationOptions: UseMutationOptions<AuthDeviceAuthResponse, AuthDeviceAuthError, Options<AuthDeviceAuthData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await Auth.authDeviceAuth({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Device Bind
 * Bind this device to the signed-in member, so that pinned device recovery
 * (`/auth/device` with `expected_user_id`) can sign them back in after the
 * app loses their session. Guests are bound when they are created.
 *
 * The same proof as `/biometric/register`: the member's own session. The
 * device can only ever sign in the account that bound it. One device per
 * member, so a newer phone's bind replaces the last. A device another
 * account holds is never moved (409): that account's way back is this
 * device, and only guest merge releases it.
 */
export const authDeviceBindMutation = (options?: Partial<Options<AuthDeviceBindData>>): UseMutationOptions<AuthDeviceBindResponse, AuthDeviceBindError, Options<AuthDeviceBindData>> => {
    const mutationOptions: UseMutationOptions<AuthDeviceBindResponse, AuthDeviceBindError, Options<AuthDeviceBindData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await Auth.authDeviceBind({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Device Convert
 * Convert an anonymous (device-auth) user to a regular account.
 *
 * Sets email + password on the existing user row. All data stays linked
 * to the same user_id.
 *
 * The address is typed, not proven, so this does not register a member: that
 * happens when the address is first verified (``user_crud.register_member``).
 */
export const authDeviceConvertMutation = (options?: Partial<Options<AuthDeviceConvertData>>): UseMutationOptions<AuthDeviceConvertResponse, AuthDeviceConvertError, Options<AuthDeviceConvertData>> => {
    const mutationOptions: UseMutationOptions<AuthDeviceConvertResponse, AuthDeviceConvertError, Options<AuthDeviceConvertData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await Auth.authDeviceConvert({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const oauthGoogleLoginQueryKey = (options: Options<OauthGoogleLoginData>) => createQueryKey('oauthGoogleLogin', options);

/**
 * Google Login
 */
export const oauthGoogleLoginOptions = (options: Options<OauthGoogleLoginData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await Oauth.oauthGoogleLogin({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: oauthGoogleLoginQueryKey(options)
    });
};

export const oauthGoogleCallbackQueryKey = (options: Options<OauthGoogleCallbackData>) => createQueryKey('oauthGoogleCallback', options);

/**
 * Google Callback
 */
export const oauthGoogleCallbackOptions = (options: Options<OauthGoogleCallbackData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await Oauth.oauthGoogleCallback({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: oauthGoogleCallbackQueryKey(options)
    });
};

/**
 * Google Mobile Callback
 * Verify Google authorization code and create/login user for mobile apps.
 *
 * Google Sign In flow for mobile:
 * 1. Client gets authorization code from Google via expo-auth-session
 * 2. Client sends code to this endpoint
 * 3. Backend exchanges code for Google tokens
 * 4. Backend verifies Google ID token
 * 5. Extract user ID (sub) from verified token
 * 6. Check if user exists by google_oauth_id
 * 7. If not found and email provided, try to link to existing email account
 * 8. Create new user if needed
 * 9. Return our JWT access token
 */
export const oauthGoogleMobileCallbackMutation = (options?: Partial<Options<OauthGoogleMobileCallbackData>>): UseMutationOptions<OauthGoogleMobileCallbackResponse, OauthGoogleMobileCallbackError, Options<OauthGoogleMobileCallbackData>> => {
    const mutationOptions: UseMutationOptions<OauthGoogleMobileCallbackResponse, OauthGoogleMobileCallbackError, Options<OauthGoogleMobileCallbackData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await Oauth.oauthGoogleMobileCallback({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Apple Callback
 * Verify Apple identity token and create/login user.
 *
 * Apple Sign In flow:
 * 1. Client gets identity_token from Apple SDK
 * 2. Client sends identity_token to this endpoint
 * 3. Backend verifies token with Apple's public keys
 * 4. Extract user ID (sub) from verified token
 * 5. Check if user exists by apple_oauth_id
 * 6. If not found and email provided, try to link to existing email account
 * 7. Create new user if needed
 * 8. Return our JWT access token
 *
 * Note: Apple only provides email/name on FIRST sign-in. Subsequent sign-ins
 * will only have the identity_token with the stable user ID (sub).
 */
export const oauthAppleCallbackMutation = (options?: Partial<Options<OauthAppleCallbackData>>): UseMutationOptions<OauthAppleCallbackResponse, OauthAppleCallbackError, Options<OauthAppleCallbackData>> => {
    const mutationOptions: UseMutationOptions<OauthAppleCallbackResponse, OauthAppleCallbackError, Options<OauthAppleCallbackData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await Oauth.oauthAppleCallback({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const oauthGetOauthConfigQueryKey = (options?: Options<OauthGetOauthConfigData>) => createQueryKey('oauthGetOauthConfig', options);

/**
 * Get Oauth Config
 * Get OAuth configuration for mobile clients.
 *
 * Returns public OAuth client IDs (safe to expose).
 * Used by mobile apps to initiate OAuth flows.
 *
 * If platform is provided ("ios" or "android"), returns the platform-specific client ID.
 */
export const oauthGetOauthConfigOptions = (options?: Options<OauthGetOauthConfigData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await Oauth.oauthGetOauthConfig({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: oauthGetOauthConfigQueryKey(options)
    });
};

export const oauthTestOauthConfigQueryKey = (options?: Options<OauthTestOauthConfigData>) => createQueryKey('oauthTestOauthConfig', options);

/**
 * Test Oauth Config
 * Test endpoint to verify OAuth configuration for localhost testing.
 */
export const oauthTestOauthConfigOptions = (options?: Options<OauthTestOauthConfigData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await Oauth.oauthTestOauthConfig({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: oauthTestOauthConfigQueryKey(options)
    });
};

/**
 * Delete User Me
 * Request deletion of your own account.
 *
 * This is a SOFT delete plus offboarding, not an immediate erasure. It marks
 * the account for deletion (recoverable during a grace window by logging back
 * in), writes a PII-free audit tombstone, kills all sessions, cancels any live
 * Stripe subscription at period end, and emails a confirmation with the right
 * place to cancel a store-managed subscription. The daily grace cron performs
 * the irreversible erasure after the grace window, once nothing still bills
 * the account.
 */
export const usersDeleteUserMeMutation = (options?: Partial<Options<UsersDeleteUserMeData>>): UseMutationOptions<UsersDeleteUserMeResponse, DefaultError, Options<UsersDeleteUserMeData>> => {
    const mutationOptions: UseMutationOptions<UsersDeleteUserMeResponse, DefaultError, Options<UsersDeleteUserMeData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await Users.usersDeleteUserMe({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const usersReadUserMeQueryKey = (options?: Options<UsersReadUserMeData>) => createQueryKey('usersReadUserMe', options);

/**
 * Read User Me
 * Get current user.
 *
 * ``is_onboarded`` is derived server-side from the onboarding marker entry —
 * the single source of truth the app and web funnel share — so a fresh device
 * (whose local copy hasn't synced) gets the authoritative answer here rather
 * than inferring it from an empty local database.
 */
export const usersReadUserMeOptions = (options?: Options<UsersReadUserMeData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await Users.usersReadUserMe({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: usersReadUserMeQueryKey(options)
    });
};

/**
 * Update User Me
 * Update own user.
 *
 * Changing the email is a security-sensitive step-up action: it re-points the
 * login identity and feeds the (previously verified) address into downstream
 * SSO tokens (Octopus/beehiiv). So when the email changes we (a) require the
 * current password to prove it's really the account owner, (b) reset the
 * verified flag and (c) send a fresh verification email. Name/metadata-only
 * updates are unaffected.
 */
export const usersUpdateUserMeMutation = (options?: Partial<Options<UsersUpdateUserMeData>>): UseMutationOptions<UsersUpdateUserMeResponse, UsersUpdateUserMeError, Options<UsersUpdateUserMeData>> => {
    const mutationOptions: UseMutationOptions<UsersUpdateUserMeResponse, UsersUpdateUserMeError, Options<UsersUpdateUserMeData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await Users.usersUpdateUserMe({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const usersGetMyBillingIdQueryKey = (options?: Options<UsersGetMyBillingIdData>) => createQueryKey('usersGetMyBillingId', options);

/**
 * Get My Billing Id
 * The pseudonym to hand a payment provider for this account.
 *
 * The app calls Purchases.logIn() with THIS, never a.users.id — so the real
 * account id is not what RevenueCat/Adapty stores.
 *
 * It is NOT safe to assume this equals a.users.id. Accounts that existed when
 * the 20260722_090000 migration ran carry billing_id == user_id as a legacy
 * alias, but every account created since gets an opaque uuid4, so the client
 * must use whatever this returns and must not substitute the account id when
 * the call fails — RevenueCat would mint a second customer for the same person
 * and never merge the two. See RevenueCatService.fetchBillingId.
 *
 * get_or_create_current self-heals if the account somehow has no identity yet.
 */
export const usersGetMyBillingIdOptions = (options?: Options<UsersGetMyBillingIdData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await Users.usersGetMyBillingId({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: usersGetMyBillingIdQueryKey(options)
    });
};

export const usersGetUserAccessQueryKey = (options?: Options<UsersGetUserAccessData>) => createQueryKey('usersGetUserAccess', options);

/**
 * Get User Access
 * Get user access level and permissions.
 */
export const usersGetUserAccessOptions = (options?: Options<UsersGetUserAccessData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await Users.usersGetUserAccess({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: usersGetUserAccessQueryKey(options)
    });
};

/**
 * Update Password Me
 * Update own password.
 */
export const usersUpdatePasswordMeMutation = (options?: Partial<Options<UsersUpdatePasswordMeData>>): UseMutationOptions<UsersUpdatePasswordMeResponse, UsersUpdatePasswordMeError, Options<UsersUpdatePasswordMeData>> => {
    const mutationOptions: UseMutationOptions<UsersUpdatePasswordMeResponse, UsersUpdatePasswordMeError, Options<UsersUpdatePasswordMeData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await Users.usersUpdatePasswordMe({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update Device Metadata
 * Update device metadata (device_type, is_test, app_version, and device details) in app_metadata.
 *
 * This is a dedicated endpoint for device-specific metadata updates that should
 * only happen once per user per device. All fields are optional - only provided
 * fields will be updated.
 *
 * This endpoint is idempotent and designed to be called during app initialization
 * to sync device type, test flight status, app version, and detailed device information.
 */
export const usersUpdateDeviceMetadataMutation = (options?: Partial<Options<UsersUpdateDeviceMetadataData>>): UseMutationOptions<UsersUpdateDeviceMetadataResponse, UsersUpdateDeviceMetadataError, Options<UsersUpdateDeviceMetadataData>> => {
    const mutationOptions: UseMutationOptions<UsersUpdateDeviceMetadataResponse, UsersUpdateDeviceMetadataError, Options<UsersUpdateDeviceMetadataData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await Users.usersUpdateDeviceMetadata({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Record Install Attribution
 * Record the measurement partner's verdict on this install (guests too).
 *
 * Idempotent: first report per (user, provider) wins, a repeat is a 200 and a
 * no-op, so the app can retry until it sees one. A failure to store is a 503
 * so the app keeps its copy and tries again next launch.
 */
export const usersRecordInstallAttributionMutation = (options?: Partial<Options<UsersRecordInstallAttributionData>>): UseMutationOptions<UsersRecordInstallAttributionResponse, UsersRecordInstallAttributionError, Options<UsersRecordInstallAttributionData>> => {
    const mutationOptions: UseMutationOptions<UsersRecordInstallAttributionResponse, UsersRecordInstallAttributionError, Options<UsersRecordInstallAttributionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await Users.usersRecordInstallAttribution({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Report Permission Change
 * Record that an OS permission (push, or iOS ATT) changed on this device.
 *
 * The app reports only when what the OS says differs from what it last
 * reported, and retries until it gets a 2xx, so this is idempotent: a report
 * that repeats the latest state for this device and kind writes nothing.
 */
export const usersReportPermissionChangeMutation = (options?: Partial<Options<UsersReportPermissionChangeData>>): UseMutationOptions<UsersReportPermissionChangeResponse, UsersReportPermissionChangeError, Options<UsersReportPermissionChangeData>> => {
    const mutationOptions: UseMutationOptions<UsersReportPermissionChangeResponse, UsersReportPermissionChangeError, Options<UsersReportPermissionChangeData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await Users.usersReportPermissionChange({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Mark Widget Used
 * Record that the user has used the panic-button widget — launched from it,
 * or confirmed 'I've already added it'. Idempotent. Sets a flag in
 * user_metadata that server-gates the 'add the widget' portal card so we stop
 * nagging them (the client also gates locally as an offline fallback).
 */
export const usersMarkWidgetUsedMutation = (options?: Partial<Options<UsersMarkWidgetUsedData>>): UseMutationOptions<UsersMarkWidgetUsedResponse, DefaultError, Options<UsersMarkWidgetUsedData>> => {
    const mutationOptions: UseMutationOptions<UsersMarkWidgetUsedResponse, DefaultError, Options<UsersMarkWidgetUsedData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await Users.usersMarkWidgetUsed({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update Ab Test Variant
 * Update A/B test variant selection in app_metadata.
 *
 * Stores the selected variant for a feature flag in the user's app_metadata
 * under the 'ab_test_variants' key. This allows the app to remember which
 * variant was assigned to the user for consistent experience.
 */
export const usersUpdateAbTestVariantMutation = (options?: Partial<Options<UsersUpdateAbTestVariantData>>): UseMutationOptions<UsersUpdateAbTestVariantResponse, UsersUpdateAbTestVariantError, Options<UsersUpdateAbTestVariantData>> => {
    const mutationOptions: UseMutationOptions<UsersUpdateAbTestVariantResponse, UsersUpdateAbTestVariantError, Options<UsersUpdateAbTestVariantData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await Users.usersUpdateAbTestVariant({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update Journey Pace
 * Choose the Journey's pacing: one day per day, or as fast as you work.
 *
 * Scoped to the caller alone — there is deliberately no ``user_id``, so no
 * token confusion can re-pace somebody else's programme.
 *
 * Changing pace is not retroactive and moves nobody: it changes which day the
 * client will OFFER next, and the member still has to tap. Going back to
 * ``daily`` re-applies the calendar to wherever they now stand, which can mean
 * today's day is already finished and tomorrow is a real wait again. That is
 * the honest behaviour, and the reason this is a preference rather than a
 * one-way door.
 *
 * See ``app/services/journey_pace.py`` for why this is not time travel.
 */
export const usersUpdateJourneyPaceMutation = (options?: Partial<Options<UsersUpdateJourneyPaceData>>): UseMutationOptions<UsersUpdateJourneyPaceResponse, UsersUpdateJourneyPaceError, Options<UsersUpdateJourneyPaceData>> => {
    const mutationOptions: UseMutationOptions<UsersUpdateJourneyPaceResponse, UsersUpdateJourneyPaceError, Options<UsersUpdateJourneyPaceData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await Users.usersUpdateJourneyPace({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const usersReadMyEmailPreferencesQueryKey = (options?: Options<UsersReadMyEmailPreferencesData>) => createQueryKey('usersReadMyEmailPreferences', options);

/**
 * Read My Email Preferences
 * Which email purposes this account currently receives (Settings).
 */
export const usersReadMyEmailPreferencesOptions = (options?: Options<UsersReadMyEmailPreferencesData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await Users.usersReadMyEmailPreferences({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: usersReadMyEmailPreferencesQueryKey(options)
    });
};

/**
 * Update My Email Preference
 * Turn one email purpose on or off from Settings.
 *
 * Needs a verified address: consent belongs to an inbox, and an address
 * nobody proved is not one yet. The toggle's label is sent as the statement,
 * so the log keeps the words that were on screen.
 */
export const usersUpdateMyEmailPreferenceMutation = (options?: Partial<Options<UsersUpdateMyEmailPreferenceData>>): UseMutationOptions<UsersUpdateMyEmailPreferenceResponse, UsersUpdateMyEmailPreferenceError, Options<UsersUpdateMyEmailPreferenceData>> => {
    const mutationOptions: UseMutationOptions<UsersUpdateMyEmailPreferenceResponse, UsersUpdateMyEmailPreferenceError, Options<UsersUpdateMyEmailPreferenceData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await Users.usersUpdateMyEmailPreference({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const usersReadMyHealthDataConsentQueryKey = (options?: Options<UsersReadMyHealthDataConsentData>) => createQueryKey('usersReadMyHealthDataConsent', options);

/**
 * Read My Health Data Consent
 * Whether this account has agreed to us processing its health information.
 */
export const usersReadMyHealthDataConsentOptions = (options?: Options<UsersReadMyHealthDataConsentData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await Users.usersReadMyHealthDataConsent({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: usersReadMyHealthDataConsentQueryKey(options)
    });
};

/**
 * Record My Health Data Consent
 * Record the in-app Art. 9 decision, keyed to the account.
 *
 * Guests included: they have no address, and the data this covers is held
 * under the account rather than an inbox. The screen's words are sent as the
 * statement, so the log keeps exactly what was on screen.
 */
export const usersRecordMyHealthDataConsentMutation = (options?: Partial<Options<UsersRecordMyHealthDataConsentData>>): UseMutationOptions<UsersRecordMyHealthDataConsentResponse, UsersRecordMyHealthDataConsentError, Options<UsersRecordMyHealthDataConsentData>> => {
    const mutationOptions: UseMutationOptions<UsersRecordMyHealthDataConsentResponse, UsersRecordMyHealthDataConsentError, Options<UsersRecordMyHealthDataConsentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await Users.usersRecordMyHealthDataConsent({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const usersReadMyResearchConsentQueryKey = (options?: Options<UsersReadMyResearchConsentData>) => createQueryKey('usersReadMyResearchConsent', options);

/**
 * Read My Research Consent
 * Whether this account has agreed to its data being used for research.
 */
export const usersReadMyResearchConsentOptions = (options?: Options<UsersReadMyResearchConsentData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await Users.usersReadMyResearchConsent({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: usersReadMyResearchConsentQueryKey(options)
    });
};

/**
 * Record My Research Consent
 * Record the optional research decision, keyed to the account.
 *
 * Given as an unticked box on the health information screen, and taken back
 * from Settings. A "no" after a yes is a withdrawal.
 */
export const usersRecordMyResearchConsentMutation = (options?: Partial<Options<UsersRecordMyResearchConsentData>>): UseMutationOptions<UsersRecordMyResearchConsentResponse, UsersRecordMyResearchConsentError, Options<UsersRecordMyResearchConsentData>> => {
    const mutationOptions: UseMutationOptions<UsersRecordMyResearchConsentResponse, UsersRecordMyResearchConsentError, Options<UsersRecordMyResearchConsentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await Users.usersRecordMyResearchConsent({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const usersReadUserAuthProfileQueryKey = (options?: Options<UsersReadUserAuthProfileData>) => createQueryKey('usersReadUserAuthProfile', options);

/**
 * Read User Auth Profile
 * Get current user's authentication profile.
 */
export const usersReadUserAuthProfileOptions = (options?: Options<UsersReadUserAuthProfileData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await Users.usersReadUserAuthProfile({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: usersReadUserAuthProfileQueryKey(options)
    });
};

/**
 * Delete All Push Tokens
 * Delete all push tokens for the current user.
 */
export const usersDeleteAllPushTokensMutation = (options?: Partial<Options<UsersDeleteAllPushTokensData>>): UseMutationOptions<UsersDeleteAllPushTokensResponse, DefaultError, Options<UsersDeleteAllPushTokensData>> => {
    const mutationOptions: UseMutationOptions<UsersDeleteAllPushTokensResponse, DefaultError, Options<UsersDeleteAllPushTokensData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await Users.usersDeleteAllPushTokens({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const usersGetUserPushTokensQueryKey = (options?: Options<UsersGetUserPushTokensData>) => createQueryKey('usersGetUserPushTokens', options);

/**
 * Get User Push Tokens
 * Get all push tokens for the current user.
 */
export const usersGetUserPushTokensOptions = (options?: Options<UsersGetUserPushTokensData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await Users.usersGetUserPushTokens({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: usersGetUserPushTokensQueryKey(options)
    });
};

/**
 * Register Push Token
 * Register a push token for the current user.
 *
 * If this user already has the token (even if disabled) it is re-enabled.
 * If ANOTHER user has it, they lose it: one Expo token is one phone, and it
 * belongs to whoever is signed in on it now. See `upsert_push_token`.
 *
 * Except a walk account (walk mode): the phone belongs to the walker, who is
 * only borrowing the walk's session. Registering would MOVE the walker's
 * token to the test account, and their own notifications would stop until
 * they came back. 409, never stored.
 */
export const usersRegisterPushTokenMutation = (options?: Partial<Options<UsersRegisterPushTokenData>>): UseMutationOptions<UsersRegisterPushTokenResponse, UsersRegisterPushTokenError, Options<UsersRegisterPushTokenData>> => {
    const mutationOptions: UseMutationOptions<UsersRegisterPushTokenResponse, UsersRegisterPushTokenError, Options<UsersRegisterPushTokenData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await Users.usersRegisterPushToken({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete Push Token
 * Delete a push token for the current user.
 */
export const usersDeletePushTokenMutation = (options?: Partial<Options<UsersDeletePushTokenData>>): UseMutationOptions<UsersDeletePushTokenResponse, UsersDeletePushTokenError, Options<UsersDeletePushTokenData>> => {
    const mutationOptions: UseMutationOptions<UsersDeletePushTokenResponse, UsersDeletePushTokenError, Options<UsersDeletePushTokenData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await Users.usersDeletePushToken({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Get Octopus Token
 * Generate a JWT token for Octopus Community SSO.
 *
 * This endpoint is called on-demand by the Octopus SDK when it needs
 * a fresh authentication token. The token includes user profile data
 * and expires in 1 hour.
 *
 * The token is signed with OCTOPUS_SSO_SECRET (different from the
 * standard SECRET_KEY used for app authentication).
 *
 * The frontend should extract the 'token' field from the response
 * and provide it to the Octopus SDK via the userTokenProvider callback.
 */
export const usersGetOctopusTokenMutation = (options?: Partial<Options<UsersGetOctopusTokenData>>): UseMutationOptions<UsersGetOctopusTokenResponse, DefaultError, Options<UsersGetOctopusTokenData>> => {
    const mutationOptions: UseMutationOptions<UsersGetOctopusTokenResponse, DefaultError, Options<UsersGetOctopusTokenData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await Users.usersGetOctopusToken({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const usersReadUserByIdQueryKey = (options: Options<UsersReadUserByIdData>) => createQueryKey('usersReadUserById', options);

/**
 * Read User By Id
 * Get a specific user by id.
 */
export const usersReadUserByIdOptions = (options: Options<UsersReadUserByIdData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await Users.usersReadUserById({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: usersReadUserByIdQueryKey(options)
    });
};

export const usersReadUsersQueryKey = (options?: Options<UsersReadUsersData>) => createQueryKey('usersReadUsers', options);

/**
 * Read Users
 * Retrieve users with pagination and filtering. Only accessible to admins.
 */
export const usersReadUsersOptions = (options?: Options<UsersReadUsersData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await Users.usersReadUsers({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: usersReadUsersQueryKey(options)
    });
};

const createInfiniteParams = <K extends Pick<QueryKey<Options>[0], 'body' | 'headers' | 'path' | 'query'>>(queryKey: QueryKey<Options>, page: K) => {
    const params = {
        ...queryKey[0]
    };
    if (page.body) {
        params.body = {
            ...queryKey[0].body as any,
            ...page.body as any
        };
    }
    if (page.headers) {
        params.headers = {
            ...queryKey[0].headers,
            ...page.headers
        };
    }
    if (page.path) {
        params.path = {
            ...queryKey[0].path as any,
            ...page.path as any
        };
    }
    if (page.query) {
        params.query = {
            ...queryKey[0].query as any,
            ...page.query as any
        };
    }
    return params as unknown as typeof page;
};

export const usersReadUsersInfiniteQueryKey = (options?: Options<UsersReadUsersData>): QueryKey<Options<UsersReadUsersData>> => createQueryKey('usersReadUsers', options, true);

/**
 * Read Users
 * Retrieve users with pagination and filtering. Only accessible to admins.
 */
export const usersReadUsersInfiniteOptions = (options?: Options<UsersReadUsersData>) => {
    return infiniteQueryOptions<UsersReadUsersResponse, UsersReadUsersError, InfiniteData<UsersReadUsersResponse>, QueryKey<Options<UsersReadUsersData>>, number | Pick<QueryKey<Options<UsersReadUsersData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<UsersReadUsersData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await Users.usersReadUsers({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: usersReadUsersInfiniteQueryKey(options)
    });
};

/**
 * Create User
 * Create new user (admin only).
 */
export const usersCreateUserMutation = (options?: Partial<Options<UsersCreateUserData>>): UseMutationOptions<unknown, UsersCreateUserError, Options<UsersCreateUserData>> => {
    const mutationOptions: UseMutationOptions<unknown, UsersCreateUserError, Options<UsersCreateUserData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await Users.usersCreateUser({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const usersExportUsersCsvQueryKey = (options?: Options<UsersExportUsersCsvData>) => createQueryKey('usersExportUsersCsv', options);

/**
 * Export Users Csv
 * Export users to CSV with all filters applied. Only accessible to admins.
 *
 * Without PII scope the Email and Full Name columns are written empty: the
 * header stays put so a spreadsheet built on this file keeps working.
 */
export const usersExportUsersCsvOptions = (options?: Options<UsersExportUsersCsvData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await Users.usersExportUsersCsv({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: usersExportUsersCsvQueryKey(options)
    });
};

/**
 * Delete User
 * Delete a user (admin only).
 *
 * If the user has a sandbox RevenueCat subscription, also deletes the customer
 * from RevenueCat. If RevenueCat deletion fails, logs the error but continues
 * with user deletion.
 */
export const usersDeleteUserMutation = (options?: Partial<Options<UsersDeleteUserData>>): UseMutationOptions<UsersDeleteUserResponse, UsersDeleteUserError, Options<UsersDeleteUserData>> => {
    const mutationOptions: UseMutationOptions<UsersDeleteUserResponse, UsersDeleteUserError, Options<UsersDeleteUserData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await Users.usersDeleteUser({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update User
 * Update a user (admin only).
 */
export const usersUpdateUserMutation = (options?: Partial<Options<UsersUpdateUserData>>): UseMutationOptions<UsersUpdateUserResponse, UsersUpdateUserError, Options<UsersUpdateUserData>> => {
    const mutationOptions: UseMutationOptions<UsersUpdateUserResponse, UsersUpdateUserError, Options<UsersUpdateUserData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await Users.usersUpdateUser({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Create User Feedback
 * Submit feedback from the current user.
 *
 * Use the category field to specify feedback type:
 * - "subscription_cancellation" for subscription cancellation feedback
 * - "account_deletion" for account deletion feedback
 * - "bug", "feature", "improvement", "other" for general feedback
 */
export const usersCreateUserFeedbackMutation = (options?: Partial<Options<UsersCreateUserFeedbackData>>): UseMutationOptions<UsersCreateUserFeedbackResponse, UsersCreateUserFeedbackError, Options<UsersCreateUserFeedbackData>> => {
    const mutationOptions: UseMutationOptions<UsersCreateUserFeedbackResponse, UsersCreateUserFeedbackError, Options<UsersCreateUserFeedbackData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await Users.usersCreateUserFeedback({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update User Staff Flag
 * Set or clear `is_staff` — who counts as Condri.
 *
 * Behind `panel:users:roles:write`, NOT `panel:users:write`, because this is a
 * permission grant and not an edit: `is_staff` carries community moderation
 * (staff are automatic community admins) and every internal affordance in the
 * app. Nobody who could not already hand out a role can hand out this.
 *
 * **No no-escalation guard, deliberately.** The one on `update_user_roles`
 * compares the scopes a grant would confer against the scopes the caller
 * holds; `is_staff` is a column, not a scope bundle, so there is nothing to
 * compare. What bounds it instead is who can reach the route at all: only
 * `admin` holds `panel:users:roles:write`, and an admin already holds every
 * capability `is_staff` carries. A guard here would compare admin to admin.
 *
 * **No self-guard, deliberately.** Clearing your own flag is recoverable
 * without help: panel access is decided by `panel:` scopes
 * (`has_panel_access`), which `is_staff` does not touch, so an admin who
 * switches their own off is still looking at the switch and can put it back.
 * The lockout that IS possible — removing your own admin role — is already
 * refused in `update_user_roles` below. Adding a second guard here would be
 * ceremony against a door that does not lock.
 */
export const usersUpdateUserStaffFlagMutation = (options?: Partial<Options<UsersUpdateUserStaffFlagData>>): UseMutationOptions<UsersUpdateUserStaffFlagResponse, UsersUpdateUserStaffFlagError, Options<UsersUpdateUserStaffFlagData>> => {
    const mutationOptions: UseMutationOptions<UsersUpdateUserStaffFlagResponse, UsersUpdateUserStaffFlagError, Options<UsersUpdateUserStaffFlagData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await Users.usersUpdateUserStaffFlag({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update User Roles
 * Replace a user's roles.
 *
 * Behind `panel:users:roles:write`, which only `admin` holds: a role carries
 * its whole scope bundle, so handing one out hands out everything in it.
 *
 * Three refusals, in order. An incoherent grant (a machine role on a person,
 * or the reverse). An escalation -- granting a role whose scopes the caller
 * does not hold, which is what stops the scope that gates this route from
 * being a route to every other scope. And the two lockouts: you cannot remove
 * your own admin role, and you cannot remove the last admin's.
 */
export const usersUpdateUserRolesMutation = (options?: Partial<Options<UsersUpdateUserRolesData>>): UseMutationOptions<UsersUpdateUserRolesResponse, UsersUpdateUserRolesError, Options<UsersUpdateUserRolesData>> => {
    const mutationOptions: UseMutationOptions<UsersUpdateUserRolesResponse, UsersUpdateUserRolesError, Options<UsersUpdateUserRolesData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await Users.usersUpdateUserRoles({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const usersCheckRevenuecatCustomerStatusQueryKey = (options: Options<UsersCheckRevenuecatCustomerStatusData>) => createQueryKey('usersCheckRevenuecatCustomerStatus', options);

/**
 * Check Revenuecat Customer Status
 * Check if RevenueCat customers exist for a user (admin only).
 *
 * Returns status for all RevenueCat subscriptions found for the user.
 * Each subscription may have a different app_user_id, so we check all of them.
 */
export const usersCheckRevenuecatCustomerStatusOptions = (options: Options<UsersCheckRevenuecatCustomerStatusData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await Users.usersCheckRevenuecatCustomerStatus({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: usersCheckRevenuecatCustomerStatusQueryKey(options)
    });
};

export const usersGetRevenuecatRawCustomerInfoQueryKey = (options: Options<UsersGetRevenuecatRawCustomerInfoData>) => createQueryKey('usersGetRevenuecatRawCustomerInfo', options);

/**
 * Get Revenuecat Raw Customer Info
 * Get raw RevenueCat customer info for debugging (admin only).
 *
 * Fetches the latest customer info from RevenueCat API and returns it as-is.
 */
export const usersGetRevenuecatRawCustomerInfoOptions = (options: Options<UsersGetRevenuecatRawCustomerInfoData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await Users.usersGetRevenuecatRawCustomerInfo({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: usersGetRevenuecatRawCustomerInfoQueryKey(options)
    });
};

/**
 * Delete Revenuecat Customer
 * Delete RevenueCat customer for a user (admin only).
 *
 * Deletes the customer from RevenueCat but keeps the user in the database.
 * Uses the latest subscription with a valid app_user_id.
 */
export const usersDeleteRevenuecatCustomerMutation = (options?: Partial<Options<UsersDeleteRevenuecatCustomerData>>): UseMutationOptions<UsersDeleteRevenuecatCustomerResponse, UsersDeleteRevenuecatCustomerError, Options<UsersDeleteRevenuecatCustomerData>> => {
    const mutationOptions: UseMutationOptions<UsersDeleteRevenuecatCustomerResponse, UsersDeleteRevenuecatCustomerError, Options<UsersDeleteRevenuecatCustomerData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await Users.usersDeleteRevenuecatCustomer({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const usersGetMyEntitlementQueryKey = (options?: Options<UsersGetMyEntitlementData>) => createQueryKey('usersGetMyEntitlement', options);

/**
 * Get My Entitlement
 * What the BACKEND thinks this user is entitled to.
 *
 * Today nothing on this server decides app access. The client does, from the
 * RevenueCat SDK's ``CustomerInfo`` (see expo ``atoms/subscription.ts``), and
 * ``a.rc_subscription_state`` gates nothing — it feeds admin views and the
 * unshipped banner context. So this endpoint is not replacing a server-side
 * source of truth; it is offering one for the first time.
 *
 * That shapes the contract:
 *
 * * ``entitled`` is the backend's answer, derived at read time from status +
 * expiry in ``a.entitlement``. Always computed, always returned.
 * * ``authoritative`` says whether this client should OBEY it. False means the
 * device keeps using the RevenueCat SDK exactly as it does today, and this
 * response is informational — fetch it and compare, but do not act on it.
 *
 * Calling this endpoint therefore changes nobody's access until their
 * ``payments_v2`` flag is on. The intended trial is: the client fetches both,
 * keeps obeying the SDK, and reports disagreement — which is how we learn
 * whether the backend projection is right in production before trusting it.
 *
 * The comparison that matters is against the RevenueCat SDK on the device, not
 * against ``rc_subscription_state`` — that projection decides nothing, so a
 * server-side diff with it would measure the wrong thing. The client holds the
 * only answer worth checking against, so the client reports the mismatch.
 */
export const usersGetMyEntitlementOptions = (options?: Options<UsersGetMyEntitlementData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await Users.usersGetMyEntitlement({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: usersGetMyEntitlementQueryKey(options)
    });
};

/**
 * Grant My Purchase Pending
 * Provisionally grant OWNED entitlement right after a store purchase.
 *
 * The store confirms the transaction on the device immediately; the provider
 * webhook that makes it true on our side lands seconds, minutes, or (during an
 * outage) never later. In that gap a user who just paid asks the backend
 * whether they are entitled and is told no — a paywall for the thing they
 * bought thirty seconds ago. The app calls this the moment a purchase
 * completes so OWNED entitlement grants on the client's word while the real
 * webhook confirms.
 *
 * Bounded and idempotent by the primitive, not by this route:
 *
 * * The grant is capped at 24h and never renewed — it lapses unless a real
 * entitlement supersedes it.
 * * The grant id is derived from the user id, so one live pending grant per
 * user; calling again while one is live is a no-op returning the same id.
 * * If a real provider entitlement already covers this user there is no gap to
 * bridge and nothing is written.
 * * A small rolling budget stops the call being replayed into free access a
 * day at a time. Exhausting it is a support case, surfaced as 409 so the
 * client shows the "we're still confirming your purchase" path rather than
 * retrying or treating it as a silent denial.
 *
 * The body is optional, and so is every field in it. Builds already shipped
 * send no body at all and must keep working, and a value we do not recognise
 * is recorded as a fallback rather than rejected: a 4xx here would deny a
 * provisional grant to someone who just paid, which is precisely the harm this
 * endpoint exists to prevent. Rejecting is the more expensive mistake, so the
 * diagnostic fields yield. That is why the body carries no rejecting
 * validation even where `/app/status` validates the same field names with
 * one — that endpoint can afford to turn a client away, and this one cannot.
 *
 * What the body is FOR: a lapsed pending grant is someone who paid and got
 * nothing, and it is the only payment record with no store attached, because
 * it is written precisely when no provider event has arrived. `store` and
 * `app_version` are what let support answer "which store, which build" without
 * a second investigation.
 */
export const usersGrantMyPurchasePendingMutation = (options?: Partial<Options<UsersGrantMyPurchasePendingData>>): UseMutationOptions<UsersGrantMyPurchasePendingResponse, UsersGrantMyPurchasePendingError, Options<UsersGrantMyPurchasePendingData>> => {
    const mutationOptions: UseMutationOptions<UsersGrantMyPurchasePendingResponse, UsersGrantMyPurchasePendingError, Options<UsersGrantMyPurchasePendingData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await Users.usersGrantMyPurchasePending({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Record App Touches
 * Record a batch of queued app touches for the signed-in account.
 *
 * Any 2xx tells the app to drop the batch, so a touch that fails to write
 * is logged and dropped here rather than failing the whole batch into an
 * endless retry.
 */
export const touchEventsRecordAppTouchesMutation = (options?: Partial<Options<TouchEventsRecordAppTouchesData>>): UseMutationOptions<TouchEventsRecordAppTouchesResponse, TouchEventsRecordAppTouchesError, Options<TouchEventsRecordAppTouchesData>> => {
    const mutationOptions: UseMutationOptions<TouchEventsRecordAppTouchesResponse, TouchEventsRecordAppTouchesError, Options<TouchEventsRecordAppTouchesData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await TouchEvents.touchEventsRecordAppTouches({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Record App Install
 * Record this install's first open. No account needed; idempotent.
 */
export const appInstallsRecordAppInstallMutation = (options?: Partial<Options<AppInstallsRecordAppInstallData>>): UseMutationOptions<AppInstallsRecordAppInstallResponse, AppInstallsRecordAppInstallError, Options<AppInstallsRecordAppInstallData>> => {
    const mutationOptions: UseMutationOptions<AppInstallsRecordAppInstallResponse, AppInstallsRecordAppInstallError, Options<AppInstallsRecordAppInstallData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await AppInstalls.appInstallsRecordAppInstall({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Link App Install
 * Tie this install to the signed-in account (guest or member).
 *
 * 404 when the install has not been recorded yet: the app records it first
 * and retries the link after.
 */
export const appInstallsLinkAppInstallMutation = (options?: Partial<Options<AppInstallsLinkAppInstallData>>): UseMutationOptions<AppInstallsLinkAppInstallResponse, AppInstallsLinkAppInstallError, Options<AppInstallsLinkAppInstallData>> => {
    const mutationOptions: UseMutationOptions<AppInstallsLinkAppInstallResponse, AppInstallsLinkAppInstallError, Options<AppInstallsLinkAppInstallData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await AppInstalls.appInstallsLinkAppInstall({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const usersGetMyHardshipRequestQueryKey = (options?: Options<UsersGetMyHardshipRequestData>) => createQueryKey('usersGetMyHardshipRequest', options);

/**
 * Get My Hardship Request
 * Whether this person may ask, their request if they have, and whether
 * they are covered by anything else.
 *
 * The flag gates new requests only. A request made before it went off is
 * still returned, and its offer still claimable: the email has promised it.
 */
export const usersGetMyHardshipRequestOptions = (options?: Options<UsersGetMyHardshipRequestData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await Users.usersGetMyHardshipRequest({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: usersGetMyHardshipRequestQueryKey(options)
    });
};

/**
 * Create My Hardship Request
 * Ask for the hardship price.
 *
 * Approved by rule. Records the request and the reason they typed (private:
 * stored on the request only, never returned, logged or passed on), gives a
 * day of access unless this phone has had one this month, records the
 * newsletter choice, and enrols the account in the offer email.
 *
 * * 404 when the `hardship_plan` flag is off for this person, or they have
 * subscribed before.
 * * 409 `email_unverified` when the account has no verified address: the
 * offer is emailed, and only to an address the person has proven, so that
 * nobody can have us mail a stranger about money trouble.
 * * 409 `hardship_request_exists` on a second request.
 * * 400 for a consent purpose this form does not ask.
 * * 422 for a reason shorter than 10 or longer than 1000 characters.
 */
export const usersCreateMyHardshipRequestMutation = (options?: Partial<Options<UsersCreateMyHardshipRequestData>>): UseMutationOptions<UsersCreateMyHardshipRequestResponse, UsersCreateMyHardshipRequestError, Options<UsersCreateMyHardshipRequestData>> => {
    const mutationOptions: UseMutationOptions<UsersCreateMyHardshipRequestResponse, UsersCreateMyHardshipRequestError, Options<UsersCreateMyHardshipRequestData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await Users.usersCreateMyHardshipRequest({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Schedule My Billing Reminder
 * Email me two days before my next charge.
 *
 * * 409 `email_unverified` when the account has no proven address. The app
 * verifies first (which is also what turns a guest into an account), so
 * nobody can have us email a stranger about their billing.
 * * 422 `charge_date_unknown` when neither the store nor the app can say
 * when the charge is.
 * * `scheduled: false` when reminders are switched off. Asking twice is
 * fine: the first reminder stands.
 */
export const usersScheduleMyBillingReminderMutation = (options?: Partial<Options<UsersScheduleMyBillingReminderData>>): UseMutationOptions<UsersScheduleMyBillingReminderResponse, UsersScheduleMyBillingReminderError, Options<UsersScheduleMyBillingReminderData>> => {
    const mutationOptions: UseMutationOptions<UsersScheduleMyBillingReminderResponse, UsersScheduleMyBillingReminderError, Options<UsersScheduleMyBillingReminderData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await Users.usersScheduleMyBillingReminder({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const adminBillingIdentityResolveBillingIdQueryKey = (options: Options<AdminBillingIdentityResolveBillingIdData>) => createQueryKey('adminBillingIdentityResolveBillingId', options);

/**
 * Resolve Billing Id
 * billing_id -> user_id. Every call is logged with the caller.
 */
export const adminBillingIdentityResolveBillingIdOptions = (options: Options<AdminBillingIdentityResolveBillingIdData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await AdminBillingIdentity.adminBillingIdentityResolveBillingId({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: adminBillingIdentityResolveBillingIdQueryKey(options)
    });
};

/**
 * Import Revenuecat Csv
 * Import RevenueCat webhook events from CSV file (admin only).
 *
 * CSV file should have a BODY column containing JSON strings with webhook event payloads.
 * Events are processed sequentially and stored in the database. Storing them
 * is the whole job: no projection is built from here.
 */
export const adminRevenuecatImportImportRevenuecatCsvMutation = (options?: Partial<Options<AdminRevenuecatImportImportRevenuecatCsvData>>): UseMutationOptions<AdminRevenuecatImportImportRevenuecatCsvResponse, AdminRevenuecatImportImportRevenuecatCsvError, Options<AdminRevenuecatImportImportRevenuecatCsvData>> => {
    const mutationOptions: UseMutationOptions<AdminRevenuecatImportImportRevenuecatCsvResponse, AdminRevenuecatImportImportRevenuecatCsvError, Options<AdminRevenuecatImportImportRevenuecatCsvData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await AdminRevenuecatImport.adminRevenuecatImportImportRevenuecatCsv({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const adminInsightsEventCountsQueryKey = (options?: Options<AdminInsightsEventCountsData>) => createQueryKey('adminInsightsEventCounts', options);

/**
 * Event Counts
 * Per custom event: counts and unique users for the last `days` (7 or 28)
 * against the period before it. From PostHog, production builds only, cached a few minutes.
 */
export const adminInsightsEventCountsOptions = (options?: Options<AdminInsightsEventCountsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await AdminInsights.adminInsightsEventCounts({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: adminInsightsEventCountsQueryKey(options)
    });
};

export const adminInsightsActiveUsersQueryKey = (options?: Options<AdminInsightsActiveUsersData>) => createQueryKey('adminInsightsActiveUsers', options);

/**
 * Active Users
 * Daily unique app users (any event) for the last `days` (7 or 28), by
 * UTC day. From PostHog, production builds only, cached a few minutes.
 */
export const adminInsightsActiveUsersOptions = (options?: Options<AdminInsightsActiveUsersData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await AdminInsights.adminInsightsActiveUsers({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: adminInsightsActiveUsersQueryKey(options)
    });
};

export const adminInsightsNewUsersQueryKey = (options?: Options<AdminInsightsNewUsersData>) => createQueryKey('adminInsightsNewUsers', options);

/**
 * New Users
 * New app users per UTC day for the last `days` (7 or 28): guest accounts
 * created, the real top of the app funnel. From PostHog, production builds only, cached a few minutes.
 */
export const adminInsightsNewUsersOptions = (options?: Options<AdminInsightsNewUsersData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await AdminInsights.adminInsightsNewUsers({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: adminInsightsNewUsersQueryKey(options)
    });
};

export const adminInsightsChurnScreensQueryKey = (options?: Options<AdminInsightsChurnScreensData>) => createQueryKey('adminInsightsChurnScreens', options);

/**
 * Churn Screens
 * Where people stop: the last screen of users seen in the last 90 days who
 * then went quiet for 14+ days, top 20, beside each screen's total visitors.
 * From PostHog, production builds only, cached a few minutes.
 */
export const adminInsightsChurnScreensOptions = (options?: Options<AdminInsightsChurnScreensData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await AdminInsights.adminInsightsChurnScreens({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: adminInsightsChurnScreensQueryKey(options)
    });
};

export const adminInsightsVersionBreakdownQueryKey = (options?: Options<AdminInsightsVersionBreakdownData>) => createQueryKey('adminInsightsVersionBreakdown', options);

/**
 * Version Breakdown
 * Per app version (1.5.x and newer): unique users at each funnel stage and
 * engagement, over the last `days` (7 or 28). From PostHog, production builds only, cached a few minutes.
 */
export const adminInsightsVersionBreakdownOptions = (options?: Options<AdminInsightsVersionBreakdownData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await AdminInsights.adminInsightsVersionBreakdown({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: adminInsightsVersionBreakdownQueryKey(options)
    });
};

export const adminInsightsUsageBreakdownQueryKey = (options?: Options<AdminInsightsUsageBreakdownData>) => createQueryKey('adminInsightsUsageBreakdown', options);

/**
 * Usage Breakdown
 * Screen views, onboarding steps, and login methods over the last `days`
 * (7 or 28), as unique-user counts. From PostHog, production builds only, cached a few minutes.
 */
export const adminInsightsUsageBreakdownOptions = (options?: Options<AdminInsightsUsageBreakdownData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await AdminInsights.adminInsightsUsageBreakdown({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: adminInsightsUsageBreakdownQueryKey(options)
    });
};

export const adminInsightsWebFunnelQueryKey = (options?: Options<AdminInsightsWebFunnelData>) => createQueryKey('adminInsightsWebFunnel', options);

/**
 * Web Funnel
 * Website onboarding funnels (condri.app/start, /coaching-quiz → Stripe).
 */
export const adminInsightsWebFunnelOptions = (options?: Options<AdminInsightsWebFunnelData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await AdminInsights.adminInsightsWebFunnel({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: adminInsightsWebFunnelQueryKey(options)
    });
};

export const adminInsightsEmailCoverageQueryKey = (options?: Options<AdminInsightsEmailCoverageData>) => createQueryKey('adminInsightsEmailCoverage', options);

/**
 * Email Coverage
 * What share of real users we hold an email address for, by signup week.
 *
 * Weekly cohorts rather than a single number, because a single number moves
 * slowly: the install base dilutes it for months. Cohort-by-cohort is where a
 * change to onboarding actually shows up, within a week of shipping.
 */
export const adminInsightsEmailCoverageOptions = (options?: Options<AdminInsightsEmailCoverageData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await AdminInsights.adminInsightsEmailCoverage({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: adminInsightsEmailCoverageQueryKey(options)
    });
};

export const adminCheckpointsReachByVersionQueryKey = (options: Options<AdminCheckpointsReachByVersionData>) => createQueryKey('adminCheckpointsReachByVersion', options);

/**
 * Reach By Version
 * Share of each app version's active users who hit each moment at all.
 *
 * Rates AND counts, from one query so every number shares a denominator. The
 * count answers "how many people"; the rate answers "is this version broken"
 * (a version's size otherwise drowns out its behaviour, and a moment that
 * steps between two versions names the release that changed it).
 *
 * Two semantics to read with:
 *
 * * Version rows OVERLAP: a person active on two versions in the window is
 * in both denominators. Rates are per-version honest; the rows do not sum.
 * * A once-per-lifetime moment (onboarding completed, first post) reads low
 * on every version by construction — few of a version's actives are new
 * signups. That is cohort composition, not breakage; the registry marks
 * such moments `once` and the page annotates them.
 */
export const adminCheckpointsReachByVersionOptions = (options: Options<AdminCheckpointsReachByVersionData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await AdminCheckpoints.adminCheckpointsReachByVersion({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: adminCheckpointsReachByVersionQueryKey(options)
    });
};

export const adminCheckpointsTimeToMomentQueryKey = (options: Options<AdminCheckpointsTimeToMomentData>) => createQueryKey('adminCheckpointsTimeToMoment', options);

/**
 * Time To Moment
 * Distribution of how long the signup cohort takes to reach each moment.
 *
 * Anchor: `person.created_at`, when PostHog first created the person profile.
 * That approximates signup and does not move with the query window. The
 * population is restricted to profiles CREATED in the window — without that,
 * a 300-day-old user firing the event today enters the distribution at ~300
 * days and the number measures tenure, not time-to-moment. Quantiles are over
 * reachers only: people in the cohort who never fired the event contribute
 * nothing (reach measures them). Negative gaps (an event stamped before
 * profile creation, which merges can produce) clamp to zero.
 *
 * ClickHouse `quantile()` is approximate (a sampling reservoir), unlike the
 * exact `percentile_cont` behind /backend-reach; at small n the high
 * percentiles are essentially the max. The UI suppresses P90/P99 below n=20.
 */
export const adminCheckpointsTimeToMomentOptions = (options: Options<AdminCheckpointsTimeToMomentData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await AdminCheckpoints.adminCheckpointsTimeToMoment({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: adminCheckpointsTimeToMomentQueryKey(options)
    });
};

export const adminCheckpointsHealthEntryVolumeQueryKey = (options: Options<AdminCheckpointsHealthEntryVolumeData>) => createQueryKey('adminCheckpointsHealthEntryVolume', options);

/**
 * Health Entry Volume
 * Server-side volume for moments that write a health entry.
 *
 * Durable where PostHog is not: survives reinstall and device change, and no
 * ad-blocker touches it. It cannot be broken down by app version — see the
 * version-attribution note in brain/notes/checkpoints-plan.md.
 */
export const adminCheckpointsHealthEntryVolumeOptions = (options: Options<AdminCheckpointsHealthEntryVolumeData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await AdminCheckpoints.adminCheckpointsHealthEntryVolume({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: adminCheckpointsHealthEntryVolumeQueryKey(options)
    });
};

export const adminCheckpointsBackendReachQueryKey = (options: Options<AdminCheckpointsBackendReachData>) => createQueryKey('adminCheckpointsBackendReach', options);

/**
 * Backend Reach
 * Owned reach and time-to: the signup cohort, measured from OUR tables.
 *
 * Not PostHog: no ad-blocker, no sampling, and the numbers exist even when
 * the PostHog query API is down. The cohort is real users (not staff,
 * superusers or soft-deleted) created in the window, so every measure reads
 * as "of the people who signed up recently, how many, and how fast".
 *
 * Cohort immaturity is a real bias: yesterday's signup sits in the
 * denominator with no time to have reached anything, so a signup surge
 * mechanically drags every percentage down and a drought "improves" them.
 * Read the pct together with the window, or against a stable baseline; the
 * UI carries the same caveat.
 *
 * The time-to quantiles use percentile_cont over a TRUE anchor,
 * users.dt_created, which is deliberately better than the PostHog time-to
 * endpoint's person.created_at approximation: signup here is a fact, not a
 * profile artefact. (shai_retake is the exception by design: its gap runs
 * first-score-to-second-score.) `timed` is the quantiles' real n.
 *
 * Known asymmetry: no version slicing. The database holds no per-user app
 * version history (deferred with #521), so backend measures cannot split by
 * release the way reach does. Revive that work when a consumer actually
 * wants version-sliced backend measures.
 *
 * The measure catalog is fixed in this module; the query accepts names only.
 */
export const adminCheckpointsBackendReachOptions = (options: Options<AdminCheckpointsBackendReachData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await AdminCheckpoints.adminCheckpointsBackendReach({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: adminCheckpointsBackendReachQueryKey(options)
    });
};

export const adminActivationActivationOverviewQueryKey = (options?: Options<AdminActivationActivationOverviewData>) => createQueryKey('adminActivationActivationOverview', options);

/**
 * Activation Overview
 * Activation and its week-1 signals for signups from `start` to `end`
 * (both included; the last 90 days when not given). Definitions travel in
 * `metrics`.
 */
export const adminActivationActivationOverviewOptions = (options?: Options<AdminActivationActivationOverviewData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await AdminActivation.adminActivationActivationOverview({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: adminActivationActivationOverviewQueryKey(options)
    });
};

export const adminActivationActivationOverviewInfiniteQueryKey = (options?: Options<AdminActivationActivationOverviewData>): QueryKey<Options<AdminActivationActivationOverviewData>> => createQueryKey('adminActivationActivationOverview', options, true);

/**
 * Activation Overview
 * Activation and its week-1 signals for signups from `start` to `end`
 * (both included; the last 90 days when not given). Definitions travel in
 * `metrics`.
 */
export const adminActivationActivationOverviewInfiniteOptions = (options?: Options<AdminActivationActivationOverviewData>) => {
    return infiniteQueryOptions<AdminActivationActivationOverviewResponse, AdminActivationActivationOverviewError, InfiniteData<AdminActivationActivationOverviewResponse>, QueryKey<Options<AdminActivationActivationOverviewData>>, string | null | Pick<QueryKey<Options<AdminActivationActivationOverviewData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<AdminActivationActivationOverviewData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    start: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await AdminActivation.adminActivationActivationOverview({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: adminActivationActivationOverviewInfiniteQueryKey(options)
    });
};

export const adminJourneyHealthJourneySummaryQueryKey = (options?: Options<AdminJourneyHealthJourneySummaryData>) => createQueryKey('adminJourneyHealthJourneySummary', options);

/**
 * Journey Summary
 * The Journey's headline numbers now and seven days earlier.
 *
 * New signups who reached day 2, day 2 done on its unlock day, existing
 * members who started, and weekly actives. Rates carry n (who could have)
 * and k (who did) and are None below `min_readable_n`. Real users only
 * unless `include_staff`.
 */
export const adminJourneyHealthJourneySummaryOptions = (options?: Options<AdminJourneyHealthJourneySummaryData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await AdminJourneyHealth.adminJourneyHealthJourneySummary({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: adminJourneyHealthJourneySummaryQueryKey(options)
    });
};

export const adminJourneyHealthJourneyLadderQueryKey = (options?: Options<AdminJourneyHealthJourneyLadderData>) => createQueryKey('adminJourneyHealthJourneyLadder', options);

/**
 * Journey Ladder
 * Each Journey day: how many members were eligible for it, how many did it
 * on the day it unlocked, how many did it later, how many have not, and how
 * many were active on its unlock day. `too_few` marks a day whose eligible
 * count is below `min_readable_n`.
 */
export const adminJourneyHealthJourneyLadderOptions = (options?: Options<AdminJourneyHealthJourneyLadderData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await AdminJourneyHealth.adminJourneyHealthJourneyLadder({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: adminJourneyHealthJourneyLadderQueryKey(options)
    });
};

export const adminJourneyHealthJourneyFunnelQueryKey = (options?: Options<AdminJourneyHealthJourneyFunnelData>) => createQueryKey('adminJourneyHealthJourneyFunnel', options);

/**
 * Journey Funnel
 * New signups between `start` and `end` (whole UTC days, inclusive),
 * step by step through the Journey's first days. New means signed up after
 * the Journey flip, so the window never starts before it. Rates carry n and
 * k and are None below `min_readable_n`.
 */
export const adminJourneyHealthJourneyFunnelOptions = (options?: Options<AdminJourneyHealthJourneyFunnelData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await AdminJourneyHealth.adminJourneyHealthJourneyFunnel({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: adminJourneyHealthJourneyFunnelQueryKey(options)
    });
};

export const adminJourneyHealthJourneyFunnelInfiniteQueryKey = (options?: Options<AdminJourneyHealthJourneyFunnelData>): QueryKey<Options<AdminJourneyHealthJourneyFunnelData>> => createQueryKey('adminJourneyHealthJourneyFunnel', options, true);

/**
 * Journey Funnel
 * New signups between `start` and `end` (whole UTC days, inclusive),
 * step by step through the Journey's first days. New means signed up after
 * the Journey flip, so the window never starts before it. Rates carry n and
 * k and are None below `min_readable_n`.
 */
export const adminJourneyHealthJourneyFunnelInfiniteOptions = (options?: Options<AdminJourneyHealthJourneyFunnelData>) => {
    return infiniteQueryOptions<AdminJourneyHealthJourneyFunnelResponse, AdminJourneyHealthJourneyFunnelError, InfiniteData<AdminJourneyHealthJourneyFunnelResponse>, QueryKey<Options<AdminJourneyHealthJourneyFunnelData>>, string | null | Pick<QueryKey<Options<AdminJourneyHealthJourneyFunnelData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<AdminJourneyHealthJourneyFunnelData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    start: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await AdminJourneyHealth.adminJourneyHealthJourneyFunnel({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: adminJourneyHealthJourneyFunnelInfiniteQueryKey(options)
    });
};

export const adminJourneyHealthJourneyCohortsQueryKey = (options?: Options<AdminJourneyHealthJourneyCohortsData>) => createQueryKey('adminJourneyHealthJourneyCohorts', options);

/**
 * Journey Cohorts
 * Cohort grid. Rows are the week a member finished day 0; columns are the
 * furthest Journey day reached. A member counts in a cell only once they
 * could have reached that day by going every day, so recent weeks are not
 * understated.
 */
export const adminJourneyHealthJourneyCohortsOptions = (options?: Options<AdminJourneyHealthJourneyCohortsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await AdminJourneyHealth.adminJourneyHealthJourneyCohorts({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: adminJourneyHealthJourneyCohortsQueryKey(options)
    });
};

export const adminJourneyHealthJourneyRetentionQueryKey = (options?: Options<AdminJourneyHealthJourneyRetentionData>) => createQueryKey('adminJourneyHealthJourneyRetention', options);

/**
 * Journey Retention
 * Retention by signup week: who came back on day 1, 7 and 14 (any health
 * entry in that UTC day after signup), plus weekly actives. A signup counts
 * for day d only once its window has closed.
 */
export const adminJourneyHealthJourneyRetentionOptions = (options?: Options<AdminJourneyHealthJourneyRetentionData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await AdminJourneyHealth.adminJourneyHealthJourneyRetention({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: adminJourneyHealthJourneyRetentionQueryKey(options)
    });
};

export const adminPricingGetPricingGridQueryKey = (options?: Options<AdminPricingGetPricingGridData>) => createQueryKey('adminPricingGetPricingGrid', options);

/**
 * Get Pricing Grid
 * The full plan x band grid with live Stripe amounts.
 *
 * Amounts come from Stripe rather than our database on purpose: the panel
 * should show what customers will actually be charged, not what we recorded.
 * Read uncached and concurrently — uncached because `active` is the mutable
 * field that reveals a broken slot, concurrently so eight prices cost one
 * round trip and no blocked event loop.
 *
 * `variant` asks for an experiment ARM's grid rather than the default one. An
 * arm with no price of its own reads as `inherited`, which is exactly what it
 * does on the funnel: it shows the control price. Without this the panel had
 * no way to see or set arm prices at all, so a started test assigned people to
 * an arm priced identically to control and measured nothing.
 */
export const adminPricingGetPricingGridOptions = (options?: Options<AdminPricingGetPricingGridData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await AdminPricing.adminPricingGetPricingGrid({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: adminPricingGetPricingGridQueryKey(options)
    });
};

export const adminPricingGetStorePricesQueryKey = (options?: Options<AdminPricingGetStorePricesData>) => createQueryKey('adminPricingGetStorePrices', options);

/**
 * Get Store Prices
 * Live App Store and Play prices for every RevenueCat offering's products.
 *
 * Read-only, cached for a few minutes; `refresh` skips the cache. A store
 * that cannot be read comes back as that source's error, not a failed page.
 */
export const adminPricingGetStorePricesOptions = (options?: Options<AdminPricingGetStorePricesData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await AdminPricing.adminPricingGetStorePrices({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: adminPricingGetStorePricesQueryKey(options)
    });
};

export const adminPricingListStripePricesQueryKey = (options?: Options<AdminPricingListStripePricesData>) => createQueryKey('adminPricingListStripePrices', options);

/**
 * List Stripe Prices
 * Every price in the Stripe account, with what we know about each.
 *
 * Stripe can say what a price is. Only we can say whether anything sells it
 * and whether anyone is still owed it, and those two columns are what make the
 * list usable: an active price nothing points at reads as litter until you can
 * see a live stamp still promises it to somebody.
 *
 * Archived prices are included deliberately. They are what a slot can be
 * pointed back at, and seeing "we already sold at $12.99" is what stops a
 * second $12.99 being created next to the first.
 */
export const adminPricingListStripePricesOptions = (options?: Options<AdminPricingListStripePricesData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await AdminPricing.adminPricingListStripePrices({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: adminPricingListStripePricesQueryKey(options)
    });
};

/**
 * Adopt Env Prices
 * Write a pointer row for every slot still resolving through an env var.
 *
 * Not required for anything to work — rotation reads through the env fallback,
 * so an un-adopted slot behaves identically. This exists so the env vars can be
 * *deleted*, which is only safe once every slot has a row of its own.
 *
 * Only adopts a band's own env var, never the standard-band fallback. Adopting
 * the fallback would pin the youth band to today's standard price, so a later
 * change to the standard price would silently stop applying to youth — turning
 * an intentional inheritance into a stale copy.
 *
 * Idempotent: slots that already have a pointer are skipped, so running it
 * twice does nothing and it can be re-run after a new plan is configured.
 */
export const adminPricingAdoptEnvPricesMutation = (options?: Partial<Options<AdminPricingAdoptEnvPricesData>>): UseMutationOptions<AdminPricingAdoptEnvPricesResponse, DefaultError, Options<AdminPricingAdoptEnvPricesData>> => {
    const mutationOptions: UseMutationOptions<AdminPricingAdoptEnvPricesResponse, DefaultError, Options<AdminPricingAdoptEnvPricesData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await AdminPricing.adminPricingAdoptEnvPrices({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Rotate Price
 * Point a (plan, band) at a new Stripe price at the given amount.
 *
 * Order of operations matters. The lock is taken before any Stripe write, so a
 * concurrent caller blocks before spending anything. The new price is created
 * and the pointer committed BEFORE the old price is archived, so the worst case
 * of a mid-way failure is an unused price in Stripe — never a funnel pointing
 * at an archived price, which would fail every checkout.
 */
export const adminPricingRotatePriceMutation = (options?: Partial<Options<AdminPricingRotatePriceData>>): UseMutationOptions<AdminPricingRotatePriceResponse, AdminPricingRotatePriceError, Options<AdminPricingRotatePriceData>> => {
    const mutationOptions: UseMutationOptions<AdminPricingRotatePriceResponse, AdminPricingRotatePriceError, Options<AdminPricingRotatePriceData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await AdminPricing.adminPricingRotatePrice({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const adminPricingGetPriceHistoryQueryKey = (options: Options<AdminPricingGetPriceHistoryData>) => createQueryKey('adminPricingGetPriceHistory', options);

/**
 * Get Price History
 * Recent prices this (plan, band) has pointed at, newest first.
 *
 * Only covers changes made through this API — prices set via env before the
 * pointer table existed have no history to show. Bounded by the CRUD layer,
 * since each entry costs a Stripe lookup.
 *
 * Omit `variant` for every arm; pass one to see just that arm's changes. A
 * control history with an arm's rotations spliced into it reads as a price
 * that moved twice as often as it did.
 */
export const adminPricingGetPriceHistoryOptions = (options: Options<AdminPricingGetPriceHistoryData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await AdminPricing.adminPricingGetPriceHistory({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: adminPricingGetPriceHistoryQueryKey(options)
    });
};

export const adminPricingListExperimentsQueryKey = (options?: Options<AdminPricingListExperimentsData>) => createQueryKey('adminPricingListExperiments', options);

/**
 * List Experiments
 * Every experiment, newest first, with its assignment counts.
 */
export const adminPricingListExperimentsOptions = (options?: Options<AdminPricingListExperimentsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await AdminPricing.adminPricingListExperiments({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: adminPricingListExperimentsQueryKey(options)
    });
};

/**
 * Upsert Experiment
 * Create or update an experiment. Never activates it — that is its own call,
 * so writing weights cannot start a test by accident.
 */
export const adminPricingUpsertExperimentMutation = (options?: Partial<Options<AdminPricingUpsertExperimentData>>): UseMutationOptions<AdminPricingUpsertExperimentResponse, AdminPricingUpsertExperimentError, Options<AdminPricingUpsertExperimentData>> => {
    const mutationOptions: UseMutationOptions<AdminPricingUpsertExperimentResponse, AdminPricingUpsertExperimentError, Options<AdminPricingUpsertExperimentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await AdminPricing.adminPricingUpsertExperiment({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Set Experiment Active
 * Start or stop an experiment.
 *
 * Deactivates whatever else was running first: the partial unique index allows
 * exactly one active experiment, so activating without standing the other down
 * would be a 500 rather than a decision. Doing it here makes "start this one"
 * mean "and stop the other", which is the only sane reading.
 *
 * Stopping does NOT move anyone already assigned. Their offer is stamped, and
 * the stamp is a promise — a finished experiment still owes its arms the price
 * they were shown until those stamps expire.
 */
export const adminPricingSetExperimentActiveMutation = (options?: Partial<Options<AdminPricingSetExperimentActiveData>>): UseMutationOptions<AdminPricingSetExperimentActiveResponse, AdminPricingSetExperimentActiveError, Options<AdminPricingSetExperimentActiveData>> => {
    const mutationOptions: UseMutationOptions<AdminPricingSetExperimentActiveResponse, AdminPricingSetExperimentActiveError, Options<AdminPricingSetExperimentActiveData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await AdminPricing.adminPricingSetExperimentActive({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const adminPricingListPublicOffersQueryKey = (options?: Options<AdminPricingListPublicOffersData>) => createQueryKey('adminPricingListPublicOffers', options);

/**
 * List Public Offers
 * The named offers dedicated checkout pages can request (PUBLIC_OFFERS).
 *
 * Defined in code — an offer is a page plus a policy, and both ship together.
 * Listed here so the panel can render an editable price grid per offer
 * variant; the prices themselves live on the same pointer axis as experiment
 * arms and rotate without a deploy.
 */
export const adminPricingListPublicOffersOptions = (options?: Options<AdminPricingListPublicOffersData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await AdminPricing.adminPricingListPublicOffers({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: adminPricingListPublicOffersQueryKey(options)
    });
};

export const adminPricingGetPlanDisplayQueryKey = (options?: Options<AdminPricingGetPlanDisplayData>) => createQueryKey('adminPricingGetPlanDisplay', options);

/**
 * Get Plan Display
 * Which plans the funnel shows, in order.
 *
 * The ONE source. Env booleans, the web-paywall-show-* feature flags and the
 * PostHog plan-pair variant are all gone.
 */
export const adminPricingGetPlanDisplayOptions = (options?: Options<AdminPricingGetPlanDisplayData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await AdminPricing.adminPricingGetPlanDisplay({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: adminPricingGetPlanDisplayQueryKey(options)
    });
};

/**
 * Set Plan Display
 * Set which plans the funnel shows.
 *
 * Refuses to hide everything: a paywall with no plans sells nothing, and the
 * mistake is one keystroke away when the control is a row of switches. Turning
 * the last one off is far more likely to be a slip than an intention, so it
 * fails loudly rather than taking the funnel down quietly.
 */
export const adminPricingSetPlanDisplayMutation = (options?: Partial<Options<AdminPricingSetPlanDisplayData>>): UseMutationOptions<AdminPricingSetPlanDisplayResponse, AdminPricingSetPlanDisplayError, Options<AdminPricingSetPlanDisplayData>> => {
    const mutationOptions: UseMutationOptions<AdminPricingSetPlanDisplayResponse, AdminPricingSetPlanDisplayError, Options<AdminPricingSetPlanDisplayData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await AdminPricing.adminPricingSetPlanDisplay({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const adminPaymentsPaymentsOverviewQueryKey = (options?: Options<AdminPaymentsPaymentsOverviewData>) => createQueryKey('adminPaymentsPaymentsOverview', options);

/**
 * Payments Overview
 * Subscription stock now, flows in a window, and MRR now.
 *
 * `stock` and `mrr` are as of this moment; `flow` counts events between
 * `start` and `end` (ISO, UTC; the last 30 days when not given). Web money is
 * in GBP with the per-currency split beside it (the web sells in several
 * currencies); store money is in USD, as the stores report it. Group
 * Coaching sales are kept out of revenue and MRR and reported on their own
 * lines. Each MRR formula travels in the payload.
 */
export const adminPaymentsPaymentsOverviewOptions = (options?: Options<AdminPaymentsPaymentsOverviewData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await AdminPayments.adminPaymentsPaymentsOverview({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: adminPaymentsPaymentsOverviewQueryKey(options)
    });
};

export const adminPaymentsPaymentsOverviewInfiniteQueryKey = (options?: Options<AdminPaymentsPaymentsOverviewData>): QueryKey<Options<AdminPaymentsPaymentsOverviewData>> => createQueryKey('adminPaymentsPaymentsOverview', options, true);

/**
 * Payments Overview
 * Subscription stock now, flows in a window, and MRR now.
 *
 * `stock` and `mrr` are as of this moment; `flow` counts events between
 * `start` and `end` (ISO, UTC; the last 30 days when not given). Web money is
 * in GBP with the per-currency split beside it (the web sells in several
 * currencies); store money is in USD, as the stores report it. Group
 * Coaching sales are kept out of revenue and MRR and reported on their own
 * lines. Each MRR formula travels in the payload.
 */
export const adminPaymentsPaymentsOverviewInfiniteOptions = (options?: Options<AdminPaymentsPaymentsOverviewData>) => {
    return infiniteQueryOptions<AdminPaymentsPaymentsOverviewResponse, AdminPaymentsPaymentsOverviewError, InfiniteData<AdminPaymentsPaymentsOverviewResponse>, QueryKey<Options<AdminPaymentsPaymentsOverviewData>>, string | null | Pick<QueryKey<Options<AdminPaymentsPaymentsOverviewData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<AdminPaymentsPaymentsOverviewData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    start: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await AdminPayments.adminPaymentsPaymentsOverview({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: adminPaymentsPaymentsOverviewInfiniteQueryKey(options)
    });
};

export const adminPaymentsPaymentsGrowthQueryKey = (options?: Options<AdminPaymentsPaymentsGrowthData>) => createQueryKey('adminPaymentsPaymentsGrowth', options);

/**
 * Payments Growth
 * The Growth tile group: DAU, MAU, DAU/MAU, signups (30d + today).
 *
 * Owned sources only (d.user_health_entries, a.users) — the sound half of the
 * old dashboard-summary, minus every RC-webhook-derived number.
 */
export const adminPaymentsPaymentsGrowthOptions = (options?: Options<AdminPaymentsPaymentsGrowthData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await AdminPayments.adminPaymentsPaymentsGrowth({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: adminPaymentsPaymentsGrowthQueryKey(options)
    });
};

export const adminPaymentsPaymentsRetentionQueryKey = (options?: Options<AdminPaymentsPaymentsRetentionData>) => createQueryKey('adminPaymentsPaymentsRetention', options);

/**
 * Payments Retention
 * Week-joined signup cohorts with health-entry retention, plus a D1/D7/D30
 * summary. ``paid_users_only`` sources the paid filter from a.entitlement, not
 * the RC webhook table. One grouped query, no per-day MAU loop.
 *
 * The cohort lookback was fixed before; ``weeks`` makes it configurable. It
 * drives both the row count and the day window (a request for 52 weeks needs
 * ~52 weeks of days to have those cohorts to return), leaving max_cohorts/days
 * as the unchanged default path for callers that do not pass it.
 */
export const adminPaymentsPaymentsRetentionOptions = (options?: Options<AdminPaymentsPaymentsRetentionData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await AdminPayments.adminPaymentsPaymentsRetention({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: adminPaymentsPaymentsRetentionQueryKey(options)
    });
};

export const adminPaymentsPaymentDimensionsQueryKey = (options?: Options<AdminPaymentsPaymentDimensionsData>) => createQueryKey('adminPaymentsPaymentDimensions', options);

/**
 * Payment Dimensions
 * Distinct values per filter/segment dimension, from subscription_dim.
 *
 * Feeds the panel's filter dropdowns so nobody has to guess a value's
 * spelling. Cheap (one small table), cacheable client-side.
 */
export const adminPaymentsPaymentDimensionsOptions = (options?: Options<AdminPaymentsPaymentDimensionsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await AdminPayments.adminPaymentsPaymentDimensions({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: adminPaymentsPaymentDimensionsQueryKey(options)
    });
};

export const adminPaymentsPaymentsChartQueryKey = (options: Options<AdminPaymentsPaymentsChartData>) => createQueryKey('adminPaymentsPaymentsChart', options);

/**
 * Payments Chart
 * One grammar for every chart, RC Charts style.
 *
 * `chart` names the chart (its parameter lists them). The window is `start` to
 * `end` (ISO, UTC; the last 30 days when not given), bucketed by
 * `resolution` (day, week, month, quarter, year; weeks start Monday).
 * `segment` splits the series by a dimension (see the dimensions route).
 * Each chart's definition and units come back in its summary.
 *
 * `filter` narrows and `selector` sets a per-chart option; see their
 * parameters. The panel's ``filter.<dimension>=v1,v2`` /
 * ``selector.<name>=<value>`` form still works.
 */
export const adminPaymentsPaymentsChartOptions = (options: Options<AdminPaymentsPaymentsChartData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await AdminPayments.adminPaymentsPaymentsChart({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: adminPaymentsPaymentsChartQueryKey(options)
    });
};

export const adminPaymentsPaymentsChartInfiniteQueryKey = (options: Options<AdminPaymentsPaymentsChartData>): QueryKey<Options<AdminPaymentsPaymentsChartData>> => createQueryKey('adminPaymentsPaymentsChart', options, true);

/**
 * Payments Chart
 * One grammar for every chart, RC Charts style.
 *
 * `chart` names the chart (its parameter lists them). The window is `start` to
 * `end` (ISO, UTC; the last 30 days when not given), bucketed by
 * `resolution` (day, week, month, quarter, year; weeks start Monday).
 * `segment` splits the series by a dimension (see the dimensions route).
 * Each chart's definition and units come back in its summary.
 *
 * `filter` narrows and `selector` sets a per-chart option; see their
 * parameters. The panel's ``filter.<dimension>=v1,v2`` /
 * ``selector.<name>=<value>`` form still works.
 */
export const adminPaymentsPaymentsChartInfiniteOptions = (options: Options<AdminPaymentsPaymentsChartData>) => {
    return infiniteQueryOptions<AdminPaymentsPaymentsChartResponse, AdminPaymentsPaymentsChartError, InfiniteData<AdminPaymentsPaymentsChartResponse>, QueryKey<Options<AdminPaymentsPaymentsChartData>>, string | null | Pick<QueryKey<Options<AdminPaymentsPaymentsChartData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<AdminPaymentsPaymentsChartData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    start: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await AdminPayments.adminPaymentsPaymentsChart({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: adminPaymentsPaymentsChartInfiniteQueryKey(options)
    });
};

export const adminPaymentsPaymentsChartsBatchQueryKey = (options: Options<AdminPaymentsPaymentsChartsBatchData>) => createQueryKey('adminPaymentsPaymentsChartsBatch', options);

/**
 * Payments Charts Batch
 * Several charts over ONE window/resolution, in request order.
 *
 * Backs the overlay view (a primary series plus overlays on a shared axis)
 * and the Ship Health grid, which needs many launch-sensitive signals aligned
 * on the same time axis. ``filter.<dim>`` / ``selector.<name>`` apply to every
 * chart in the batch, matching the single-chart grammar.
 */
export const adminPaymentsPaymentsChartsBatchOptions = (options: Options<AdminPaymentsPaymentsChartsBatchData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await AdminPayments.adminPaymentsPaymentsChartsBatch({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: adminPaymentsPaymentsChartsBatchQueryKey(options)
    });
};

export const adminPaymentsPaymentsChartsBatchInfiniteQueryKey = (options: Options<AdminPaymentsPaymentsChartsBatchData>): QueryKey<Options<AdminPaymentsPaymentsChartsBatchData>> => createQueryKey('adminPaymentsPaymentsChartsBatch', options, true);

/**
 * Payments Charts Batch
 * Several charts over ONE window/resolution, in request order.
 *
 * Backs the overlay view (a primary series plus overlays on a shared axis)
 * and the Ship Health grid, which needs many launch-sensitive signals aligned
 * on the same time axis. ``filter.<dim>`` / ``selector.<name>`` apply to every
 * chart in the batch, matching the single-chart grammar.
 */
export const adminPaymentsPaymentsChartsBatchInfiniteOptions = (options: Options<AdminPaymentsPaymentsChartsBatchData>) => {
    return infiniteQueryOptions<AdminPaymentsPaymentsChartsBatchResponse, AdminPaymentsPaymentsChartsBatchError, InfiniteData<AdminPaymentsPaymentsChartsBatchResponse>, QueryKey<Options<AdminPaymentsPaymentsChartsBatchData>>, string | null | Pick<QueryKey<Options<AdminPaymentsPaymentsChartsBatchData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<AdminPaymentsPaymentsChartsBatchData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    start: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await AdminPayments.adminPaymentsPaymentsChartsBatch({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: adminPaymentsPaymentsChartsBatchInfiniteQueryKey(options)
    });
};

export const adminPaymentsPaymentsReleaseMarkersQueryKey = (options?: Options<AdminPaymentsPaymentsReleaseMarkersData>) => createQueryKey('adminPaymentsPaymentsReleaseMarkers', options);

/**
 * Payments Release Markers
 * Ship/release annotation lines for the Ship Health charts.
 *
 * Derived from the first appearance of each app version (thresholded by
 * device count) plus any manual, non-version launches. See
 * ``crud.a.release_markers`` for the source of truth.
 */
export const adminPaymentsPaymentsReleaseMarkersOptions = (options?: Options<AdminPaymentsPaymentsReleaseMarkersData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await AdminPayments.adminPaymentsPaymentsReleaseMarkers({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: adminPaymentsPaymentsReleaseMarkersQueryKey(options)
    });
};

export const adminPaymentsPaymentsReleaseMarkersInfiniteQueryKey = (options?: Options<AdminPaymentsPaymentsReleaseMarkersData>): QueryKey<Options<AdminPaymentsPaymentsReleaseMarkersData>> => createQueryKey('adminPaymentsPaymentsReleaseMarkers', options, true);

/**
 * Payments Release Markers
 * Ship/release annotation lines for the Ship Health charts.
 *
 * Derived from the first appearance of each app version (thresholded by
 * device count) plus any manual, non-version launches. See
 * ``crud.a.release_markers`` for the source of truth.
 */
export const adminPaymentsPaymentsReleaseMarkersInfiniteOptions = (options?: Options<AdminPaymentsPaymentsReleaseMarkersData>) => {
    return infiniteQueryOptions<AdminPaymentsPaymentsReleaseMarkersResponse, AdminPaymentsPaymentsReleaseMarkersError, InfiniteData<AdminPaymentsPaymentsReleaseMarkersResponse>, QueryKey<Options<AdminPaymentsPaymentsReleaseMarkersData>>, string | null | Pick<QueryKey<Options<AdminPaymentsPaymentsReleaseMarkersData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<AdminPaymentsPaymentsReleaseMarkersData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    start: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await AdminPayments.adminPaymentsPaymentsReleaseMarkers({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: adminPaymentsPaymentsReleaseMarkersInfiniteQueryKey(options)
    });
};

export const adminPaymentsListSubscriptionsQueryKey = (options?: Options<AdminPaymentsListSubscriptionsData>) => createQueryKey('adminPaymentsListSubscriptions', options);

/**
 * List Subscriptions
 * The canonical subscription list — one row per subscription per user.
 *
 * Composes ``canonical_entitlements()`` (never restates the dedup), so a
 * bridged Stripe+RevenueCat pair appears exactly once, under the
 * higher-precedence provider. Read-only; paginated for the ~2k+ real rows.
 */
export const adminPaymentsListSubscriptionsOptions = (options?: Options<AdminPaymentsListSubscriptionsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await AdminPayments.adminPaymentsListSubscriptions({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: adminPaymentsListSubscriptionsQueryKey(options)
    });
};

export const adminPaymentsListSubscriptionsInfiniteQueryKey = (options?: Options<AdminPaymentsListSubscriptionsData>): QueryKey<Options<AdminPaymentsListSubscriptionsData>> => createQueryKey('adminPaymentsListSubscriptions', options, true);

/**
 * List Subscriptions
 * The canonical subscription list — one row per subscription per user.
 *
 * Composes ``canonical_entitlements()`` (never restates the dedup), so a
 * bridged Stripe+RevenueCat pair appears exactly once, under the
 * higher-precedence provider. Read-only; paginated for the ~2k+ real rows.
 */
export const adminPaymentsListSubscriptionsInfiniteOptions = (options?: Options<AdminPaymentsListSubscriptionsData>) => {
    return infiniteQueryOptions<AdminPaymentsListSubscriptionsResponse, AdminPaymentsListSubscriptionsError, InfiniteData<AdminPaymentsListSubscriptionsResponse>, QueryKey<Options<AdminPaymentsListSubscriptionsData>>, number | Pick<QueryKey<Options<AdminPaymentsListSubscriptionsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<AdminPaymentsListSubscriptionsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    offset: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await AdminPayments.adminPaymentsListSubscriptions({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: adminPaymentsListSubscriptionsInfiniteQueryKey(options)
    });
};

export const adminPaymentsSubscriptionEventsQueryKey = (options: Options<AdminPaymentsSubscriptionEventsData>) => createQueryKey('adminPaymentsSubscriptionEvents', options);

/**
 * Subscription Events
 * Full event history for one subscription, across ALL providers.
 *
 * The log is keyed by ``subscription_key`` (the adapter's coalesce), so a
 * bridged web subscription's Stripe rows and RevenueCat echoes both match on
 * the shared identifier — the debugging view no vendor dashboard gives.
 */
export const adminPaymentsSubscriptionEventsOptions = (options: Options<AdminPaymentsSubscriptionEventsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await AdminPayments.adminPaymentsSubscriptionEvents({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: adminPaymentsSubscriptionEventsQueryKey(options)
    });
};

export const adminPaymentsHealthDetailQueryKey = (options: Options<AdminPaymentsHealthDetailData>) => createQueryKey('adminPaymentsHealthDetail', options);

/**
 * Health Detail
 * The rows behind one health tile — the drill-down for the cockpit.
 */
export const adminPaymentsHealthDetailOptions = (options: Options<AdminPaymentsHealthDetailData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await AdminPayments.adminPaymentsHealthDetail({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: adminPaymentsHealthDetailQueryKey(options)
    });
};

export const adminPaymentsPipelineHealthQueryKey = (options?: Options<AdminPaymentsPipelineHealthData>) => createQueryKey('adminPaymentsPipelineHealth', options);

/**
 * Pipeline Health
 * Health of the payments pipeline: are provider events arriving and does
 * the ledger add up.
 *
 * Each check is a count of rows breaking one invariant from the latest
 * nightly run; red ones mean money or access is wrong for someone. Counts
 * only, no rows: the rows behind a check are a separate, per-person route.
 * Unprocessed events are counted live.
 */
export const adminPaymentsPipelineHealthOptions = (options?: Options<AdminPaymentsPipelineHealthData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await AdminPayments.adminPaymentsPipelineHealth({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: adminPaymentsPipelineHealthQueryKey(options)
    });
};

export const adminPaymentsListAnomaliesQueryKey = (options: Options<AdminPaymentsListAnomaliesData>) => createQueryKey('adminPaymentsListAnomalies', options);

/**
 * List Anomalies
 * The flagged items of one invariant bucket, with triage state and the user.
 *
 * Each row carries its disposition (or none == new), whether it is currently
 * "loud" (new, resurfaced deferred, or stale needs_action), and — for
 * unattributed rows — whether it can be attributed to a user in-app.
 */
export const adminPaymentsListAnomaliesOptions = (options: Options<AdminPaymentsListAnomaliesData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await AdminPayments.adminPaymentsListAnomalies({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: adminPaymentsListAnomaliesQueryKey(options)
    });
};

/**
 * Triage Anomalies
 * Set the triage disposition on one or more flagged items (bulk).
 */
export const adminPaymentsTriageAnomaliesMutation = (options?: Partial<Options<AdminPaymentsTriageAnomaliesData>>): UseMutationOptions<AdminPaymentsTriageAnomaliesResponse, AdminPaymentsTriageAnomaliesError, Options<AdminPaymentsTriageAnomaliesData>> => {
    const mutationOptions: UseMutationOptions<AdminPaymentsTriageAnomaliesResponse, AdminPaymentsTriageAnomaliesError, Options<AdminPaymentsTriageAnomaliesData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await AdminPayments.adminPaymentsTriageAnomalies({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Attribute Anomaly
 * Attribute an unresolved payment identity to an account and re-project it.
 *
 * A targeted fix for `unattributed_entitled`: aliases the provider's
 * `app_user_id` to the target user and runs a scoped re-projection so the
 * entitlement resolves — no full replay. Gated on `payments:grant` and audited.
 */
export const adminPaymentsAttributeAnomalyMutation = (options?: Partial<Options<AdminPaymentsAttributeAnomalyData>>): UseMutationOptions<AdminPaymentsAttributeAnomalyResponse, AdminPaymentsAttributeAnomalyError, Options<AdminPaymentsAttributeAnomalyData>> => {
    const mutationOptions: UseMutationOptions<AdminPaymentsAttributeAnomalyResponse, AdminPaymentsAttributeAnomalyError, Options<AdminPaymentsAttributeAnomalyData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await AdminPayments.adminPaymentsAttributeAnomaly({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const adminPaymentsLookupProviderProfileQueryKey = (options: Options<AdminPaymentsLookupProviderProfileData>) => createQueryKey('adminPaymentsLookupProviderProfile', options);

/**
 * Lookup Provider Profile
 * Paste the id out of a provider dashboard URL, get the customer.
 *
 * Adapty's dashboard links look like
 * `app.adapty.io/profiles/users/<profile_id>`, and that id is theirs, not
 * ours — until privacy.provider_profile existed there was no way back from it
 * to an account.
 *
 * 404 means we have never received a webhook naming this profile, which is
 * NOT the same as "no such customer": Adapty webhooks on lifecycle
 * transitions, so a subscriber mid-period is legitimately absent until their
 * next renewal.
 */
export const adminPaymentsLookupProviderProfileOptions = (options: Options<AdminPaymentsLookupProviderProfileData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await AdminPayments.adminPaymentsLookupProviderProfile({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: adminPaymentsLookupProviderProfileQueryKey(options)
    });
};

export const adminPaymentsRecentTransactionsQueryKey = (options?: Options<AdminPaymentsRecentTransactionsData>) => createQueryKey('adminPaymentsRecentTransactions', options);

/**
 * Recent Transactions
 * The latest money-shaped events, newest first.
 *
 * Every list filter takes `!value` to exclude it: `kinds=!renewal`.
 *
 * Money events only — trial starts, purchases, renewals, refunds,
 * chargebacks, coaching places and conversions. Auto-renew toggles,
 * billing-issue notices and the opening and closing of a dispute are real
 * events but they are not transactions, and mixing them in turns the feed
 * into the webhook log we already have at /subscriptions.
 */
export const adminPaymentsRecentTransactionsOptions = (options?: Options<AdminPaymentsRecentTransactionsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await AdminPayments.adminPaymentsRecentTransactions({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: adminPaymentsRecentTransactionsQueryKey(options)
    });
};

export const adminPaymentsRecentTransactionsInfiniteQueryKey = (options?: Options<AdminPaymentsRecentTransactionsData>): QueryKey<Options<AdminPaymentsRecentTransactionsData>> => createQueryKey('adminPaymentsRecentTransactions', options, true);

/**
 * Recent Transactions
 * The latest money-shaped events, newest first.
 *
 * Every list filter takes `!value` to exclude it: `kinds=!renewal`.
 *
 * Money events only — trial starts, purchases, renewals, refunds,
 * chargebacks, coaching places and conversions. Auto-renew toggles,
 * billing-issue notices and the opening and closing of a dispute are real
 * events but they are not transactions, and mixing them in turns the feed
 * into the webhook log we already have at /subscriptions.
 */
export const adminPaymentsRecentTransactionsInfiniteOptions = (options?: Options<AdminPaymentsRecentTransactionsData>) => {
    return infiniteQueryOptions<AdminPaymentsRecentTransactionsResponse, AdminPaymentsRecentTransactionsError, InfiniteData<AdminPaymentsRecentTransactionsResponse>, QueryKey<Options<AdminPaymentsRecentTransactionsData>>, number | Pick<QueryKey<Options<AdminPaymentsRecentTransactionsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<AdminPaymentsRecentTransactionsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    offset: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await AdminPayments.adminPaymentsRecentTransactions({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: adminPaymentsRecentTransactionsInfiniteQueryKey(options)
    });
};

export const adminPaymentsGroupCoachingCampaignsQueryKey = (options?: Options<AdminPaymentsGroupCoachingCampaignsData>) => createQueryKey('adminPaymentsGroupCoachingCampaigns', options);

/**
 * Group Coaching Campaigns
 * Banner reach, coaching page visits and coaching sales, by utm source.
 */
export const adminPaymentsGroupCoachingCampaignsOptions = (options?: Options<AdminPaymentsGroupCoachingCampaignsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await AdminPayments.adminPaymentsGroupCoachingCampaigns({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: adminPaymentsGroupCoachingCampaignsQueryKey(options)
    });
};

export const adminPaymentsGroupCoachingCampaignsInfiniteQueryKey = (options?: Options<AdminPaymentsGroupCoachingCampaignsData>): QueryKey<Options<AdminPaymentsGroupCoachingCampaignsData>> => createQueryKey('adminPaymentsGroupCoachingCampaigns', options, true);

/**
 * Group Coaching Campaigns
 * Banner reach, coaching page visits and coaching sales, by utm source.
 */
export const adminPaymentsGroupCoachingCampaignsInfiniteOptions = (options?: Options<AdminPaymentsGroupCoachingCampaignsData>) => {
    return infiniteQueryOptions<AdminPaymentsGroupCoachingCampaignsResponse, AdminPaymentsGroupCoachingCampaignsError, InfiniteData<AdminPaymentsGroupCoachingCampaignsResponse>, QueryKey<Options<AdminPaymentsGroupCoachingCampaignsData>>, string | null | Pick<QueryKey<Options<AdminPaymentsGroupCoachingCampaignsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<AdminPaymentsGroupCoachingCampaignsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    start: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await AdminPayments.adminPaymentsGroupCoachingCampaigns({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: adminPaymentsGroupCoachingCampaignsInfiniteQueryKey(options)
    });
};

export const adminPaymentsCoachingBuyersQueryKey = (options?: Options<AdminPaymentsCoachingBuyersData>) => createQueryKey('adminPaymentsCoachingBuyers', options);

/**
 * Coaching Buyers
 * Every place on the Condri Group Coaching Programme sold in the window,
 * newest first: who bought it, whether they already had an account, whether
 * the money came back, and whether the app access that came with the place
 * is still live.
 *
 * Per-person rows, so it carries the subscriptions scope like the
 * transactions feed rather than the aggregate payments scope.
 */
export const adminPaymentsCoachingBuyersOptions = (options?: Options<AdminPaymentsCoachingBuyersData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await AdminPayments.adminPaymentsCoachingBuyers({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: adminPaymentsCoachingBuyersQueryKey(options)
    });
};

export const adminPaymentsCoachingBuyersInfiniteQueryKey = (options?: Options<AdminPaymentsCoachingBuyersData>): QueryKey<Options<AdminPaymentsCoachingBuyersData>> => createQueryKey('adminPaymentsCoachingBuyers', options, true);

/**
 * Coaching Buyers
 * Every place on the Condri Group Coaching Programme sold in the window,
 * newest first: who bought it, whether they already had an account, whether
 * the money came back, and whether the app access that came with the place
 * is still live.
 *
 * Per-person rows, so it carries the subscriptions scope like the
 * transactions feed rather than the aggregate payments scope.
 */
export const adminPaymentsCoachingBuyersInfiniteOptions = (options?: Options<AdminPaymentsCoachingBuyersData>) => {
    return infiniteQueryOptions<AdminPaymentsCoachingBuyersResponse, AdminPaymentsCoachingBuyersError, InfiniteData<AdminPaymentsCoachingBuyersResponse>, QueryKey<Options<AdminPaymentsCoachingBuyersData>>, string | null | Pick<QueryKey<Options<AdminPaymentsCoachingBuyersData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<AdminPaymentsCoachingBuyersData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    start: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await AdminPayments.adminPaymentsCoachingBuyers({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: adminPaymentsCoachingBuyersInfiniteQueryKey(options)
    });
};

export const adminVitalSignsVitalSignsQueryKey = (options?: Options<AdminVitalSignsVitalSignsData>) => createQueryKey('adminVitalSignsVitalSigns', options);

/**
 * Vital Signs
 * Each of the last `days` days, ending yesterday (UTC), judged the way the
 * morning alert judges it: against the BASELINE_DAYS before it.
 */
export const adminVitalSignsVitalSignsOptions = (options?: Options<AdminVitalSignsVitalSignsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await AdminVitalSigns.adminVitalSignsVitalSigns({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: adminVitalSignsVitalSignsQueryKey(options)
    });
};

export const adminCustomersLookupCustomerQueryKey = (options: Options<AdminCustomersLookupCustomerData>) => createQueryKey('adminCustomersLookupCustomer', options);

/**
 * Lookup Customer
 * Type-ahead search: partial email/name match (or exact user id),
 * returning compact cells. The exact email hit always ranks first;
 * ``user_id`` is the top hit so Enter can open it directly.
 */
export const adminCustomersLookupCustomerOptions = (options: Options<AdminCustomersLookupCustomerData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await AdminCustomers.adminCustomersLookupCustomer({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: adminCustomersLookupCustomerQueryKey(options)
    });
};

export const adminCustomersCustomerLandingQueryKey = (options?: Options<AdminCustomersCustomerLandingData>) => createQueryKey('adminCustomersCustomerLanding', options);

/**
 * Customer Landing
 * The /customers index lists. Per-list access rules:
 *
 * Gated by `users:read`, not `payments:read`: every list here names people
 * (email, name, id), and `payments:read` is the AGGREGATE payments scope
 * that `viewer-insights` holds for charts. Under it, an aggregate-only
 * viewer could read the newest signups' emails.
 *
 * * recently_viewed — the caller's OWN scv_access_audit trail, so no extra
 * scope beyond admin. Every kind of row counts: from now on each person
 * page open writes a `page_view`, and the rows written before that column
 * existed are `activity_read`s, which were page opens too (the page read
 * activity on every open). Filtering to `page_view` would empty the strip
 * on deploy day for no gain.
 * * recent_subscribers — per-user payment data: included only when the
 * caller's roles grant payments:subscriptions:read, empty otherwise.
 * * newest_signups — plain admin.
 */
export const adminCustomersCustomerLandingOptions = (options?: Options<AdminCustomersCustomerLandingData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await AdminCustomers.adminCustomersCustomerLanding({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: adminCustomersCustomerLandingQueryKey(options)
    });
};

export const adminCustomersGetCustomerQueryKey = (options: Options<AdminCustomersGetCustomerData>) => createQueryKey('adminCustomersGetCustomer', options);

/**
 * Get Customer
 */
export const adminCustomersGetCustomerOptions = (options: Options<AdminCustomersGetCustomerData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await AdminCustomers.adminCustomersGetCustomer({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: adminCustomersGetCustomerQueryKey(options)
    });
};

export const adminCustomersGetCustomerActivityQueryKey = (options: Options<AdminCustomersGetCustomerActivityData>) => createQueryKey('adminCustomersGetCustomerActivity', options);

/**
 * Get Customer Activity
 * Engagement counts. How often, never what — no entry text, no messages.
 *
 * Every call writes an access-audit row (viewer, subject, when) before the
 * counts are read: activity frequency per identified person is health data.
 */
export const adminCustomersGetCustomerActivityOptions = (options: Options<AdminCustomersGetCustomerActivityData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await AdminCustomers.adminCustomersGetCustomerActivity({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: adminCustomersGetCustomerActivityQueryKey(options)
    });
};

export const adminCustomersGetCustomerEmailsQueryKey = (options: Options<AdminCustomersGetCustomerEmailsData>) => createQueryKey('adminCustomersGetCustomerEmails', options);

/**
 * Get Customer Emails
 * Sends + engagement state, enrolled campaigns and email consent. Never
 * message bodies.
 */
export const adminCustomersGetCustomerEmailsOptions = (options: Options<AdminCustomersGetCustomerEmailsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await AdminCustomers.adminCustomersGetCustomerEmails({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: adminCustomersGetCustomerEmailsQueryKey(options)
    });
};

export const adminCustomersGetCustomerEmailsInfiniteQueryKey = (options: Options<AdminCustomersGetCustomerEmailsData>): QueryKey<Options<AdminCustomersGetCustomerEmailsData>> => createQueryKey('adminCustomersGetCustomerEmails', options, true);

/**
 * Get Customer Emails
 * Sends + engagement state, enrolled campaigns and email consent. Never
 * message bodies.
 */
export const adminCustomersGetCustomerEmailsInfiniteOptions = (options: Options<AdminCustomersGetCustomerEmailsData>) => {
    return infiniteQueryOptions<AdminCustomersGetCustomerEmailsResponse, AdminCustomersGetCustomerEmailsError, InfiniteData<AdminCustomersGetCustomerEmailsResponse>, QueryKey<Options<AdminCustomersGetCustomerEmailsData>>, number | Pick<QueryKey<Options<AdminCustomersGetCustomerEmailsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<AdminCustomersGetCustomerEmailsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await AdminCustomers.adminCustomersGetCustomerEmails({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: adminCustomersGetCustomerEmailsInfiniteQueryKey(options)
    });
};

export const adminCustomersGetCustomerEmailDataQueryKey = (options: Options<AdminCustomersGetCustomerEmailDataData>) => createQueryKey('adminCustomersGetCustomerEmailData', options);

/**
 * Get Customer Email Data
 * The email part of a subject access request (DATA-03), as one JSON
 * file: every consent decision with the words shown and where, what was
 * sent and what happened to it, "Did this help?" answers, sign-in and
 * account emails, campaigns, and the do-not-email list. PII scope only.
 */
export const adminCustomersGetCustomerEmailDataOptions = (options: Options<AdminCustomersGetCustomerEmailDataData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await AdminCustomers.adminCustomersGetCustomerEmailData({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: adminCustomersGetCustomerEmailDataQueryKey(options)
    });
};

export const adminCustomersGetCustomerDevicesQueryKey = (options: Options<AdminCustomersGetCustomerDevicesData>) => createQueryKey('adminCustomersGetCustomerDevices', options);

/**
 * Get Customer Devices
 * Devices this account has been seen on (a.user_device_sightings).
 *
 * Scope decision, documented: this is device metadata (platform, versions,
 * when) — hardware facts, not health data — so it sits behind the page's
 * base payments:subscriptions:read like the entitlement and email blocks,
 * NOT behind users:activity:read. The raw identifiers (device_key, idfv)
 * stay server-side: support needs "same device y/n", never the key itself.
 */
export const adminCustomersGetCustomerDevicesOptions = (options: Options<AdminCustomersGetCustomerDevicesData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await AdminCustomers.adminCustomersGetCustomerDevices({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: adminCustomersGetCustomerDevicesQueryKey(options)
    });
};

export const adminCustomersGetCustomerReleaseStateQueryKey = (options: Options<AdminCustomersGetCustomerReleaseStateData>) => createQueryKey('adminCustomersGetCustomerReleaseState', options);

/**
 * Get Customer Release State
 * What software this account is running, from every system that decides it.
 *
 * "Why has this person not got the fix" has four possible answers living in
 * four places — their OTA cohort, the bundle actually on the device, a
 * backend flag row, a PostHog gate — and nothing joined them, so answering it
 * meant four lookups and remembering all four existed. This is the join.
 *
 * WHAT IT DELIBERATELY DOES NOT CARRY. No email, no name, no `device_key`,
 * no `idfv`. The devices block takes that decision straight from
 * `get_customer_devices` above and adds only the OTA fields. That absence is
 * what the narrow `panel:users:release:read` is: the agent principal holds it
 * and holds nothing that turns an id into a person.
 *
 * Either scope opens it. A person on the customer page already holds
 * `panel:users:read`, and giving them a second scope to see a block on a page
 * they can already read would be a permission that only ever surprises
 * somebody.
 *
 * PostHog is evaluated for the same distinct id the app identifies with — the
 * user id as a string (`AuthService.identify`) — so this reports what that
 * phone is actually told, not what a rollout percentage suggests. It is
 * allowed to be unanswerable: a gate row with `enabled: null` and a note
 * beats a 500, because the other three sources are usually where the answer
 * is.
 */
export const adminCustomersGetCustomerReleaseStateOptions = (options: Options<AdminCustomersGetCustomerReleaseStateData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await AdminCustomers.adminCustomersGetCustomerReleaseState({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: adminCustomersGetCustomerReleaseStateQueryKey(options)
    });
};

/**
 * Create Grant
 * Issue a manual entitlement grant (spec-scv.md finding 1, all of it).
 *
 * * Kind whitelist: comp / support / staff / refund_goodwill / lifetime_comp.
 * `migration` and `purchase_pending` are unreachable from this surface —
 * the request model rejects them before this function runs.
 * * `expires_at` is REQUIRED unless the kind is `lifetime_comp`, which is a
 * deliberate choice of kind, never a forgotten date. `lifetime_comp` with
 * an expiry is also rejected: one of the two must be meant.
 * * The acting admin is recorded in the event (`granted_by`).
 * * Hourly caps, per admin and global, counted from the event log. The
 * global cap logs at ERROR — that is the mass-grant alarm.
 */
export const adminCustomersCreateGrantMutation = (options?: Partial<Options<AdminCustomersCreateGrantData>>): UseMutationOptions<AdminCustomersCreateGrantResponse, AdminCustomersCreateGrantError, Options<AdminCustomersCreateGrantData>> => {
    const mutationOptions: UseMutationOptions<AdminCustomersCreateGrantResponse, AdminCustomersCreateGrantError, Options<AdminCustomersCreateGrantData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await AdminCustomers.adminCustomersCreateGrant({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Revoke Grant
 * Revoke a manual grant — after validating it (spec-scv.md finding 3).
 *
 * The CRUD will happily write a revocation for any id, which would mint a
 * phantom `expired` entitlement row via apply_delta's insert path. So this
 * endpoint loads the grant first and refuses unless it exists, belongs to
 * this user, is a manual admin grant, and is currently live.
 */
export const adminCustomersRevokeGrantMutation = (options?: Partial<Options<AdminCustomersRevokeGrantData>>): UseMutationOptions<AdminCustomersRevokeGrantResponse, AdminCustomersRevokeGrantError, Options<AdminCustomersRevokeGrantData>> => {
    const mutationOptions: UseMutationOptions<AdminCustomersRevokeGrantResponse, AdminCustomersRevokeGrantError, Options<AdminCustomersRevokeGrantData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await AdminCustomers.adminCustomersRevokeGrant({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Set Customer Payments V2
 * Flip the per-user ``payments_v2`` override for ONE user — the Phase-2
 * rollout control that makes our owned entitlement authoritative for that
 * account.
 *
 * * ``authoritative=true`` sets an explicit user override to ON.
 * * ``authoritative=false`` DELETES the override so the user falls back to
 * the global setting — the rollback path. We never write an explicit
 * False row: "stop overriding" is a clear, single semantic, and it means a
 * later global rollout still reaches this user.
 *
 * Scope is ``PAYMENTS_GRANT`` — the same authority as a manual entitlement
 * grant, because this changes whose answer the user's app obeys. The change
 * is bound to this exact ``user_id`` and fully reversible.
 *
 * If the flag row is not seeded, ``calculate_flag_value`` would report false
 * for everyone and a toggle here would silently no-op — so we 409 loudly
 * rather than pretend it worked.
 */
export const adminCustomersSetCustomerPaymentsV2Mutation = (options?: Partial<Options<AdminCustomersSetCustomerPaymentsV2Data>>): UseMutationOptions<AdminCustomersSetCustomerPaymentsV2Response, AdminCustomersSetCustomerPaymentsV2Error, Options<AdminCustomersSetCustomerPaymentsV2Data>> => {
    const mutationOptions: UseMutationOptions<AdminCustomersSetCustomerPaymentsV2Response, AdminCustomersSetCustomerPaymentsV2Error, Options<AdminCustomersSetCustomerPaymentsV2Data>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await AdminCustomers.adminCustomersSetCustomerPaymentsV2({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const adminCustomersGetCustomerSegmentsQueryKey = (options: Options<AdminCustomersGetCustomerSegmentsData>) => createQueryKey('adminCustomersGetCustomerSegments', options);

/**
 * Get Customer Segments
 */
export const adminCustomersGetCustomerSegmentsOptions = (options: Options<AdminCustomersGetCustomerSegmentsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await AdminCustomers.adminCustomersGetCustomerSegments({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: adminCustomersGetCustomerSegmentsQueryKey(options)
    });
};

/**
 * Remove Customer From Segment
 */
export const adminCustomersRemoveCustomerFromSegmentMutation = (options?: Partial<Options<AdminCustomersRemoveCustomerFromSegmentData>>): UseMutationOptions<AdminCustomersRemoveCustomerFromSegmentResponse, AdminCustomersRemoveCustomerFromSegmentError, Options<AdminCustomersRemoveCustomerFromSegmentData>> => {
    const mutationOptions: UseMutationOptions<AdminCustomersRemoveCustomerFromSegmentResponse, AdminCustomersRemoveCustomerFromSegmentError, Options<AdminCustomersRemoveCustomerFromSegmentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await AdminCustomers.adminCustomersRemoveCustomerFromSegment({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Add Customer To Segment
 * Add this user to a static segment, stamped with who did it.
 */
export const adminCustomersAddCustomerToSegmentMutation = (options?: Partial<Options<AdminCustomersAddCustomerToSegmentData>>): UseMutationOptions<AdminCustomersAddCustomerToSegmentResponse, AdminCustomersAddCustomerToSegmentError, Options<AdminCustomersAddCustomerToSegmentData>> => {
    const mutationOptions: UseMutationOptions<AdminCustomersAddCustomerToSegmentResponse, AdminCustomersAddCustomerToSegmentError, Options<AdminCustomersAddCustomerToSegmentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await AdminCustomers.adminCustomersAddCustomerToSegment({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Revoke Static Login Code
 * Kill this account's live code. The revoked row stays, as the record.
 */
export const adminCustomersRevokeStaticLoginCodeMutation = (options?: Partial<Options<AdminCustomersRevokeStaticLoginCodeData>>): UseMutationOptions<AdminCustomersRevokeStaticLoginCodeResponse, AdminCustomersRevokeStaticLoginCodeError, Options<AdminCustomersRevokeStaticLoginCodeData>> => {
    const mutationOptions: UseMutationOptions<AdminCustomersRevokeStaticLoginCodeResponse, AdminCustomersRevokeStaticLoginCodeError, Options<AdminCustomersRevokeStaticLoginCodeData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await AdminCustomers.adminCustomersRevokeStaticLoginCode({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const adminCustomersGetStaticLoginCodeQueryKey = (options: Options<AdminCustomersGetStaticLoginCodeData>) => createQueryKey('adminCustomersGetStaticLoginCode', options);

/**
 * Get Static Login Code
 * Its own admin-only read scope, not the customer-page one.
 *
 * The response body is a live credential. Handing it to everyone who can view
 * a customer record would make "who can sign in as this account" much wider
 * than "who can create the code", which is the wrong way round -- so this sits
 * with `secrets:read`, not with the rest of this file.
 */
export const adminCustomersGetStaticLoginCodeOptions = (options: Options<AdminCustomersGetStaticLoginCodeData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await AdminCustomers.adminCustomersGetStaticLoginCode({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: adminCustomersGetStaticLoginCodeQueryKey(options)
    });
};

/**
 * Create Static Login Code
 * Mint this account's permanent code, replacing any it already had.
 *
 * Create and regenerate are one operation — the caller never has to know which
 * it is, and no path can leave two live codes behind.
 *
 * Refused for anonymous accounts and for accounts with no email: the code is
 * typed on a screen the app only reaches after an address is submitted, so on
 * an account without one it would be a credential with no door to open.
 */
export const adminCustomersCreateStaticLoginCodeMutation = (options?: Partial<Options<AdminCustomersCreateStaticLoginCodeData>>): UseMutationOptions<AdminCustomersCreateStaticLoginCodeResponse, AdminCustomersCreateStaticLoginCodeError, Options<AdminCustomersCreateStaticLoginCodeData>> => {
    const mutationOptions: UseMutationOptions<AdminCustomersCreateStaticLoginCodeResponse, AdminCustomersCreateStaticLoginCodeError, Options<AdminCustomersCreateStaticLoginCodeData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await AdminCustomers.adminCustomersCreateStaticLoginCode({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const adminFunnelLeadsListFunnelLeadsQueryKey = (options?: Options<AdminFunnelLeadsListFunnelLeadsData>) => createQueryKey('adminFunnelLeadsListFunnelLeads', options);

/**
 * List Funnel Leads
 * Funnel contacts with no subscription, newest first.
 */
export const adminFunnelLeadsListFunnelLeadsOptions = (options?: Options<AdminFunnelLeadsListFunnelLeadsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await AdminFunnelLeads.adminFunnelLeadsListFunnelLeads({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: adminFunnelLeadsListFunnelLeadsQueryKey(options)
    });
};

export const adminFunnelLeadsListFunnelLeadsInfiniteQueryKey = (options?: Options<AdminFunnelLeadsListFunnelLeadsData>): QueryKey<Options<AdminFunnelLeadsListFunnelLeadsData>> => createQueryKey('adminFunnelLeadsListFunnelLeads', options, true);

/**
 * List Funnel Leads
 * Funnel contacts with no subscription, newest first.
 */
export const adminFunnelLeadsListFunnelLeadsInfiniteOptions = (options?: Options<AdminFunnelLeadsListFunnelLeadsData>) => {
    return infiniteQueryOptions<AdminFunnelLeadsListFunnelLeadsResponse, AdminFunnelLeadsListFunnelLeadsError, InfiniteData<AdminFunnelLeadsListFunnelLeadsResponse>, QueryKey<Options<AdminFunnelLeadsListFunnelLeadsData>>, number | Pick<QueryKey<Options<AdminFunnelLeadsListFunnelLeadsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<AdminFunnelLeadsListFunnelLeadsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await AdminFunnelLeads.adminFunnelLeadsListFunnelLeads({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: adminFunnelLeadsListFunnelLeadsInfiniteQueryKey(options)
    });
};

export const adminFunnelLeadsExportFunnelLeadsCsvQueryKey = (options?: Options<AdminFunnelLeadsExportFunnelLeadsCsvData>) => createQueryKey('adminFunnelLeadsExportFunnelLeadsCsv', options);

/**
 * Export Funnel Leads Csv
 * Every lead matching the filters, as a CSV file.
 */
export const adminFunnelLeadsExportFunnelLeadsCsvOptions = (options?: Options<AdminFunnelLeadsExportFunnelLeadsCsvData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await AdminFunnelLeads.adminFunnelLeadsExportFunnelLeadsCsv({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: adminFunnelLeadsExportFunnelLeadsCsvQueryKey(options)
    });
};

export const adminHardshipOfferGetHardshipOfferQueryKey = (options?: Options<AdminHardshipOfferGetHardshipOfferData>) => createQueryKey('adminHardshipOfferGetHardshipOffer', options);

/**
 * Get Hardship Offer
 */
export const adminHardshipOfferGetHardshipOfferOptions = (options?: Options<AdminHardshipOfferGetHardshipOfferData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await AdminHardshipOffer.adminHardshipOfferGetHardshipOffer({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: adminHardshipOfferGetHardshipOfferQueryKey(options)
    });
};

/**
 * Remove Hardship Email
 * Take one address off. Its next checkout prices normally.
 */
export const adminHardshipOfferRemoveHardshipEmailMutation = (options?: Partial<Options<AdminHardshipOfferRemoveHardshipEmailData>>): UseMutationOptions<AdminHardshipOfferRemoveHardshipEmailResponse, AdminHardshipOfferRemoveHardshipEmailError, Options<AdminHardshipOfferRemoveHardshipEmailData>> => {
    const mutationOptions: UseMutationOptions<AdminHardshipOfferRemoveHardshipEmailResponse, AdminHardshipOfferRemoveHardshipEmailError, Options<AdminHardshipOfferRemoveHardshipEmailData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await AdminHardshipOffer.adminHardshipOfferRemoveHardshipEmail({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Add Hardship Emails
 * Add every address in the pasted text. Duplicates and ones already on
 * the list are reported, not errors; invalid entries are echoed back.
 */
export const adminHardshipOfferAddHardshipEmailsMutation = (options?: Partial<Options<AdminHardshipOfferAddHardshipEmailsData>>): UseMutationOptions<AdminHardshipOfferAddHardshipEmailsResponse, AdminHardshipOfferAddHardshipEmailsError, Options<AdminHardshipOfferAddHardshipEmailsData>> => {
    const mutationOptions: UseMutationOptions<AdminHardshipOfferAddHardshipEmailsResponse, AdminHardshipOfferAddHardshipEmailsError, Options<AdminHardshipOfferAddHardshipEmailsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await AdminHardshipOffer.adminHardshipOfferAddHardshipEmails({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Send Hardship Offer Email
 * The offer email to everyone on the list who has not had it in the
 * last 30 days. A service notice: they are told about a price we set aside
 * for them, so marketing opt-outs do not stop it; the do-not-email list
 * does. `dry_run` (the default) counts and sends nothing. A real send goes
 * after the one-minute undo window, like every one-off.
 */
export const adminHardshipOfferSendHardshipOfferEmailMutation = (options?: Partial<Options<AdminHardshipOfferSendHardshipOfferEmailData>>): UseMutationOptions<AdminHardshipOfferSendHardshipOfferEmailResponse, AdminHardshipOfferSendHardshipOfferEmailError, Options<AdminHardshipOfferSendHardshipOfferEmailData>> => {
    const mutationOptions: UseMutationOptions<AdminHardshipOfferSendHardshipOfferEmailResponse, AdminHardshipOfferSendHardshipOfferEmailError, Options<AdminHardshipOfferSendHardshipOfferEmailData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await AdminHardshipOffer.adminHardshipOfferSendHardshipOfferEmail({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Test Send Hardship Offer Email
 * The offer email to your own address, marked [TEST].
 */
export const adminHardshipOfferTestSendHardshipOfferEmailMutation = (options?: Partial<Options<AdminHardshipOfferTestSendHardshipOfferEmailData>>): UseMutationOptions<AdminHardshipOfferTestSendHardshipOfferEmailResponse, DefaultError, Options<AdminHardshipOfferTestSendHardshipOfferEmailData>> => {
    const mutationOptions: UseMutationOptions<AdminHardshipOfferTestSendHardshipOfferEmailResponse, DefaultError, Options<AdminHardshipOfferTestSendHardshipOfferEmailData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await AdminHardshipOffer.adminHardshipOfferTestSendHardshipOfferEmail({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const adminConsentConsentDashboardQueryKey = (options?: Options<AdminConsentConsentDashboardData>) => createQueryKey('adminConsentConsentDashboard', options);

/**
 * Consent Dashboard
 * Per-purpose states, cohorts of what we may send, statement versions,
 * and the invariants that say whether the counts add up.
 */
export const adminConsentConsentDashboardOptions = (options?: Options<AdminConsentConsentDashboardData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await AdminConsent.adminConsentConsentDashboard({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: adminConsentConsentDashboardQueryKey(options)
    });
};

export const adminCustomersGetPushReadinessQueryKey = (options: Options<AdminCustomersGetPushReadinessData>) => createQueryKey('adminCustomersGetPushReadiness', options);

/**
 * Get Push Readiness
 * Device and quiet-hours state for one user, before anything is sent.
 *
 * Behind NOTIFICATIONS_READ, not the send scope. The first draft of this
 * guarded it with `:send` on the reasoning that a person's local hour says
 * where they are, and `test_read_routes_are_not_guarded_by_write_scopes`
 * rejected it: a GET behind a mutating scope locks viewers out of a page
 * they are meant to see. The invariant is right. This is device health and
 * a clock reading, the same shape of fact as the device list already behind
 * a viewer scope, and the panel hides the whole card behind `:send` anyway,
 * so nothing is advertised to someone who cannot act on it. The token
 * strings, which are the only part worth guarding harder, never leave the
 * server at all.
 */
export const adminCustomersGetPushReadinessOptions = (options: Options<AdminCustomersGetPushReadinessData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await AdminCustomers.adminCustomersGetPushReadiness({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: adminCustomersGetPushReadinessQueryKey(options)
    });
};

/**
 * Check Push Receipts
 * Ask Expo what became of each of this person's last push messages.
 *
 * `send()` reports success when Expo ACCEPTS a message, so the panel said
 * "sent" for a phone dead for an hour. Only the receipt knows.
 *
 * Behind the send scope, not the read scope: a DeviceNotRegistered receipt
 * deactivates that token, and a route that writes should not hide behind a
 * viewer's permissions. Returns the whole readiness block so the caller
 * re-renders from one response.
 */
export const adminCustomersCheckPushReceiptsMutation = (options?: Partial<Options<AdminCustomersCheckPushReceiptsData>>): UseMutationOptions<AdminCustomersCheckPushReceiptsResponse, AdminCustomersCheckPushReceiptsError, Options<AdminCustomersCheckPushReceiptsData>> => {
    const mutationOptions: UseMutationOptions<AdminCustomersCheckPushReceiptsResponse, AdminCustomersCheckPushReceiptsError, Options<AdminCustomersCheckPushReceiptsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await AdminCustomers.adminCustomersCheckPushReceipts({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Send Test Push
 * Send ONE real push to ONE user and report exactly what Expo said.
 *
 * Strictly one recipient. There is no list form of this endpoint and there
 * should not be one: it is a diagnostic, and a diagnostic that can address
 * many people is a broadcast channel that skipped the review a broadcast
 * channel gets. Campaigns go through the bulk sender.
 *
 * Drives the real `PushNotificationSender.send()` path, not a shortcut, so
 * that this doubles as the smoke test for the sender itself -- a mock in
 * front of our own send method would hide exactly the bugs an operator is
 * here to find.
 *
 * Returns 200 with `status="no_recipient"` when there is no live device.
 * That is an answer, not an error: "this user has no active token" is
 * frequently the very thing being asked, and a 4xx would make the caller
 * treat the successful diagnosis as a failure.
 */
export const adminCustomersSendTestPushMutation = (options?: Partial<Options<AdminCustomersSendTestPushData>>): UseMutationOptions<AdminCustomersSendTestPushResponse, AdminCustomersSendTestPushError, Options<AdminCustomersSendTestPushData>> => {
    const mutationOptions: UseMutationOptions<AdminCustomersSendTestPushResponse, AdminCustomersSendTestPushError, Options<AdminCustomersSendTestPushData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await AdminCustomers.adminCustomersSendTestPush({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Preview Push List
 * Who this would reach right now. Sends nothing.
 */
export const adminPushListsPreviewPushListMutation = (options?: Partial<Options<AdminPushListsPreviewPushListData>>): UseMutationOptions<AdminPushListsPreviewPushListResponse, AdminPushListsPreviewPushListError, Options<AdminPushListsPreviewPushListData>> => {
    const mutationOptions: UseMutationOptions<AdminPushListsPreviewPushListResponse, AdminPushListsPreviewPushListError, Options<AdminPushListsPreviewPushListData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await AdminPushLists.adminPushListsPreviewPushList({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Send Push List
 */
export const adminPushListsSendPushListMutation = (options?: Partial<Options<AdminPushListsSendPushListData>>): UseMutationOptions<AdminPushListsSendPushListResponse, AdminPushListsSendPushListError, Options<AdminPushListsSendPushListData>> => {
    const mutationOptions: UseMutationOptions<AdminPushListsSendPushListResponse, AdminPushListsSendPushListError, Options<AdminPushListsSendPushListData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await AdminPushLists.adminPushListsSendPushList({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Preview Schedule
 * When each person would get it, and where that estimate came from.
 */
export const adminPushListsPreviewScheduleMutation = (options?: Partial<Options<AdminPushListsPreviewScheduleData>>): UseMutationOptions<AdminPushListsPreviewScheduleResponse, AdminPushListsPreviewScheduleError, Options<AdminPushListsPreviewScheduleData>> => {
    const mutationOptions: UseMutationOptions<AdminPushListsPreviewScheduleResponse, AdminPushListsPreviewScheduleError, Options<AdminPushListsPreviewScheduleData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await AdminPushLists.adminPushListsPreviewSchedule({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Create Schedule
 * Freeze the list and each person's send time. The scheduler does the rest.
 */
export const adminPushListsCreateScheduleMutation = (options?: Partial<Options<AdminPushListsCreateScheduleData>>): UseMutationOptions<AdminPushListsCreateScheduleResponse, AdminPushListsCreateScheduleError, Options<AdminPushListsCreateScheduleData>> => {
    const mutationOptions: UseMutationOptions<AdminPushListsCreateScheduleResponse, AdminPushListsCreateScheduleError, Options<AdminPushListsCreateScheduleData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await AdminPushLists.adminPushListsCreateSchedule({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const adminPushListsListScheduledQueryKey = (options?: Options<AdminPushListsListScheduledData>) => createQueryKey('adminPushListsListScheduled', options);

/**
 * List Scheduled
 * The 30 most recent scheduled pushes, with how far each has got.
 */
export const adminPushListsListScheduledOptions = (options?: Options<AdminPushListsListScheduledData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await AdminPushLists.adminPushListsListScheduled({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: adminPushListsListScheduledQueryKey(options)
    });
};

/**
 * Cancel Scheduled
 * Stop it for everyone not yet sent. Already-sent pushes stay sent.
 */
export const adminPushListsCancelScheduledMutation = (options?: Partial<Options<AdminPushListsCancelScheduledData>>): UseMutationOptions<AdminPushListsCancelScheduledResponse, AdminPushListsCancelScheduledError, Options<AdminPushListsCancelScheduledData>> => {
    const mutationOptions: UseMutationOptions<AdminPushListsCancelScheduledResponse, AdminPushListsCancelScheduledError, Options<AdminPushListsCancelScheduledData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await AdminPushLists.adminPushListsCancelScheduled({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const adminStoreReviewGetStoreReviewOverviewQueryKey = (options?: Options<AdminStoreReviewGetStoreReviewOverviewData>) => createQueryKey('adminStoreReviewGetStoreReviewOverview', options);

/**
 * Get Store Review Overview
 * Every account with a live permanent code, plus the address to prefill.
 *
 * The list is the answer to "what doors are currently open", which is the
 * question nobody could ask before this page existed -- the codes were only
 * visible one customer record at a time.
 */
export const adminStoreReviewGetStoreReviewOverviewOptions = (options?: Options<AdminStoreReviewGetStoreReviewOverviewData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await AdminStoreReview.adminStoreReviewGetStoreReviewOverview({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: adminStoreReviewGetStoreReviewOverviewQueryKey(options)
    });
};

export const adminStoreReviewLookupStoreReviewEmailQueryKey = (options: Options<AdminStoreReviewLookupStoreReviewEmailData>) => createQueryKey('adminStoreReviewLookupStoreReviewEmail', options);

/**
 * Lookup Store Review Email
 * Resolve an address to the account a code would be issued against.
 *
 * Answers 200 with `found: false` rather than 404 for an address nobody owns.
 * That is not an error here: typing an address that has no account yet is the
 * normal first step of setting one up, and the page needs to say "create the
 * account first" rather than show a failure.
 */
export const adminStoreReviewLookupStoreReviewEmailOptions = (options: Options<AdminStoreReviewLookupStoreReviewEmailData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await AdminStoreReview.adminStoreReviewLookupStoreReviewEmail({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: adminStoreReviewLookupStoreReviewEmailQueryKey(options)
    });
};

/**
 * Provision Store Review Account
 * Make this address ready to hand to a store reviewer, in one action.
 *
 * Three things have to be true before review notes can be filled in, and
 * doing them separately is how one gets forgotten: the account must exist,
 * something must pay for it, and it must hold a permanent code. This does all
 * three and reports which ones it had to do.
 *
 * Idempotent by design -- each step is skipped if it is already true -- so it
 * is safe to press again on a half-set-up account, and pressing it twice never
 * rotates a code somebody has already pasted into App Store Connect.
 *
 * Deliberately a button rather than a migration. A migration that mints a live
 * credential bakes it into schema history, runs where nobody is watching, and
 * silently does nothing when the account is absent. This runs on demand in any
 * environment, is attributed to the admin who pressed it, and is revocable
 * from the same page.
 */
export const adminStoreReviewProvisionStoreReviewAccountMutation = (options?: Partial<Options<AdminStoreReviewProvisionStoreReviewAccountData>>): UseMutationOptions<AdminStoreReviewProvisionStoreReviewAccountResponse, AdminStoreReviewProvisionStoreReviewAccountError, Options<AdminStoreReviewProvisionStoreReviewAccountData>> => {
    const mutationOptions: UseMutationOptions<AdminStoreReviewProvisionStoreReviewAccountResponse, AdminStoreReviewProvisionStoreReviewAccountError, Options<AdminStoreReviewProvisionStoreReviewAccountData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await AdminStoreReview.adminStoreReviewProvisionStoreReviewAccount({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const adminCommunityListCommunityPostsQueryKey = (options?: Options<AdminCommunityListCommunityPostsData>) => createQueryKey('adminCommunityListCommunityPosts', options);

/**
 * List Community Posts
 * Newest-first page of posts, with optional author-email, single-day, and
 * status filters. With no `status`, archived posts are hidden (the active
 * view); pass `status=archived` for the archive. Offset pagination.
 */
export const adminCommunityListCommunityPostsOptions = (options?: Options<AdminCommunityListCommunityPostsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await AdminCommunity.adminCommunityListCommunityPosts({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: adminCommunityListCommunityPostsQueryKey(options)
    });
};

export const adminCommunityListCommunityPostsInfiniteQueryKey = (options?: Options<AdminCommunityListCommunityPostsData>): QueryKey<Options<AdminCommunityListCommunityPostsData>> => createQueryKey('adminCommunityListCommunityPosts', options, true);

/**
 * List Community Posts
 * Newest-first page of posts, with optional author-email, single-day, and
 * status filters. With no `status`, archived posts are hidden (the active
 * view); pass `status=archived` for the archive. Offset pagination.
 */
export const adminCommunityListCommunityPostsInfiniteOptions = (options?: Options<AdminCommunityListCommunityPostsData>) => {
    return infiniteQueryOptions<AdminCommunityListCommunityPostsResponse, AdminCommunityListCommunityPostsError, InfiniteData<AdminCommunityListCommunityPostsResponse>, QueryKey<Options<AdminCommunityListCommunityPostsData>>, number | Pick<QueryKey<Options<AdminCommunityListCommunityPostsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<AdminCommunityListCommunityPostsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    offset: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await AdminCommunity.adminCommunityListCommunityPosts({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: adminCommunityListCommunityPostsInfiniteQueryKey(options)
    });
};

/**
 * Create Community Post
 * Post to the community as the signed-in moderator's own profile: now, or
 * at `publish_at`, when the scheduler publishes it as a new post.
 */
export const adminCommunityCreateCommunityPostMutation = (options?: Partial<Options<AdminCommunityCreateCommunityPostData>>): UseMutationOptions<AdminCommunityCreateCommunityPostResponse, AdminCommunityCreateCommunityPostError, Options<AdminCommunityCreateCommunityPostData>> => {
    const mutationOptions: UseMutationOptions<AdminCommunityCreateCommunityPostResponse, AdminCommunityCreateCommunityPostError, Options<AdminCommunityCreateCommunityPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await AdminCommunity.adminCommunityCreateCommunityPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Cancel Scheduled Community Post
 * Cancel a scheduled post. Only one that hasn't gone live: a live post is
 * archived instead, which can be undone.
 */
export const adminCommunityCancelScheduledCommunityPostMutation = (options?: Partial<Options<AdminCommunityCancelScheduledCommunityPostData>>): UseMutationOptions<AdminCommunityCancelScheduledCommunityPostResponse, AdminCommunityCancelScheduledCommunityPostError, Options<AdminCommunityCancelScheduledCommunityPostData>> => {
    const mutationOptions: UseMutationOptions<AdminCommunityCancelScheduledCommunityPostResponse, AdminCommunityCancelScheduledCommunityPostError, Options<AdminCommunityCancelScheduledCommunityPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await AdminCommunity.adminCommunityCancelScheduledCommunityPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const adminCommunityGetCommunityPostQueryKey = (options: Options<AdminCommunityGetCommunityPostData>) => createQueryKey('adminCommunityGetCommunityPost', options);

/**
 * Get Community Post
 */
export const adminCommunityGetCommunityPostOptions = (options: Options<AdminCommunityGetCommunityPostData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await AdminCommunity.adminCommunityGetCommunityPost({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: adminCommunityGetCommunityPostQueryKey(options)
    });
};

/**
 * Update Scheduled Community Post
 * Rewrite a scheduled post before it goes live: text, category, media
 * (null removes it) and time.
 */
export const adminCommunityUpdateScheduledCommunityPostMutation = (options?: Partial<Options<AdminCommunityUpdateScheduledCommunityPostData>>): UseMutationOptions<AdminCommunityUpdateScheduledCommunityPostResponse, AdminCommunityUpdateScheduledCommunityPostError, Options<AdminCommunityUpdateScheduledCommunityPostData>> => {
    const mutationOptions: UseMutationOptions<AdminCommunityUpdateScheduledCommunityPostResponse, AdminCommunityUpdateScheduledCommunityPostError, Options<AdminCommunityUpdateScheduledCommunityPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await AdminCommunity.adminCommunityUpdateScheduledCommunityPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Archive Community Post
 * Reversible soft-delete: hide from the feed but keep the row.
 */
export const adminCommunityArchiveCommunityPostMutation = (options?: Partial<Options<AdminCommunityArchiveCommunityPostData>>): UseMutationOptions<AdminCommunityArchiveCommunityPostResponse, AdminCommunityArchiveCommunityPostError, Options<AdminCommunityArchiveCommunityPostData>> => {
    const mutationOptions: UseMutationOptions<AdminCommunityArchiveCommunityPostResponse, AdminCommunityArchiveCommunityPostError, Options<AdminCommunityArchiveCommunityPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await AdminCommunity.adminCommunityArchiveCommunityPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Restore Community Post
 */
export const adminCommunityRestoreCommunityPostMutation = (options?: Partial<Options<AdminCommunityRestoreCommunityPostData>>): UseMutationOptions<AdminCommunityRestoreCommunityPostResponse, AdminCommunityRestoreCommunityPostError, Options<AdminCommunityRestoreCommunityPostData>> => {
    const mutationOptions: UseMutationOptions<AdminCommunityRestoreCommunityPostResponse, AdminCommunityRestoreCommunityPostError, Options<AdminCommunityRestoreCommunityPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await AdminCommunity.adminCommunityRestoreCommunityPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Set Community Post Topic
 * Move a post to another category. The target must be an active category;
 * posts in a private room (feedback) stay where they are.
 */
export const adminCommunitySetCommunityPostTopicMutation = (options?: Partial<Options<AdminCommunitySetCommunityPostTopicData>>): UseMutationOptions<AdminCommunitySetCommunityPostTopicResponse, AdminCommunitySetCommunityPostTopicError, Options<AdminCommunitySetCommunityPostTopicData>> => {
    const mutationOptions: UseMutationOptions<AdminCommunitySetCommunityPostTopicResponse, AdminCommunitySetCommunityPostTopicError, Options<AdminCommunitySetCommunityPostTopicData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await AdminCommunity.adminCommunitySetCommunityPostTopic({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Boost Community Post
 * Pin to the top of the feed. Stacks with other boosts (newest boost on
 * top). `hours` needs a positive `hours`; `until_next_post` ignores it.
 */
export const adminCommunityBoostCommunityPostMutation = (options?: Partial<Options<AdminCommunityBoostCommunityPostData>>): UseMutationOptions<AdminCommunityBoostCommunityPostResponse, AdminCommunityBoostCommunityPostError, Options<AdminCommunityBoostCommunityPostData>> => {
    const mutationOptions: UseMutationOptions<AdminCommunityBoostCommunityPostResponse, AdminCommunityBoostCommunityPostError, Options<AdminCommunityBoostCommunityPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await AdminCommunity.adminCommunityBoostCommunityPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Unboost Community Post
 */
export const adminCommunityUnboostCommunityPostMutation = (options?: Partial<Options<AdminCommunityUnboostCommunityPostData>>): UseMutationOptions<AdminCommunityUnboostCommunityPostResponse, AdminCommunityUnboostCommunityPostError, Options<AdminCommunityUnboostCommunityPostData>> => {
    const mutationOptions: UseMutationOptions<AdminCommunityUnboostCommunityPostResponse, AdminCommunityUnboostCommunityPostError, Options<AdminCommunityUnboostCommunityPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await AdminCommunity.adminCommunityUnboostCommunityPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Highlight Community Post
 * Override the wins/milestone tint. null = auto (client heuristic).
 */
export const adminCommunityHighlightCommunityPostMutation = (options?: Partial<Options<AdminCommunityHighlightCommunityPostData>>): UseMutationOptions<AdminCommunityHighlightCommunityPostResponse, AdminCommunityHighlightCommunityPostError, Options<AdminCommunityHighlightCommunityPostData>> => {
    const mutationOptions: UseMutationOptions<AdminCommunityHighlightCommunityPostResponse, AdminCommunityHighlightCommunityPostError, Options<AdminCommunityHighlightCommunityPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await AdminCommunity.adminCommunityHighlightCommunityPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Hero Community Post
 * Override the short-win pull-quote. null = auto (client heuristic).
 */
export const adminCommunityHeroCommunityPostMutation = (options?: Partial<Options<AdminCommunityHeroCommunityPostData>>): UseMutationOptions<AdminCommunityHeroCommunityPostResponse, AdminCommunityHeroCommunityPostError, Options<AdminCommunityHeroCommunityPostData>> => {
    const mutationOptions: UseMutationOptions<AdminCommunityHeroCommunityPostResponse, AdminCommunityHeroCommunityPostError, Options<AdminCommunityHeroCommunityPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await AdminCommunity.adminCommunityHeroCommunityPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const adminCommunityGetCommunityIdentityQueryKey = (options?: Options<AdminCommunityGetCommunityIdentityData>) => createQueryKey('adminCommunityGetCommunityIdentity', options);

/**
 * Get Community Identity
 */
export const adminCommunityGetCommunityIdentityOptions = (options?: Options<AdminCommunityGetCommunityIdentityData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await AdminCommunity.adminCommunityGetCommunityIdentity({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: adminCommunityGetCommunityIdentityQueryKey(options)
    });
};

/**
 * Set Community Name
 * Set the moderator's own community name, the one members see on what
 * they post from here, exactly as typed. Only the name: bio and avatar are
 * left as they are.
 */
export const adminCommunitySetCommunityNameMutation = (options?: Partial<Options<AdminCommunitySetCommunityNameData>>): UseMutationOptions<AdminCommunitySetCommunityNameResponse, AdminCommunitySetCommunityNameError, Options<AdminCommunitySetCommunityNameData>> => {
    const mutationOptions: UseMutationOptions<AdminCommunitySetCommunityNameResponse, AdminCommunitySetCommunityNameError, Options<AdminCommunitySetCommunityNameData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await AdminCommunity.adminCommunitySetCommunityName({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const adminCommunityListCommunityPostCommentsQueryKey = (options: Options<AdminCommunityListCommunityPostCommentsData>) => createQueryKey('adminCommunityListCommunityPostComments', options);

/**
 * List Community Post Comments
 * Every comment on the post, hidden ones included, as a thread: top-level
 * comments oldest first, each with its replies.
 */
export const adminCommunityListCommunityPostCommentsOptions = (options: Options<AdminCommunityListCommunityPostCommentsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await AdminCommunity.adminCommunityListCommunityPostComments({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: adminCommunityListCommunityPostCommentsQueryKey(options)
    });
};

/**
 * Create Community Post Comment
 * Respond to the post, or reply to one of its top-level comments, as the
 * signed-in moderator's own community profile. The same path a member's
 * comment takes, so whoever is answered gets the same push.
 */
export const adminCommunityCreateCommunityPostCommentMutation = (options?: Partial<Options<AdminCommunityCreateCommunityPostCommentData>>): UseMutationOptions<AdminCommunityCreateCommunityPostCommentResponse, AdminCommunityCreateCommunityPostCommentError, Options<AdminCommunityCreateCommunityPostCommentData>> => {
    const mutationOptions: UseMutationOptions<AdminCommunityCreateCommunityPostCommentResponse, AdminCommunityCreateCommunityPostCommentError, Options<AdminCommunityCreateCommunityPostCommentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await AdminCommunity.adminCommunityCreateCommunityPostComment({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Archive Community Comment
 * Hide a comment from members. Reversible; its replies go out of sight
 * with it and come back with it.
 */
export const adminCommunityArchiveCommunityCommentMutation = (options?: Partial<Options<AdminCommunityArchiveCommunityCommentData>>): UseMutationOptions<AdminCommunityArchiveCommunityCommentResponse, AdminCommunityArchiveCommunityCommentError, Options<AdminCommunityArchiveCommunityCommentData>> => {
    const mutationOptions: UseMutationOptions<AdminCommunityArchiveCommunityCommentResponse, AdminCommunityArchiveCommunityCommentError, Options<AdminCommunityArchiveCommunityCommentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await AdminCommunity.adminCommunityArchiveCommunityComment({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Restore Community Comment
 */
export const adminCommunityRestoreCommunityCommentMutation = (options?: Partial<Options<AdminCommunityRestoreCommunityCommentData>>): UseMutationOptions<AdminCommunityRestoreCommunityCommentResponse, AdminCommunityRestoreCommunityCommentError, Options<AdminCommunityRestoreCommunityCommentData>> => {
    const mutationOptions: UseMutationOptions<AdminCommunityRestoreCommunityCommentResponse, AdminCommunityRestoreCommunityCommentError, Options<AdminCommunityRestoreCommunityCommentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await AdminCommunity.adminCommunityRestoreCommunityComment({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Set Community Comment Reaction
 * React to a comment as the signed-in moderator, the same toggle a
 * member's tap is: same kind clears, a different kind switches, none adds.
 * Only a comment members can see: a hidden one, or a reply under one, is a
 * 404, as it is in the app.
 */
export const adminCommunitySetCommunityCommentReactionMutation = (options?: Partial<Options<AdminCommunitySetCommunityCommentReactionData>>): UseMutationOptions<AdminCommunitySetCommunityCommentReactionResponse, AdminCommunitySetCommunityCommentReactionError, Options<AdminCommunitySetCommunityCommentReactionData>> => {
    const mutationOptions: UseMutationOptions<AdminCommunitySetCommunityCommentReactionResponse, AdminCommunitySetCommunityCommentReactionError, Options<AdminCommunitySetCommunityCommentReactionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await AdminCommunity.adminCommunitySetCommunityCommentReaction({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Set Community Post Reaction
 * React to a post as the signed-in moderator, the same toggle a member's
 * tap is: same kind clears, a different kind switches, none adds. Only a
 * post members can see; an archived, hidden or scheduled one is a 404.
 */
export const adminCommunitySetCommunityPostReactionMutation = (options?: Partial<Options<AdminCommunitySetCommunityPostReactionData>>): UseMutationOptions<AdminCommunitySetCommunityPostReactionResponse, AdminCommunitySetCommunityPostReactionError, Options<AdminCommunitySetCommunityPostReactionData>> => {
    const mutationOptions: UseMutationOptions<AdminCommunitySetCommunityPostReactionResponse, AdminCommunitySetCommunityPostReactionError, Options<AdminCommunitySetCommunityPostReactionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await AdminCommunity.adminCommunitySetCommunityPostReaction({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Publish Scheduled Community Post
 * Put a scheduled post live now instead of at its time.
 */
export const adminCommunityPublishScheduledCommunityPostMutation = (options?: Partial<Options<AdminCommunityPublishScheduledCommunityPostData>>): UseMutationOptions<AdminCommunityPublishScheduledCommunityPostResponse, AdminCommunityPublishScheduledCommunityPostError, Options<AdminCommunityPublishScheduledCommunityPostData>> => {
    const mutationOptions: UseMutationOptions<AdminCommunityPublishScheduledCommunityPostResponse, AdminCommunityPublishScheduledCommunityPostError, Options<AdminCommunityPublishScheduledCommunityPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await AdminCommunity.adminCommunityPublishScheduledCommunityPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const adminCommunityCommunityStatsQueryKey = (options?: Options<AdminCommunityCommunityStatsData>) => createQueryKey('adminCommunityCommunityStats', options);

/**
 * Community Stats
 * Everything on the community dashboard, from our own tables (UTC days).
 * Default window is the last 30 days; the previous window is the same
 * length ending the day before `start`.
 */
export const adminCommunityCommunityStatsOptions = (options?: Options<AdminCommunityCommunityStatsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await AdminCommunity.adminCommunityCommunityStats({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: adminCommunityCommunityStatsQueryKey(options)
    });
};

export const adminCommunityCommunityStatsInfiniteQueryKey = (options?: Options<AdminCommunityCommunityStatsData>): QueryKey<Options<AdminCommunityCommunityStatsData>> => createQueryKey('adminCommunityCommunityStats', options, true);

/**
 * Community Stats
 * Everything on the community dashboard, from our own tables (UTC days).
 * Default window is the last 30 days; the previous window is the same
 * length ending the day before `start`.
 */
export const adminCommunityCommunityStatsInfiniteOptions = (options?: Options<AdminCommunityCommunityStatsData>) => {
    return infiniteQueryOptions<AdminCommunityCommunityStatsResponse, AdminCommunityCommunityStatsError, InfiniteData<AdminCommunityCommunityStatsResponse>, QueryKey<Options<AdminCommunityCommunityStatsData>>, string | null | Pick<QueryKey<Options<AdminCommunityCommunityStatsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<AdminCommunityCommunityStatsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    start: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await AdminCommunity.adminCommunityCommunityStats({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: adminCommunityCommunityStatsInfiniteQueryKey(options)
    });
};

export const adminBeehiivGetSubscriptionByEmailQueryKey = (options: Options<AdminBeehiivGetSubscriptionByEmailData>) => createQueryKey('adminBeehiivGetSubscriptionByEmail', options);

/**
 * Get Subscription By Email
 * Get Beehiiv subscription information by email.
 *
 * Args:
 * email: Subscriber email address
 * expand: Optional comma-separated list: custom_fields,stats,tags,referrals,subscription_premium_tiers
 */
export const adminBeehiivGetSubscriptionByEmailOptions = (options: Options<AdminBeehiivGetSubscriptionByEmailData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await AdminBeehiiv.adminBeehiivGetSubscriptionByEmail({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: adminBeehiivGetSubscriptionByEmailQueryKey(options)
    });
};

export const adminBeehiivListCustomFieldsQueryKey = (options?: Options<AdminBeehiivListCustomFieldsData>) => createQueryKey('adminBeehiivListCustomFields', options);

/**
 * List Custom Fields
 * List all custom fields for the publication.
 */
export const adminBeehiivListCustomFieldsOptions = (options?: Options<AdminBeehiivListCustomFieldsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await AdminBeehiiv.adminBeehiivListCustomFields({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: adminBeehiivListCustomFieldsQueryKey(options)
    });
};

export const adminBeehiivGetPublicationQueryKey = (options?: Options<AdminBeehiivGetPublicationData>) => createQueryKey('adminBeehiivGetPublication', options);

/**
 * Get Publication
 * Get publication information (cached for 1 hour).
 */
export const adminBeehiivGetPublicationOptions = (options?: Options<AdminBeehiivGetPublicationData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await AdminBeehiiv.adminBeehiivGetPublication({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: adminBeehiivGetPublicationQueryKey(options)
    });
};

export const adminBeehiivListPostsQueryKey = (options?: Options<AdminBeehiivListPostsData>) => createQueryKey('adminBeehiivListPosts', options);

/**
 * List Posts
 * List all posts for the publication with optional filtering and pagination.
 */
export const adminBeehiivListPostsOptions = (options?: Options<AdminBeehiivListPostsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await AdminBeehiiv.adminBeehiivListPosts({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: adminBeehiivListPostsQueryKey(options)
    });
};

export const adminBeehiivListPostsInfiniteQueryKey = (options?: Options<AdminBeehiivListPostsData>): QueryKey<Options<AdminBeehiivListPostsData>> => createQueryKey('adminBeehiivListPosts', options, true);

/**
 * List Posts
 * List all posts for the publication with optional filtering and pagination.
 */
export const adminBeehiivListPostsInfiniteOptions = (options?: Options<AdminBeehiivListPostsData>) => {
    return infiniteQueryOptions<AdminBeehiivListPostsResponse, AdminBeehiivListPostsError, InfiniteData<AdminBeehiivListPostsResponse>, QueryKey<Options<AdminBeehiivListPostsData>>, number | Pick<QueryKey<Options<AdminBeehiivListPostsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<AdminBeehiivListPostsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await AdminBeehiiv.adminBeehiivListPosts({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: adminBeehiivListPostsInfiniteQueryKey(options)
    });
};

export const adminBeehiivGetPostsAggregateStatsQueryKey = (options?: Options<AdminBeehiivGetPostsAggregateStatsData>) => createQueryKey('adminBeehiivGetPostsAggregateStats', options);

/**
 * Get Posts Aggregate Stats
 * Get aggregate statistics for all posts (cached for 5 minutes).
 */
export const adminBeehiivGetPostsAggregateStatsOptions = (options?: Options<AdminBeehiivGetPostsAggregateStatsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await AdminBeehiiv.adminBeehiivGetPostsAggregateStats({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: adminBeehiivGetPostsAggregateStatsQueryKey(options)
    });
};

export const adminBeehiivListSubscriptionsQueryKey = (options?: Options<AdminBeehiivListSubscriptionsData>) => createQueryKey('adminBeehiivListSubscriptions', options);

/**
 * List Subscriptions
 * List all subscriptions for the publication with optional filtering.
 *
 * Note: To get unsubscribed users, use status=inactive.
 * Spam reports and delivery failures are only available in aggregate stats, not per-subscriber.
 * If segment_id is provided, returns members of that segment instead of all subscriptions.
 */
export const adminBeehiivListSubscriptionsOptions = (options?: Options<AdminBeehiivListSubscriptionsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await AdminBeehiiv.adminBeehiivListSubscriptions({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: adminBeehiivListSubscriptionsQueryKey(options)
    });
};

export const adminBeehiivListSubscriptionsInfiniteQueryKey = (options?: Options<AdminBeehiivListSubscriptionsData>): QueryKey<Options<AdminBeehiivListSubscriptionsData>> => createQueryKey('adminBeehiivListSubscriptions', options, true);

/**
 * List Subscriptions
 * List all subscriptions for the publication with optional filtering.
 *
 * Note: To get unsubscribed users, use status=inactive.
 * Spam reports and delivery failures are only available in aggregate stats, not per-subscriber.
 * If segment_id is provided, returns members of that segment instead of all subscriptions.
 */
export const adminBeehiivListSubscriptionsInfiniteOptions = (options?: Options<AdminBeehiivListSubscriptionsData>) => {
    return infiniteQueryOptions<AdminBeehiivListSubscriptionsResponse, AdminBeehiivListSubscriptionsError, InfiniteData<AdminBeehiivListSubscriptionsResponse>, QueryKey<Options<AdminBeehiivListSubscriptionsData>>, string | null | Pick<QueryKey<Options<AdminBeehiivListSubscriptionsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<AdminBeehiivListSubscriptionsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    cursor: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await AdminBeehiiv.adminBeehiivListSubscriptions({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: adminBeehiivListSubscriptionsInfiniteQueryKey(options)
    });
};

export const adminBeehiivListSegmentsQueryKey = (options?: Options<AdminBeehiivListSegmentsData>) => createQueryKey('adminBeehiivListSegments', options);

/**
 * List Segments
 * List all segments for the publication.
 */
export const adminBeehiivListSegmentsOptions = (options?: Options<AdminBeehiivListSegmentsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await AdminBeehiiv.adminBeehiivListSegments({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: adminBeehiivListSegmentsQueryKey(options)
    });
};

export const adminBeehiivListSegmentsInfiniteQueryKey = (options?: Options<AdminBeehiivListSegmentsData>): QueryKey<Options<AdminBeehiivListSegmentsData>> => createQueryKey('adminBeehiivListSegments', options, true);

/**
 * List Segments
 * List all segments for the publication.
 */
export const adminBeehiivListSegmentsInfiniteOptions = (options?: Options<AdminBeehiivListSegmentsData>) => {
    return infiniteQueryOptions<AdminBeehiivListSegmentsResponse, AdminBeehiivListSegmentsError, InfiniteData<AdminBeehiivListSegmentsResponse>, QueryKey<Options<AdminBeehiivListSegmentsData>>, number | Pick<QueryKey<Options<AdminBeehiivListSegmentsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<AdminBeehiivListSegmentsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await AdminBeehiiv.adminBeehiivListSegments({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: adminBeehiivListSegmentsInfiniteQueryKey(options)
    });
};

/**
 * Recalculate Segment
 * Recalculate a specific segment.
 */
export const adminBeehiivRecalculateSegmentMutation = (options?: Partial<Options<AdminBeehiivRecalculateSegmentData>>): UseMutationOptions<AdminBeehiivRecalculateSegmentResponse, AdminBeehiivRecalculateSegmentError, Options<AdminBeehiivRecalculateSegmentData>> => {
    const mutationOptions: UseMutationOptions<AdminBeehiivRecalculateSegmentResponse, AdminBeehiivRecalculateSegmentError, Options<AdminBeehiivRecalculateSegmentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await AdminBeehiiv.adminBeehiivRecalculateSegment({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const usersV2ListUsersV2QueryKey = (options?: Options<UsersV2ListUsersV2Data>) => createQueryKey('usersV2ListUsersV2', options);

/**
 * List Users V2
 * List users with subscription state (admin only).
 */
export const usersV2ListUsersV2Options = (options?: Options<UsersV2ListUsersV2Data>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await UsersV2.usersV2ListUsersV2({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: usersV2ListUsersV2QueryKey(options)
    });
};

export const usersV2ListUsersV2InfiniteQueryKey = (options?: Options<UsersV2ListUsersV2Data>): QueryKey<Options<UsersV2ListUsersV2Data>> => createQueryKey('usersV2ListUsersV2', options, true);

/**
 * List Users V2
 * List users with subscription state (admin only).
 */
export const usersV2ListUsersV2InfiniteOptions = (options?: Options<UsersV2ListUsersV2Data>) => {
    return infiniteQueryOptions<UsersV2ListUsersV2Response, UsersV2ListUsersV2Error, InfiniteData<UsersV2ListUsersV2Response>, QueryKey<Options<UsersV2ListUsersV2Data>>, number | Pick<QueryKey<Options<UsersV2ListUsersV2Data>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<UsersV2ListUsersV2Data>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await UsersV2.usersV2ListUsersV2({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: usersV2ListUsersV2InfiniteQueryKey(options)
    });
};

export const usersV2GetUserV2QueryKey = (options: Options<UsersV2GetUserV2Data>) => createQueryKey('usersV2GetUserV2', options);

/**
 * Get User V2
 * Get a user with subscription state.
 */
export const usersV2GetUserV2Options = (options: Options<UsersV2GetUserV2Data>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await UsersV2.usersV2GetUserV2({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: usersV2GetUserV2QueryKey(options)
    });
};

export const usersV2GetUserEventsV2QueryKey = (options: Options<UsersV2GetUserEventsV2Data>) => createQueryKey('usersV2GetUserEventsV2', options);

/**
 * Get User Events V2
 * Get lifecycle events for a user.
 */
export const usersV2GetUserEventsV2Options = (options: Options<UsersV2GetUserEventsV2Data>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await UsersV2.usersV2GetUserEventsV2({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: usersV2GetUserEventsV2QueryKey(options)
    });
};

export const usersV2GetUserEventsV2InfiniteQueryKey = (options: Options<UsersV2GetUserEventsV2Data>): QueryKey<Options<UsersV2GetUserEventsV2Data>> => createQueryKey('usersV2GetUserEventsV2', options, true);

/**
 * Get User Events V2
 * Get lifecycle events for a user.
 */
export const usersV2GetUserEventsV2InfiniteOptions = (options: Options<UsersV2GetUserEventsV2Data>) => {
    return infiniteQueryOptions<UsersV2GetUserEventsV2Response, UsersV2GetUserEventsV2Error, InfiniteData<UsersV2GetUserEventsV2Response>, QueryKey<Options<UsersV2GetUserEventsV2Data>>, number | Pick<QueryKey<Options<UsersV2GetUserEventsV2Data>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<UsersV2GetUserEventsV2Data>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await UsersV2.usersV2GetUserEventsV2({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: usersV2GetUserEventsV2InfiniteQueryKey(options)
    });
};

export const usersV2GetUserStatsV2QueryKey = (options?: Options<UsersV2GetUserStatsV2Data>) => createQueryKey('usersV2GetUserStatsV2', options);

/**
 * Get User Stats V2
 * Get aggregated user stats (admin only).
 */
export const usersV2GetUserStatsV2Options = (options?: Options<UsersV2GetUserStatsV2Data>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await UsersV2.usersV2GetUserStatsV2({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: usersV2GetUserStatsV2QueryKey(options)
    });
};

export const metricsGetUserCountsQueryKey = (options?: Options<MetricsGetUserCountsData>) => createQueryKey('metricsGetUserCounts', options);

/**
 * Get User Counts
 * How many accounts, and how many of them are paying now.
 *
 * The Users overview reads this instead of the people list's `total`, so the
 * overview needs only the aggregate `metrics:read` scope and never fetches a
 * row that names anybody. Same Account/Environment predicates as the list.
 */
export const metricsGetUserCountsOptions = (options?: Options<MetricsGetUserCountsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await Metrics.metricsGetUserCounts({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: metricsGetUserCountsQueryKey(options)
    });
};

export const metricsGetNewUsersChartQueryKey = (options?: Options<MetricsGetNewUsersChartData>) => createQueryKey('metricsGetNewUsersChart', options);

/**
 * Get New Users Chart
 * New accounts per UTC period, for the Users page's New users chart.
 *
 * The payments charts' response shape and filter grammar
 * (``filter.country=GB,US``, ``filter.platform=iOS``), scoped by the same
 * Account and Environment filters as the Users headline, so the two agree.
 * ``summary.countries`` lists the window's countries for the filter picker.
 */
export const metricsGetNewUsersChartOptions = (options?: Options<MetricsGetNewUsersChartData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await Metrics.metricsGetNewUsersChart({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: metricsGetNewUsersChartQueryKey(options)
    });
};

export const metricsGetNewUsersChartInfiniteQueryKey = (options?: Options<MetricsGetNewUsersChartData>): QueryKey<Options<MetricsGetNewUsersChartData>> => createQueryKey('metricsGetNewUsersChart', options, true);

/**
 * Get New Users Chart
 * New accounts per UTC period, for the Users page's New users chart.
 *
 * The payments charts' response shape and filter grammar
 * (``filter.country=GB,US``, ``filter.platform=iOS``), scoped by the same
 * Account and Environment filters as the Users headline, so the two agree.
 * ``summary.countries`` lists the window's countries for the filter picker.
 */
export const metricsGetNewUsersChartInfiniteOptions = (options?: Options<MetricsGetNewUsersChartData>) => {
    return infiniteQueryOptions<MetricsGetNewUsersChartResponse, MetricsGetNewUsersChartError, InfiniteData<MetricsGetNewUsersChartResponse>, QueryKey<Options<MetricsGetNewUsersChartData>>, string | null | Pick<QueryKey<Options<MetricsGetNewUsersChartData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<MetricsGetNewUsersChartData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    start: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await Metrics.metricsGetNewUsersChart({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: metricsGetNewUsersChartInfiniteQueryKey(options)
    });
};

export const metricsGetUserCountOverTimeQueryKey = (options?: Options<MetricsGetUserCountOverTimeData>) => createQueryKey('metricsGetUserCountOverTime', options);

/**
 * Get User Count Over Time
 * Get user count over time for charting (admin only).
 *
 * Returns daily user counts for the specified number of days.
 * Can optionally split counts by promo_code, store (iOS/Android/Test), or product_identifier.
 */
export const metricsGetUserCountOverTimeOptions = (options?: Options<MetricsGetUserCountOverTimeData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await Metrics.metricsGetUserCountOverTime({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: metricsGetUserCountOverTimeQueryKey(options)
    });
};

export const metricsListUserGrowthEventsQueryKey = (options?: Options<MetricsListUserGrowthEventsData>) => createQueryKey('metricsListUserGrowthEvents', options);

/**
 * List User Growth Events
 * Annotations staff put on the growth charts (launches, campaigns,
 * outages): date, label and description, newest first. Use them to explain
 * a step change in a metric.
 */
export const metricsListUserGrowthEventsOptions = (options?: Options<MetricsListUserGrowthEventsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await Metrics.metricsListUserGrowthEvents({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: metricsListUserGrowthEventsQueryKey(options)
    });
};

/**
 * Create User Growth Event
 * Create a user growth event (admin only).
 *
 * Events are displayed on the user growth chart to track marketing campaigns,
 * launches, etc.
 */
export const metricsCreateUserGrowthEventMutation = (options?: Partial<Options<MetricsCreateUserGrowthEventData>>): UseMutationOptions<MetricsCreateUserGrowthEventResponse, MetricsCreateUserGrowthEventError, Options<MetricsCreateUserGrowthEventData>> => {
    const mutationOptions: UseMutationOptions<MetricsCreateUserGrowthEventResponse, MetricsCreateUserGrowthEventError, Options<MetricsCreateUserGrowthEventData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await Metrics.metricsCreateUserGrowthEvent({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete User Growth Event
 * Delete a user growth event (admin only).
 */
export const metricsDeleteUserGrowthEventMutation = (options?: Partial<Options<MetricsDeleteUserGrowthEventData>>): UseMutationOptions<MetricsDeleteUserGrowthEventResponse, MetricsDeleteUserGrowthEventError, Options<MetricsDeleteUserGrowthEventData>> => {
    const mutationOptions: UseMutationOptions<MetricsDeleteUserGrowthEventResponse, MetricsDeleteUserGrowthEventError, Options<MetricsDeleteUserGrowthEventData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await Metrics.metricsDeleteUserGrowthEvent({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const metricsGetDistinctProductIdentifiersQueryKey = (options?: Options<MetricsGetDistinctProductIdentifiersData>) => createQueryKey('metricsGetDistinctProductIdentifiers', options);

/**
 * Get Distinct Product Identifiers
 * Distinct product identifiers for the Users admin filter (cached 24h).
 *
 * Reads a.entitlement.product_id — the owned projection, not the RC webhook
 * table — so it survives the RevenueCat retirement. The one live caller is the
 * Users page subscription-product filter, which is why this endpoint stays
 * while the dashboard metrics around it were removed.
 */
export const metricsGetDistinctProductIdentifiersOptions = (options?: Options<MetricsGetDistinctProductIdentifiersData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await Metrics.metricsGetDistinctProductIdentifiers({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: metricsGetDistinctProductIdentifiersQueryKey(options)
    });
};

export const metricsGetUserRetentionQueryKey = (options?: Options<MetricsGetUserRetentionData>) => createQueryKey('metricsGetUserRetention', options);

/**
 * Get User Retention
 * Bracket retention of daily signup cohorts (``crud.a.retention``).
 *
 * A cohort is the real users (``a.is_real_user``) who signed up on one UTC
 * day; that day is day 0. A person is retained at a point if they made a
 * health entry on any day of its bracket. Sign-ins and token refreshes do
 * not count: a background launch makes those with nobody in the app.
 *
 * - d1: day 1
 * - d7: days 7-13
 * - d30: days 30-59
 * - d30_plus: any day after day 30, so far
 *
 * Each point is independent, so one user can count for all of them. Day 0
 * (onboarding) never counts. A point whose bracket has not ended yet (UTC)
 * has ``active`` and ``retention_rate`` null rather than 0, so a young cohort
 * does not read as churn; d30_plus is measured once day 31 has ended and keeps
 * growing. ``retention_rate`` is a percentage.
 */
export const metricsGetUserRetentionOptions = (options?: Options<MetricsGetUserRetentionData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await Metrics.metricsGetUserRetention({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: metricsGetUserRetentionQueryKey(options)
    });
};

export const metricsGetCohortRetentionQueryKey = (options?: Options<MetricsGetCohortRetentionData>) => createQueryKey('metricsGetCohortRetention', options);

/**
 * Get Cohort Retention
 * Get cohort retention metrics (admin only).
 *
 * Returns retention rates for week-joined cohorts at specified retention days.
 */
export const metricsGetCohortRetentionOptions = (options?: Options<MetricsGetCohortRetentionData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await Metrics.metricsGetCohortRetention({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: metricsGetCohortRetentionQueryKey(options)
    });
};

export const utilsHealthCheckQueryKey = (options?: Options<UtilsHealthCheckData>) => createQueryKey('utilsHealthCheck', options);

/**
 * Health Check
 * Liveness for Railway's deploy gate and synthetic probes.
 *
 * Polled every second or so during a deploy, so it does exactly one thing: a
 * round trip to the database. A build with a bad DATABASE_URL, a broken pool
 * or a migration that left the schema unusable answers 503 here and never
 * receives traffic. Nothing about the failure is echoed to the caller.
 */
export const utilsHealthCheckOptions = (options?: Options<UtilsHealthCheckData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await Utils.utilsHealthCheck({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: utilsHealthCheckQueryKey(options)
    });
};

/**
 * Delete All Notification Preferences
 * Delete all notification preferences for the current user.
 */
export const notificationsDeleteAllNotificationPreferencesMutation = (options?: Partial<Options<NotificationsDeleteAllNotificationPreferencesData>>): UseMutationOptions<NotificationsDeleteAllNotificationPreferencesResponse, DefaultError, Options<NotificationsDeleteAllNotificationPreferencesData>> => {
    const mutationOptions: UseMutationOptions<NotificationsDeleteAllNotificationPreferencesResponse, DefaultError, Options<NotificationsDeleteAllNotificationPreferencesData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await Notifications.notificationsDeleteAllNotificationPreferences({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const notificationsGetNotificationPreferencesQueryKey = (options?: Options<NotificationsGetNotificationPreferencesData>) => createQueryKey('notificationsGetNotificationPreferences', options);

/**
 * Get Notification Preferences
 * Get all notification preferences for the current user.
 */
export const notificationsGetNotificationPreferencesOptions = (options?: Options<NotificationsGetNotificationPreferencesData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await Notifications.notificationsGetNotificationPreferences({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: notificationsGetNotificationPreferencesQueryKey(options)
    });
};

/**
 * Create Notification Preference
 * Create a new notification preference for the current user.
 */
export const notificationsCreateNotificationPreferenceMutation = (options?: Partial<Options<NotificationsCreateNotificationPreferenceData>>): UseMutationOptions<NotificationsCreateNotificationPreferenceResponse, NotificationsCreateNotificationPreferenceError, Options<NotificationsCreateNotificationPreferenceData>> => {
    const mutationOptions: UseMutationOptions<NotificationsCreateNotificationPreferenceResponse, NotificationsCreateNotificationPreferenceError, Options<NotificationsCreateNotificationPreferenceData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await Notifications.notificationsCreateNotificationPreference({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete Notification Preference
 * Delete a notification preference by ID.
 */
export const notificationsDeleteNotificationPreferenceMutation = (options?: Partial<Options<NotificationsDeleteNotificationPreferenceData>>): UseMutationOptions<NotificationsDeleteNotificationPreferenceResponse, NotificationsDeleteNotificationPreferenceError, Options<NotificationsDeleteNotificationPreferenceData>> => {
    const mutationOptions: UseMutationOptions<NotificationsDeleteNotificationPreferenceResponse, NotificationsDeleteNotificationPreferenceError, Options<NotificationsDeleteNotificationPreferenceData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await Notifications.notificationsDeleteNotificationPreference({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update Notification Preference
 * Update a specific notification preference by ID.
 */
export const notificationsUpdateNotificationPreferenceMutation = (options?: Partial<Options<NotificationsUpdateNotificationPreferenceData>>): UseMutationOptions<NotificationsUpdateNotificationPreferenceResponse, NotificationsUpdateNotificationPreferenceError, Options<NotificationsUpdateNotificationPreferenceData>> => {
    const mutationOptions: UseMutationOptions<NotificationsUpdateNotificationPreferenceResponse, NotificationsUpdateNotificationPreferenceError, Options<NotificationsUpdateNotificationPreferenceData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await Notifications.notificationsUpdateNotificationPreference({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const notificationsReadAllNotificationPreferencesQueryKey = (options?: Options<NotificationsReadAllNotificationPreferencesData>) => createQueryKey('notificationsReadAllNotificationPreferences', options);

/**
 * Read All Notification Preferences
 * Get all notification preferences with pagination. Only accessible to admins.
 */
export const notificationsReadAllNotificationPreferencesOptions = (options?: Options<NotificationsReadAllNotificationPreferencesData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await Notifications.notificationsReadAllNotificationPreferences({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: notificationsReadAllNotificationPreferencesQueryKey(options)
    });
};

export const notificationsReadNotificationHistoryQueryKey = (options?: Options<NotificationsReadNotificationHistoryData>) => createQueryKey('notificationsReadNotificationHistory', options);

/**
 * Read Notification History
 * Get all notification history with pagination. Only accessible to admins.
 */
export const notificationsReadNotificationHistoryOptions = (options?: Options<NotificationsReadNotificationHistoryData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await Notifications.notificationsReadNotificationHistory({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: notificationsReadNotificationHistoryQueryKey(options)
    });
};

export const notificationsReadUserNotificationHistoryQueryKey = (options: Options<NotificationsReadUserNotificationHistoryData>) => createQueryKey('notificationsReadUserNotificationHistory', options);

/**
 * Read User Notification History
 * Get notification history for a specific user with pagination. Only accessible to admins.
 */
export const notificationsReadUserNotificationHistoryOptions = (options: Options<NotificationsReadUserNotificationHistoryData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await Notifications.notificationsReadUserNotificationHistory({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: notificationsReadUserNotificationHistoryQueryKey(options)
    });
};

export const notificationsReadNotificationHistoryByIdQueryKey = (options: Options<NotificationsReadNotificationHistoryByIdData>) => createQueryKey('notificationsReadNotificationHistoryById', options);

/**
 * Read Notification History By Id
 * Get notification history by ID. Only accessible to admins.
 */
export const notificationsReadNotificationHistoryByIdOptions = (options: Options<NotificationsReadNotificationHistoryByIdData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await Notifications.notificationsReadNotificationHistoryById({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: notificationsReadNotificationHistoryByIdQueryKey(options)
    });
};

/**
 * Record Notification Opened
 * Stamp when the user tapped a push open. Idempotent: the first stamp wins.
 *
 * The push payload carries the history row's id as ``notification_id``. A row
 * that is not this user's is a 404, the same answer as one that does not
 * exist, so the endpoint cannot be used to probe other people's ids.
 */
export const notificationsRecordNotificationOpenedMutation = (options?: Partial<Options<NotificationsRecordNotificationOpenedData>>): UseMutationOptions<NotificationsRecordNotificationOpenedResponse, NotificationsRecordNotificationOpenedError, Options<NotificationsRecordNotificationOpenedData>> => {
    const mutationOptions: UseMutationOptions<NotificationsRecordNotificationOpenedResponse, NotificationsRecordNotificationOpenedError, Options<NotificationsRecordNotificationOpenedData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await Notifications.notificationsRecordNotificationOpened({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const publicGetCommunityStatsQueryKey = (options?: Options<PublicGetCommunityStatsData>) => createQueryKey('publicGetCommunityStats', options);

/**
 * Get Community Stats
 * Get community stats for public board.
 * Cached for 1 hour to reduce database load.
 *
 * If selected_date is provided, returns stats for that specific date.
 * Otherwise, returns stats for today (UTC).
 */
export const publicGetCommunityStatsOptions = (options?: Options<PublicGetCommunityStatsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await Public.publicGetCommunityStats({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: publicGetCommunityStatsQueryKey(options)
    });
};

export const publicGetCohortMoodProgressionQueryKey = (options?: Options<PublicGetCohortMoodProgressionData>) => createQueryKey('publicGetCohortMoodProgression', options);

/**
 * Get Cohort Mood Progression
 * Get mood progression data for week-joined cohorts.
 * Cached for 1 hour to reduce database load.
 *
 * Groups users by the week they signed up and tracks their mood progression
 * over the specified number of days. Returns the most recent cohorts (up to max_cohorts).
 *
 * Cohorts are labeled as "1st week of Jan 2024", "2nd week of Jan 2024", etc.
 */
export const publicGetCohortMoodProgressionOptions = (options?: Options<PublicGetCohortMoodProgressionData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await Public.publicGetCohortMoodProgression({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: publicGetCohortMoodProgressionQueryKey(options)
    });
};

export const publicGetEmailPreferencesQueryKey = (options: Options<PublicGetEmailPreferencesData>) => createQueryKey('publicGetEmailPreferences', options);

/**
 * Get Email Preferences
 * Which email purposes this address currently receives.
 *
 * Read-only on purpose: mail scanners prefetch GET links, so a GET that
 * changed anything would unsubscribe people nobody asked about.
 */
export const publicGetEmailPreferencesOptions = (options: Options<PublicGetEmailPreferencesData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await Public.publicGetEmailPreferences({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: publicGetEmailPreferencesQueryKey(options)
    });
};

/**
 * Update Email Preference
 * Turn one purpose on or off from the preferences page.
 *
 * The token came out of the inbox, so the mailbox is proven: turning a
 * purpose back on here is an explicit opt-in in its own right.
 */
export const publicUpdateEmailPreferenceMutation = (options?: Partial<Options<PublicUpdateEmailPreferenceData>>): UseMutationOptions<PublicUpdateEmailPreferenceResponse, PublicUpdateEmailPreferenceError, Options<PublicUpdateEmailPreferenceData>> => {
    const mutationOptions: UseMutationOptions<PublicUpdateEmailPreferenceResponse, PublicUpdateEmailPreferenceError, Options<PublicUpdateEmailPreferenceData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await Public.publicUpdateEmailPreference({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * One Click Unsubscribe
 * RFC 8058 one-click: the mail client POSTs here from List-Unsubscribe.
 *
 * Scoped to the purpose of the email it came from, so leaving the welcome
 * emails does not also cancel the newsletter. A purpose that is not live is
 * left alone: a withdrawal of something never given is a decision nobody
 * made.
 */
export const publicOneClickUnsubscribeMutation = (options?: Partial<Options<PublicOneClickUnsubscribeData>>): UseMutationOptions<PublicOneClickUnsubscribeResponse, PublicOneClickUnsubscribeError, Options<PublicOneClickUnsubscribeData>> => {
    const mutationOptions: UseMutationOptions<PublicOneClickUnsubscribeResponse, PublicOneClickUnsubscribeError, Options<PublicOneClickUnsubscribeData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await Public.publicOneClickUnsubscribe({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Unsubscribe From Emails
 * Unsubscribe a user from all marketing emails using a token from an email link.
 *
 * This is a public endpoint that doesn't require authentication. The token
 * is provided in unsubscribe links in emails and contains the user's email
 * and user_id in a secure, signed JWT.
 */
export const publicUnsubscribeFromEmailsMutation = (options?: Partial<Options<PublicUnsubscribeFromEmailsData>>): UseMutationOptions<PublicUnsubscribeFromEmailsResponse, PublicUnsubscribeFromEmailsError, Options<PublicUnsubscribeFromEmailsData>> => {
    const mutationOptions: UseMutationOptions<PublicUnsubscribeFromEmailsResponse, PublicUnsubscribeFromEmailsError, Options<PublicUnsubscribeFromEmailsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await Public.publicUnsubscribeFromEmails({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const stripeRefundEligibilityQueryKey = (options?: Options<StripeRefundEligibilityData>) => createQueryKey('stripeRefundEligibility', options);

/**
 * Refund Eligibility
 * Whether the authenticated user's web Stripe sub is refundable (<=35 days).
 */
export const stripeRefundEligibilityOptions = (options?: Options<StripeRefundEligibilityData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await Stripe.stripeRefundEligibility({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: stripeRefundEligibilityQueryKey(options)
    });
};

/**
 * Refund
 * Refund + cancel the authenticated user's eligible web Stripe subscription.
 *
 * Eligibility is re-checked server-side; the client identity is established by the
 * magic-link JWT, so only the account owner can refund their own subscription.
 */
export const stripeRefundMutation = (options?: Partial<Options<StripeRefundData>>): UseMutationOptions<StripeRefundResponse, DefaultError, Options<StripeRefundData>> => {
    const mutationOptions: UseMutationOptions<StripeRefundResponse, DefaultError, Options<StripeRefundData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await Stripe.stripeRefund({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const stripeGetStripePricesQueryKey = (options?: Options<StripeGetStripePricesData>) => createQueryKey('stripeGetStripePrices', options);

/**
 * Get Stripe Prices
 * Get available Stripe prices for subscription plans.
 *
 * The prices returned depend on the caller's onboarding `age_range` bucket: the
 * youth band gets the lower-priced variants (see app.core.payment.pricing). The
 * band is resolved server-side; checkout re-resolves it from the stored answers,
 * so the displayed price always matches the charged price.
 *
 * Amounts are in the visitor's currency where the price carries it (GBP in the
 * UK, EUR in the EU), as the offer endpoint does; `currency` forces one for QA
 * outside production. See core.payment.local_currency.
 */
export const stripeGetStripePricesOptions = (options?: Options<StripeGetStripePricesData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await Stripe.stripeGetStripePrices({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: stripeGetStripePricesQueryKey(options)
    });
};

/**
 * Create Billing Portal Session
 * Create a Stripe billing-portal session for the signed-in user.
 *
 * Web (Stripe-store) buyers need this for self-service manage/cancel: RevenueCat's
 * managementURL is null for Stripe subscriptions, so the app's in-app
 * manage-subscription link would otherwise dead-end for them.
 */
export const stripeCreateBillingPortalSessionMutation = (options?: Partial<Options<StripeCreateBillingPortalSessionData>>): UseMutationOptions<StripeCreateBillingPortalSessionResponse, DefaultError, Options<StripeCreateBillingPortalSessionData>> => {
    const mutationOptions: UseMutationOptions<StripeCreateBillingPortalSessionResponse, DefaultError, Options<StripeCreateBillingPortalSessionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await Stripe.stripeCreateBillingPortalSession({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Ingest Web Onboarding
 * Persist onboarding answers for the authenticated user (marker contract).
 */
export const webOnboardingIngestWebOnboardingMutation = (options?: Partial<Options<WebOnboardingIngestWebOnboardingData>>): UseMutationOptions<WebOnboardingIngestWebOnboardingResponse, WebOnboardingIngestWebOnboardingError, Options<WebOnboardingIngestWebOnboardingData>> => {
    const mutationOptions: UseMutationOptions<WebOnboardingIngestWebOnboardingResponse, WebOnboardingIngestWebOnboardingError, Options<WebOnboardingIngestWebOnboardingData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await WebOnboarding.webOnboardingIngestWebOnboarding({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Funnel Touch
 * Record a landing on the site: one ``web_landing`` touch.
 *
 * Called by the site on every landing (a new tab session, or a new ad click
 * in an open one), not only when the paywall renders, so a visitor who
 * leaves at the first question is still in the touch log. Mints the funnel
 * session cookie when there is none, the same one the quiz gate, offer and
 * checkout reuse; that is what stitches this landing to whatever the
 * session later becomes.
 *
 * Always answers 200 with the ref once the cookie is set. A failure to
 * write the touch is logged, never surfaced: the site is not waiting on it.
 */
export const webOnboardingFunnelTouchMutation = (options?: Partial<Options<WebOnboardingFunnelTouchData>>): UseMutationOptions<WebOnboardingFunnelTouchResponse, WebOnboardingFunnelTouchError, Options<WebOnboardingFunnelTouchData>> => {
    const mutationOptions: UseMutationOptions<WebOnboardingFunnelTouchResponse, WebOnboardingFunnelTouchError, Options<WebOnboardingFunnelTouchData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await WebOnboarding.webOnboardingFunnelTouch({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Funnel Offer
 * The offer to show, recorded so it cannot change under the person shown it.
 *
 * Call this when the PAYWALL renders, not on funnel entry: someone still
 * answering questions has been told no number, so there is nothing to promise
 * and stamping them would pin a price for every abandoned quiz.
 *
 * **The funnel must call this with `credentials: 'include'`**, or the session
 * cookie is neither stored nor sent back, every render looks like a new person,
 * and the promise this endpoint exists to keep is silently not kept.
 */
export const webOnboardingFunnelOfferMutation = (options?: Partial<Options<WebOnboardingFunnelOfferData>>): UseMutationOptions<WebOnboardingFunnelOfferResponse, WebOnboardingFunnelOfferError, Options<WebOnboardingFunnelOfferData>> => {
    const mutationOptions: UseMutationOptions<WebOnboardingFunnelOfferResponse, WebOnboardingFunnelOfferError, Options<WebOnboardingFunnelOfferData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await WebOnboarding.webOnboardingFunnelOffer({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const webOnboardingWebOnboardingConfigQueryKey = (options?: Options<WebOnboardingWebOnboardingConfigData>) => createQueryKey('webOnboardingWebOnboardingConfig', options);

/**
 * Web Onboarding Config
 * Legacy funnel config: trial + which plans to show.
 *
 * Superseded by /web-onboarding/offer, which resolves prices at the same time
 * and RECORDS what it showed. Kept for funnel builds that predate it, and it
 * now reads plan visibility from the same single source — a.funnel_plan_display
 * — so the two endpoints cannot disagree about what the paywall contains.
 *
 * The trial stays a PostHog flag: it is a genuine per-visitor experiment, and
 * unlike plan visibility it was never configured in four places at once.
 */
export const webOnboardingWebOnboardingConfigOptions = (options?: Options<WebOnboardingWebOnboardingConfigData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await WebOnboarding.webOnboardingWebOnboardingConfig({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: webOnboardingWebOnboardingConfigQueryKey(options)
    });
};

/**
 * Web Onboarding Checkout
 * Email-keyed checkout: get-or-create the account by email, attach the
 * onboarding answers, and open a Stripe embedded checkout for it.
 */
export const webOnboardingWebOnboardingCheckoutMutation = (options?: Partial<Options<WebOnboardingWebOnboardingCheckoutData>>): UseMutationOptions<WebOnboardingWebOnboardingCheckoutResponse, WebOnboardingWebOnboardingCheckoutError, Options<WebOnboardingWebOnboardingCheckoutData>> => {
    const mutationOptions: UseMutationOptions<WebOnboardingWebOnboardingCheckoutResponse, WebOnboardingWebOnboardingCheckoutError, Options<WebOnboardingWebOnboardingCheckoutData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await WebOnboarding.webOnboardingWebOnboardingCheckout({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Web Onboarding Complete
 * After embedded checkout completes: save the sub (fires the Stripe→RC
 * bridge) and send the long-lived magic link to the account's email.
 */
export const webOnboardingWebOnboardingCompleteMutation = (options?: Partial<Options<WebOnboardingWebOnboardingCompleteData>>): UseMutationOptions<WebOnboardingWebOnboardingCompleteResponse, WebOnboardingWebOnboardingCompleteError, Options<WebOnboardingWebOnboardingCompleteData>> => {
    const mutationOptions: UseMutationOptions<WebOnboardingWebOnboardingCompleteResponse, WebOnboardingWebOnboardingCompleteError, Options<WebOnboardingWebOnboardingCompleteData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await WebOnboarding.webOnboardingWebOnboardingComplete({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Web Onboarding Resend
 * Resend the handoff link to an email — works on any device since the account
 * is email-keyed. Silently succeeds if no account exists (no enumeration).
 */
export const webOnboardingWebOnboardingResendMutation = (options?: Partial<Options<WebOnboardingWebOnboardingResendData>>): UseMutationOptions<WebOnboardingWebOnboardingResendResponse, WebOnboardingWebOnboardingResendError, Options<WebOnboardingWebOnboardingResendData>> => {
    const mutationOptions: UseMutationOptions<WebOnboardingWebOnboardingResendResponse, WebOnboardingWebOnboardingResendError, Options<WebOnboardingWebOnboardingResendData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await WebOnboarding.webOnboardingWebOnboardingResend({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Payment Webhook
 */
export const paymentsPaymentWebhookMutation = (options?: Partial<Options<PaymentsPaymentWebhookData>>): UseMutationOptions<PaymentsPaymentWebhookResponse, PaymentsPaymentWebhookError, Options<PaymentsPaymentWebhookData>> => {
    const mutationOptions: UseMutationOptions<PaymentsPaymentWebhookResponse, PaymentsPaymentWebhookError, Options<PaymentsPaymentWebhookData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await Payments.paymentsPaymentWebhook({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Stripe Webhook
 * Handle Stripe webhook events.
 *
 * Processes subscription-related events:
 * - checkout.session.completed: Initial subscription creation
 * - charge.refunded: Withdraw access a refunded purchase paid for
 * - charge.dispute.created: Withdraw access a charged-back purchase paid for
 * - customer.subscription.created: Subscription created
 * - customer.subscription.updated: Subscription updated
 * - customer.subscription.deleted: Subscription canceled
 * - invoice.payment_succeeded: Payment succeeded
 * - invoice.payment_failed: Payment failed
 */
export const stripeWebhookStripeWebhookMutation = (options?: Partial<Options<StripeWebhookStripeWebhookData>>): UseMutationOptions<unknown, DefaultError, Options<StripeWebhookStripeWebhookData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<StripeWebhookStripeWebhookData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await StripeWebhook.stripeWebhookStripeWebhook({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Sync Revenuecat Subscription
 * Answer what the backend knows about this account's subscription.
 *
 * The name is a fossil. Nothing is synced upward any more: current builds
 * stopped posting here when the RevenueCat SDK went away (expo
 * ``SubscriptionBackendSync.tsx``), and the store's answer reaches us through
 * the provider webhook. The route stays because installed older builds still
 * call it on purchase and on customer-info refresh, and a 404 in that path
 * would surface as a purchase-time error on a purchase that succeeded.
 *
 * It used to rebuild ``a.rc_subscription_state`` from webhook events on the
 * request path. That projection is retired — nothing read it, and the
 * read-then-insert rebuild raced itself. ``subscription_status`` now comes
 * from ``a.entitlement``, the replayable projection of ``a.payment_event``
 * that every other reader already uses.
 *
 * ``customer_info`` is still only echoed back for the display fields; it is
 * not trusted for status and is not stored.
 */
export const revenuecatSyncRevenuecatSubscriptionMutation = (options?: Partial<Options<RevenuecatSyncRevenuecatSubscriptionData>>): UseMutationOptions<RevenuecatSyncRevenuecatSubscriptionResponse, RevenuecatSyncRevenuecatSubscriptionError, Options<RevenuecatSyncRevenuecatSubscriptionData>> => {
    const mutationOptions: UseMutationOptions<RevenuecatSyncRevenuecatSubscriptionResponse, RevenuecatSyncRevenuecatSubscriptionError, Options<RevenuecatSyncRevenuecatSubscriptionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await Revenuecat.revenuecatSyncRevenuecatSubscription({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Revenuecat Webhook
 * Handle RevenueCat webhook events.
 *
 * Simply stores webhook events in the database for later processing.
 */
export const revenuecatWebhookRevenuecatWebhookMutation = (options?: Partial<Options<RevenuecatWebhookRevenuecatWebhookData>>): UseMutationOptions<unknown, DefaultError, Options<RevenuecatWebhookRevenuecatWebhookData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<RevenuecatWebhookRevenuecatWebhookData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await RevenuecatWebhook.revenuecatWebhookRevenuecatWebhook({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Validate Promo Code
 * Validate a promo code and apply it to the user.
 *
 * - Validates code exists, is active, not expired, and hasn't exceeded max uses
 * - Increments usage count
 * - Stores code on user record
 * - Returns RevenueCat product IDs for promotion products
 */
export const promoCodesValidatePromoCodeMutation = (options?: Partial<Options<PromoCodesValidatePromoCodeData>>): UseMutationOptions<PromoCodesValidatePromoCodeResponse, PromoCodesValidatePromoCodeError, Options<PromoCodesValidatePromoCodeData>> => {
    const mutationOptions: UseMutationOptions<PromoCodesValidatePromoCodeResponse, PromoCodesValidatePromoCodeError, Options<PromoCodesValidatePromoCodeData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await PromoCodes.promoCodesValidatePromoCode({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const feedbackReadFeedbackListQueryKey = (options?: Options<FeedbackReadFeedbackListData>) => createQueryKey('feedbackReadFeedbackList', options);

/**
 * Read Feedback List
 * Retrieve feedback with pagination. Only accessible to admins.
 *
 * Parameters:
 * - skip: Number of records to skip
 * - limit: Maximum number of records to return
 * - category: Filter by category
 * - status: Filter by status
 * - priority: Filter by priority
 * - sort_by: Field to sort by (dt_created, dt_updated, category, status, priority, title)
 * - sort_direction: Sort direction (asc or desc)
 */
export const feedbackReadFeedbackListOptions = (options?: Options<FeedbackReadFeedbackListData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await Feedback.feedbackReadFeedbackList({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: feedbackReadFeedbackListQueryKey(options)
    });
};

/**
 * Create Feedback
 * Create new feedback.
 */
export const feedbackCreateFeedbackMutation = (options?: Partial<Options<FeedbackCreateFeedbackData>>): UseMutationOptions<FeedbackCreateFeedbackResponse, FeedbackCreateFeedbackError, Options<FeedbackCreateFeedbackData>> => {
    const mutationOptions: UseMutationOptions<FeedbackCreateFeedbackResponse, FeedbackCreateFeedbackError, Options<FeedbackCreateFeedbackData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await Feedback.feedbackCreateFeedback({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete Feedback
 * Delete feedback. Only accessible to admins.
 */
export const feedbackDeleteFeedbackMutation = (options?: Partial<Options<FeedbackDeleteFeedbackData>>): UseMutationOptions<FeedbackDeleteFeedbackResponse, FeedbackDeleteFeedbackError, Options<FeedbackDeleteFeedbackData>> => {
    const mutationOptions: UseMutationOptions<FeedbackDeleteFeedbackResponse, FeedbackDeleteFeedbackError, Options<FeedbackDeleteFeedbackData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await Feedback.feedbackDeleteFeedback({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const feedbackReadFeedbackQueryKey = (options: Options<FeedbackReadFeedbackData>) => createQueryKey('feedbackReadFeedback', options);

/**
 * Read Feedback
 * Get feedback by ID. Only accessible to admins.
 */
export const feedbackReadFeedbackOptions = (options: Options<FeedbackReadFeedbackData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await Feedback.feedbackReadFeedback({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: feedbackReadFeedbackQueryKey(options)
    });
};

/**
 * Update Feedback
 * Update feedback. Only accessible to admins.
 */
export const feedbackUpdateFeedbackMutation = (options?: Partial<Options<FeedbackUpdateFeedbackData>>): UseMutationOptions<FeedbackUpdateFeedbackResponse, FeedbackUpdateFeedbackError, Options<FeedbackUpdateFeedbackData>> => {
    const mutationOptions: UseMutationOptions<FeedbackUpdateFeedbackResponse, FeedbackUpdateFeedbackError, Options<FeedbackUpdateFeedbackData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await Feedback.feedbackUpdateFeedback({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const agentConfigsGetAgentConfigBySlugQueryKey = (options: Options<AgentConfigsGetAgentConfigBySlugData>) => createQueryKey('agentConfigsGetAgentConfigBySlug', options);

/**
 * Get Agent Config By Slug
 * Get an agent config by slug (authenticated users only).
 * Returns config without secrets.
 */
export const agentConfigsGetAgentConfigBySlugOptions = (options: Options<AgentConfigsGetAgentConfigBySlugData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await AgentConfigs.agentConfigsGetAgentConfigBySlug({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: agentConfigsGetAgentConfigBySlugQueryKey(options)
    });
};

/**
 * Create Elevenlabs Signed Url
 * Create ElevenLabs signed URL for starting a conversation.
 * Uses caching to avoid unnecessary API calls to ElevenLabs.
 */
export const agentConfigsCreateElevenlabsSignedUrlMutation = (options?: Partial<Options<AgentConfigsCreateElevenlabsSignedUrlData>>): UseMutationOptions<AgentConfigsCreateElevenlabsSignedUrlResponse, AgentConfigsCreateElevenlabsSignedUrlError, Options<AgentConfigsCreateElevenlabsSignedUrlData>> => {
    const mutationOptions: UseMutationOptions<AgentConfigsCreateElevenlabsSignedUrlResponse, AgentConfigsCreateElevenlabsSignedUrlError, Options<AgentConfigsCreateElevenlabsSignedUrlData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await AgentConfigs.agentConfigsCreateElevenlabsSignedUrl({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const agentConfigsListAgentConfigsQueryKey = (options?: Options<AgentConfigsListAgentConfigsData>) => createQueryKey('agentConfigsListAgentConfigs', options);

/**
 * List Agent Configs
 * List all agent configs with pagination (admin only).
 */
export const agentConfigsListAgentConfigsOptions = (options?: Options<AgentConfigsListAgentConfigsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await AgentConfigs.agentConfigsListAgentConfigs({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: agentConfigsListAgentConfigsQueryKey(options)
    });
};

export const agentConfigsListAgentConfigsInfiniteQueryKey = (options?: Options<AgentConfigsListAgentConfigsData>): QueryKey<Options<AgentConfigsListAgentConfigsData>> => createQueryKey('agentConfigsListAgentConfigs', options, true);

/**
 * List Agent Configs
 * List all agent configs with pagination (admin only).
 */
export const agentConfigsListAgentConfigsInfiniteOptions = (options?: Options<AgentConfigsListAgentConfigsData>) => {
    return infiniteQueryOptions<AgentConfigsListAgentConfigsResponse, AgentConfigsListAgentConfigsError, InfiniteData<AgentConfigsListAgentConfigsResponse>, QueryKey<Options<AgentConfigsListAgentConfigsData>>, number | Pick<QueryKey<Options<AgentConfigsListAgentConfigsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<AgentConfigsListAgentConfigsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await AgentConfigs.agentConfigsListAgentConfigs({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: agentConfigsListAgentConfigsInfiniteQueryKey(options)
    });
};

/**
 * Create Agent Config
 * Create a new agent config (admin only).
 */
export const agentConfigsCreateAgentConfigMutation = (options?: Partial<Options<AgentConfigsCreateAgentConfigData>>): UseMutationOptions<AgentConfigsCreateAgentConfigResponse, AgentConfigsCreateAgentConfigError, Options<AgentConfigsCreateAgentConfigData>> => {
    const mutationOptions: UseMutationOptions<AgentConfigsCreateAgentConfigResponse, AgentConfigsCreateAgentConfigError, Options<AgentConfigsCreateAgentConfigData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await AgentConfigs.agentConfigsCreateAgentConfig({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete Agent Config
 * Delete an agent config (admin only).
 */
export const agentConfigsDeleteAgentConfigMutation = (options?: Partial<Options<AgentConfigsDeleteAgentConfigData>>): UseMutationOptions<AgentConfigsDeleteAgentConfigResponse, AgentConfigsDeleteAgentConfigError, Options<AgentConfigsDeleteAgentConfigData>> => {
    const mutationOptions: UseMutationOptions<AgentConfigsDeleteAgentConfigResponse, AgentConfigsDeleteAgentConfigError, Options<AgentConfigsDeleteAgentConfigData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await AgentConfigs.agentConfigsDeleteAgentConfig({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const agentConfigsGetAgentConfigByIdQueryKey = (options: Options<AgentConfigsGetAgentConfigByIdData>) => createQueryKey('agentConfigsGetAgentConfigById', options);

/**
 * Get Agent Config By Id
 * Get an agent config by ID (admin only).
 */
export const agentConfigsGetAgentConfigByIdOptions = (options: Options<AgentConfigsGetAgentConfigByIdData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await AgentConfigs.agentConfigsGetAgentConfigById({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: agentConfigsGetAgentConfigByIdQueryKey(options)
    });
};

/**
 * Update Agent Config
 * Update an agent config (admin only).
 */
export const agentConfigsUpdateAgentConfigMutation = (options?: Partial<Options<AgentConfigsUpdateAgentConfigData>>): UseMutationOptions<AgentConfigsUpdateAgentConfigResponse, AgentConfigsUpdateAgentConfigError, Options<AgentConfigsUpdateAgentConfigData>> => {
    const mutationOptions: UseMutationOptions<AgentConfigsUpdateAgentConfigResponse, AgentConfigsUpdateAgentConfigError, Options<AgentConfigsUpdateAgentConfigData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await AgentConfigs.agentConfigsUpdateAgentConfig({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Invalidate Agent Cache
 * Invalidate cached signed URLs for an agent config (admin only).
 */
export const agentConfigsInvalidateAgentCacheMutation = (options?: Partial<Options<AgentConfigsInvalidateAgentCacheData>>): UseMutationOptions<AgentConfigsInvalidateAgentCacheResponse, AgentConfigsInvalidateAgentCacheError, Options<AgentConfigsInvalidateAgentCacheData>> => {
    const mutationOptions: UseMutationOptions<AgentConfigsInvalidateAgentCacheResponse, AgentConfigsInvalidateAgentCacheError, Options<AgentConfigsInvalidateAgentCacheData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await AgentConfigs.agentConfigsInvalidateAgentCache({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const exercisesGetDailyFlowBehaviorsQueryKey = (options?: Options<ExercisesGetDailyFlowBehaviorsData>) => createQueryKey('exercisesGetDailyFlowBehaviors', options);

/**
 * Get Daily Flow Behaviors
 * Get the available daily flow behavior options for the multi-select.
 *
 * This endpoint provides the behavior options that users can select from
 * during their daily check-in flow. These behaviors are then used to
 * recommend appropriate exercises.
 */
export const exercisesGetDailyFlowBehaviorsOptions = (options?: Options<ExercisesGetDailyFlowBehaviorsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await Exercises.exercisesGetDailyFlowBehaviors({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: exercisesGetDailyFlowBehaviorsQueryKey(options)
    });
};

export const exercisesGetDailyFlowRecommendationQueryKey = (options: Options<ExercisesGetDailyFlowRecommendationData>) => createQueryKey('exercisesGetDailyFlowRecommendation', options);

/**
 * Get Daily Flow Recommendation
 * Get a recommended exercise based on daily flow tags (authenticated users only).
 *
 * This endpoint implements the daily flow recommendation feature:
 * - Takes daily flow tags as input
 * - Finds exercises that match those tags
 * - Returns a recommended exercise based on historic weighting
 * - Returns None if no matching exercises found
 */
export const exercisesGetDailyFlowRecommendationOptions = (options: Options<ExercisesGetDailyFlowRecommendationData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await Exercises.exercisesGetDailyFlowRecommendation({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: exercisesGetDailyFlowRecommendationQueryKey(options)
    });
};

export const exercisesListExercisesQueryKey = (options?: Options<ExercisesListExercisesData>) => createQueryKey('exercisesListExercises', options);

/**
 * List Exercises
 * List exercises with pagination (authenticated users only).
 */
export const exercisesListExercisesOptions = (options?: Options<ExercisesListExercisesData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await Exercises.exercisesListExercises({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: exercisesListExercisesQueryKey(options)
    });
};

export const exercisesListExercisesInfiniteQueryKey = (options?: Options<ExercisesListExercisesData>): QueryKey<Options<ExercisesListExercisesData>> => createQueryKey('exercisesListExercises', options, true);

/**
 * List Exercises
 * List exercises with pagination (authenticated users only).
 */
export const exercisesListExercisesInfiniteOptions = (options?: Options<ExercisesListExercisesData>) => {
    return infiniteQueryOptions<ExercisesListExercisesResponse, ExercisesListExercisesError, InfiniteData<ExercisesListExercisesResponse>, QueryKey<Options<ExercisesListExercisesData>>, number | Pick<QueryKey<Options<ExercisesListExercisesData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<ExercisesListExercisesData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await Exercises.exercisesListExercises({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: exercisesListExercisesInfiniteQueryKey(options)
    });
};

/**
 * Create Exercise
 * Create a new exercise (admin only).
 */
export const exercisesCreateExerciseMutation = (options?: Partial<Options<ExercisesCreateExerciseData>>): UseMutationOptions<ExercisesCreateExerciseResponse, ExercisesCreateExerciseError, Options<ExercisesCreateExerciseData>> => {
    const mutationOptions: UseMutationOptions<ExercisesCreateExerciseResponse, ExercisesCreateExerciseError, Options<ExercisesCreateExerciseData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await Exercises.exercisesCreateExercise({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete Exercise
 * Delete an exercise by ID (admin only).
 */
export const exercisesDeleteExerciseMutation = (options?: Partial<Options<ExercisesDeleteExerciseData>>): UseMutationOptions<ExercisesDeleteExerciseResponse, ExercisesDeleteExerciseError, Options<ExercisesDeleteExerciseData>> => {
    const mutationOptions: UseMutationOptions<ExercisesDeleteExerciseResponse, ExercisesDeleteExerciseError, Options<ExercisesDeleteExerciseData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await Exercises.exercisesDeleteExercise({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const exercisesGetExerciseByIdAdminQueryKey = (options: Options<ExercisesGetExerciseByIdAdminData>) => createQueryKey('exercisesGetExerciseByIdAdmin', options);

/**
 * Get Exercise By Id Admin
 * Get an exercise by ID (admin only).
 */
export const exercisesGetExerciseByIdAdminOptions = (options: Options<ExercisesGetExerciseByIdAdminData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await Exercises.exercisesGetExerciseByIdAdmin({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: exercisesGetExerciseByIdAdminQueryKey(options)
    });
};

/**
 * Update Exercise
 * Update an exercise by ID (admin only).
 */
export const exercisesUpdateExerciseMutation = (options?: Partial<Options<ExercisesUpdateExerciseData>>): UseMutationOptions<ExercisesUpdateExerciseResponse, ExercisesUpdateExerciseError, Options<ExercisesUpdateExerciseData>> => {
    const mutationOptions: UseMutationOptions<ExercisesUpdateExerciseResponse, ExercisesUpdateExerciseError, Options<ExercisesUpdateExerciseData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await Exercises.exercisesUpdateExercise({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Promote Exercise From Staging
 * Promote a draft exercise from staging to production.
 * Called from staging backend - creates draft on production.
 */
export const exercisesPromoteExerciseFromStagingMutation = (options?: Partial<Options<ExercisesPromoteExerciseFromStagingData>>): UseMutationOptions<ExercisesPromoteExerciseFromStagingResponse, ExercisesPromoteExerciseFromStagingError, Options<ExercisesPromoteExerciseFromStagingData>> => {
    const mutationOptions: UseMutationOptions<ExercisesPromoteExerciseFromStagingResponse, ExercisesPromoteExerciseFromStagingError, Options<ExercisesPromoteExerciseFromStagingData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await Exercises.exercisesPromoteExerciseFromStaging({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Publish Exercise
 * Publish a draft exercise (set is_draft=False, dt_published=now).
 * Only available in production environment.
 */
export const exercisesPublishExerciseMutation = (options?: Partial<Options<ExercisesPublishExerciseData>>): UseMutationOptions<ExercisesPublishExerciseResponse, ExercisesPublishExerciseError, Options<ExercisesPublishExerciseData>> => {
    const mutationOptions: UseMutationOptions<ExercisesPublishExerciseResponse, ExercisesPublishExerciseError, Options<ExercisesPublishExerciseData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await Exercises.exercisesPublishExercise({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Unpublish Exercise
 * Unpublish an exercise (set is_draft=True, dt_published=None).
 * Only available in production environment.
 */
export const exercisesUnpublishExerciseMutation = (options?: Partial<Options<ExercisesUnpublishExerciseData>>): UseMutationOptions<ExercisesUnpublishExerciseResponse, ExercisesUnpublishExerciseError, Options<ExercisesUnpublishExerciseData>> => {
    const mutationOptions: UseMutationOptions<ExercisesUnpublishExerciseResponse, ExercisesUnpublishExerciseError, Options<ExercisesUnpublishExerciseData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await Exercises.exercisesUnpublishExercise({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Sync Exercises From Production
 * Sync published exercises from production to staging.
 * Only available in staging environment.
 */
export const exercisesSyncExercisesFromProductionMutation = (options?: Partial<Options<ExercisesSyncExercisesFromProductionData>>): UseMutationOptions<ExercisesSyncExercisesFromProductionResponse, DefaultError, Options<ExercisesSyncExercisesFromProductionData>> => {
    const mutationOptions: UseMutationOptions<ExercisesSyncExercisesFromProductionResponse, DefaultError, Options<ExercisesSyncExercisesFromProductionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await Exercises.exercisesSyncExercisesFromProduction({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const exercisesListExerciseCategoriesQueryKey = (options?: Options<ExercisesListExerciseCategoriesData>) => createQueryKey('exercisesListExerciseCategories', options);

/**
 * List Exercise Categories
 * List all exercise categories (authenticated users only).
 */
export const exercisesListExerciseCategoriesOptions = (options?: Options<ExercisesListExerciseCategoriesData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await Exercises.exercisesListExerciseCategories({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: exercisesListExerciseCategoriesQueryKey(options)
    });
};

export const exercisesGetExercisesByCategoryQueryKey = (options: Options<ExercisesGetExercisesByCategoryData>) => createQueryKey('exercisesGetExercisesByCategory', options);

/**
 * Get Exercises By Category
 * Get exercises by category (authenticated users only).
 */
export const exercisesGetExercisesByCategoryOptions = (options: Options<ExercisesGetExercisesByCategoryData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await Exercises.exercisesGetExercisesByCategory({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: exercisesGetExercisesByCategoryQueryKey(options)
    });
};

export const exercisesGetExercisesByCategoryInfiniteQueryKey = (options: Options<ExercisesGetExercisesByCategoryData>): QueryKey<Options<ExercisesGetExercisesByCategoryData>> => createQueryKey('exercisesGetExercisesByCategory', options, true);

/**
 * Get Exercises By Category
 * Get exercises by category (authenticated users only).
 */
export const exercisesGetExercisesByCategoryInfiniteOptions = (options: Options<ExercisesGetExercisesByCategoryData>) => {
    return infiniteQueryOptions<ExercisesGetExercisesByCategoryResponse, ExercisesGetExercisesByCategoryError, InfiniteData<ExercisesGetExercisesByCategoryResponse>, QueryKey<Options<ExercisesGetExercisesByCategoryData>>, number | Pick<QueryKey<Options<ExercisesGetExercisesByCategoryData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<ExercisesGetExercisesByCategoryData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await Exercises.exercisesGetExercisesByCategory({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: exercisesGetExercisesByCategoryInfiniteQueryKey(options)
    });
};

export const exercisesGetExerciseBySlugQueryKey = (options: Options<ExercisesGetExerciseBySlugData>) => createQueryKey('exercisesGetExerciseBySlug', options);

/**
 * Get Exercise By Slug
 * Get the latest version of an exercise by slug (authenticated users only).
 * Only returns published (non-draft) exercises.
 */
export const exercisesGetExerciseBySlugOptions = (options: Options<ExercisesGetExerciseBySlugData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await Exercises.exercisesGetExerciseBySlug({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: exercisesGetExerciseBySlugQueryKey(options)
    });
};

export const exercisesGetExerciseBySlugAndVersionQueryKey = (options: Options<ExercisesGetExerciseBySlugAndVersionData>) => createQueryKey('exercisesGetExerciseBySlugAndVersion', options);

/**
 * Get Exercise By Slug And Version
 * Get a specific version of an exercise by slug and version (authenticated users only).
 * Only returns published (non-draft) exercises.
 */
export const exercisesGetExerciseBySlugAndVersionOptions = (options: Options<ExercisesGetExerciseBySlugAndVersionData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await Exercises.exercisesGetExerciseBySlugAndVersion({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: exercisesGetExerciseBySlugAndVersionQueryKey(options)
    });
};

export const amisExercisesListAmisExercisesQueryKey = (options?: Options<AmisExercisesListAmisExercisesData>) => createQueryKey('amisExercisesListAmisExercises', options);

/**
 * List Amis Exercises
 * List Amis exercises with pagination (authenticated users only).
 */
export const amisExercisesListAmisExercisesOptions = (options?: Options<AmisExercisesListAmisExercisesData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await AmisExercises.amisExercisesListAmisExercises({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: amisExercisesListAmisExercisesQueryKey(options)
    });
};

export const amisExercisesListAmisExercisesInfiniteQueryKey = (options?: Options<AmisExercisesListAmisExercisesData>): QueryKey<Options<AmisExercisesListAmisExercisesData>> => createQueryKey('amisExercisesListAmisExercises', options, true);

/**
 * List Amis Exercises
 * List Amis exercises with pagination (authenticated users only).
 */
export const amisExercisesListAmisExercisesInfiniteOptions = (options?: Options<AmisExercisesListAmisExercisesData>) => {
    return infiniteQueryOptions<AmisExercisesListAmisExercisesResponse, AmisExercisesListAmisExercisesError, InfiniteData<AmisExercisesListAmisExercisesResponse>, QueryKey<Options<AmisExercisesListAmisExercisesData>>, number | Pick<QueryKey<Options<AmisExercisesListAmisExercisesData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<AmisExercisesListAmisExercisesData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await AmisExercises.amisExercisesListAmisExercises({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: amisExercisesListAmisExercisesInfiniteQueryKey(options)
    });
};

/**
 * Create Amis Exercise
 * Create a new Amis exercise (admin only).
 * Creates exercise with initial draft version D1.
 */
export const amisExercisesCreateAmisExerciseMutation = (options?: Partial<Options<AmisExercisesCreateAmisExerciseData>>): UseMutationOptions<AmisExercisesCreateAmisExerciseResponse, AmisExercisesCreateAmisExerciseError, Options<AmisExercisesCreateAmisExerciseData>> => {
    const mutationOptions: UseMutationOptions<AmisExercisesCreateAmisExerciseResponse, AmisExercisesCreateAmisExerciseError, Options<AmisExercisesCreateAmisExerciseData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await AmisExercises.amisExercisesCreateAmisExercise({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const amisExercisesGetDailyFlowRecommendationQueryKey = (options: Options<AmisExercisesGetDailyFlowRecommendationData>) => createQueryKey('amisExercisesGetDailyFlowRecommendation', options);

/**
 * Get Daily Flow Recommendation
 * Get a recommended Amis exercise based on daily flow tags (authenticated users only).
 *
 * This endpoint implements the daily flow recommendation feature:
 * - Takes daily flow tags as input
 * - Finds Amis exercises that match those tags
 * - Returns a recommended exercise based on historic weighting
 * - Returns None if no matching exercises found
 */
export const amisExercisesGetDailyFlowRecommendationOptions = (options: Options<AmisExercisesGetDailyFlowRecommendationData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await AmisExercises.amisExercisesGetDailyFlowRecommendation({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: amisExercisesGetDailyFlowRecommendationQueryKey(options)
    });
};

/**
 * Delete Amis Exercise
 * Delete an Amis exercise by ID (admin only).
 * Cascades to version history.
 */
export const amisExercisesDeleteAmisExerciseMutation = (options?: Partial<Options<AmisExercisesDeleteAmisExerciseData>>): UseMutationOptions<AmisExercisesDeleteAmisExerciseResponse, AmisExercisesDeleteAmisExerciseError, Options<AmisExercisesDeleteAmisExerciseData>> => {
    const mutationOptions: UseMutationOptions<AmisExercisesDeleteAmisExerciseResponse, AmisExercisesDeleteAmisExerciseError, Options<AmisExercisesDeleteAmisExerciseData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await AmisExercises.amisExercisesDeleteAmisExercise({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const amisExercisesGetAmisExerciseByIdQueryKey = (options: Options<AmisExercisesGetAmisExerciseByIdData>) => createQueryKey('amisExercisesGetAmisExerciseById', options);

/**
 * Get Amis Exercise By Id
 * Get an Amis exercise by ID (authenticated users only).
 *
 * If prefer_draft=True:
 * - Returns the latest draft version if one exists
 * - Otherwise returns the latest published version
 *
 * If prefer_draft=False (default):
 * - Returns the latest published version
 * - If no published version exists, returns the current version (which may be a draft)
 */
export const amisExercisesGetAmisExerciseByIdOptions = (options: Options<AmisExercisesGetAmisExerciseByIdData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await AmisExercises.amisExercisesGetAmisExerciseById({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: amisExercisesGetAmisExerciseByIdQueryKey(options)
    });
};

/**
 * Update Amis Exercise
 * Update an Amis exercise by ID (admin only).
 * Creates a new version (D2, D3, etc. or D1 if coming from published).
 */
export const amisExercisesUpdateAmisExerciseMutation = (options?: Partial<Options<AmisExercisesUpdateAmisExerciseData>>): UseMutationOptions<AmisExercisesUpdateAmisExerciseResponse, AmisExercisesUpdateAmisExerciseError, Options<AmisExercisesUpdateAmisExerciseData>> => {
    const mutationOptions: UseMutationOptions<AmisExercisesUpdateAmisExerciseResponse, AmisExercisesUpdateAmisExerciseError, Options<AmisExercisesUpdateAmisExerciseData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await AmisExercises.amisExercisesUpdateAmisExercise({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Publish Amis Exercise
 * Publish a draft Amis exercise (admin only).
 * Creates a published version (P1, P2, etc.) and deletes all draft versions.
 */
export const amisExercisesPublishAmisExerciseMutation = (options?: Partial<Options<AmisExercisesPublishAmisExerciseData>>): UseMutationOptions<AmisExercisesPublishAmisExerciseResponse, AmisExercisesPublishAmisExerciseError, Options<AmisExercisesPublishAmisExerciseData>> => {
    const mutationOptions: UseMutationOptions<AmisExercisesPublishAmisExerciseResponse, AmisExercisesPublishAmisExerciseError, Options<AmisExercisesPublishAmisExerciseData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await AmisExercises.amisExercisesPublishAmisExercise({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const amisExercisesGetAmisExerciseHistoryQueryKey = (options: Options<AmisExercisesGetAmisExerciseHistoryData>) => createQueryKey('amisExercisesGetAmisExerciseHistory', options);

/**
 * Get Amis Exercise History
 * Get version history for an Amis exercise (admin only).
 * Returns all versions (drafts and published) ordered by creation date (newest first).
 */
export const amisExercisesGetAmisExerciseHistoryOptions = (options: Options<AmisExercisesGetAmisExerciseHistoryData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await AmisExercises.amisExercisesGetAmisExerciseHistory({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: amisExercisesGetAmisExerciseHistoryQueryKey(options)
    });
};

/**
 * Delete Amis Exercise Version
 * Delete a specific version (admin only).
 * Cannot delete current version or published versions.
 */
export const amisExercisesDeleteAmisExerciseVersionMutation = (options?: Partial<Options<AmisExercisesDeleteAmisExerciseVersionData>>): UseMutationOptions<AmisExercisesDeleteAmisExerciseVersionResponse, AmisExercisesDeleteAmisExerciseVersionError, Options<AmisExercisesDeleteAmisExerciseVersionData>> => {
    const mutationOptions: UseMutationOptions<AmisExercisesDeleteAmisExerciseVersionResponse, AmisExercisesDeleteAmisExerciseVersionError, Options<AmisExercisesDeleteAmisExerciseVersionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await AmisExercises.amisExercisesDeleteAmisExerciseVersion({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const amisExercisesGetAmisExerciseVersionByIdQueryKey = (options: Options<AmisExercisesGetAmisExerciseVersionByIdData>) => createQueryKey('amisExercisesGetAmisExerciseVersionById', options);

/**
 * Get Amis Exercise Version By Id
 * Get a specific version history entry by ID (admin only).
 * Used for diff comparison.
 */
export const amisExercisesGetAmisExerciseVersionByIdOptions = (options: Options<AmisExercisesGetAmisExerciseVersionByIdData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await AmisExercises.amisExercisesGetAmisExerciseVersionById({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: amisExercisesGetAmisExerciseVersionByIdQueryKey(options)
    });
};

/**
 * Delete Old Draft Versions
 * Delete all draft versions older than the latest published version (admin only).
 * Returns the number of versions deleted.
 */
export const amisExercisesDeleteOldDraftVersionsMutation = (options?: Partial<Options<AmisExercisesDeleteOldDraftVersionsData>>): UseMutationOptions<AmisExercisesDeleteOldDraftVersionsResponse, AmisExercisesDeleteOldDraftVersionsError, Options<AmisExercisesDeleteOldDraftVersionsData>> => {
    const mutationOptions: UseMutationOptions<AmisExercisesDeleteOldDraftVersionsResponse, AmisExercisesDeleteOldDraftVersionsError, Options<AmisExercisesDeleteOldDraftVersionsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await AmisExercises.amisExercisesDeleteOldDraftVersions({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const dailyLessonsGetAvailableLessonsQueryKey = (options?: Options<DailyLessonsGetAvailableLessonsData>) => createQueryKey('dailyLessonsGetAvailableLessons', options);

/**
 * Get Available Lessons
 * Get available daily lessons for the current user.
 *
 * Returns lessons based on:
 * - User's current sequence day (based on unique days using app)
 * - Excludes lessons user has already dismissed
 * - Only shows lessons up to today's sequence day (previous days' lessons show if not dismissed)
 *
 * If test_sequence_day is provided, it overrides the calculated sequence day.
 * This is useful for testing different lesson sequences.
 *
 * If include_drafts is True, shows draft lessons (for dev mode testing).
 * Otherwise, only shows published (is_draft=False) and active lessons.
 */
export const dailyLessonsGetAvailableLessonsOptions = (options?: Options<DailyLessonsGetAvailableLessonsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await DailyLessons.dailyLessonsGetAvailableLessons({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: dailyLessonsGetAvailableLessonsQueryKey(options)
    });
};

export const dailyLessonsGetSavedLessonsQueryKey = (options?: Options<DailyLessonsGetSavedLessonsData>) => createQueryKey('dailyLessonsGetSavedLessons', options);

/**
 * Get Saved Lessons
 * Get all saved (liked) daily lessons for the current user.
 * Returns lessons where the user has liked=1 (saved).
 */
export const dailyLessonsGetSavedLessonsOptions = (options?: Options<DailyLessonsGetSavedLessonsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await DailyLessons.dailyLessonsGetSavedLessons({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: dailyLessonsGetSavedLessonsQueryKey(options)
    });
};

export const dailyLessonsGetDailyLessonQueryKey = (options: Options<DailyLessonsGetDailyLessonData>) => createQueryKey('dailyLessonsGetDailyLesson', options);

/**
 * Get Daily Lesson
 * Get a single daily lesson by ID. Only returns published (non-draft) lessons.
 */
export const dailyLessonsGetDailyLessonOptions = (options: Options<DailyLessonsGetDailyLessonData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await DailyLessons.dailyLessonsGetDailyLesson({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: dailyLessonsGetDailyLessonQueryKey(options)
    });
};

/**
 * Dismiss Lesson
 * Mark a lesson as dismissed for the current user.
 */
export const dailyLessonsDismissLessonMutation = (options?: Partial<Options<DailyLessonsDismissLessonData>>): UseMutationOptions<DailyLessonsDismissLessonResponse, DailyLessonsDismissLessonError, Options<DailyLessonsDismissLessonData>> => {
    const mutationOptions: UseMutationOptions<DailyLessonsDismissLessonResponse, DailyLessonsDismissLessonError, Options<DailyLessonsDismissLessonData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await DailyLessons.dailyLessonsDismissLesson({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Like Lesson
 * Like a lesson for the current user.
 */
export const dailyLessonsLikeLessonMutation = (options?: Partial<Options<DailyLessonsLikeLessonData>>): UseMutationOptions<DailyLessonsLikeLessonResponse, DailyLessonsLikeLessonError, Options<DailyLessonsLikeLessonData>> => {
    const mutationOptions: UseMutationOptions<DailyLessonsLikeLessonResponse, DailyLessonsLikeLessonError, Options<DailyLessonsLikeLessonData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await DailyLessons.dailyLessonsLikeLesson({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const dailyLessonsListDailyLessonsAdminQueryKey = (options?: Options<DailyLessonsListDailyLessonsAdminData>) => createQueryKey('dailyLessonsListDailyLessonsAdmin', options);

/**
 * List Daily Lessons Admin
 * List all daily lessons with pagination (admin only).
 */
export const dailyLessonsListDailyLessonsAdminOptions = (options?: Options<DailyLessonsListDailyLessonsAdminData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await DailyLessons.dailyLessonsListDailyLessonsAdmin({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: dailyLessonsListDailyLessonsAdminQueryKey(options)
    });
};

export const dailyLessonsListDailyLessonsAdminInfiniteQueryKey = (options?: Options<DailyLessonsListDailyLessonsAdminData>): QueryKey<Options<DailyLessonsListDailyLessonsAdminData>> => createQueryKey('dailyLessonsListDailyLessonsAdmin', options, true);

/**
 * List Daily Lessons Admin
 * List all daily lessons with pagination (admin only).
 */
export const dailyLessonsListDailyLessonsAdminInfiniteOptions = (options?: Options<DailyLessonsListDailyLessonsAdminData>) => {
    return infiniteQueryOptions<DailyLessonsListDailyLessonsAdminResponse, DailyLessonsListDailyLessonsAdminError, InfiniteData<DailyLessonsListDailyLessonsAdminResponse>, QueryKey<Options<DailyLessonsListDailyLessonsAdminData>>, number | Pick<QueryKey<Options<DailyLessonsListDailyLessonsAdminData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<DailyLessonsListDailyLessonsAdminData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await DailyLessons.dailyLessonsListDailyLessonsAdmin({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: dailyLessonsListDailyLessonsAdminInfiniteQueryKey(options)
    });
};

/**
 * Create Daily Lesson Admin
 * Create a new daily lesson (admin only).
 */
export const dailyLessonsCreateDailyLessonAdminMutation = (options?: Partial<Options<DailyLessonsCreateDailyLessonAdminData>>): UseMutationOptions<DailyLessonsCreateDailyLessonAdminResponse, DailyLessonsCreateDailyLessonAdminError, Options<DailyLessonsCreateDailyLessonAdminData>> => {
    const mutationOptions: UseMutationOptions<DailyLessonsCreateDailyLessonAdminResponse, DailyLessonsCreateDailyLessonAdminError, Options<DailyLessonsCreateDailyLessonAdminData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await DailyLessons.dailyLessonsCreateDailyLessonAdmin({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Bulk Upsert Daily Lessons Admin
 * Bulk upsert daily lessons by slug (admin only).
 * If a lesson with the slug exists, it will be updated. Otherwise, it will be created.
 */
export const dailyLessonsBulkUpsertDailyLessonsAdminMutation = (options?: Partial<Options<DailyLessonsBulkUpsertDailyLessonsAdminData>>): UseMutationOptions<DailyLessonsBulkUpsertDailyLessonsAdminResponse, DailyLessonsBulkUpsertDailyLessonsAdminError, Options<DailyLessonsBulkUpsertDailyLessonsAdminData>> => {
    const mutationOptions: UseMutationOptions<DailyLessonsBulkUpsertDailyLessonsAdminResponse, DailyLessonsBulkUpsertDailyLessonsAdminError, Options<DailyLessonsBulkUpsertDailyLessonsAdminData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await DailyLessons.dailyLessonsBulkUpsertDailyLessonsAdmin({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete Daily Lesson Admin
 * Soft delete a daily lesson by setting is_active=False (admin only).
 */
export const dailyLessonsDeleteDailyLessonAdminMutation = (options?: Partial<Options<DailyLessonsDeleteDailyLessonAdminData>>): UseMutationOptions<DailyLessonsDeleteDailyLessonAdminResponse, DailyLessonsDeleteDailyLessonAdminError, Options<DailyLessonsDeleteDailyLessonAdminData>> => {
    const mutationOptions: UseMutationOptions<DailyLessonsDeleteDailyLessonAdminResponse, DailyLessonsDeleteDailyLessonAdminError, Options<DailyLessonsDeleteDailyLessonAdminData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await DailyLessons.dailyLessonsDeleteDailyLessonAdmin({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const dailyLessonsGetDailyLessonAdminQueryKey = (options: Options<DailyLessonsGetDailyLessonAdminData>) => createQueryKey('dailyLessonsGetDailyLessonAdmin', options);

/**
 * Get Daily Lesson Admin
 * Get a daily lesson by ID (admin only).
 */
export const dailyLessonsGetDailyLessonAdminOptions = (options: Options<DailyLessonsGetDailyLessonAdminData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await DailyLessons.dailyLessonsGetDailyLessonAdmin({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: dailyLessonsGetDailyLessonAdminQueryKey(options)
    });
};

/**
 * Update Daily Lesson Admin
 * Update a daily lesson (admin only).
 */
export const dailyLessonsUpdateDailyLessonAdminMutation = (options?: Partial<Options<DailyLessonsUpdateDailyLessonAdminData>>): UseMutationOptions<DailyLessonsUpdateDailyLessonAdminResponse, DailyLessonsUpdateDailyLessonAdminError, Options<DailyLessonsUpdateDailyLessonAdminData>> => {
    const mutationOptions: UseMutationOptions<DailyLessonsUpdateDailyLessonAdminResponse, DailyLessonsUpdateDailyLessonAdminError, Options<DailyLessonsUpdateDailyLessonAdminData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await DailyLessons.dailyLessonsUpdateDailyLessonAdmin({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Promote Daily Lesson From Staging
 * Promote a draft daily lesson from staging to production.
 * Called from staging backend - creates draft on production.
 */
export const dailyLessonsPromoteDailyLessonFromStagingMutation = (options?: Partial<Options<DailyLessonsPromoteDailyLessonFromStagingData>>): UseMutationOptions<DailyLessonsPromoteDailyLessonFromStagingResponse, DailyLessonsPromoteDailyLessonFromStagingError, Options<DailyLessonsPromoteDailyLessonFromStagingData>> => {
    const mutationOptions: UseMutationOptions<DailyLessonsPromoteDailyLessonFromStagingResponse, DailyLessonsPromoteDailyLessonFromStagingError, Options<DailyLessonsPromoteDailyLessonFromStagingData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await DailyLessons.dailyLessonsPromoteDailyLessonFromStaging({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Publish Daily Lesson
 * Publish a draft daily lesson (set is_draft=False, dt_published=now).
 * Only available in production environment.
 */
export const dailyLessonsPublishDailyLessonMutation = (options?: Partial<Options<DailyLessonsPublishDailyLessonData>>): UseMutationOptions<DailyLessonsPublishDailyLessonResponse, DailyLessonsPublishDailyLessonError, Options<DailyLessonsPublishDailyLessonData>> => {
    const mutationOptions: UseMutationOptions<DailyLessonsPublishDailyLessonResponse, DailyLessonsPublishDailyLessonError, Options<DailyLessonsPublishDailyLessonData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await DailyLessons.dailyLessonsPublishDailyLesson({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Unpublish Daily Lesson
 * Unpublish a daily lesson (set is_draft=True, dt_published=None).
 * Only available in production environment.
 */
export const dailyLessonsUnpublishDailyLessonMutation = (options?: Partial<Options<DailyLessonsUnpublishDailyLessonData>>): UseMutationOptions<DailyLessonsUnpublishDailyLessonResponse, DailyLessonsUnpublishDailyLessonError, Options<DailyLessonsUnpublishDailyLessonData>> => {
    const mutationOptions: UseMutationOptions<DailyLessonsUnpublishDailyLessonResponse, DailyLessonsUnpublishDailyLessonError, Options<DailyLessonsUnpublishDailyLessonData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await DailyLessons.dailyLessonsUnpublishDailyLesson({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Sync Daily Lessons From Production
 * Sync published daily lessons from production to staging.
 * Only available in staging environment.
 */
export const dailyLessonsSyncDailyLessonsFromProductionMutation = (options?: Partial<Options<DailyLessonsSyncDailyLessonsFromProductionData>>): UseMutationOptions<DailyLessonsSyncDailyLessonsFromProductionResponse, DefaultError, Options<DailyLessonsSyncDailyLessonsFromProductionData>> => {
    const mutationOptions: UseMutationOptions<DailyLessonsSyncDailyLessonsFromProductionResponse, DefaultError, Options<DailyLessonsSyncDailyLessonsFromProductionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await DailyLessons.dailyLessonsSyncDailyLessonsFromProduction({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const bannersGetEligibleBannersQueryKey = (options?: Options<BannersGetEligibleBannersData>) => createQueryKey('bannersGetEligibleBanners', options);

/**
 * Get Eligible Banners
 * Resolve the user's portal shelf. **Fail-soft:** if the DB can't serve the
 * portal — e.g. a migration hasn't been applied yet, so a column/table the
 * resolver reads doesn't exist — degrade to an EMPTY shelf instead of 500. The
 * app renders "no shelf" for an empty list, so Home stays healthy and the
 * portal is simply, silently unavailable until the schema catches up. This lets
 * the app ship ahead of the backend migration.
 * ponytail: broad SQLAlchemyError catch is deliberate — a portal that can't
 * read its own tables should disappear, not take Home down.
 *
 * It logs at ERROR and emits ``portal_shelf_degraded``, because the failure is
 * otherwise INDISTINGUISHABLE from correct behaviour: a broken query and a
 * healthy paced shelf both render as an empty Home. Without a distinct signal
 * the only way to tell them apart is to go reading server logs, which is exactly
 * what nobody does while QA'ing a quiet shelf. WARNING was too quiet for
 * something that silently removes the entire feature.
 */
export const bannersGetEligibleBannersOptions = (options?: Options<BannersGetEligibleBannersData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await Banners.bannersGetEligibleBanners({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: bannersGetEligibleBannersQueryKey(options)
    });
};

export const bannersGetBannerHistoryQueryKey = (options?: Options<BannersGetBannerHistoryData>) => createQueryKey('bannersGetBannerHistory', options);

/**
 * Get Banner History
 * The user's past letters (mailbox view): every card that was ever
 * delivered to them, newest interaction first, with its content so the
 * client can render the letter face again.
 */
export const bannersGetBannerHistoryOptions = (options?: Options<BannersGetBannerHistoryData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await Banners.bannersGetBannerHistory({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: bannersGetBannerHistoryQueryKey(options)
    });
};

/**
 * Record Banner Shown
 * Record that a banner was shown to the user (impression).
 *
 * ``channel`` attributes the interaction ('portal' in-app, 'push' when the
 * user arrived via a push notification tap). One state row spans channels;
 * the column records where the most recent interaction happened.
 */
export const bannersRecordBannerShownMutation = (options?: Partial<Options<BannersRecordBannerShownData>>): UseMutationOptions<BannersRecordBannerShownResponse, BannersRecordBannerShownError, Options<BannersRecordBannerShownData>> => {
    const mutationOptions: UseMutationOptions<BannersRecordBannerShownResponse, BannersRecordBannerShownError, Options<BannersRecordBannerShownData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await Banners.bannersRecordBannerShown({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Record Banner Click
 * Record that the user clicked the banner's CTA.
 *
 * A push-notification tap counts as the card's click (same engagement
 * cooldowns take it off the pile) with ``channel='push'`` for attribution.
 */
export const bannersRecordBannerClickMutation = (options?: Partial<Options<BannersRecordBannerClickData>>): UseMutationOptions<BannersRecordBannerClickResponse, BannersRecordBannerClickError, Options<BannersRecordBannerClickData>> => {
    const mutationOptions: UseMutationOptions<BannersRecordBannerClickResponse, BannersRecordBannerClickError, Options<BannersRecordBannerClickData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await Banners.bannersRecordBannerClick({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Record Banner Complete
 * Record that the user COMPLETED the action behind the banner's CTA
 * (SHAI submitted, lesson finished, supporter invited).
 *
 * Distinct from click (CTA tapped): clicked-without-completed = abandoned.
 * Completion also starts the post-completion rest window — a quiet period
 * before the next letter arrives.
 */
export const bannersRecordBannerCompleteMutation = (options?: Partial<Options<BannersRecordBannerCompleteData>>): UseMutationOptions<BannersRecordBannerCompleteResponse, BannersRecordBannerCompleteError, Options<BannersRecordBannerCompleteData>> => {
    const mutationOptions: UseMutationOptions<BannersRecordBannerCompleteResponse, BannersRecordBannerCompleteError, Options<BannersRecordBannerCompleteData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await Banners.bannersRecordBannerComplete({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Record Banner Delivered
 * Record that the banner was delivered (sets dt_first_shown if unset).
 *
 * The witness is VALIDATED against the resolved shelf: a delivery only
 * counts for the card that actually is today's selection (or a pin). The
 * client re-fires this on day changes, and a jump/midnight race can make it
 * report the still-rendered STALE card before its refetch lands - counting
 * that witness restarted a turn for a letter whose return interval had not
 * passed, resetting its clock and stealing the day from the rightful card.
 *
 * `meta` carries the client build, so the delivered->opened funnel can be
 * segmented by build (i.e. "does this card fail to render on older
 * bundles?"). A rejected witness writes no event at all, so it carries no
 * build either - the build is a property of a recorded delivery, not of the
 * request that claimed one.
 */
export const bannersRecordBannerDeliveredMutation = (options?: Partial<Options<BannersRecordBannerDeliveredData>>): UseMutationOptions<BannersRecordBannerDeliveredResponse, BannersRecordBannerDeliveredError, Options<BannersRecordBannerDeliveredData>> => {
    const mutationOptions: UseMutationOptions<BannersRecordBannerDeliveredResponse, BannersRecordBannerDeliveredError, Options<BannersRecordBannerDeliveredData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await Banners.bannersRecordBannerDelivered({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Dismiss Banner
 * Record that the user dismissed the banner.
 */
export const bannersDismissBannerMutation = (options?: Partial<Options<BannersDismissBannerData>>): UseMutationOptions<BannersDismissBannerResponse, BannersDismissBannerError, Options<BannersDismissBannerData>> => {
    const mutationOptions: UseMutationOptions<BannersDismissBannerResponse, BannersDismissBannerError, Options<BannersDismissBannerData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await Banners.bannersDismissBanner({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const bannersListBannersAdminQueryKey = (options?: Options<BannersListBannersAdminData>) => createQueryKey('bannersListBannersAdmin', options);

/**
 * List Banners Admin
 * List Portal banners, paginated. Filter with is_draft=true for unpublished
 * drafts, is_active for the active flag (admin only).
 */
export const bannersListBannersAdminOptions = (options?: Options<BannersListBannersAdminData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await Banners.bannersListBannersAdmin({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: bannersListBannersAdminQueryKey(options)
    });
};

export const bannersListBannersAdminInfiniteQueryKey = (options?: Options<BannersListBannersAdminData>): QueryKey<Options<BannersListBannersAdminData>> => createQueryKey('bannersListBannersAdmin', options, true);

/**
 * List Banners Admin
 * List Portal banners, paginated. Filter with is_draft=true for unpublished
 * drafts, is_active for the active flag (admin only).
 */
export const bannersListBannersAdminInfiniteOptions = (options?: Options<BannersListBannersAdminData>) => {
    return infiniteQueryOptions<BannersListBannersAdminResponse, BannersListBannersAdminError, InfiniteData<BannersListBannersAdminResponse>, QueryKey<Options<BannersListBannersAdminData>>, number | Pick<QueryKey<Options<BannersListBannersAdminData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<BannersListBannersAdminData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await Banners.bannersListBannersAdmin({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: bannersListBannersAdminInfiniteQueryKey(options)
    });
};

export const bannersGetBannerStatsAdminQueryKey = (options: Options<BannersGetBannerStatsAdminData>) => createQueryKey('bannersGetBannerStatsAdmin', options);

/**
 * Get Banner Stats Admin
 * Full letter funnel for a banner: delivered → opened → the opened-outcome
 * split (completed / abandoned / ignored / dismissed) + rates.
 */
export const bannersGetBannerStatsAdminOptions = (options: Options<BannersGetBannerStatsAdminData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await Banners.bannersGetBannerStatsAdmin({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: bannersGetBannerStatsAdminQueryKey(options)
    });
};

/**
 * Create Banner Admin
 * Create a new banner (admin only). Creating it live needs the publish
 * scope. The publish checks run on the content, which the panel adds after
 * creating, so they are /publish's and PATCH's job, not this one's.
 */
export const bannersCreateBannerAdminMutation = (options?: Partial<Options<BannersCreateBannerAdminData>>): UseMutationOptions<BannersCreateBannerAdminResponse, BannersCreateBannerAdminError, Options<BannersCreateBannerAdminData>> => {
    const mutationOptions: UseMutationOptions<BannersCreateBannerAdminResponse, BannersCreateBannerAdminError, Options<BannersCreateBannerAdminData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await Banners.bannersCreateBannerAdmin({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Create Draft Banner Admin
 * Create a NEW banner as an unpublished draft, optionally with content.
 *
 * The draft cannot reach anyone: publishing is a separate, deliberate step in
 * the admin panel. Returns the draft and its panel_url for review.
 */
export const bannersCreateDraftBannerAdminMutation = (options?: Partial<Options<BannersCreateDraftBannerAdminData>>): UseMutationOptions<BannersCreateDraftBannerAdminResponse, BannersCreateDraftBannerAdminError, Options<BannersCreateDraftBannerAdminData>> => {
    const mutationOptions: UseMutationOptions<BannersCreateDraftBannerAdminResponse, BannersCreateDraftBannerAdminError, Options<BannersCreateDraftBannerAdminData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await Banners.bannersCreateDraftBannerAdmin({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete Banner Admin
 * Soft delete a banner (admin only).
 */
export const bannersDeleteBannerAdminMutation = (options?: Partial<Options<BannersDeleteBannerAdminData>>): UseMutationOptions<BannersDeleteBannerAdminResponse, BannersDeleteBannerAdminError, Options<BannersDeleteBannerAdminData>> => {
    const mutationOptions: UseMutationOptions<BannersDeleteBannerAdminResponse, BannersDeleteBannerAdminError, Options<BannersDeleteBannerAdminData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await Banners.bannersDeleteBannerAdmin({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const bannersGetBannerAdminQueryKey = (options: Options<BannersGetBannerAdminData>) => createQueryKey('bannersGetBannerAdmin', options);

/**
 * Get Banner Admin
 * Get a banner's full config, its content DSL in every locale, and its
 * panel_url (admin only).
 */
export const bannersGetBannerAdminOptions = (options: Options<BannersGetBannerAdminData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await Banners.bannersGetBannerAdmin({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: bannersGetBannerAdminQueryKey(options)
    });
};

/**
 * Update Banner Admin
 * Update a banner (admin only). Taking a draft live here is publishing:
 * it needs the publish scope and passes the same checks as /publish.
 */
export const bannersUpdateBannerAdminMutation = (options?: Partial<Options<BannersUpdateBannerAdminData>>): UseMutationOptions<BannersUpdateBannerAdminResponse, BannersUpdateBannerAdminError, Options<BannersUpdateBannerAdminData>> => {
    const mutationOptions: UseMutationOptions<BannersUpdateBannerAdminResponse, BannersUpdateBannerAdminError, Options<BannersUpdateBannerAdminData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await Banners.bannersUpdateBannerAdmin({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const bannersGetBannerDistributionAdminQueryKey = (options: Options<BannersGetBannerDistributionAdminData>) => createQueryKey('bannersGetBannerDistributionAdmin', options);

/**
 * Get Banner Distribution Admin
 * Estimate who would see a banner and when in their journey.
 *
 * Samples real users, evaluates the banner's targeting (conditions, segment,
 * sequence day, active window) against each, and extrapolates how many are
 * eligible NOW, how many will EVENTUALLY be, what blocks the rest, the
 * journey start day and the cadence. Approximate: ignores pacing, cooldowns,
 * impression history and competition from higher-priority banners.
 */
export const bannersGetBannerDistributionAdminOptions = (options: Options<BannersGetBannerDistributionAdminData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await Banners.bannersGetBannerDistributionAdmin({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: bannersGetBannerDistributionAdminQueryKey(options)
    });
};

/**
 * Publish Banner Admin
 * Publish a draft banner (admin only).
 *
 * Publishing is the irreversible-ish step: the card becomes eligible for real
 * people's phones and, on a push channel, can wake them up. The admin panel
 * lints before it lets anyone press the button, but the panel is not a trust
 * boundary — the API, the Admin MCP and curl all reach this endpoint. So the
 * error-level rules are re-checked here and a failing card is refused with the
 * full list, not the first problem.
 *
 * Only the rules that are unambiguously WRONG live here. The panel's softer
 * warnings (missing translations, no CTA, a long title) stay client-side: they
 * need a human's judgement, not a 400.
 */
export const bannersPublishBannerAdminMutation = (options?: Partial<Options<BannersPublishBannerAdminData>>): UseMutationOptions<BannersPublishBannerAdminResponse, BannersPublishBannerAdminError, Options<BannersPublishBannerAdminData>> => {
    const mutationOptions: UseMutationOptions<BannersPublishBannerAdminResponse, BannersPublishBannerAdminError, Options<BannersPublishBannerAdminData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await Banners.bannersPublishBannerAdmin({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Force Deliver Banner Admin
 * Force-deliver a banner NOW to a segment's members and/or explicit users,
 * ignoring cadence, cooldowns, caps, pacing and the segment gate (admin only).
 *
 * The banner pins to the top of each target's portal shelf until they open it.
 * With ``push=True`` a push notification is also sent immediately — even for a
 * portal-only banner — so push vs no-push can be tested per delivery. The
 * banner must be published (draft cards have nothing to show).
 */
export const bannersForceDeliverBannerAdminMutation = (options?: Partial<Options<BannersForceDeliverBannerAdminData>>): UseMutationOptions<BannersForceDeliverBannerAdminResponse, BannersForceDeliverBannerAdminError, Options<BannersForceDeliverBannerAdminData>> => {
    const mutationOptions: UseMutationOptions<BannersForceDeliverBannerAdminResponse, BannersForceDeliverBannerAdminError, Options<BannersForceDeliverBannerAdminData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await Banners.bannersForceDeliverBannerAdmin({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const bannersGetBannerContentAdminQueryKey = (options: Options<BannersGetBannerContentAdminData>) => createQueryKey('bannersGetBannerContentAdmin', options);

/**
 * Get Banner Content Admin
 * Get banner content for a locale (admin only).
 */
export const bannersGetBannerContentAdminOptions = (options: Options<BannersGetBannerContentAdminData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await Banners.bannersGetBannerContentAdmin({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: bannersGetBannerContentAdminQueryKey(options)
    });
};

/**
 * Upsert Banner Content Admin
 * Create or update banner content for a locale (admin only). On a live
 * card this changes what members see at once, so it needs the publish scope.
 */
export const bannersUpsertBannerContentAdminMutation = (options?: Partial<Options<BannersUpsertBannerContentAdminData>>): UseMutationOptions<BannersUpsertBannerContentAdminResponse, BannersUpsertBannerContentAdminError, Options<BannersUpsertBannerContentAdminData>> => {
    const mutationOptions: UseMutationOptions<BannersUpsertBannerContentAdminResponse, BannersUpsertBannerContentAdminError, Options<BannersUpsertBannerContentAdminData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await Banners.bannersUpsertBannerContentAdmin({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Upsert Draft Content Admin
 * Set or replace one locale's content DSL on an UNPUBLISHED draft banner.
 *
 * Refuses a published banner (409): content written there is live at once,
 * so edit those in the admin panel.
 */
export const bannersUpsertDraftContentAdminMutation = (options?: Partial<Options<BannersUpsertDraftContentAdminData>>): UseMutationOptions<BannersUpsertDraftContentAdminResponse, BannersUpsertDraftContentAdminError, Options<BannersUpsertDraftContentAdminData>> => {
    const mutationOptions: UseMutationOptions<BannersUpsertDraftContentAdminResponse, BannersUpsertDraftContentAdminError, Options<BannersUpsertDraftContentAdminData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await Banners.bannersUpsertDraftContentAdmin({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Pin Contextual Banner
 * Pin a contextual card above the caller's daily card.
 *
 * This is the trigger path the app needs: a panic session that classifies a
 * heart-anxiety loop can surface the matching lesson as a letter, on top of
 * today's card, without waiting for tomorrow's rotation.
 *
 * A client-callable "put a card on my shelf" is a spam vector, so it is fenced:
 *
 * - the banner must be marked ``contextual``; ordinary sequence cards can never
 * be self-pinned, which keeps the daily rotation out of the client's reach
 * - it pins for the CALLING user only. No user_ids, no segment. Blasting other
 * people stays behind the admin force-deliver route and its mega-confirm
 * - it is idempotent per (user, banner): re-triggering an unconsumed pin is a
 * no-op, so a retry loop or a double-tap cannot stack duplicates
 * - it respects ``PORTAL_MAX_CONTEXTUAL_PER_DAY``. Overflow is SCHEDULED
 * FORWARD, not dropped and not stacked: a heavy panic day yields one extra
 * letter today and the rest on following days, which is the whole point of
 * treating these as a pool rather than an interrupt.
 */
export const bannersPinContextualBannerMutation = (options?: Partial<Options<BannersPinContextualBannerData>>): UseMutationOptions<BannersPinContextualBannerResponse, BannersPinContextualBannerError, Options<BannersPinContextualBannerData>> => {
    const mutationOptions: UseMutationOptions<BannersPinContextualBannerResponse, BannersPinContextualBannerError, Options<BannersPinContextualBannerData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await Banners.bannersPinContextualBanner({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Reset Personal Clock
 * Back to real time, optionally nuking the future the trip left behind.
 *
 * ``purge_future=true`` deletes THIS user's journey data stamped later than
 * real now: banner events and state fields, health entries (which otherwise
 * haunt charts and streaks as records from days that have not happened), and
 * pending campaign-email executions that were scheduled during the trip.
 * Future-dated rows are by definition not real history - the same reasoning
 * as the Sim Lab's reset scrub. Emails that already SENT stay sent; there is
 * no unsending. Scoped to the caller alone, like everything else here.
 */
export const bannersResetPersonalClockMutation = (options?: Partial<Options<BannersResetPersonalClockData>>): UseMutationOptions<BannersResetPersonalClockResponse, BannersResetPersonalClockError, Options<BannersResetPersonalClockData>> => {
    const mutationOptions: UseMutationOptions<BannersResetPersonalClockResponse, BannersResetPersonalClockError, Options<BannersResetPersonalClockData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await Banners.bannersResetPersonalClock({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const bannersGetPersonalClockQueryKey = (options?: Options<BannersGetPersonalClockData>) => createQueryKey('bannersGetPersonalClock', options);

/**
 * Get Personal Clock
 * Discovery: may this user travel, and where do they currently live?
 *
 * Always 200 - the app uses this to decide whether to SHOW the time-travel
 * Pip at all. An ineligible account (or an environment with the feature off)
 * gets ``eligible: false`` and no floater, rather than a button that fails.
 */
export const bannersGetPersonalClockOptions = (options?: Options<BannersGetPersonalClockData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await Banners.bannersGetPersonalClock({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: bannersGetPersonalClockQueryKey(options)
    });
};

/**
 * Advance Personal Clock
 * Jump the CALLING user's portal clock forward (the app's "+24h" button).
 *
 * Cumulative, and NEGATIVE hours travel back toward the present (floored at
 * zero - the past is not on offer). ``clean`` (default on) is clean travel:
 * whenever the jump moves toward the present, journey data stamped beyond
 * the NEW now is purged, so stepping back from +7d to +2d does not leave
 * days 3..7 haunting charts and streaks. Affects only this user.
 */
export const bannersAdvancePersonalClockMutation = (options?: Partial<Options<BannersAdvancePersonalClockData>>): UseMutationOptions<BannersAdvancePersonalClockResponse, BannersAdvancePersonalClockError, Options<BannersAdvancePersonalClockData>> => {
    const mutationOptions: UseMutationOptions<BannersAdvancePersonalClockResponse, BannersAdvancePersonalClockError, Options<BannersAdvancePersonalClockData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await Banners.bannersAdvancePersonalClock({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Start Walk
 * Build (or resume) the caller's walk account for this spec and return a
 * session for it.
 */
export const walkStartWalkMutation = (options?: Partial<Options<WalkStartWalkData>>): UseMutationOptions<WalkStartWalkResponse, WalkStartWalkError, Options<WalkStartWalkData>> => {
    const mutationOptions: UseMutationOptions<WalkStartWalkResponse, WalkStartWalkError, Options<WalkStartWalkData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await Walk.walkStartWalk({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const liveActivityGetLiveActivityQueryKey = (options?: Options<LiveActivityGetLiveActivityData>) => createQueryKey('liveActivityGetLiveActivity', options);

/**
 * Get Live Activity
 * Ambient community counts for the home screen, under the panic button.
 *
 * Cheap and short-cached: every app open hits this, and the numbers only need
 * to be roughly current. On error we return zeroes rather than a 500. This is
 * decoration, and a failure here must never break the home screen; zeroes fall
 * below the client's floor, so the line simply does not render.
 */
export const liveActivityGetLiveActivityOptions = (options?: Options<LiveActivityGetLiveActivityData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await LiveActivity.liveActivityGetLiveActivity({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: liveActivityGetLiveActivityQueryKey(options)
    });
};

/**
 * Sim Reset
 * Wipe + rebuild the synthetic cohort and reset the sim clock to real time.
 *
 * Also scrubs any future-dated banner state left behind by a previous
 * time-travel session — see ``_scrub_future_state``. Reset is the "put
 * everything back" button, so it repairs real accounts caught by the shared
 * clock, not just the cohort.
 */
export const simSimResetMutation = (options?: Partial<Options<SimSimResetData>>): UseMutationOptions<SimSimResetResponse, SimSimResetError, Options<SimSimResetData>> => {
    const mutationOptions: UseMutationOptions<SimSimResetResponse, SimSimResetError, Options<SimSimResetData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await Sim.simSimReset({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Sim Tick
 * Advance the sim clock by hours and/or days (no data mutation).
 */
export const simSimTickMutation = (options?: Partial<Options<SimSimTickData>>): UseMutationOptions<SimSimTickResponse, SimSimTickError, Options<SimSimTickData>> => {
    const mutationOptions: UseMutationOptions<SimSimTickResponse, SimSimTickError, Options<SimSimTickData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await Sim.simSimTick({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Sim Step
 * Run N interaction rounds for every cohort user at the current sim clock.
 */
export const simSimStepMutation = (options?: Partial<Options<SimSimStepData>>): UseMutationOptions<SimSimStepResponse, SimSimStepError, Options<SimSimStepData>> => {
    const mutationOptions: UseMutationOptions<SimSimStepResponse, SimSimStepError, Options<SimSimStepData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await Sim.simSimStep({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Sim Publish
 * Create + activate a banner mid-run (reuses the real banner CRUD).
 */
export const simSimPublishMutation = (options?: Partial<Options<SimSimPublishData>>): UseMutationOptions<SimSimPublishResponse, SimSimPublishError, Options<SimSimPublishData>> => {
    const mutationOptions: UseMutationOptions<SimSimPublishResponse, SimSimPublishError, Options<SimSimPublishData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await Sim.simSimPublish({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const simSimStateQueryKey = (options?: Options<SimSimStateData>) => createQueryKey('simSimState', options);

/**
 * Sim State
 * Snapshot: sim clock, each user's current card, per-banner funnel + reach.
 */
export const simSimStateOptions = (options?: Options<SimSimStateData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await Sim.simSimState({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: simSimStateQueryKey(options)
    });
};

export const simSimUserDetailQueryKey = (options: Options<SimSimUserDetailData>) => createQueryKey('simSimUserDetail', options);

/**
 * Sim User Detail
 * One user's resolved queue + full state history + WHY each banner is/ isn't shown.
 */
export const simSimUserDetailOptions = (options: Options<SimSimUserDetailData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await Sim.simSimUserDetail({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: simSimUserDetailQueryKey(options)
    });
};

/**
 * Reset Own Journey
 * Wipe the CALLING user's Journey progress and put their clock back to now.
 *
 * Scoped to the caller alone — there is deliberately no ``user_id`` parameter,
 * so no amount of token confusion can reset somebody else's Journey. Use
 * ``scripts/reset_journey.py`` for the operator-driven, reset-someone-else
 * case, where the target is named explicitly and previewed first.
 *
 * The account, auth, billing and the onboarding SHAI baseline all survive; see
 * ``app/services/journey_reset.py`` for the full kept/wiped contract.
 */
export const journeyDevResetOwnJourneyMutation = (options?: Partial<Options<JourneyDevResetOwnJourneyData>>): UseMutationOptions<JourneyDevResetOwnJourneyResponse, JourneyDevResetOwnJourneyError, Options<JourneyDevResetOwnJourneyData>> => {
    const mutationOptions: UseMutationOptions<JourneyDevResetOwnJourneyResponse, JourneyDevResetOwnJourneyError, Options<JourneyDevResetOwnJourneyData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await JourneyDev.journeyDevResetOwnJourney({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Seed Own Journey
 * Give the CALLING user the work that stands them on a later Arrival day.
 *
 * Idempotent: only the shortfall is written, so calling it twice is the same
 * as calling it once, and calling it over real usage tops up rather than
 * duplicating.
 *
 * ``apply_personal_clock`` is attached deliberately — unlike the reset, which
 * is putting the member back to real now, seeding wants the member's PRODUCT
 * time so day 1's work backdates to their real day 1 rather than to a week in
 * the future. Same gate as the reset.
 */
export const journeyDevSeedOwnJourneyMutation = (options?: Partial<Options<JourneyDevSeedOwnJourneyData>>): UseMutationOptions<JourneyDevSeedOwnJourneyResponse, JourneyDevSeedOwnJourneyError, Options<JourneyDevSeedOwnJourneyData>> => {
    const mutationOptions: UseMutationOptions<JourneyDevSeedOwnJourneyResponse, JourneyDevSeedOwnJourneyError, Options<JourneyDevSeedOwnJourneyData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await JourneyDev.journeyDevSeedOwnJourney({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Capture Book Interest
 * Capture interest in the health anxiety book concept.
 *
 * Public and unauthenticated, so the email address is a claim and not a
 * credential. Two rules follow, and both are load-bearing:
 *
 * - The response is contentless. It carries nothing about the stored record,
 * and does not vary on whether the address is already known.
 * - An existing lead is gap-filled, never overwritten. From here, "the same
 * person re-submitting" and "a stranger rewriting their record" are the
 * identical request.
 */
export const bookInterestCaptureBookInterestMutation = (options?: Partial<Options<BookInterestCaptureBookInterestData>>): UseMutationOptions<BookInterestCaptureBookInterestResponse, BookInterestCaptureBookInterestError, Options<BookInterestCaptureBookInterestData>> => {
    const mutationOptions: UseMutationOptions<BookInterestCaptureBookInterestResponse, BookInterestCaptureBookInterestError, Options<BookInterestCaptureBookInterestData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await BookInterest.bookInterestCaptureBookInterest({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Capture Quiz Result
 * Record the contact, their consents, and the answers behind their result.
 *
 * Public and unauthenticated, like the book-interest route it sits beside.
 * The response is deliberately contentless: it must not confirm whether an
 * address is known to us, belongs to a customer, or has a score on file.
 */
export const quizResultCaptureQuizResultMutation = (options?: Partial<Options<QuizResultCaptureQuizResultData>>): UseMutationOptions<QuizResultCaptureQuizResultResponse, QuizResultCaptureQuizResultError, Options<QuizResultCaptureQuizResultData>> => {
    const mutationOptions: UseMutationOptions<QuizResultCaptureQuizResultResponse, QuizResultCaptureQuizResultError, Options<QuizResultCaptureQuizResultData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await QuizResult.quizResultCaptureQuizResult({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Capture Coaching Waitlist
 * Record the contact and the consent they gave to be contacted.
 *
 * Public and unauthenticated, like the two capture routes it sits beside. No
 * quiz result is written: nothing here is health data, and an empty row in
 * `a.quiz_results` would put a health record on file for someone who never
 * answered a health question.
 *
 * The response is contentless on purpose. It must not confirm whether the
 * address is already known to us, already on the list, or belongs to a
 * customer.
 *
 * Joining sends mail to a typed address (a "please confirm" email; the
 * double opt-in, N2), so it has contact-capture's guards: the honeypot and
 * the bot check, with the same answer whatever they decide. A "yes" counts
 * once the inbox confirms or the account at the address signs in.
 */
export const coachingWaitlistCaptureCoachingWaitlistMutation = (options?: Partial<Options<CoachingWaitlistCaptureCoachingWaitlistData>>): UseMutationOptions<CoachingWaitlistCaptureCoachingWaitlistResponse, CoachingWaitlistCaptureCoachingWaitlistError, Options<CoachingWaitlistCaptureCoachingWaitlistData>> => {
    const mutationOptions: UseMutationOptions<CoachingWaitlistCaptureCoachingWaitlistResponse, CoachingWaitlistCaptureCoachingWaitlistError, Options<CoachingWaitlistCaptureCoachingWaitlistData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await CoachingWaitlist.coachingWaitlistCaptureCoachingWaitlist({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Capture Contact
 * Record a contact and the email choices they made on a site form.
 *
 * Public and unauthenticated, so the address is a claim and not a
 * credential. The response is contentless for the same reason as its
 * siblings: it must not confirm whether the address is already known.
 *
 * A "yes" to an email list is confirmed from the inbox before anything is
 * sent (the double opt-in, N2): the grant is recorded, then one "please
 * confirm" email goes, within its limits. Because that sends mail to a
 * typed address, a "yes" needs the site's bot check (Turnstile) and an
 * empty honeypot. A bot or a refused check gets the same answer as
 * everyone else, with nothing recorded or sent; past the confirmation
 * limit the sign-up is recorded and no email goes, with the same answer.
 */
export const contactCaptureCaptureContactMutation = (options?: Partial<Options<ContactCaptureCaptureContactData>>): UseMutationOptions<ContactCaptureCaptureContactResponse, ContactCaptureCaptureContactError, Options<ContactCaptureCaptureContactData>> => {
    const mutationOptions: UseMutationOptions<ContactCaptureCaptureContactResponse, ContactCaptureCaptureContactError, Options<ContactCaptureCaptureContactData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await ContactCapture.contactCaptureCaptureContact({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const quizResultDownloadQuizResultQueryKey = (options?: Options<QuizResultDownloadQuizResultData>) => createQueryKey('quizResultDownloadQuizResult', options);

/**
 * Download Quiz Result
 */
export const quizResultDownloadQuizResultOptions = (options?: Options<QuizResultDownloadQuizResultData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await QuizResult.quizResultDownloadQuizResult({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: quizResultDownloadQuizResultQueryKey(options)
    });
};

export const featureFlagsGetFeatureFlagsQueryKey = (options?: Options<FeatureFlagsGetFeatureFlagsData>) => createQueryKey('featureFlagsGetFeatureFlags', options);

/**
 * Get Feature Flags
 * Every flag for the current user, resolved per flag: override, global
 * switch, the first matching rule (platform and version read from this
 * request, see ``app.services.flag_context``), then the flag's percentage.
 *
 * Siblings of ``flags``: A/B configs for flags this user has on, the OTA
 * cohort, and the Journey hold config when ``journey_hold`` is on.
 *
 * One write hides in this read: the first time ``journey`` resolves on for a
 * member with no ``journey_epoch``, the epoch is stamped. That is the moment
 * their day 1 should start, and it is idempotent, so it happens once.
 */
export const featureFlagsGetFeatureFlagsOptions = (options?: Options<FeatureFlagsGetFeatureFlagsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await FeatureFlags.featureFlagsGetFeatureFlags({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: featureFlagsGetFeatureFlagsQueryKey(options)
    });
};

export const featureFlagsListFeatureFlagsAdminQueryKey = (options?: Options<FeatureFlagsListFeatureFlagsAdminData>) => createQueryKey('featureFlagsListFeatureFlagsAdmin', options);

/**
 * List Feature Flags Admin
 * Every flag with its rules, segment health and override count.
 */
export const featureFlagsListFeatureFlagsAdminOptions = (options?: Options<FeatureFlagsListFeatureFlagsAdminData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await FeatureFlags.featureFlagsListFeatureFlagsAdmin({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: featureFlagsListFeatureFlagsAdminQueryKey(options)
    });
};

export const featureFlagsListFeatureFlagsAdminInfiniteQueryKey = (options?: Options<FeatureFlagsListFeatureFlagsAdminData>): QueryKey<Options<FeatureFlagsListFeatureFlagsAdminData>> => createQueryKey('featureFlagsListFeatureFlagsAdmin', options, true);

/**
 * List Feature Flags Admin
 * Every flag with its rules, segment health and override count.
 */
export const featureFlagsListFeatureFlagsAdminInfiniteOptions = (options?: Options<FeatureFlagsListFeatureFlagsAdminData>) => {
    return infiniteQueryOptions<FeatureFlagsListFeatureFlagsAdminResponse, FeatureFlagsListFeatureFlagsAdminError, InfiniteData<FeatureFlagsListFeatureFlagsAdminResponse>, QueryKey<Options<FeatureFlagsListFeatureFlagsAdminData>>, number | Pick<QueryKey<Options<FeatureFlagsListFeatureFlagsAdminData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<FeatureFlagsListFeatureFlagsAdminData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await FeatureFlags.featureFlagsListFeatureFlagsAdmin({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: featureFlagsListFeatureFlagsAdminInfiniteQueryKey(options)
    });
};

/**
 * Create Feature Flag
 * Create a new feature flag (admin only).
 */
export const featureFlagsCreateFeatureFlagMutation = (options?: Partial<Options<FeatureFlagsCreateFeatureFlagData>>): UseMutationOptions<FeatureFlagsCreateFeatureFlagResponse, FeatureFlagsCreateFeatureFlagError, Options<FeatureFlagsCreateFeatureFlagData>> => {
    const mutationOptions: UseMutationOptions<FeatureFlagsCreateFeatureFlagResponse, FeatureFlagsCreateFeatureFlagError, Options<FeatureFlagsCreateFeatureFlagData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await FeatureFlags.featureFlagsCreateFeatureFlag({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const featureFlagsGetStoreVersionsQueryKey = (options?: Options<FeatureFlagsGetStoreVersionsData>) => createQueryKey('featureFlagsGetStoreVersions', options);

/**
 * Get Store Versions
 * What each store serves everyone now, as the force-update guard sees it.
 */
export const featureFlagsGetStoreVersionsOptions = (options?: Options<FeatureFlagsGetStoreVersionsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await FeatureFlags.featureFlagsGetStoreVersions({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: featureFlagsGetStoreVersionsQueryKey(options)
    });
};

/**
 * Delete Feature Flag
 * Delete a feature flag (admin only).
 */
export const featureFlagsDeleteFeatureFlagMutation = (options?: Partial<Options<FeatureFlagsDeleteFeatureFlagData>>): UseMutationOptions<FeatureFlagsDeleteFeatureFlagResponse, FeatureFlagsDeleteFeatureFlagError, Options<FeatureFlagsDeleteFeatureFlagData>> => {
    const mutationOptions: UseMutationOptions<FeatureFlagsDeleteFeatureFlagResponse, FeatureFlagsDeleteFeatureFlagError, Options<FeatureFlagsDeleteFeatureFlagData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await FeatureFlags.featureFlagsDeleteFeatureFlag({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const featureFlagsGetFeatureFlagAdminQueryKey = (options: Options<FeatureFlagsGetFeatureFlagAdminData>) => createQueryKey('featureFlagsGetFeatureFlagAdmin', options);

/**
 * Get Feature Flag Admin
 * One flag with its rules and an estimated reach.
 */
export const featureFlagsGetFeatureFlagAdminOptions = (options: Options<FeatureFlagsGetFeatureFlagAdminData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await FeatureFlags.featureFlagsGetFeatureFlagAdmin({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: featureFlagsGetFeatureFlagAdminQueryKey(options)
    });
};

/**
 * Update Feature Flag
 * One validated change. Returns the flag and, as `previous`, what it replaced.
 *
 * With `expected_dt_updated`, a flag changed since the caller read it is a
 * 409 whose detail carries the current state, never a silent overwrite.
 */
export const featureFlagsUpdateFeatureFlagMutation = (options?: Partial<Options<FeatureFlagsUpdateFeatureFlagData>>): UseMutationOptions<FeatureFlagsUpdateFeatureFlagResponse, FeatureFlagsUpdateFeatureFlagError, Options<FeatureFlagsUpdateFeatureFlagData>> => {
    const mutationOptions: UseMutationOptions<FeatureFlagsUpdateFeatureFlagResponse, FeatureFlagsUpdateFeatureFlagError, Options<FeatureFlagsUpdateFeatureFlagData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await FeatureFlags.featureFlagsUpdateFeatureFlag({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Estimate Feature Flag Reach
 * Estimated reach of draft rules, before saving. Writes nothing.
 */
export const featureFlagsEstimateFeatureFlagReachMutation = (options?: Partial<Options<FeatureFlagsEstimateFeatureFlagReachData>>): UseMutationOptions<FeatureFlagsEstimateFeatureFlagReachResponse, FeatureFlagsEstimateFeatureFlagReachError, Options<FeatureFlagsEstimateFeatureFlagReachData>> => {
    const mutationOptions: UseMutationOptions<FeatureFlagsEstimateFeatureFlagReachResponse, FeatureFlagsEstimateFeatureFlagReachError, Options<FeatureFlagsEstimateFeatureFlagReachData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await FeatureFlags.featureFlagsEstimateFeatureFlagReach({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const featureFlagsExplainFeatureFlagQueryKey = (options: Options<FeatureFlagsExplainFeatureFlagData>) => createQueryKey('featureFlagsExplainFeatureFlag', options);

/**
 * Explain Feature Flag
 * Which rule decides this user's value, against their stored platform and
 * version. Their app sends its own, which can be newer.
 *
 * Shows a person's platform, version and segments, so it also needs one of
 * the scopes that already read those on the customer page.
 */
export const featureFlagsExplainFeatureFlagOptions = (options: Options<FeatureFlagsExplainFeatureFlagData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await FeatureFlags.featureFlagsExplainFeatureFlag({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: featureFlagsExplainFeatureFlagQueryKey(options)
    });
};

export const featureFlagsListFeatureFlagRevisionsQueryKey = (options: Options<FeatureFlagsListFeatureFlagRevisionsData>) => createQueryKey('featureFlagsListFeatureFlagRevisions', options);

/**
 * List Feature Flag Revisions
 * Newest first. Each carries the whole state before and after, so undo is
 * a PATCH with `before`.
 */
export const featureFlagsListFeatureFlagRevisionsOptions = (options: Options<FeatureFlagsListFeatureFlagRevisionsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await FeatureFlags.featureFlagsListFeatureFlagRevisions({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: featureFlagsListFeatureFlagRevisionsQueryKey(options)
    });
};

export const featureFlagsListFeatureFlagRevisionsByKeyQueryKey = (options: Options<FeatureFlagsListFeatureFlagRevisionsByKeyData>) => createQueryKey('featureFlagsListFeatureFlagRevisionsByKey', options);

/**
 * List Feature Flag Revisions By Key
 * History by key, including a flag that has since been deleted.
 */
export const featureFlagsListFeatureFlagRevisionsByKeyOptions = (options: Options<FeatureFlagsListFeatureFlagRevisionsByKeyData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await FeatureFlags.featureFlagsListFeatureFlagRevisionsByKey({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: featureFlagsListFeatureFlagRevisionsByKeyQueryKey(options)
    });
};

export const featureFlagsListUserFeatureFlagOverridesQueryKey = (options: Options<FeatureFlagsListUserFeatureFlagOverridesData>) => createQueryKey('featureFlagsListUserFeatureFlagOverrides', options);

/**
 * List User Feature Flag Overrides
 * List user overrides for a feature flag with pagination (admin only).
 */
export const featureFlagsListUserFeatureFlagOverridesOptions = (options: Options<FeatureFlagsListUserFeatureFlagOverridesData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await FeatureFlags.featureFlagsListUserFeatureFlagOverrides({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: featureFlagsListUserFeatureFlagOverridesQueryKey(options)
    });
};

export const featureFlagsListUserFeatureFlagOverridesInfiniteQueryKey = (options: Options<FeatureFlagsListUserFeatureFlagOverridesData>): QueryKey<Options<FeatureFlagsListUserFeatureFlagOverridesData>> => createQueryKey('featureFlagsListUserFeatureFlagOverrides', options, true);

/**
 * List User Feature Flag Overrides
 * List user overrides for a feature flag with pagination (admin only).
 */
export const featureFlagsListUserFeatureFlagOverridesInfiniteOptions = (options: Options<FeatureFlagsListUserFeatureFlagOverridesData>) => {
    return infiniteQueryOptions<FeatureFlagsListUserFeatureFlagOverridesResponse, FeatureFlagsListUserFeatureFlagOverridesError, InfiniteData<FeatureFlagsListUserFeatureFlagOverridesResponse>, QueryKey<Options<FeatureFlagsListUserFeatureFlagOverridesData>>, number | Pick<QueryKey<Options<FeatureFlagsListUserFeatureFlagOverridesData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<FeatureFlagsListUserFeatureFlagOverridesData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await FeatureFlags.featureFlagsListUserFeatureFlagOverrides({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: featureFlagsListUserFeatureFlagOverridesInfiniteQueryKey(options)
    });
};

/**
 * Create User Feature Flag Override
 * Create or update user-specific override for a feature flag (admin only).
 */
export const featureFlagsCreateUserFeatureFlagOverrideMutation = (options?: Partial<Options<FeatureFlagsCreateUserFeatureFlagOverrideData>>): UseMutationOptions<FeatureFlagsCreateUserFeatureFlagOverrideResponse, FeatureFlagsCreateUserFeatureFlagOverrideError, Options<FeatureFlagsCreateUserFeatureFlagOverrideData>> => {
    const mutationOptions: UseMutationOptions<FeatureFlagsCreateUserFeatureFlagOverrideResponse, FeatureFlagsCreateUserFeatureFlagOverrideError, Options<FeatureFlagsCreateUserFeatureFlagOverrideData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await FeatureFlags.featureFlagsCreateUserFeatureFlagOverride({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete User Feature Flag Override
 * Remove user-specific override (admin only).
 */
export const featureFlagsDeleteUserFeatureFlagOverrideMutation = (options?: Partial<Options<FeatureFlagsDeleteUserFeatureFlagOverrideData>>): UseMutationOptions<FeatureFlagsDeleteUserFeatureFlagOverrideResponse, FeatureFlagsDeleteUserFeatureFlagOverrideError, Options<FeatureFlagsDeleteUserFeatureFlagOverrideData>> => {
    const mutationOptions: UseMutationOptions<FeatureFlagsDeleteUserFeatureFlagOverrideResponse, FeatureFlagsDeleteUserFeatureFlagOverrideError, Options<FeatureFlagsDeleteUserFeatureFlagOverrideData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await FeatureFlags.featureFlagsDeleteUserFeatureFlagOverride({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const featureFlagsListSegmentFeatureFlagOverridesQueryKey = (options: Options<FeatureFlagsListSegmentFeatureFlagOverridesData>) => createQueryKey('featureFlagsListSegmentFeatureFlagOverrides', options);

/**
 * List Segment Feature Flag Overrides
 * Which segments this flag is overridden for, and how those rows split.
 */
export const featureFlagsListSegmentFeatureFlagOverridesOptions = (options: Options<FeatureFlagsListSegmentFeatureFlagOverridesData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await FeatureFlags.featureFlagsListSegmentFeatureFlagOverrides({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: featureFlagsListSegmentFeatureFlagOverridesQueryKey(options)
    });
};

/**
 * Set Segment Feature Flag Override
 * Set a flag for everybody currently in a segment.
 *
 * Idempotent: re-running it updates the same rows rather than making more.
 *
 * A member who already has an override this segment does not own — one set
 * by hand, or one another segment wrote — keeps it, and comes back in
 * `kept_user_ids`. Nobody's individual decision is overwritten by a list.
 */
export const featureFlagsSetSegmentFeatureFlagOverrideMutation = (options?: Partial<Options<FeatureFlagsSetSegmentFeatureFlagOverrideData>>): UseMutationOptions<FeatureFlagsSetSegmentFeatureFlagOverrideResponse, FeatureFlagsSetSegmentFeatureFlagOverrideError, Options<FeatureFlagsSetSegmentFeatureFlagOverrideData>> => {
    const mutationOptions: UseMutationOptions<FeatureFlagsSetSegmentFeatureFlagOverrideResponse, FeatureFlagsSetSegmentFeatureFlagOverrideError, Options<FeatureFlagsSetSegmentFeatureFlagOverrideData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await FeatureFlags.featureFlagsSetSegmentFeatureFlagOverride({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Clear Segment Feature Flag Override
 * Remove the overrides this segment wrote, and only those.
 *
 * Matched on the segment recorded in each row's `data`, so an override
 * somebody set by hand for the same person on the same flag survives, and so
 * does one another segment wrote. The write never takes those rows over, so
 * this never has one to remove.
 */
export const featureFlagsClearSegmentFeatureFlagOverrideMutation = (options?: Partial<Options<FeatureFlagsClearSegmentFeatureFlagOverrideData>>): UseMutationOptions<FeatureFlagsClearSegmentFeatureFlagOverrideResponse, FeatureFlagsClearSegmentFeatureFlagOverrideError, Options<FeatureFlagsClearSegmentFeatureFlagOverrideData>> => {
    const mutationOptions: UseMutationOptions<FeatureFlagsClearSegmentFeatureFlagOverrideResponse, FeatureFlagsClearSegmentFeatureFlagOverrideError, Options<FeatureFlagsClearSegmentFeatureFlagOverrideData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await FeatureFlags.featureFlagsClearSegmentFeatureFlagOverride({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Propose Feature Flag Change
 * Compute a change without applying it: the diff, reach before and after,
 * and whether it is `auto` (apply it) or needs `approval` (send the link).
 */
export const featureFlagsProposeFeatureFlagChangeMutation = (options?: Partial<Options<FeatureFlagsProposeFeatureFlagChangeData>>): UseMutationOptions<FeatureFlagsProposeFeatureFlagChangeResponse, FeatureFlagsProposeFeatureFlagChangeError, Options<FeatureFlagsProposeFeatureFlagChangeData>> => {
    const mutationOptions: UseMutationOptions<FeatureFlagsProposeFeatureFlagChangeResponse, FeatureFlagsProposeFeatureFlagChangeError, Options<FeatureFlagsProposeFeatureFlagChangeData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await FeatureFlags.featureFlagsProposeFeatureFlagChange({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const featureFlagsListFeatureFlagChangesQueryKey = (options?: Options<FeatureFlagsListFeatureFlagChangesData>) => createQueryKey('featureFlagsListFeatureFlagChanges', options);

/**
 * List Feature Flag Changes
 * Newest first. Requests past their expiry read as `expired`.
 */
export const featureFlagsListFeatureFlagChangesOptions = (options?: Options<FeatureFlagsListFeatureFlagChangesData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await FeatureFlags.featureFlagsListFeatureFlagChanges({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: featureFlagsListFeatureFlagChangesQueryKey(options)
    });
};

export const featureFlagsGetFeatureFlagChangeQueryKey = (options: Options<FeatureFlagsGetFeatureFlagChangeData>) => createQueryKey('featureFlagsGetFeatureFlagChange', options);

/**
 * Get Feature Flag Change
 * One change, with the store checks an approver has to confirm.
 */
export const featureFlagsGetFeatureFlagChangeOptions = (options: Options<FeatureFlagsGetFeatureFlagChangeData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await FeatureFlags.featureFlagsGetFeatureFlagChange({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: featureFlagsGetFeatureFlagChangeQueryKey(options)
    });
};

/**
 * Apply Feature Flag Change
 * Apply an `auto` change. Anything else is a 403 carrying the approval
 * link. Applying an applied change returns it unchanged.
 */
export const featureFlagsApplyFeatureFlagChangeMutation = (options?: Partial<Options<FeatureFlagsApplyFeatureFlagChangeData>>): UseMutationOptions<FeatureFlagsApplyFeatureFlagChangeResponse, FeatureFlagsApplyFeatureFlagChangeError, Options<FeatureFlagsApplyFeatureFlagChangeData>> => {
    const mutationOptions: UseMutationOptions<FeatureFlagsApplyFeatureFlagChangeResponse, FeatureFlagsApplyFeatureFlagChangeError, Options<FeatureFlagsApplyFeatureFlagChangeData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await FeatureFlags.featureFlagsApplyFeatureFlagChange({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Approve Feature Flag Change
 * A person, not the proposer and not a machine account, applies the change
 * they were shown. Every guard runs again; a flag changed since the proposal
 * makes it `superseded`.
 */
export const featureFlagsApproveFeatureFlagChangeMutation = (options?: Partial<Options<FeatureFlagsApproveFeatureFlagChangeData>>): UseMutationOptions<FeatureFlagsApproveFeatureFlagChangeResponse, FeatureFlagsApproveFeatureFlagChangeError, Options<FeatureFlagsApproveFeatureFlagChangeData>> => {
    const mutationOptions: UseMutationOptions<FeatureFlagsApproveFeatureFlagChangeResponse, FeatureFlagsApproveFeatureFlagChangeError, Options<FeatureFlagsApproveFeatureFlagChangeData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await FeatureFlags.featureFlagsApproveFeatureFlagChange({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Reject Feature Flag Change
 */
export const featureFlagsRejectFeatureFlagChangeMutation = (options?: Partial<Options<FeatureFlagsRejectFeatureFlagChangeData>>): UseMutationOptions<FeatureFlagsRejectFeatureFlagChangeResponse, FeatureFlagsRejectFeatureFlagChangeError, Options<FeatureFlagsRejectFeatureFlagChangeData>> => {
    const mutationOptions: UseMutationOptions<FeatureFlagsRejectFeatureFlagChangeResponse, FeatureFlagsRejectFeatureFlagChangeError, Options<FeatureFlagsRejectFeatureFlagChangeData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await FeatureFlags.featureFlagsRejectFeatureFlagChange({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const insightsGetPeerInsightsQueryKey = (options: Options<InsightsGetPeerInsightsData>) => createQueryKey('insightsGetPeerInsights', options);

/**
 * Get Peer Insights
 * Get peer empathy insights for a specific entry type.
 *
 * Returns anonymized statistics about how many other users have done similar actions.
 */
export const insightsGetPeerInsightsOptions = (options: Options<InsightsGetPeerInsightsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await Insights.insightsGetPeerInsights({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: insightsGetPeerInsightsQueryKey(options)
    });
};

export const insightsGetBehaviorInsightsQueryKey = (options: Options<InsightsGetBehaviorInsightsData>) => createQueryKey('insightsGetBehaviorInsights', options);

/**
 * Get Behavior Insights
 * Get peer empathy insights for specific behaviors in daily check-ins.
 *
 * Returns anonymized statistics about how many other users selected each behavior.
 */
export const insightsGetBehaviorInsightsOptions = (options: Options<InsightsGetBehaviorInsightsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await Insights.insightsGetBehaviorInsights({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: insightsGetBehaviorInsightsQueryKey(options)
    });
};

export const secretsListSecretsQueryKey = (options?: Options<SecretsListSecretsData>) => createQueryKey('secretsListSecrets', options);

/**
 * List Secrets
 * List secrets with pagination (admin only).
 * Returns secrets without values for security.
 */
export const secretsListSecretsOptions = (options?: Options<SecretsListSecretsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await Secrets.secretsListSecrets({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: secretsListSecretsQueryKey(options)
    });
};

export const secretsListSecretsInfiniteQueryKey = (options?: Options<SecretsListSecretsData>): QueryKey<Options<SecretsListSecretsData>> => createQueryKey('secretsListSecrets', options, true);

/**
 * List Secrets
 * List secrets with pagination (admin only).
 * Returns secrets without values for security.
 */
export const secretsListSecretsInfiniteOptions = (options?: Options<SecretsListSecretsData>) => {
    return infiniteQueryOptions<SecretsListSecretsResponse, SecretsListSecretsError, InfiniteData<SecretsListSecretsResponse>, QueryKey<Options<SecretsListSecretsData>>, number | Pick<QueryKey<Options<SecretsListSecretsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<SecretsListSecretsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await Secrets.secretsListSecrets({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: secretsListSecretsInfiniteQueryKey(options)
    });
};

/**
 * Create Secret
 * Create a new secret or new version of existing secret (admin only).
 * If secret name already exists, creates a new version.
 */
export const secretsCreateSecretMutation = (options?: Partial<Options<SecretsCreateSecretData>>): UseMutationOptions<SecretsCreateSecretResponse, SecretsCreateSecretError, Options<SecretsCreateSecretData>> => {
    const mutationOptions: UseMutationOptions<SecretsCreateSecretResponse, SecretsCreateSecretError, Options<SecretsCreateSecretData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await Secrets.secretsCreateSecret({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const secretsGetLatestSecretQueryKey = (options: Options<SecretsGetLatestSecretData>) => createQueryKey('secretsGetLatestSecret', options);

/**
 * Get Latest Secret
 * Get the latest active version of a secret by name (admin only).
 * Returns secret without value for security.
 */
export const secretsGetLatestSecretOptions = (options: Options<SecretsGetLatestSecretData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await Secrets.secretsGetLatestSecret({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: secretsGetLatestSecretQueryKey(options)
    });
};

export const secretsGetSecretVersionsQueryKey = (options: Options<SecretsGetSecretVersionsData>) => createQueryKey('secretsGetSecretVersions', options);

/**
 * Get Secret Versions
 * Get all versions of a secret by name (admin only).
 * Returns secrets without values for security.
 */
export const secretsGetSecretVersionsOptions = (options: Options<SecretsGetSecretVersionsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await Secrets.secretsGetSecretVersions({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: secretsGetSecretVersionsQueryKey(options)
    });
};

/**
 * Delete Secret
 * Delete a specific version of a secret (admin only).
 * WARNING: This is a hard delete and cannot be undone.
 */
export const secretsDeleteSecretMutation = (options?: Partial<Options<SecretsDeleteSecretData>>): UseMutationOptions<SecretsDeleteSecretResponse, SecretsDeleteSecretError, Options<SecretsDeleteSecretData>> => {
    const mutationOptions: UseMutationOptions<SecretsDeleteSecretResponse, SecretsDeleteSecretError, Options<SecretsDeleteSecretData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await Secrets.secretsDeleteSecret({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update Secret
 * Update a secret (admin only).
 * Typically used to deactivate old versions.
 */
export const secretsUpdateSecretMutation = (options?: Partial<Options<SecretsUpdateSecretData>>): UseMutationOptions<SecretsUpdateSecretResponse, SecretsUpdateSecretError, Options<SecretsUpdateSecretData>> => {
    const mutationOptions: UseMutationOptions<SecretsUpdateSecretResponse, SecretsUpdateSecretError, Options<SecretsUpdateSecretData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await Secrets.secretsUpdateSecret({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const secretsGetSecretAgentConfigsQueryKey = (options: Options<SecretsGetSecretAgentConfigsData>) => createQueryKey('secretsGetSecretAgentConfigs', options);

/**
 * Get Secret Agent Configs
 * Get all agent configs that use this secret (admin only).
 * Returns list of agent config slugs and names.
 */
export const secretsGetSecretAgentConfigsOptions = (options: Options<SecretsGetSecretAgentConfigsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await Secrets.secretsGetSecretAgentConfigs({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: secretsGetSecretAgentConfigsQueryKey(options)
    });
};

export const mediaListMediaQueryKey = (options?: Options<MediaListMediaData>) => createQueryKey('mediaListMedia', options);

/**
 * List Media
 * List media with pagination and filters. Admin only.
 */
export const mediaListMediaOptions = (options?: Options<MediaListMediaData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await Media.mediaListMedia({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: mediaListMediaQueryKey(options)
    });
};

export const mediaListMediaInfiniteQueryKey = (options?: Options<MediaListMediaData>): QueryKey<Options<MediaListMediaData>> => createQueryKey('mediaListMedia', options, true);

/**
 * List Media
 * List media with pagination and filters. Admin only.
 */
export const mediaListMediaInfiniteOptions = (options?: Options<MediaListMediaData>) => {
    return infiniteQueryOptions<MediaListMediaResponse, MediaListMediaError, InfiniteData<MediaListMediaResponse>, QueryKey<Options<MediaListMediaData>>, number | Pick<QueryKey<Options<MediaListMediaData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<MediaListMediaData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await Media.mediaListMedia({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: mediaListMediaInfiniteQueryKey(options)
    });
};

/**
 * Upload Media
 * Upload a media file to R2 (production) or local storage (development) and create media record.
 * Admin only.
 */
export const mediaUploadMediaMutation = (options?: Partial<Options<MediaUploadMediaData>>): UseMutationOptions<MediaUploadMediaResponse, MediaUploadMediaError, Options<MediaUploadMediaData>> => {
    const mutationOptions: UseMutationOptions<MediaUploadMediaResponse, MediaUploadMediaError, Options<MediaUploadMediaData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await Media.mediaUploadMedia({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const mediaCheckFilenameConflictQueryKey = (options: Options<MediaCheckFilenameConflictData>) => createQueryKey('mediaCheckFilenameConflict', options);

/**
 * Check Filename Conflict
 * Check if filename already exists. Admin only.
 */
export const mediaCheckFilenameConflictOptions = (options: Options<MediaCheckFilenameConflictData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await Media.mediaCheckFilenameConflict({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: mediaCheckFilenameConflictQueryKey(options)
    });
};

/**
 * Delete Media
 * Delete media (soft delete by default).
 * If hard_delete=True, also removes file from storage (R2 or local).
 * Admin only.
 */
export const mediaDeleteMediaMutation = (options?: Partial<Options<MediaDeleteMediaData>>): UseMutationOptions<MediaDeleteMediaResponse, MediaDeleteMediaError, Options<MediaDeleteMediaData>> => {
    const mutationOptions: UseMutationOptions<MediaDeleteMediaResponse, MediaDeleteMediaError, Options<MediaDeleteMediaData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await Media.mediaDeleteMedia({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const mediaGetMediaQueryKey = (options: Options<MediaGetMediaData>) => createQueryKey('mediaGetMedia', options);

/**
 * Get Media
 * Get media by ID. Admin only.
 */
export const mediaGetMediaOptions = (options: Options<MediaGetMediaData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await Media.mediaGetMedia({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: mediaGetMediaQueryKey(options)
    });
};

/**
 * Update Media
 * Update media metadata. Admin only.
 */
export const mediaUpdateMediaMutation = (options?: Partial<Options<MediaUpdateMediaData>>): UseMutationOptions<MediaUpdateMediaResponse, MediaUpdateMediaError, Options<MediaUpdateMediaData>> => {
    const mutationOptions: UseMutationOptions<MediaUpdateMediaResponse, MediaUpdateMediaError, Options<MediaUpdateMediaData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await Media.mediaUpdateMedia({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Upload Media Batch
 * Upload multiple media files at once.
 * Admin only.
 */
export const mediaUploadMediaBatchMutation = (options?: Partial<Options<MediaUploadMediaBatchData>>): UseMutationOptions<MediaUploadMediaBatchResponse, MediaUploadMediaBatchError, Options<MediaUploadMediaBatchData>> => {
    const mutationOptions: UseMutationOptions<MediaUploadMediaBatchResponse, MediaUploadMediaBatchError, Options<MediaUploadMediaBatchData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await Media.mediaUploadMediaBatch({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const reviewsListReviewsQueryKey = (options?: Options<ReviewsListReviewsData>) => createQueryKey('reviewsListReviews', options);

/**
 * List Reviews
 * Get approved reviews (public endpoint).
 * Only returns reviews with status='approved', ordered by priority.
 * Cached for 30 minutes to reduce database load.
 */
export const reviewsListReviewsOptions = (options?: Options<ReviewsListReviewsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await Reviews.reviewsListReviews({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: reviewsListReviewsQueryKey(options)
    });
};

export const reviewsListReviewsInfiniteQueryKey = (options?: Options<ReviewsListReviewsData>): QueryKey<Options<ReviewsListReviewsData>> => createQueryKey('reviewsListReviews', options, true);

/**
 * List Reviews
 * Get approved reviews (public endpoint).
 * Only returns reviews with status='approved', ordered by priority.
 * Cached for 30 minutes to reduce database load.
 */
export const reviewsListReviewsInfiniteOptions = (options?: Options<ReviewsListReviewsData>) => {
    return infiniteQueryOptions<ReviewsListReviewsResponse, ReviewsListReviewsError, InfiniteData<ReviewsListReviewsResponse>, QueryKey<Options<ReviewsListReviewsData>>, number | Pick<QueryKey<Options<ReviewsListReviewsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<ReviewsListReviewsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await Reviews.reviewsListReviews({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: reviewsListReviewsInfiniteQueryKey(options)
    });
};

/**
 * Create Review
 * Submit a new review (public endpoint).
 * Creates review with status='pending' - requires admin approval.
 * Invalidates cache on creation.
 */
export const reviewsCreateReviewMutation = (options?: Partial<Options<ReviewsCreateReviewData>>): UseMutationOptions<ReviewsCreateReviewResponse, ReviewsCreateReviewError, Options<ReviewsCreateReviewData>> => {
    const mutationOptions: UseMutationOptions<ReviewsCreateReviewResponse, ReviewsCreateReviewError, Options<ReviewsCreateReviewData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await Reviews.reviewsCreateReview({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const reviewsListReviewsAdminQueryKey = (options?: Options<ReviewsListReviewsAdminData>) => createQueryKey('reviewsListReviewsAdmin', options);

/**
 * List Reviews Admin
 * List all reviews with filters (admin only).
 */
export const reviewsListReviewsAdminOptions = (options?: Options<ReviewsListReviewsAdminData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await Reviews.reviewsListReviewsAdmin({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: reviewsListReviewsAdminQueryKey(options)
    });
};

export const reviewsListReviewsAdminInfiniteQueryKey = (options?: Options<ReviewsListReviewsAdminData>): QueryKey<Options<ReviewsListReviewsAdminData>> => createQueryKey('reviewsListReviewsAdmin', options, true);

/**
 * List Reviews Admin
 * List all reviews with filters (admin only).
 */
export const reviewsListReviewsAdminInfiniteOptions = (options?: Options<ReviewsListReviewsAdminData>) => {
    return infiniteQueryOptions<ReviewsListReviewsAdminResponse, ReviewsListReviewsAdminError, InfiniteData<ReviewsListReviewsAdminResponse>, QueryKey<Options<ReviewsListReviewsAdminData>>, number | Pick<QueryKey<Options<ReviewsListReviewsAdminData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<ReviewsListReviewsAdminData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await Reviews.reviewsListReviewsAdmin({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: reviewsListReviewsAdminInfiniteQueryKey(options)
    });
};

/**
 * Delete Review Admin
 * Delete a review (admin only).
 */
export const reviewsDeleteReviewAdminMutation = (options?: Partial<Options<ReviewsDeleteReviewAdminData>>): UseMutationOptions<ReviewsDeleteReviewAdminResponse, ReviewsDeleteReviewAdminError, Options<ReviewsDeleteReviewAdminData>> => {
    const mutationOptions: UseMutationOptions<ReviewsDeleteReviewAdminResponse, ReviewsDeleteReviewAdminError, Options<ReviewsDeleteReviewAdminData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await Reviews.reviewsDeleteReviewAdmin({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const reviewsGetReviewAdminQueryKey = (options: Options<ReviewsGetReviewAdminData>) => createQueryKey('reviewsGetReviewAdmin', options);

/**
 * Get Review Admin
 * Get any review by ID (admin only).
 */
export const reviewsGetReviewAdminOptions = (options: Options<ReviewsGetReviewAdminData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await Reviews.reviewsGetReviewAdmin({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: reviewsGetReviewAdminQueryKey(options)
    });
};

/**
 * Update Review Admin
 * Update a review (admin only).
 */
export const reviewsUpdateReviewAdminMutation = (options?: Partial<Options<ReviewsUpdateReviewAdminData>>): UseMutationOptions<ReviewsUpdateReviewAdminResponse, ReviewsUpdateReviewAdminError, Options<ReviewsUpdateReviewAdminData>> => {
    const mutationOptions: UseMutationOptions<ReviewsUpdateReviewAdminResponse, ReviewsUpdateReviewAdminError, Options<ReviewsUpdateReviewAdminData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await Reviews.reviewsUpdateReviewAdmin({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const reviewsGetReviewQueryKey = (options: Options<ReviewsGetReviewData>) => createQueryKey('reviewsGetReview', options);

/**
 * Get Review
 * Get a single approved review by ID (public endpoint).
 * Only returns reviews with status='approved'.
 */
export const reviewsGetReviewOptions = (options: Options<ReviewsGetReviewData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await Reviews.reviewsGetReview({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: reviewsGetReviewQueryKey(options)
    });
};

export const promoCodesAdminListPromoCodesQueryKey = (options?: Options<PromoCodesAdminListPromoCodesData>) => createQueryKey('promoCodesAdminListPromoCodes', options);

/**
 * List Promo Codes
 * List all promo codes with pagination (admin only).
 */
export const promoCodesAdminListPromoCodesOptions = (options?: Options<PromoCodesAdminListPromoCodesData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await PromoCodesAdmin.promoCodesAdminListPromoCodes({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: promoCodesAdminListPromoCodesQueryKey(options)
    });
};

export const promoCodesAdminListPromoCodesInfiniteQueryKey = (options?: Options<PromoCodesAdminListPromoCodesData>): QueryKey<Options<PromoCodesAdminListPromoCodesData>> => createQueryKey('promoCodesAdminListPromoCodes', options, true);

/**
 * List Promo Codes
 * List all promo codes with pagination (admin only).
 */
export const promoCodesAdminListPromoCodesInfiniteOptions = (options?: Options<PromoCodesAdminListPromoCodesData>) => {
    return infiniteQueryOptions<PromoCodesAdminListPromoCodesResponse, PromoCodesAdminListPromoCodesError, InfiniteData<PromoCodesAdminListPromoCodesResponse>, QueryKey<Options<PromoCodesAdminListPromoCodesData>>, number | Pick<QueryKey<Options<PromoCodesAdminListPromoCodesData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<PromoCodesAdminListPromoCodesData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await PromoCodesAdmin.promoCodesAdminListPromoCodes({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: promoCodesAdminListPromoCodesInfiniteQueryKey(options)
    });
};

/**
 * Create Promo Code
 * Create a new promo code (admin only).
 */
export const promoCodesAdminCreatePromoCodeMutation = (options?: Partial<Options<PromoCodesAdminCreatePromoCodeData>>): UseMutationOptions<PromoCodesAdminCreatePromoCodeResponse, PromoCodesAdminCreatePromoCodeError, Options<PromoCodesAdminCreatePromoCodeData>> => {
    const mutationOptions: UseMutationOptions<PromoCodesAdminCreatePromoCodeResponse, PromoCodesAdminCreatePromoCodeError, Options<PromoCodesAdminCreatePromoCodeData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await PromoCodesAdmin.promoCodesAdminCreatePromoCode({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete Promo Code
 * Delete a promo code (soft delete by setting is_active=False) (admin only).
 */
export const promoCodesAdminDeletePromoCodeMutation = (options?: Partial<Options<PromoCodesAdminDeletePromoCodeData>>): UseMutationOptions<PromoCodesAdminDeletePromoCodeResponse, PromoCodesAdminDeletePromoCodeError, Options<PromoCodesAdminDeletePromoCodeData>> => {
    const mutationOptions: UseMutationOptions<PromoCodesAdminDeletePromoCodeResponse, PromoCodesAdminDeletePromoCodeError, Options<PromoCodesAdminDeletePromoCodeData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await PromoCodesAdmin.promoCodesAdminDeletePromoCode({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const promoCodesAdminGetPromoCodeByIdQueryKey = (options: Options<PromoCodesAdminGetPromoCodeByIdData>) => createQueryKey('promoCodesAdminGetPromoCodeById', options);

/**
 * Get Promo Code By Id
 * Get a promo code by ID (admin only).
 */
export const promoCodesAdminGetPromoCodeByIdOptions = (options: Options<PromoCodesAdminGetPromoCodeByIdData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await PromoCodesAdmin.promoCodesAdminGetPromoCodeById({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: promoCodesAdminGetPromoCodeByIdQueryKey(options)
    });
};

/**
 * Update Promo Code
 * Update a promo code (admin only).
 */
export const promoCodesAdminUpdatePromoCodeMutation = (options?: Partial<Options<PromoCodesAdminUpdatePromoCodeData>>): UseMutationOptions<PromoCodesAdminUpdatePromoCodeResponse, PromoCodesAdminUpdatePromoCodeError, Options<PromoCodesAdminUpdatePromoCodeData>> => {
    const mutationOptions: UseMutationOptions<PromoCodesAdminUpdatePromoCodeResponse, PromoCodesAdminUpdatePromoCodeError, Options<PromoCodesAdminUpdatePromoCodeData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await PromoCodesAdmin.promoCodesAdminUpdatePromoCode({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const promoCodesAdminGetRevenuecatProductsQueryKey = (options?: Options<PromoCodesAdminGetRevenuecatProductsData>) => createQueryKey('promoCodesAdminGetRevenuecatProducts', options);

/**
 * Get Revenuecat Products
 * Get available RevenueCat products (admin only).
 * Results are cached for 1 hour to reduce API calls.
 */
export const promoCodesAdminGetRevenuecatProductsOptions = (options?: Options<PromoCodesAdminGetRevenuecatProductsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await PromoCodesAdmin.promoCodesAdminGetRevenuecatProducts({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: promoCodesAdminGetRevenuecatProductsQueryKey(options)
    });
};

export const promoCodesAdminGetRevenuecatOfferingsQueryKey = (options?: Options<PromoCodesAdminGetRevenuecatOfferingsData>) => createQueryKey('promoCodesAdminGetRevenuecatOfferings', options);

/**
 * Get Revenuecat Offerings
 * Get available RevenueCat offerings (admin only).
 * Results are cached for 1 hour to reduce API calls.
 */
export const promoCodesAdminGetRevenuecatOfferingsOptions = (options?: Options<PromoCodesAdminGetRevenuecatOfferingsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await PromoCodesAdmin.promoCodesAdminGetRevenuecatOfferings({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: promoCodesAdminGetRevenuecatOfferingsQueryKey(options)
    });
};

export const promoCodesAdminGetRevenuecatAppQueryKey = (options: Options<PromoCodesAdminGetRevenuecatAppData>) => createQueryKey('promoCodesAdminGetRevenuecatApp', options);

/**
 * Get Revenuecat App
 * Get RevenueCat app details by app_id (admin only).
 * Results are cached for 1 hour to reduce API calls.
 */
export const promoCodesAdminGetRevenuecatAppOptions = (options: Options<PromoCodesAdminGetRevenuecatAppData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await PromoCodesAdmin.promoCodesAdminGetRevenuecatApp({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: promoCodesAdminGetRevenuecatAppQueryKey(options)
    });
};

/**
 * Clear Revenuecat Cache
 * Clear RevenueCat cache (admin only).
 * Useful for refreshing product/app data after changes in RevenueCat dashboard.
 */
export const promoCodesAdminClearRevenuecatCacheMutation = (options?: Partial<Options<PromoCodesAdminClearRevenuecatCacheData>>): UseMutationOptions<PromoCodesAdminClearRevenuecatCacheResponse, PromoCodesAdminClearRevenuecatCacheError, Options<PromoCodesAdminClearRevenuecatCacheData>> => {
    const mutationOptions: UseMutationOptions<PromoCodesAdminClearRevenuecatCacheResponse, PromoCodesAdminClearRevenuecatCacheError, Options<PromoCodesAdminClearRevenuecatCacheData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await PromoCodesAdmin.promoCodesAdminClearRevenuecatCache({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const emailTemplatesListEmailTemplatesQueryKey = (options?: Options<EmailTemplatesListEmailTemplatesData>) => createQueryKey('emailTemplatesListEmailTemplates', options);

/**
 * List Email Templates
 * List email templates (admin only).
 */
export const emailTemplatesListEmailTemplatesOptions = (options?: Options<EmailTemplatesListEmailTemplatesData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await EmailTemplates.emailTemplatesListEmailTemplates({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: emailTemplatesListEmailTemplatesQueryKey(options)
    });
};

export const emailTemplatesListEmailTemplatesInfiniteQueryKey = (options?: Options<EmailTemplatesListEmailTemplatesData>): QueryKey<Options<EmailTemplatesListEmailTemplatesData>> => createQueryKey('emailTemplatesListEmailTemplates', options, true);

/**
 * List Email Templates
 * List email templates (admin only).
 */
export const emailTemplatesListEmailTemplatesInfiniteOptions = (options?: Options<EmailTemplatesListEmailTemplatesData>) => {
    return infiniteQueryOptions<EmailTemplatesListEmailTemplatesResponse, EmailTemplatesListEmailTemplatesError, InfiniteData<EmailTemplatesListEmailTemplatesResponse>, QueryKey<Options<EmailTemplatesListEmailTemplatesData>>, number | Pick<QueryKey<Options<EmailTemplatesListEmailTemplatesData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<EmailTemplatesListEmailTemplatesData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await EmailTemplates.emailTemplatesListEmailTemplates({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: emailTemplatesListEmailTemplatesInfiniteQueryKey(options)
    });
};

/**
 * Create Email Template
 * Create a new email template whose content is an unpublished draft.
 *
 * Nothing is sent and nothing goes live: no campaign can use a template
 * until a person reviews and publishes a version in the admin panel
 * (/admin/email-templates/{id}, the `id` in the response). Names starting
 * `system-` are refused.
 *
 * Content format: `subject`, `body_html` and `body_text` are Jinja
 * templates, rendered per member at send. Variables include
 * `{{ first_name }}`, `{{ unsub_link }}`, `{{ app_link }}`,
 * `{{ support_email }}`; marketing mail must link `{{ unsub_link }}`.
 * `{% if may_promote %}...{% endif %}` wraps anything promotional. To write
 * in the editor's block format instead, create the template and then save a
 * draft with `format: "blocks"` (see the draft tool).
 */
export const emailTemplatesCreateEmailTemplateMutation = (options?: Partial<Options<EmailTemplatesCreateEmailTemplateData>>): UseMutationOptions<EmailTemplatesCreateEmailTemplateResponse, EmailTemplatesCreateEmailTemplateError, Options<EmailTemplatesCreateEmailTemplateData>> => {
    const mutationOptions: UseMutationOptions<EmailTemplatesCreateEmailTemplateResponse, EmailTemplatesCreateEmailTemplateError, Options<EmailTemplatesCreateEmailTemplateData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await EmailTemplates.emailTemplatesCreateEmailTemplate({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const emailTemplatesListSystemEmailsQueryKey = (options?: Options<EmailTemplatesListSystemEmailsData>) => createQueryKey('emailTemplatesListSystemEmails', options);

/**
 * List System Emails
 * The emails auth and accounts send from built-in files, and whether
 * each has been customised in the studio.
 */
export const emailTemplatesListSystemEmailsOptions = (options?: Options<EmailTemplatesListSystemEmailsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await EmailTemplates.emailTemplatesListSystemEmails({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: emailTemplatesListSystemEmailsQueryKey(options)
    });
};

export const emailTemplatesSystemEmailBuiltInQueryKey = (options: Options<EmailTemplatesSystemEmailBuiltInData>) => createQueryKey('emailTemplatesSystemEmailBuiltIn', options);

/**
 * System Email Built In
 * The built-in email as an editor document: what "Open in the editor"
 * loads into a draft. Reading it changes nothing.
 */
export const emailTemplatesSystemEmailBuiltInOptions = (options: Options<EmailTemplatesSystemEmailBuiltInData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await EmailTemplates.emailTemplatesSystemEmailBuiltIn({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: emailTemplatesSystemEmailBuiltInQueryKey(options)
    });
};

/**
 * Customize System Email
 * Copy a built-in email into the studio. Its words don't change until a
 * new version is published; the built-in file stays the fallback.
 */
export const emailTemplatesCustomizeSystemEmailMutation = (options?: Partial<Options<EmailTemplatesCustomizeSystemEmailData>>): UseMutationOptions<EmailTemplatesCustomizeSystemEmailResponse, EmailTemplatesCustomizeSystemEmailError, Options<EmailTemplatesCustomizeSystemEmailData>> => {
    const mutationOptions: UseMutationOptions<EmailTemplatesCustomizeSystemEmailResponse, EmailTemplatesCustomizeSystemEmailError, Options<EmailTemplatesCustomizeSystemEmailData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await EmailTemplates.emailTemplatesCustomizeSystemEmail({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Use Built In System Email
 * Send the built-in version again. The customised one is kept, switched
 * off, so it can be switched back on with its history intact.
 */
export const emailTemplatesUseBuiltInSystemEmailMutation = (options?: Partial<Options<EmailTemplatesUseBuiltInSystemEmailData>>): UseMutationOptions<EmailTemplatesUseBuiltInSystemEmailResponse, EmailTemplatesUseBuiltInSystemEmailError, Options<EmailTemplatesUseBuiltInSystemEmailData>> => {
    const mutationOptions: UseMutationOptions<EmailTemplatesUseBuiltInSystemEmailResponse, EmailTemplatesUseBuiltInSystemEmailError, Options<EmailTemplatesUseBuiltInSystemEmailData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await EmailTemplates.emailTemplatesUseBuiltInSystemEmail({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete Email Template
 * Delete email template (admin only).
 */
export const emailTemplatesDeleteEmailTemplateMutation = (options?: Partial<Options<EmailTemplatesDeleteEmailTemplateData>>): UseMutationOptions<EmailTemplatesDeleteEmailTemplateResponse, EmailTemplatesDeleteEmailTemplateError, Options<EmailTemplatesDeleteEmailTemplateData>> => {
    const mutationOptions: UseMutationOptions<EmailTemplatesDeleteEmailTemplateResponse, EmailTemplatesDeleteEmailTemplateError, Options<EmailTemplatesDeleteEmailTemplateData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await EmailTemplates.emailTemplatesDeleteEmailTemplate({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const emailTemplatesGetEmailTemplateQueryKey = (options: Options<EmailTemplatesGetEmailTemplateData>) => createQueryKey('emailTemplatesGetEmailTemplate', options);

/**
 * Get Email Template
 * Get email template by ID (admin only).
 */
export const emailTemplatesGetEmailTemplateOptions = (options: Options<EmailTemplatesGetEmailTemplateData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await EmailTemplates.emailTemplatesGetEmailTemplate({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: emailTemplatesGetEmailTemplateQueryKey(options)
    });
};

/**
 * Update Email Template
 * Update a template's settings: name, slug, active, variables notes.
 *
 * Not its content: that is a draft, reviewed and published.
 */
export const emailTemplatesUpdateEmailTemplateMutation = (options?: Partial<Options<EmailTemplatesUpdateEmailTemplateData>>): UseMutationOptions<EmailTemplatesUpdateEmailTemplateResponse, EmailTemplatesUpdateEmailTemplateError, Options<EmailTemplatesUpdateEmailTemplateData>> => {
    const mutationOptions: UseMutationOptions<EmailTemplatesUpdateEmailTemplateResponse, EmailTemplatesUpdateEmailTemplateError, Options<EmailTemplatesUpdateEmailTemplateData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await EmailTemplates.emailTemplatesUpdateEmailTemplate({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Preview Email Template
 * Render a template, or an unsaved draft of it, as a real send would.
 * Sends nothing and saves nothing. Leave out `user_id` to render it for
 * yourself.
 *
 * Rendered for someone else, for staff without personal details (the
 * Send review's sample recipients), their name and address read as
 * stand-ins (`_masked`): the email still shows, whether it greets by name
 * still shows, who it is doesn't.
 *
 * With a campaign step: that campaign's variables and link stamping, and
 * whether the member would get it at all. With `branches`: every
 * combination of the template's conditions, rendered strictly so an
 * undefined variable shows up as an error.
 */
export const emailTemplatesPreviewEmailTemplateMutation = (options?: Partial<Options<EmailTemplatesPreviewEmailTemplateData>>): UseMutationOptions<EmailTemplatesPreviewEmailTemplateResponse, EmailTemplatesPreviewEmailTemplateError, Options<EmailTemplatesPreviewEmailTemplateData>> => {
    const mutationOptions: UseMutationOptions<EmailTemplatesPreviewEmailTemplateResponse, EmailTemplatesPreviewEmailTemplateError, Options<EmailTemplatesPreviewEmailTemplateData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await EmailTemplates.emailTemplatesPreviewEmailTemplate({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Test Send Email Template
 * Send this template, or an unsaved draft, to yourself as a real email.
 *
 * A preview proves the template renders. This proves it survives the trip:
 * Postmark accepts it, the HTML holds up in a real mail client, the links
 * resolve. Only to the caller's own address: that is what the scope grants.
 * Not recorded as a campaign execution, so tests never move the stats.
 */
export const emailTemplatesTestSendEmailTemplateMutation = (options?: Partial<Options<EmailTemplatesTestSendEmailTemplateData>>): UseMutationOptions<EmailTemplatesTestSendEmailTemplateResponse, EmailTemplatesTestSendEmailTemplateError, Options<EmailTemplatesTestSendEmailTemplateData>> => {
    const mutationOptions: UseMutationOptions<EmailTemplatesTestSendEmailTemplateResponse, EmailTemplatesTestSendEmailTemplateError, Options<EmailTemplatesTestSendEmailTemplateData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await EmailTemplates.emailTemplatesTestSendEmailTemplate({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const emailTemplatesListTemplateVersionsQueryKey = (options: Options<EmailTemplatesListTemplateVersionsData>) => createQueryKey('emailTemplatesListTemplateVersions', options);

/**
 * List Template Versions
 * Every version, newest first: the draft (if any) and all published ones.
 */
export const emailTemplatesListTemplateVersionsOptions = (options: Options<EmailTemplatesListTemplateVersionsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await EmailTemplates.emailTemplatesListTemplateVersions({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: emailTemplatesListTemplateVersionsQueryKey(options)
    });
};

/**
 * Discard Template Draft
 */
export const emailTemplatesDiscardTemplateDraftMutation = (options?: Partial<Options<EmailTemplatesDiscardTemplateDraftData>>): UseMutationOptions<EmailTemplatesDiscardTemplateDraftResponse, EmailTemplatesDiscardTemplateDraftError, Options<EmailTemplatesDiscardTemplateDraftData>> => {
    const mutationOptions: UseMutationOptions<EmailTemplatesDiscardTemplateDraftResponse, EmailTemplatesDiscardTemplateDraftError, Options<EmailTemplatesDiscardTemplateDraftData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await EmailTemplates.emailTemplatesDiscardTemplateDraft({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Save Template Draft
 * Save (create or overwrite) the template's one draft version.
 *
 * Nothing is sent and nothing a member receives changes: what sends is the
 * published version, and only a person publishes, in the admin panel at
 * /admin/email-templates/{template_id}. Use the preview and review tools to
 * check the draft first.
 *
 * Formats: `"html"` takes `body_html` and `body_text` as Jinja (variables
 * like `{{ first_name }}`, `{{ unsub_link }}`). `"blocks"` takes `document`,
 * the editor's ProseMirror JSON: `{"type": "doc", "content": [...]}` with
 * blocks `paragraph`, `heading` (attrs.level 2 or 3), `bulletList` /
 * `orderedList` of `listItem`, `blockquote`, `horizontalRule`, `button`
 * (attrs.href, attrs.label), `image`, `logo`, `feedback`, `conditional`;
 * inline `text` (marks bold, italic, underline, link) and `variable`
 * (attrs.name, attrs.fallback), e.g.
 * `{"type": "variable", "attrs": {"name": "first_name", "fallback": "there"}}`.
 * Unknown nodes are refused. A blocks draft goes into `layout_id` (default
 * layout when unset), which adds the footer and unsubscribe link. Pass
 * `base_dt_updated` from the draft you read to avoid overwriting someone
 * else's edit.
 */
export const emailTemplatesSaveTemplateDraftMutation = (options?: Partial<Options<EmailTemplatesSaveTemplateDraftData>>): UseMutationOptions<EmailTemplatesSaveTemplateDraftResponse, EmailTemplatesSaveTemplateDraftError, Options<EmailTemplatesSaveTemplateDraftData>> => {
    const mutationOptions: UseMutationOptions<EmailTemplatesSaveTemplateDraftResponse, EmailTemplatesSaveTemplateDraftError, Options<EmailTemplatesSaveTemplateDraftData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await EmailTemplates.emailTemplatesSaveTemplateDraft({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const emailTemplatesReviewTemplateVersionQueryKey = (options: Options<EmailTemplatesReviewTemplateVersionData>) => createQueryKey('emailTemplatesReviewTemplateVersion', options);

/**
 * Review Template Version
 * Every check the version must pass to go live, rendered as you.
 */
export const emailTemplatesReviewTemplateVersionOptions = (options: Options<EmailTemplatesReviewTemplateVersionData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await EmailTemplates.emailTemplatesReviewTemplateVersion({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: emailTemplatesReviewTemplateVersionQueryKey(options)
    });
};

/**
 * Publish Template Version
 * Make a version what this template sends, from the next send on.
 *
 * The draft goes live, or an older version is restored (as a new version,
 * so history only grows). Refused with the review while any blocking check
 * fails: the guard lives here, not in the client.
 */
export const emailTemplatesPublishTemplateVersionMutation = (options?: Partial<Options<EmailTemplatesPublishTemplateVersionData>>): UseMutationOptions<EmailTemplatesPublishTemplateVersionResponse, EmailTemplatesPublishTemplateVersionError, Options<EmailTemplatesPublishTemplateVersionData>> => {
    const mutationOptions: UseMutationOptions<EmailTemplatesPublishTemplateVersionResponse, EmailTemplatesPublishTemplateVersionError, Options<EmailTemplatesPublishTemplateVersionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await EmailTemplates.emailTemplatesPublishTemplateVersion({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const emailTemplatesTemplateStatsQueryKey = (options: Options<EmailTemplatesTemplateStatsData>) => createQueryKey('emailTemplatesTemplateStats', options);

/**
 * Template Stats
 * How this email is doing, version by version, against its campaigns.
 */
export const emailTemplatesTemplateStatsOptions = (options: Options<EmailTemplatesTemplateStatsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await EmailTemplates.emailTemplatesTemplateStats({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: emailTemplatesTemplateStatsQueryKey(options)
    });
};

export const emailLayoutsListLayoutsQueryKey = (options?: Options<EmailLayoutsListLayoutsData>) => createQueryKey('emailLayoutsListLayouts', options);

/**
 * List Layouts
 * Every email layout (the wrapper a blocks email is poured into: header,
 * footer, unsubscribe line), by name.
 */
export const emailLayoutsListLayoutsOptions = (options?: Options<EmailLayoutsListLayoutsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await EmailLayouts.emailLayoutsListLayouts({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: emailLayoutsListLayoutsQueryKey(options)
    });
};

export const emailLayoutsGetSenderIdentityQueryKey = (options?: Options<EmailLayoutsGetSenderIdentityData>) => createQueryKey('emailLayoutsGetSenderIdentity', options);

/**
 * Get Sender Identity
 * Who marketing email says it is from, as every footer shows it.
 */
export const emailLayoutsGetSenderIdentityOptions = (options?: Options<EmailLayoutsGetSenderIdentityData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await EmailLayouts.emailLayoutsGetSenderIdentity({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: emailLayoutsGetSenderIdentityQueryKey(options)
    });
};

/**
 * Update Sender Identity
 * Change the legal name, postal address or contact every marketing
 * footer shows. Live from the next send: the footer reads it as it goes.
 */
export const emailLayoutsUpdateSenderIdentityMutation = (options?: Partial<Options<EmailLayoutsUpdateSenderIdentityData>>): UseMutationOptions<EmailLayoutsUpdateSenderIdentityResponse, EmailLayoutsUpdateSenderIdentityError, Options<EmailLayoutsUpdateSenderIdentityData>> => {
    const mutationOptions: UseMutationOptions<EmailLayoutsUpdateSenderIdentityResponse, EmailLayoutsUpdateSenderIdentityError, Options<EmailLayoutsUpdateSenderIdentityData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await EmailLayouts.emailLayoutsUpdateSenderIdentity({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const emailLayoutsLayoutUsageQueryKey = (options: Options<EmailLayoutsLayoutUsageData>) => createQueryKey('emailLayoutsLayoutUsage', options);

/**
 * Layout Usage
 * How many templates' published version is built on this layout.
 */
export const emailLayoutsLayoutUsageOptions = (options: Options<EmailLayoutsLayoutUsageData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await EmailLayouts.emailLayoutsLayoutUsage({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: emailLayoutsLayoutUsageQueryKey(options)
    });
};

/**
 * Duplicate Layout
 * A copy of a layout, used by no email, to change without touching the
 * original. It is also how a new layout starts: a blank one would have no
 * slots or unsubscribe link, so it starts from one that does.
 */
export const emailLayoutsDuplicateLayoutMutation = (options?: Partial<Options<EmailLayoutsDuplicateLayoutData>>): UseMutationOptions<EmailLayoutsDuplicateLayoutResponse, EmailLayoutsDuplicateLayoutError, Options<EmailLayoutsDuplicateLayoutData>> => {
    const mutationOptions: UseMutationOptions<EmailLayoutsDuplicateLayoutResponse, EmailLayoutsDuplicateLayoutError, Options<EmailLayoutsDuplicateLayoutData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await EmailLayouts.emailLayoutsDuplicateLayout({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete Layout
 * Delete a layout nothing is built on: not the default, and no version
 * of any email (live, draft or past) uses it, so no record loses its shell.
 */
export const emailLayoutsDeleteLayoutMutation = (options?: Partial<Options<EmailLayoutsDeleteLayoutData>>): UseMutationOptions<EmailLayoutsDeleteLayoutResponse, EmailLayoutsDeleteLayoutError, Options<EmailLayoutsDeleteLayoutData>> => {
    const mutationOptions: UseMutationOptions<EmailLayoutsDeleteLayoutResponse, EmailLayoutsDeleteLayoutError, Options<EmailLayoutsDeleteLayoutData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await EmailLayouts.emailLayoutsDeleteLayout({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update Layout
 */
export const emailLayoutsUpdateLayoutMutation = (options?: Partial<Options<EmailLayoutsUpdateLayoutData>>): UseMutationOptions<EmailLayoutsUpdateLayoutResponse, EmailLayoutsUpdateLayoutError, Options<EmailLayoutsUpdateLayoutData>> => {
    const mutationOptions: UseMutationOptions<EmailLayoutsUpdateLayoutResponse, EmailLayoutsUpdateLayoutError, Options<EmailLayoutsUpdateLayoutData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await EmailLayouts.emailLayoutsUpdateLayout({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Preview Layout
 * A sample email in this (possibly unsaved) layout, rendered for you.
 * Sends nothing and saves nothing.
 */
export const emailLayoutsPreviewLayoutMutation = (options?: Partial<Options<EmailLayoutsPreviewLayoutData>>): UseMutationOptions<EmailLayoutsPreviewLayoutResponse, EmailLayoutsPreviewLayoutError, Options<EmailLayoutsPreviewLayoutData>> => {
    const mutationOptions: UseMutationOptions<EmailLayoutsPreviewLayoutResponse, EmailLayoutsPreviewLayoutError, Options<EmailLayoutsPreviewLayoutData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await EmailLayouts.emailLayoutsPreviewLayout({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Compile Body
 * The editor's block document (ProseMirror JSON) as the Jinja HTML and
 * text it compiles to, for reading. Saves nothing; refuses unknown blocks,
 * so it checks a document before drafting it.
 */
export const emailLayoutsCompileBodyMutation = (options?: Partial<Options<EmailLayoutsCompileBodyData>>): UseMutationOptions<EmailLayoutsCompileBodyResponse, EmailLayoutsCompileBodyError, Options<EmailLayoutsCompileBodyData>> => {
    const mutationOptions: UseMutationOptions<EmailLayoutsCompileBodyResponse, EmailLayoutsCompileBodyError, Options<EmailLayoutsCompileBodyData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await EmailLayouts.emailLayoutsCompileBody({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const emailDeliverabilityDeliverabilityQueryKey = (options?: Options<EmailDeliverabilityDeliverabilityData>) => createQueryKey('emailDeliverabilityDeliverability', options);

/**
 * Deliverability
 * SPF, DMARC, Return-Path, MX and (via Postmark) DKIM, each with advice.
 */
export const emailDeliverabilityDeliverabilityOptions = (options?: Options<EmailDeliverabilityDeliverabilityData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await EmailDeliverability.emailDeliverabilityDeliverability({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: emailDeliverabilityDeliverabilityQueryKey(options)
    });
};

export const emailDeliverabilityRatesQueryKey = (options?: Options<EmailDeliverabilityRatesData>) => createQueryKey('emailDeliverabilityRates', options);

/**
 * Rates
 * Hard-bounce and complaint rates per stream, last 24 hours and 7 days,
 * and per mailbox provider over 7 days.
 */
export const emailDeliverabilityRatesOptions = (options?: Options<EmailDeliverabilityRatesData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await EmailDeliverability.emailDeliverabilityRates({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: emailDeliverabilityRatesQueryKey(options)
    });
};

export const emailDeliverabilityListHealthQueryKey = (options?: Options<EmailDeliverabilityListHealthData>) => createQueryKey('emailDeliverabilityListHealth', options);

/**
 * List Health
 * Is the marketing list still reading us: open rate per stream and per
 * campaign over 7, 30 and 90 days, Apple's machine opens apart, and the
 * share of people mailed with a sign of life. Aggregates only.
 */
export const emailDeliverabilityListHealthOptions = (options?: Options<EmailDeliverabilityListHealthData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await EmailDeliverability.emailDeliverabilityListHealth({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: emailDeliverabilityListHealthQueryKey(options)
    });
};

export const emailDeliverabilityDeliveryMethodsComparedQueryKey = (options?: Options<EmailDeliverabilityDeliveryMethodsComparedData>) => createQueryKey('emailDeliverabilityDeliveryMethodsCompared', options);

/**
 * Delivery Methods Compared
 * Which way of sending works best: marketing one-offs over 90 days by
 * when they landed and staged or not. Aggregates only.
 */
export const emailDeliverabilityDeliveryMethodsComparedOptions = (options?: Options<EmailDeliverabilityDeliveryMethodsComparedData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await EmailDeliverability.emailDeliverabilityDeliveryMethodsCompared({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: emailDeliverabilityDeliveryMethodsComparedQueryKey(options)
    });
};

export const emailDeliverabilityPipelineQueryKey = (options?: Options<EmailDeliverabilityPipelineData>) => createQueryKey('emailDeliverabilityPipeline', options);

/**
 * Pipeline
 * Queued, the oldest send waiting, sent and failed in the last 24 hours,
 * when we last sent and when Postmark last reported, and what is wrong.
 */
export const emailDeliverabilityPipelineOptions = (options?: Options<EmailDeliverabilityPipelineData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await EmailDeliverability.emailDeliverabilityPipeline({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: emailDeliverabilityPipelineQueryKey(options)
    });
};

export const emailSuppressionsListSuppressionsQueryKey = (options?: Options<EmailSuppressionsListSuppressionsData>) => createQueryKey('emailSuppressionsListSuppressions', options);

/**
 * List Suppressions
 */
export const emailSuppressionsListSuppressionsOptions = (options?: Options<EmailSuppressionsListSuppressionsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await EmailSuppressions.emailSuppressionsListSuppressions({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: emailSuppressionsListSuppressionsQueryKey(options)
    });
};

export const emailSuppressionsListSuppressionsInfiniteQueryKey = (options?: Options<EmailSuppressionsListSuppressionsData>): QueryKey<Options<EmailSuppressionsListSuppressionsData>> => createQueryKey('emailSuppressionsListSuppressions', options, true);

/**
 * List Suppressions
 */
export const emailSuppressionsListSuppressionsInfiniteOptions = (options?: Options<EmailSuppressionsListSuppressionsData>) => {
    return infiniteQueryOptions<EmailSuppressionsListSuppressionsResponse, EmailSuppressionsListSuppressionsError, InfiniteData<EmailSuppressionsListSuppressionsResponse>, QueryKey<Options<EmailSuppressionsListSuppressionsData>>, number | Pick<QueryKey<Options<EmailSuppressionsListSuppressionsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<EmailSuppressionsListSuppressionsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await EmailSuppressions.emailSuppressionsListSuppressions({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: emailSuppressionsListSuppressionsInfiniteQueryKey(options)
    });
};

/**
 * Add Suppression
 * Somebody asked by phone, chat or letter. Already on the list for a
 * stronger reason, it stays as it is.
 */
export const emailSuppressionsAddSuppressionMutation = (options?: Partial<Options<EmailSuppressionsAddSuppressionData>>): UseMutationOptions<EmailSuppressionsAddSuppressionResponse, EmailSuppressionsAddSuppressionError, Options<EmailSuppressionsAddSuppressionData>> => {
    const mutationOptions: UseMutationOptions<EmailSuppressionsAddSuppressionResponse, EmailSuppressionsAddSuppressionError, Options<EmailSuppressionsAddSuppressionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await EmailSuppressions.emailSuppressionsAddSuppression({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Lift Suppression
 */
export const emailSuppressionsLiftSuppressionMutation = (options?: Partial<Options<EmailSuppressionsLiftSuppressionData>>): UseMutationOptions<EmailSuppressionsLiftSuppressionResponse, EmailSuppressionsLiftSuppressionError, Options<EmailSuppressionsLiftSuppressionData>> => {
    const mutationOptions: UseMutationOptions<EmailSuppressionsLiftSuppressionResponse, EmailSuppressionsLiftSuppressionError, Options<EmailSuppressionsLiftSuppressionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await EmailSuppressions.emailSuppressionsLiftSuppression({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Request Postmark Lift
 * A spam complaint can't be removed here: Condri asks Postmark support
 * (the runbook is in docs/features/mail-studio/README.md). This records
 * that we asked; Postmark's reactivation then lifts it.
 */
export const emailSuppressionsRequestPostmarkLiftMutation = (options?: Partial<Options<EmailSuppressionsRequestPostmarkLiftData>>): UseMutationOptions<EmailSuppressionsRequestPostmarkLiftResponse, EmailSuppressionsRequestPostmarkLiftError, Options<EmailSuppressionsRequestPostmarkLiftData>> => {
    const mutationOptions: UseMutationOptions<EmailSuppressionsRequestPostmarkLiftResponse, EmailSuppressionsRequestPostmarkLiftError, Options<EmailSuppressionsRequestPostmarkLiftData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await EmailSuppressions.emailSuppressionsRequestPostmarkLift({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const emailCampaignsGetTriggerEventsQueryKey = (options?: Options<EmailCampaignsGetTriggerEventsData>) => createQueryKey('emailCampaignsGetTriggerEvents', options);

/**
 * Get Trigger Events
 * The events a campaign can start on, with the kind of mail each sends.
 */
export const emailCampaignsGetTriggerEventsOptions = (options?: Options<EmailCampaignsGetTriggerEventsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await EmailCampaigns.emailCampaignsGetTriggerEvents({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: emailCampaignsGetTriggerEventsQueryKey(options)
    });
};

export const emailCampaignsGetFlowConditionsQueryKey = (options?: Options<EmailCampaignsGetFlowConditionsData>) => createQueryKey('emailCampaignsGetFlowConditions', options);

/**
 * Get Flow Conditions
 * What a flow's step ("only if") or goal can check, from the fixed list
 * in code (application/conditions.py).
 */
export const emailCampaignsGetFlowConditionsOptions = (options?: Options<EmailCampaignsGetFlowConditionsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await EmailCampaigns.emailCampaignsGetFlowConditions({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: emailCampaignsGetFlowConditionsQueryKey(options)
    });
};

export const emailCampaignsGetEnrollmentCountsQueryKey = (options?: Options<EmailCampaignsGetEnrollmentCountsData>) => createQueryKey('emailCampaignsGetEnrollmentCounts', options);

/**
 * Get Enrollment Counts
 * How many people each campaign holds, by status. Counts only, no ids.
 */
export const emailCampaignsGetEnrollmentCountsOptions = (options?: Options<EmailCampaignsGetEnrollmentCountsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await EmailCampaigns.emailCampaignsGetEnrollmentCounts({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: emailCampaignsGetEnrollmentCountsQueryKey(options)
    });
};

export const emailCampaignsListEmailCampaignsQueryKey = (options?: Options<EmailCampaignsListEmailCampaignsData>) => createQueryKey('emailCampaignsListEmailCampaigns', options);

/**
 * List Email Campaigns
 * List email campaigns with pagination.
 */
export const emailCampaignsListEmailCampaignsOptions = (options?: Options<EmailCampaignsListEmailCampaignsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await EmailCampaigns.emailCampaignsListEmailCampaigns({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: emailCampaignsListEmailCampaignsQueryKey(options)
    });
};

export const emailCampaignsListEmailCampaignsInfiniteQueryKey = (options?: Options<EmailCampaignsListEmailCampaignsData>): QueryKey<Options<EmailCampaignsListEmailCampaignsData>> => createQueryKey('emailCampaignsListEmailCampaigns', options, true);

/**
 * List Email Campaigns
 * List email campaigns with pagination.
 */
export const emailCampaignsListEmailCampaignsInfiniteOptions = (options?: Options<EmailCampaignsListEmailCampaignsData>) => {
    return infiniteQueryOptions<EmailCampaignsListEmailCampaignsResponse, EmailCampaignsListEmailCampaignsError, InfiniteData<EmailCampaignsListEmailCampaignsResponse>, QueryKey<Options<EmailCampaignsListEmailCampaignsData>>, number | Pick<QueryKey<Options<EmailCampaignsListEmailCampaignsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<EmailCampaignsListEmailCampaignsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await EmailCampaigns.emailCampaignsListEmailCampaigns({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: emailCampaignsListEmailCampaignsInfiniteQueryKey(options)
    });
};

/**
 * Create Email Campaign
 * Create a new email campaign.
 */
export const emailCampaignsCreateEmailCampaignMutation = (options?: Partial<Options<EmailCampaignsCreateEmailCampaignData>>): UseMutationOptions<EmailCampaignsCreateEmailCampaignResponse, EmailCampaignsCreateEmailCampaignError, Options<EmailCampaignsCreateEmailCampaignData>> => {
    const mutationOptions: UseMutationOptions<EmailCampaignsCreateEmailCampaignResponse, EmailCampaignsCreateEmailCampaignError, Options<EmailCampaignsCreateEmailCampaignData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await EmailCampaigns.emailCampaignsCreateEmailCampaign({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete Email Campaign
 * Delete a campaign that never planned a send. One that has is
 * archived instead, which keeps the record of what it sent (SEND-24).
 */
export const emailCampaignsDeleteEmailCampaignMutation = (options?: Partial<Options<EmailCampaignsDeleteEmailCampaignData>>): UseMutationOptions<EmailCampaignsDeleteEmailCampaignResponse, EmailCampaignsDeleteEmailCampaignError, Options<EmailCampaignsDeleteEmailCampaignData>> => {
    const mutationOptions: UseMutationOptions<EmailCampaignsDeleteEmailCampaignResponse, EmailCampaignsDeleteEmailCampaignError, Options<EmailCampaignsDeleteEmailCampaignData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await EmailCampaigns.emailCampaignsDeleteEmailCampaign({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const emailCampaignsGetEmailCampaignQueryKey = (options: Options<EmailCampaignsGetEmailCampaignData>) => createQueryKey('emailCampaignsGetEmailCampaign', options);

/**
 * Get Email Campaign
 * Get email campaign by ID.
 */
export const emailCampaignsGetEmailCampaignOptions = (options: Options<EmailCampaignsGetEmailCampaignData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await EmailCampaigns.emailCampaignsGetEmailCampaign({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: emailCampaignsGetEmailCampaignQueryKey(options)
    });
};

/**
 * Update Email Campaign
 * Update email campaign.
 */
export const emailCampaignsUpdateEmailCampaignMutation = (options?: Partial<Options<EmailCampaignsUpdateEmailCampaignData>>): UseMutationOptions<EmailCampaignsUpdateEmailCampaignResponse, EmailCampaignsUpdateEmailCampaignError, Options<EmailCampaignsUpdateEmailCampaignData>> => {
    const mutationOptions: UseMutationOptions<EmailCampaignsUpdateEmailCampaignResponse, EmailCampaignsUpdateEmailCampaignError, Options<EmailCampaignsUpdateEmailCampaignData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await EmailCampaigns.emailCampaignsUpdateEmailCampaign({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Move Campaign
 * Move a broadcast to another state: schedule or reschedule it
 * (`send_at`), unschedule it (draft), pause, resume (sending) or cancel it.
 * Asking for the state it is already in changes nothing. A refused move is
 * a 409 that says why.
 */
export const emailCampaignsMoveCampaignMutation = (options?: Partial<Options<EmailCampaignsMoveCampaignData>>): UseMutationOptions<EmailCampaignsMoveCampaignResponse, EmailCampaignsMoveCampaignError, Options<EmailCampaignsMoveCampaignData>> => {
    const mutationOptions: UseMutationOptions<EmailCampaignsMoveCampaignResponse, EmailCampaignsMoveCampaignError, Options<EmailCampaignsMoveCampaignData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await EmailCampaigns.emailCampaignsMoveCampaign({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Cancel Rest
 * A send in stages: cancel the stages not yet sent. The ones already
 * let go carry on (or have gone). A 409 says why when there's nothing to
 * cancel.
 */
export const emailCampaignsCancelRestMutation = (options?: Partial<Options<EmailCampaignsCancelRestData>>): UseMutationOptions<EmailCampaignsCancelRestResponse, EmailCampaignsCancelRestError, Options<EmailCampaignsCancelRestData>> => {
    const mutationOptions: UseMutationOptions<EmailCampaignsCancelRestResponse, EmailCampaignsCancelRestError, Options<EmailCampaignsCancelRestData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await EmailCampaigns.emailCampaignsCancelRest({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Enroll Segment In Campaign
 * Enroll all users from a segment into a campaign.
 */
export const emailCampaignsEnrollSegmentInCampaignMutation = (options?: Partial<Options<EmailCampaignsEnrollSegmentInCampaignData>>): UseMutationOptions<EmailCampaignsEnrollSegmentInCampaignResponse, EmailCampaignsEnrollSegmentInCampaignError, Options<EmailCampaignsEnrollSegmentInCampaignData>> => {
    const mutationOptions: UseMutationOptions<EmailCampaignsEnrollSegmentInCampaignResponse, EmailCampaignsEnrollSegmentInCampaignError, Options<EmailCampaignsEnrollSegmentInCampaignData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await EmailCampaigns.emailCampaignsEnrollSegmentInCampaign({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const emailCampaignsGetCampaignEngagementQueryKey = (options: Options<EmailCampaignsGetCampaignEngagementData>) => createQueryKey('emailCampaignsGetCampaignEngagement', options);

/**
 * Get Campaign Engagement
 * Open, click, bounce and unsubscribe rates for a campaign, per step.
 */
export const emailCampaignsGetCampaignEngagementOptions = (options: Options<EmailCampaignsGetCampaignEngagementData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await EmailCampaigns.emailCampaignsGetCampaignEngagement({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: emailCampaignsGetCampaignEngagementQueryKey(options)
    });
};

export const emailCampaignsCampaignOverviewQueryKey = (options: Options<EmailCampaignsCampaignOverviewData>) => createQueryKey('emailCampaignsCampaignOverview', options);

/**
 * Campaign Overview
 * Everything the campaign page shows: who it may reach and under what
 * consent, and each step with its email, timing, results and the people
 * already enrolled who have no send planned for it.
 */
export const emailCampaignsCampaignOverviewOptions = (options: Options<EmailCampaignsCampaignOverviewData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await EmailCampaigns.emailCampaignsCampaignOverview({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: emailCampaignsCampaignOverviewQueryKey(options)
    });
};

/**
 * Discard Flow Draft
 * Throw the draft away; the live flow is untouched.
 */
export const emailFlowsDiscardFlowDraftMutation = (options?: Partial<Options<EmailFlowsDiscardFlowDraftData>>): UseMutationOptions<EmailFlowsDiscardFlowDraftResponse, EmailFlowsDiscardFlowDraftError, Options<EmailFlowsDiscardFlowDraftData>> => {
    const mutationOptions: UseMutationOptions<EmailFlowsDiscardFlowDraftResponse, EmailFlowsDiscardFlowDraftError, Options<EmailFlowsDiscardFlowDraftData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await EmailFlows.emailFlowsDiscardFlowDraft({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const emailFlowsGetFlowDraftQueryKey = (options: Options<EmailFlowsGetFlowDraftData>) => createQueryKey('emailFlowsGetFlowDraft', options);

/**
 * Get Flow Draft
 * The flow's draft, or the live flow when nobody has started one.
 */
export const emailFlowsGetFlowDraftOptions = (options: Options<EmailFlowsGetFlowDraftData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await EmailFlows.emailFlowsGetFlowDraft({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: emailFlowsGetFlowDraftQueryKey(options)
    });
};

/**
 * Save Flow Draft
 * Save the flow's draft: its steps, timing and conditions.
 *
 * Nothing is sent and nobody's enrollment or schedule changes: the live
 * flow keeps running as it is until a person publishes the draft in the
 * admin panel (/admin/email-campaigns/{campaign_id}). Read the current
 * draft first (it has the shape to send back) and check it with the review
 * and preview tools. Steps may only use templates that are published.
 */
export const emailFlowsSaveFlowDraftMutation = (options?: Partial<Options<EmailFlowsSaveFlowDraftData>>): UseMutationOptions<EmailFlowsSaveFlowDraftResponse, EmailFlowsSaveFlowDraftError, Options<EmailFlowsSaveFlowDraftData>> => {
    const mutationOptions: UseMutationOptions<EmailFlowsSaveFlowDraftResponse, EmailFlowsSaveFlowDraftError, Options<EmailFlowsSaveFlowDraftData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await EmailFlows.emailFlowsSaveFlowDraft({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const emailFlowsReviewFlowDraftQueryKey = (options: Options<EmailFlowsReviewFlowDraftData>) => createQueryKey('emailFlowsReviewFlowDraft', options);

/**
 * Review Flow Draft
 * What stops the draft going live, each with a fix, and what publishing
 * it would do to the people already in the flow.
 */
export const emailFlowsReviewFlowDraftOptions = (options: Options<EmailFlowsReviewFlowDraftData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await EmailFlows.emailFlowsReviewFlowDraft({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: emailFlowsReviewFlowDraftQueryKey(options)
    });
};

/**
 * Publish Flow Draft
 * Apply the draft. Sends to real people, so it takes the impact the
 * person was shown and refuses (409) if it has changed or the review
 * blocks.
 */
export const emailFlowsPublishFlowDraftMutation = (options?: Partial<Options<EmailFlowsPublishFlowDraftData>>): UseMutationOptions<EmailFlowsPublishFlowDraftResponse, EmailFlowsPublishFlowDraftError, Options<EmailFlowsPublishFlowDraftData>> => {
    const mutationOptions: UseMutationOptions<EmailFlowsPublishFlowDraftResponse, EmailFlowsPublishFlowDraftError, Options<EmailFlowsPublishFlowDraftData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await EmailFlows.emailFlowsPublishFlowDraft({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Preview Flow Draft
 * When each email in the draft would reach this member, in their time,
 * and which would be skipped and why, as of now. Sends and saves nothing;
 * `user_id` defaults to you.
 */
export const emailFlowsPreviewFlowDraftMutation = (options?: Partial<Options<EmailFlowsPreviewFlowDraftData>>): UseMutationOptions<EmailFlowsPreviewFlowDraftResponse, EmailFlowsPreviewFlowDraftError, Options<EmailFlowsPreviewFlowDraftData>> => {
    const mutationOptions: UseMutationOptions<EmailFlowsPreviewFlowDraftResponse, EmailFlowsPreviewFlowDraftError, Options<EmailFlowsPreviewFlowDraftData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await EmailFlows.emailFlowsPreviewFlowDraft({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Test Flow Draft
 * Send every email in the draft to yourself, "[TEST]" first, rendered as
 * the member you pick. Only to your own address; never counted as a send.
 */
export const emailFlowsTestFlowDraftMutation = (options?: Partial<Options<EmailFlowsTestFlowDraftData>>): UseMutationOptions<EmailFlowsTestFlowDraftResponse, EmailFlowsTestFlowDraftError, Options<EmailFlowsTestFlowDraftData>> => {
    const mutationOptions: UseMutationOptions<EmailFlowsTestFlowDraftResponse, EmailFlowsTestFlowDraftError, Options<EmailFlowsTestFlowDraftData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await EmailFlows.emailFlowsTestFlowDraft({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Archive Flow
 * Switch the flow off for good: its planned sends are cancelled and
 * everyone in it leaves; what it sent stays. Can't be undone.
 */
export const emailFlowsArchiveFlowMutation = (options?: Partial<Options<EmailFlowsArchiveFlowData>>): UseMutationOptions<EmailFlowsArchiveFlowResponse, EmailFlowsArchiveFlowError, Options<EmailFlowsArchiveFlowData>> => {
    const mutationOptions: UseMutationOptions<EmailFlowsArchiveFlowResponse, EmailFlowsArchiveFlowError, Options<EmailFlowsArchiveFlowData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await EmailFlows.emailFlowsArchiveFlow({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const emailFlowsFlowPreviewPeopleQueryKey = (options: Options<EmailFlowsFlowPreviewPeopleData>) => createQueryKey('emailFlowsFlowPreviewPeople', options);

/**
 * Flow Preview People
 * Members to preview the flow as, picked by the state its conditions
 * read (days since joining, opening the app, a subscription). Nothing
 * personal: an ID, when they joined, and that state.
 */
export const emailFlowsFlowPreviewPeopleOptions = (options: Options<EmailFlowsFlowPreviewPeopleData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await EmailFlows.emailFlowsFlowPreviewPeople({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: emailFlowsFlowPreviewPeopleQueryKey(options)
    });
};

/**
 * Duplicate Flow
 * A copy of the flow, off, with nobody in it and its emails as a draft
 * to review and publish; named "… (copy)", with a new slug.
 */
export const emailFlowsDuplicateFlowMutation = (options?: Partial<Options<EmailFlowsDuplicateFlowData>>): UseMutationOptions<EmailFlowsDuplicateFlowResponse, EmailFlowsDuplicateFlowError, Options<EmailFlowsDuplicateFlowData>> => {
    const mutationOptions: UseMutationOptions<EmailFlowsDuplicateFlowResponse, EmailFlowsDuplicateFlowError, Options<EmailFlowsDuplicateFlowData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await EmailFlows.emailFlowsDuplicateFlow({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const emailCampaignStepsListCampaignStepsQueryKey = (options: Options<EmailCampaignStepsListCampaignStepsData>) => createQueryKey('emailCampaignStepsListCampaignSteps', options);

/**
 * List Campaign Steps
 * List all steps for a campaign (admin only).
 */
export const emailCampaignStepsListCampaignStepsOptions = (options: Options<EmailCampaignStepsListCampaignStepsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await EmailCampaignSteps.emailCampaignStepsListCampaignSteps({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: emailCampaignStepsListCampaignStepsQueryKey(options)
    });
};

/**
 * Create Campaign Step
 * Create a new campaign step (admin only).
 */
export const emailCampaignStepsCreateCampaignStepMutation = (options?: Partial<Options<EmailCampaignStepsCreateCampaignStepData>>): UseMutationOptions<EmailCampaignStepsCreateCampaignStepResponse, EmailCampaignStepsCreateCampaignStepError, Options<EmailCampaignStepsCreateCampaignStepData>> => {
    const mutationOptions: UseMutationOptions<EmailCampaignStepsCreateCampaignStepResponse, EmailCampaignStepsCreateCampaignStepError, Options<EmailCampaignStepsCreateCampaignStepData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await EmailCampaignSteps.emailCampaignStepsCreateCampaignStep({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete Campaign Step
 * Delete a campaign step (admin only).
 */
export const emailCampaignStepsDeleteCampaignStepMutation = (options?: Partial<Options<EmailCampaignStepsDeleteCampaignStepData>>): UseMutationOptions<EmailCampaignStepsDeleteCampaignStepResponse, EmailCampaignStepsDeleteCampaignStepError, Options<EmailCampaignStepsDeleteCampaignStepData>> => {
    const mutationOptions: UseMutationOptions<EmailCampaignStepsDeleteCampaignStepResponse, EmailCampaignStepsDeleteCampaignStepError, Options<EmailCampaignStepsDeleteCampaignStepData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await EmailCampaignSteps.emailCampaignStepsDeleteCampaignStep({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const emailCampaignStepsGetCampaignStepQueryKey = (options: Options<EmailCampaignStepsGetCampaignStepData>) => createQueryKey('emailCampaignStepsGetCampaignStep', options);

/**
 * Get Campaign Step
 * Get a campaign step by ID (admin only).
 */
export const emailCampaignStepsGetCampaignStepOptions = (options: Options<EmailCampaignStepsGetCampaignStepData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await EmailCampaignSteps.emailCampaignStepsGetCampaignStep({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: emailCampaignStepsGetCampaignStepQueryKey(options)
    });
};

/**
 * Update Campaign Step
 * Update a campaign step (admin only).
 */
export const emailCampaignStepsUpdateCampaignStepMutation = (options?: Partial<Options<EmailCampaignStepsUpdateCampaignStepData>>): UseMutationOptions<EmailCampaignStepsUpdateCampaignStepResponse, EmailCampaignStepsUpdateCampaignStepError, Options<EmailCampaignStepsUpdateCampaignStepData>> => {
    const mutationOptions: UseMutationOptions<EmailCampaignStepsUpdateCampaignStepResponse, EmailCampaignStepsUpdateCampaignStepError, Options<EmailCampaignStepsUpdateCampaignStepData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await EmailCampaignSteps.emailCampaignStepsUpdateCampaignStep({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Reorder Campaign Steps
 * Reorder campaign steps (admin only).
 */
export const emailCampaignStepsReorderCampaignStepsMutation = (options?: Partial<Options<EmailCampaignStepsReorderCampaignStepsData>>): UseMutationOptions<EmailCampaignStepsReorderCampaignStepsResponse, EmailCampaignStepsReorderCampaignStepsError, Options<EmailCampaignStepsReorderCampaignStepsData>> => {
    const mutationOptions: UseMutationOptions<EmailCampaignStepsReorderCampaignStepsResponse, EmailCampaignStepsReorderCampaignStepsError, Options<EmailCampaignStepsReorderCampaignStepsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await EmailCampaignSteps.emailCampaignStepsReorderCampaignSteps({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const emailCampaignStepsPlanStepBackfillQueryKey = (options: Options<EmailCampaignStepsPlanStepBackfillData>) => createQueryKey('emailCampaignStepsPlanStepBackfill', options);

/**
 * Plan Step Backfill
 * How many people already enrolled have no send planned for this step:
 * still due (on time) and overdue (would go from now).
 */
export const emailCampaignStepsPlanStepBackfillOptions = (options: Options<EmailCampaignStepsPlanStepBackfillData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await EmailCampaignSteps.emailCampaignStepsPlanStepBackfill({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: emailCampaignStepsPlanStepBackfillQueryKey(options)
    });
};

/**
 * Apply Step Backfill
 * Schedule this step for people already enrolled. Sends to real members,
 * so it takes the count the plan showed and refuses if it has changed.
 */
export const emailCampaignStepsApplyStepBackfillMutation = (options?: Partial<Options<EmailCampaignStepsApplyStepBackfillData>>): UseMutationOptions<EmailCampaignStepsApplyStepBackfillResponse, EmailCampaignStepsApplyStepBackfillError, Options<EmailCampaignStepsApplyStepBackfillData>> => {
    const mutationOptions: UseMutationOptions<EmailCampaignStepsApplyStepBackfillResponse, EmailCampaignStepsApplyStepBackfillError, Options<EmailCampaignStepsApplyStepBackfillData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await EmailCampaignSteps.emailCampaignStepsApplyStepBackfill({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Preview Email
 * Preview rendered email for a user (admin only).
 */
export const emailSendsPreviewEmailMutation = (options?: Partial<Options<EmailSendsPreviewEmailData>>): UseMutationOptions<EmailSendsPreviewEmailResponse, EmailSendsPreviewEmailError, Options<EmailSendsPreviewEmailData>> => {
    const mutationOptions: UseMutationOptions<EmailSendsPreviewEmailResponse, EmailSendsPreviewEmailError, Options<EmailSendsPreviewEmailData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await EmailSends.emailSendsPreviewEmail({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Enqueue Email Send
 * Enqueue one-off email send (admin only). Who is left out is named
 * only for staff who may see personal details.
 */
export const emailSendsEnqueueEmailSendMutation = (options?: Partial<Options<EmailSendsEnqueueEmailSendData>>): UseMutationOptions<EmailSendsEnqueueEmailSendResponse, EmailSendsEnqueueEmailSendError, Options<EmailSendsEnqueueEmailSendData>> => {
    const mutationOptions: UseMutationOptions<EmailSendsEnqueueEmailSendResponse, EmailSendsEnqueueEmailSendError, Options<EmailSendsEnqueueEmailSendData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await EmailSends.emailSendsEnqueueEmailSend({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Enqueue Email Send From Csv
 * Enqueue one-off email send from CSV upload (admin only).
 */
export const emailSendsEnqueueEmailSendFromCsvMutation = (options?: Partial<Options<EmailSendsEnqueueEmailSendFromCsvData>>): UseMutationOptions<EmailSendsEnqueueEmailSendFromCsvResponse, EmailSendsEnqueueEmailSendFromCsvError, Options<EmailSendsEnqueueEmailSendFromCsvData>> => {
    const mutationOptions: UseMutationOptions<EmailSendsEnqueueEmailSendFromCsvResponse, EmailSendsEnqueueEmailSendFromCsvError, Options<EmailSendsEnqueueEmailSendFromCsvData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await EmailSends.emailSendsEnqueueEmailSendFromCsv({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const emailControlsGetMailControlsQueryKey = (options?: Options<EmailControlsGetMailControlsData>) => createQueryKey('emailControlsGetMailControls', options);

/**
 * Get Mail Controls
 * Whether marketing is paused, and by whom, when and why.
 */
export const emailControlsGetMailControlsOptions = (options?: Options<EmailControlsGetMailControlsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await EmailControls.emailControlsGetMailControls({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: emailControlsGetMailControlsQueryKey(options)
    });
};

/**
 * Pause Marketing
 * Hold every marketing send now. The brake is easy to pull: anyone who
 * can edit email can pause it.
 */
export const emailControlsPauseMarketingMutation = (options?: Partial<Options<EmailControlsPauseMarketingData>>): UseMutationOptions<EmailControlsPauseMarketingResponse, EmailControlsPauseMarketingError, Options<EmailControlsPauseMarketingData>> => {
    const mutationOptions: UseMutationOptions<EmailControlsPauseMarketingResponse, EmailControlsPauseMarketingError, Options<EmailControlsPauseMarketingData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await EmailControls.emailControlsPauseMarketing({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Resume Marketing
 * Let marketing go again: held sends go on the next tick. Releasing it
 * sends mail, so it needs the send permission. Refused (409, with the
 * reason) while a stream's rate is over the block level (SEND-21).
 */
export const emailControlsResumeMarketingMutation = (options?: Partial<Options<EmailControlsResumeMarketingData>>): UseMutationOptions<EmailControlsResumeMarketingResponse, DefaultError, Options<EmailControlsResumeMarketingData>> => {
    const mutationOptions: UseMutationOptions<EmailControlsResumeMarketingResponse, DefaultError, Options<EmailControlsResumeMarketingData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await EmailControls.emailControlsResumeMarketing({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const emailExecutionsListEmailExecutionsQueryKey = (options?: Options<EmailExecutionsListEmailExecutionsData>) => createQueryKey('emailExecutionsListEmailExecutions', options);

/**
 * List Email Executions
 * List email executions with filtering and pagination (admin only).
 */
export const emailExecutionsListEmailExecutionsOptions = (options?: Options<EmailExecutionsListEmailExecutionsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await EmailExecutions.emailExecutionsListEmailExecutions({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: emailExecutionsListEmailExecutionsQueryKey(options)
    });
};

export const emailExecutionsListEmailExecutionsInfiniteQueryKey = (options?: Options<EmailExecutionsListEmailExecutionsData>): QueryKey<Options<EmailExecutionsListEmailExecutionsData>> => createQueryKey('emailExecutionsListEmailExecutions', options, true);

/**
 * List Email Executions
 * List email executions with filtering and pagination (admin only).
 */
export const emailExecutionsListEmailExecutionsInfiniteOptions = (options?: Options<EmailExecutionsListEmailExecutionsData>) => {
    return infiniteQueryOptions<EmailExecutionsListEmailExecutionsResponse, EmailExecutionsListEmailExecutionsError, InfiniteData<EmailExecutionsListEmailExecutionsResponse>, QueryKey<Options<EmailExecutionsListEmailExecutionsData>>, number | Pick<QueryKey<Options<EmailExecutionsListEmailExecutionsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<EmailExecutionsListEmailExecutionsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await EmailExecutions.emailExecutionsListEmailExecutions({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: emailExecutionsListEmailExecutionsInfiniteQueryKey(options)
    });
};

export const emailExecutionsGetEmailExecutionQueryKey = (options: Options<EmailExecutionsGetEmailExecutionData>) => createQueryKey('emailExecutionsGetEmailExecution', options);

/**
 * Get Email Execution
 * Get email execution by ID (admin only).
 */
export const emailExecutionsGetEmailExecutionOptions = (options: Options<EmailExecutionsGetEmailExecutionData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await EmailExecutions.emailExecutionsGetEmailExecution({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: emailExecutionsGetEmailExecutionQueryKey(options)
    });
};

export const emailExecutionsGetExecutionStatsQueryKey = (options?: Options<EmailExecutionsGetExecutionStatsData>) => createQueryKey('emailExecutionsGetExecutionStats', options);

/**
 * Get Execution Stats
 * Get execution statistics (admin only).
 */
export const emailExecutionsGetExecutionStatsOptions = (options?: Options<EmailExecutionsGetExecutionStatsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await EmailExecutions.emailExecutionsGetExecutionStats({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: emailExecutionsGetExecutionStatsQueryKey(options)
    });
};

/**
 * Retry Email Execution
 * Retry a failed email execution (admin only). An uncertain one (it may
 * have gone out) only with `confirm_may_duplicate`.
 */
export const emailExecutionsRetryEmailExecutionMutation = (options?: Partial<Options<EmailExecutionsRetryEmailExecutionData>>): UseMutationOptions<EmailExecutionsRetryEmailExecutionResponse, EmailExecutionsRetryEmailExecutionError, Options<EmailExecutionsRetryEmailExecutionData>> => {
    const mutationOptions: UseMutationOptions<EmailExecutionsRetryEmailExecutionResponse, EmailExecutionsRetryEmailExecutionError, Options<EmailExecutionsRetryEmailExecutionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await EmailExecutions.emailExecutionsRetryEmailExecution({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Cancel Email Execution
 * Cancel a pending email execution (admin only).
 */
export const emailExecutionsCancelEmailExecutionMutation = (options?: Partial<Options<EmailExecutionsCancelEmailExecutionData>>): UseMutationOptions<EmailExecutionsCancelEmailExecutionResponse, EmailExecutionsCancelEmailExecutionError, Options<EmailExecutionsCancelEmailExecutionData>> => {
    const mutationOptions: UseMutationOptions<EmailExecutionsCancelEmailExecutionResponse, EmailExecutionsCancelEmailExecutionError, Options<EmailExecutionsCancelEmailExecutionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await EmailExecutions.emailExecutionsCancelEmailExecution({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Bulk Retry Email Executions
 * Bulk retry failed email executions (admin only). Only `failed`: an
 * uncertain send may have gone out, so it is retried one at a time, by a
 * person who has been told so.
 */
export const emailExecutionsBulkRetryEmailExecutionsMutation = (options?: Partial<Options<EmailExecutionsBulkRetryEmailExecutionsData>>): UseMutationOptions<EmailExecutionsBulkRetryEmailExecutionsResponse, EmailExecutionsBulkRetryEmailExecutionsError, Options<EmailExecutionsBulkRetryEmailExecutionsData>> => {
    const mutationOptions: UseMutationOptions<EmailExecutionsBulkRetryEmailExecutionsResponse, EmailExecutionsBulkRetryEmailExecutionsError, Options<EmailExecutionsBulkRetryEmailExecutionsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await EmailExecutions.emailExecutionsBulkRetryEmailExecutions({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Bulk Cancel Email Executions
 * Bulk cancel pending email executions (admin only).
 */
export const emailExecutionsBulkCancelEmailExecutionsMutation = (options?: Partial<Options<EmailExecutionsBulkCancelEmailExecutionsData>>): UseMutationOptions<EmailExecutionsBulkCancelEmailExecutionsResponse, EmailExecutionsBulkCancelEmailExecutionsError, Options<EmailExecutionsBulkCancelEmailExecutionsData>> => {
    const mutationOptions: UseMutationOptions<EmailExecutionsBulkCancelEmailExecutionsResponse, EmailExecutionsBulkCancelEmailExecutionsError, Options<EmailExecutionsBulkCancelEmailExecutionsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await EmailExecutions.emailExecutionsBulkCancelEmailExecutions({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const emailExecutionsGetSendRunEngagementQueryKey = (options: Options<EmailExecutionsGetSendRunEngagementData>) => createQueryKey('emailExecutionsGetSendRunEngagement', options);

/**
 * Get Send Run Engagement
 * Open/click/bounce rates for one broadcast (a single send run), and
 * what its readers said would have helped.
 */
export const emailExecutionsGetSendRunEngagementOptions = (options: Options<EmailExecutionsGetSendRunEngagementData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await EmailExecutions.emailExecutionsGetSendRunEngagement({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: emailExecutionsGetSendRunEngagementQueryKey(options)
    });
};

export const emailComebackCampaignsCameBackQueryKey = (options?: Options<EmailComebackCampaignsCameBackData>) => createQueryKey('emailComebackCampaignsCameBack', options);

/**
 * Campaigns Came Back
 * Every campaign with sends in the range, one row each.
 */
export const emailComebackCampaignsCameBackOptions = (options?: Options<EmailComebackCampaignsCameBackData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await EmailComeback.emailComebackCampaignsCameBack({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: emailComebackCampaignsCameBackQueryKey(options)
    });
};

export const emailComebackCampaignCameBackQueryKey = (options: Options<EmailComebackCampaignCameBackData>) => createQueryKey('emailComebackCampaignCameBack', options);

/**
 * Campaign Came Back
 * One campaign, per step.
 */
export const emailComebackCampaignCameBackOptions = (options: Options<EmailComebackCampaignCameBackData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await EmailComeback.emailComebackCampaignCameBack({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: emailComebackCampaignCameBackQueryKey(options)
    });
};

export const emailComebackSendRunCameBackQueryKey = (options: Options<EmailComebackSendRunCameBackData>) => createQueryKey('emailComebackSendRunCameBack', options);

/**
 * Send Run Came Back
 * One one-off send.
 */
export const emailComebackSendRunCameBackOptions = (options: Options<EmailComebackSendRunCameBackData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await EmailComeback.emailComebackSendRunCameBack({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: emailComebackSendRunCameBackQueryKey(options)
    });
};

export const emailComebackTemplateCameBackQueryKey = (options: Options<EmailComebackTemplateCameBackData>) => createQueryKey('emailComebackTemplateCameBack', options);

/**
 * Template Came Back
 * Each version of a template, newest first.
 */
export const emailComebackTemplateCameBackOptions = (options: Options<EmailComebackTemplateCameBackData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await EmailComeback.emailComebackTemplateCameBack({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: emailComebackTemplateCameBackQueryKey(options)
    });
};

export const newsletterListIssuesQueryKey = (options?: Options<NewsletterListIssuesData>) => createQueryKey('newsletterListIssues', options);

/**
 * List Issues
 * Every newsletter issue, drafted, sent and imported, with how each did.
 */
export const newsletterListIssuesOptions = (options?: Options<NewsletterListIssuesData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await Newsletter.newsletterListIssues({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: newsletterListIssuesQueryKey(options)
    });
};

/**
 * Create Issue
 * A new issue, as a draft from the starter (or from the words of issue
 * `copy_of`), for the studio to open.
 */
export const newsletterCreateIssueMutation = (options?: Partial<Options<NewsletterCreateIssueData>>): UseMutationOptions<NewsletterCreateIssueResponse, NewsletterCreateIssueError, Options<NewsletterCreateIssueData>> => {
    const mutationOptions: UseMutationOptions<NewsletterCreateIssueResponse, NewsletterCreateIssueError, Options<NewsletterCreateIssueData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await Newsletter.newsletterCreateIssue({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete Drafts
 * Bulk-delete drafts that were never published and never sent. Refuses
 * the whole request if any one was published or is a step in any campaign,
 * so a sent edition (and its results) can't go by accident.
 */
export const newsletterDeleteDraftsMutation = (options?: Partial<Options<NewsletterDeleteDraftsData>>): UseMutationOptions<NewsletterDeleteDraftsResponse, NewsletterDeleteDraftsError, Options<NewsletterDeleteDraftsData>> => {
    const mutationOptions: UseMutationOptions<NewsletterDeleteDraftsResponse, NewsletterDeleteDraftsError, Options<NewsletterDeleteDraftsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await Newsletter.newsletterDeleteDrafts({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const newsletterListHealthQueryKey = (options?: Options<NewsletterListHealthData>) => createQueryKey('newsletterListHealth', options);

/**
 * List Health
 * The newsletter lists: size and growth week by week. Counts only.
 */
export const newsletterListHealthOptions = (options?: Options<NewsletterListHealthData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await Newsletter.newsletterListHealth({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: newsletterListHealthQueryKey(options)
    });
};

export const emailPeopleListPeopleQueryKey = (options?: Options<EmailPeopleListPeopleData>) => createQueryKey('emailPeopleListPeople', options);

/**
 * List People
 * Everyone we hold an address for, newest first. Each filter is a
 * comma-separated list of values to keep. Searching by address, and the
 * address itself, need personal details on. `list_name` or `segment_id`:
 * only who a one-off send to it would target, as the send resolves them,
 * with whether each would get it (`will_get`).
 */
export const emailPeopleListPeopleOptions = (options?: Options<EmailPeopleListPeopleData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await EmailPeople.emailPeopleListPeople({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: emailPeopleListPeopleQueryKey(options)
    });
};

export const emailPeopleListPeopleInfiniteQueryKey = (options?: Options<EmailPeopleListPeopleData>): QueryKey<Options<EmailPeopleListPeopleData>> => createQueryKey('emailPeopleListPeople', options, true);

/**
 * List People
 * Everyone we hold an address for, newest first. Each filter is a
 * comma-separated list of values to keep. Searching by address, and the
 * address itself, need personal details on. `list_name` or `segment_id`:
 * only who a one-off send to it would target, as the send resolves them,
 * with whether each would get it (`will_get`).
 */
export const emailPeopleListPeopleInfiniteOptions = (options?: Options<EmailPeopleListPeopleData>) => {
    return infiniteQueryOptions<EmailPeopleListPeopleResponse, EmailPeopleListPeopleError, InfiniteData<EmailPeopleListPeopleResponse>, QueryKey<Options<EmailPeopleListPeopleData>>, number | Pick<QueryKey<Options<EmailPeopleListPeopleData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<EmailPeopleListPeopleData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await EmailPeople.emailPeopleListPeople({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: emailPeopleListPeopleInfiniteQueryKey(options)
    });
};

export const emailPeopleFindPersonQueryKey = (options: Options<EmailPeopleFindPersonData>) => createQueryKey('emailPeopleFindPerson', options);

/**
 * Find Person
 * A member when an account holds the address, else the inbox.
 */
export const emailPeopleFindPersonOptions = (options: Options<EmailPeopleFindPersonData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await EmailPeople.emailPeopleFindPerson({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: emailPeopleFindPersonQueryKey(options)
    });
};

export const emailPeopleGetPersonQueryKey = (options: Options<EmailPeopleGetPersonData>) => createQueryKey('emailPeopleGetPerson', options);

/**
 * Get Person
 */
export const emailPeopleGetPersonOptions = (options: Options<EmailPeopleGetPersonData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await EmailPeople.emailPeopleGetPerson({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: emailPeopleGetPersonQueryKey(options)
    });
};

/**
 * Withdraw Person
 * They asked support to stop one list: a `withdrawn` event through
 * support, the way the preferences page records one. A list that isn't
 * live is left alone.
 */
export const emailPeopleWithdrawPersonMutation = (options?: Partial<Options<EmailPeopleWithdrawPersonData>>): UseMutationOptions<EmailPeopleWithdrawPersonResponse, EmailPeopleWithdrawPersonError, Options<EmailPeopleWithdrawPersonData>> => {
    const mutationOptions: UseMutationOptions<EmailPeopleWithdrawPersonResponse, EmailPeopleWithdrawPersonError, Options<EmailPeopleWithdrawPersonData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await EmailPeople.emailPeopleWithdrawPerson({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Erase Person
 * Erase an inbox with no account (DATA-02, `contact.erase_contact`):
 * dry by default. The address stays, every list withdrawn, as the record
 * of their objection. Needs PII access: it acts on a person's data.
 */
export const emailPeopleErasePersonMutation = (options?: Partial<Options<EmailPeopleErasePersonData>>): UseMutationOptions<EmailPeopleErasePersonResponse, EmailPeopleErasePersonError, Options<EmailPeopleErasePersonData>> => {
    const mutationOptions: UseMutationOptions<EmailPeopleErasePersonResponse, EmailPeopleErasePersonError, Options<EmailPeopleErasePersonData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await EmailPeople.emailPeopleErasePerson({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const emailEnrollmentsListEmailEnrollmentsQueryKey = (options?: Options<EmailEnrollmentsListEmailEnrollmentsData>) => createQueryKey('emailEnrollmentsListEmailEnrollments', options);

/**
 * List Email Enrollments
 * List email enrollments with filtering and pagination (admin only).
 */
export const emailEnrollmentsListEmailEnrollmentsOptions = (options?: Options<EmailEnrollmentsListEmailEnrollmentsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await EmailEnrollments.emailEnrollmentsListEmailEnrollments({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: emailEnrollmentsListEmailEnrollmentsQueryKey(options)
    });
};

export const emailEnrollmentsListEmailEnrollmentsInfiniteQueryKey = (options?: Options<EmailEnrollmentsListEmailEnrollmentsData>): QueryKey<Options<EmailEnrollmentsListEmailEnrollmentsData>> => createQueryKey('emailEnrollmentsListEmailEnrollments', options, true);

/**
 * List Email Enrollments
 * List email enrollments with filtering and pagination (admin only).
 */
export const emailEnrollmentsListEmailEnrollmentsInfiniteOptions = (options?: Options<EmailEnrollmentsListEmailEnrollmentsData>) => {
    return infiniteQueryOptions<EmailEnrollmentsListEmailEnrollmentsResponse, EmailEnrollmentsListEmailEnrollmentsError, InfiniteData<EmailEnrollmentsListEmailEnrollmentsResponse>, QueryKey<Options<EmailEnrollmentsListEmailEnrollmentsData>>, number | Pick<QueryKey<Options<EmailEnrollmentsListEmailEnrollmentsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<EmailEnrollmentsListEmailEnrollmentsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await EmailEnrollments.emailEnrollmentsListEmailEnrollments({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: emailEnrollmentsListEmailEnrollmentsInfiniteQueryKey(options)
    });
};

export const emailEnrollmentsGetEmailEnrollmentQueryKey = (options: Options<EmailEnrollmentsGetEmailEnrollmentData>) => createQueryKey('emailEnrollmentsGetEmailEnrollment', options);

/**
 * Get Email Enrollment
 * Get email enrollment by ID (admin only).
 */
export const emailEnrollmentsGetEmailEnrollmentOptions = (options: Options<EmailEnrollmentsGetEmailEnrollmentData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await EmailEnrollments.emailEnrollmentsGetEmailEnrollment({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: emailEnrollmentsGetEmailEnrollmentQueryKey(options)
    });
};

/**
 * Pause Email Enrollment
 * Pause an email enrollment (admin only).
 */
export const emailEnrollmentsPauseEmailEnrollmentMutation = (options?: Partial<Options<EmailEnrollmentsPauseEmailEnrollmentData>>): UseMutationOptions<EmailEnrollmentsPauseEmailEnrollmentResponse, EmailEnrollmentsPauseEmailEnrollmentError, Options<EmailEnrollmentsPauseEmailEnrollmentData>> => {
    const mutationOptions: UseMutationOptions<EmailEnrollmentsPauseEmailEnrollmentResponse, EmailEnrollmentsPauseEmailEnrollmentError, Options<EmailEnrollmentsPauseEmailEnrollmentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await EmailEnrollments.emailEnrollmentsPauseEmailEnrollment({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Resume Email Enrollment
 * Resume a paused email enrollment (admin only).
 */
export const emailEnrollmentsResumeEmailEnrollmentMutation = (options?: Partial<Options<EmailEnrollmentsResumeEmailEnrollmentData>>): UseMutationOptions<EmailEnrollmentsResumeEmailEnrollmentResponse, EmailEnrollmentsResumeEmailEnrollmentError, Options<EmailEnrollmentsResumeEmailEnrollmentData>> => {
    const mutationOptions: UseMutationOptions<EmailEnrollmentsResumeEmailEnrollmentResponse, EmailEnrollmentsResumeEmailEnrollmentError, Options<EmailEnrollmentsResumeEmailEnrollmentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await EmailEnrollments.emailEnrollmentsResumeEmailEnrollment({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Cancel Email Enrollment
 * Cancel an email enrollment (admin only).
 */
export const emailEnrollmentsCancelEmailEnrollmentMutation = (options?: Partial<Options<EmailEnrollmentsCancelEmailEnrollmentData>>): UseMutationOptions<EmailEnrollmentsCancelEmailEnrollmentResponse, EmailEnrollmentsCancelEmailEnrollmentError, Options<EmailEnrollmentsCancelEmailEnrollmentData>> => {
    const mutationOptions: UseMutationOptions<EmailEnrollmentsCancelEmailEnrollmentResponse, EmailEnrollmentsCancelEmailEnrollmentError, Options<EmailEnrollmentsCancelEmailEnrollmentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await EmailEnrollments.emailEnrollmentsCancelEmailEnrollment({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const mailMediaListMailImagesQueryKey = (options?: Options<MailMediaListMailImagesData>) => createQueryKey('mailMediaListMailImages', options);

/**
 * List Mail Images
 * The most recent images, newest first, to reuse in another email.
 */
export const mailMediaListMailImagesOptions = (options?: Options<MailMediaListMailImagesData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await MailMedia.mailMediaListMailImages({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: mailMediaListMailImagesQueryKey(options)
    });
};

/**
 * Upload Mail Image
 */
export const mailMediaUploadMailImageMutation = (options?: Partial<Options<MailMediaUploadMailImageData>>): UseMutationOptions<MailMediaUploadMailImageResponse, MailMediaUploadMailImageError, Options<MailMediaUploadMailImageData>> => {
    const mutationOptions: UseMutationOptions<MailMediaUploadMailImageResponse, MailMediaUploadMailImageError, Options<MailMediaUploadMailImageData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await MailMedia.mailMediaUploadMailImage({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update Mail Image
 * The words for an image, kept with it so its next use starts with them.
 */
export const mailMediaUpdateMailImageMutation = (options?: Partial<Options<MailMediaUpdateMailImageData>>): UseMutationOptions<MailMediaUpdateMailImageResponse, MailMediaUpdateMailImageError, Options<MailMediaUpdateMailImageData>> => {
    const mutationOptions: UseMutationOptions<MailMediaUpdateMailImageResponse, MailMediaUpdateMailImageError, Options<MailMediaUpdateMailImageData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await MailMedia.mailMediaUpdateMailImage({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Enroll In Campaign
 * Enroll the current user in a campaign.
 *
 * This endpoint is idempotent - if the user is already enrolled,
 * it will return the existing enrollment without creating a duplicate.
 *
 * Args:
 * campaign_id: UUID of the campaign to enroll in
 * session: Database session
 * current_user: Current authenticated user
 *
 * Returns:
 * Enrollment details including enrollment_id, campaign_id, user_id,
 * status, already_enrolled flag, and dt_enrolled timestamp
 *
 * Raises:
 * 404: Campaign not found, inactive, or not one a member may join
 * 400: User has no email
 */
export const campaignsEnrollInCampaignMutation = (options?: Partial<Options<CampaignsEnrollInCampaignData>>): UseMutationOptions<CampaignsEnrollInCampaignResponse, CampaignsEnrollInCampaignError, Options<CampaignsEnrollInCampaignData>> => {
    const mutationOptions: UseMutationOptions<CampaignsEnrollInCampaignResponse, CampaignsEnrollInCampaignError, Options<CampaignsEnrollInCampaignData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await Campaigns.campaignsEnrollInCampaign({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Handle Postmark Webhook
 * Record a Postmark engagement event.
 *
 * Postmark treats any non-2xx as a failure and retries, so anything we
 * simply don't care about (unhandled record types, unparseable bodies,
 * duplicates) returns 200 with an explanatory status. A real failure to
 * store answers 500, so Postmark retries it: a lost bounce or complaint is
 * somebody we keep emailing who asked us to stop.
 */
export const postmarkWebhookHandlePostmarkWebhookMutation = (options?: Partial<Options<PostmarkWebhookHandlePostmarkWebhookData>>): UseMutationOptions<PostmarkWebhookHandlePostmarkWebhookResponse, DefaultError, Options<PostmarkWebhookHandlePostmarkWebhookData>> => {
    const mutationOptions: UseMutationOptions<PostmarkWebhookHandlePostmarkWebhookResponse, DefaultError, Options<PostmarkWebhookHandlePostmarkWebhookData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await PostmarkWebhook.postmarkWebhookHandlePostmarkWebhook({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Handle Postmark Webhook
 * Record a Postmark engagement event.
 *
 * Postmark treats any non-2xx as a failure and retries, so anything we
 * simply don't care about (unhandled record types, unparseable bodies,
 * duplicates) returns 200 with an explanatory status. A real failure to
 * store answers 500, so Postmark retries it: a lost bounce or complaint is
 * somebody we keep emailing who asked us to stop.
 */
export const postmarkWebhookHandlePostmarkWebhook2Mutation = (options?: Partial<Options<PostmarkWebhookHandlePostmarkWebhook2Data>>): UseMutationOptions<PostmarkWebhookHandlePostmarkWebhook2Response, DefaultError, Options<PostmarkWebhookHandlePostmarkWebhook2Data>> => {
    const mutationOptions: UseMutationOptions<PostmarkWebhookHandlePostmarkWebhook2Response, DefaultError, Options<PostmarkWebhookHandlePostmarkWebhook2Data>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await PostmarkWebhook.postmarkWebhookHandlePostmarkWebhook2({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Handle Postmark Inbound
 * An email to the List-Unsubscribe mailto, from Postmark's inbound
 * webhook (UNSUB-11). The subject carries the purpose and the signed
 * unsubscribe token from the email it came from, so it withdraws exactly
 * what the one-click link would; who it is from proves nothing and is not
 * read. Anything else (a reply, a bad token) is acknowledged and ignored,
 * so Postmark doesn't retry it; a failure to record answers 500, so it
 * does.
 */
export const postmarkWebhookHandlePostmarkInboundMutation = (options?: Partial<Options<PostmarkWebhookHandlePostmarkInboundData>>): UseMutationOptions<PostmarkWebhookHandlePostmarkInboundResponse, DefaultError, Options<PostmarkWebhookHandlePostmarkInboundData>> => {
    const mutationOptions: UseMutationOptions<PostmarkWebhookHandlePostmarkInboundResponse, DefaultError, Options<PostmarkWebhookHandlePostmarkInboundData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await PostmarkWebhook.postmarkWebhookHandlePostmarkInbound({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const userSegmentsListUserSegmentsQueryKey = (options?: Options<UserSegmentsListUserSegmentsData>) => createQueryKey('userSegmentsListUserSegments', options);

/**
 * List User Segments
 * List user segments (admin only).
 *
 * Narrowed for a dogfood-only caller, because a row is not the harmless
 * summary it looks like: `UserSegmentPublic` carries `segment_config`, which
 * for a sql segment is the stored query, and `member_count`. Without this,
 * `panel:segments:dogfood:read` reads every segment's definition and how many
 * people each reaches, and the narrowing on `/count` and `/sample` is a gate
 * beside an open door.
 *
 * The filter goes into the query, not over the page, so `total` and `pages`
 * count the rows this caller may see. A holder of `panel:segments:read` takes
 * no filter at all and gets exactly what it always got.
 */
export const userSegmentsListUserSegmentsOptions = (options?: Options<UserSegmentsListUserSegmentsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await UserSegments.userSegmentsListUserSegments({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: userSegmentsListUserSegmentsQueryKey(options)
    });
};

export const userSegmentsListUserSegmentsInfiniteQueryKey = (options?: Options<UserSegmentsListUserSegmentsData>): QueryKey<Options<UserSegmentsListUserSegmentsData>> => createQueryKey('userSegmentsListUserSegments', options, true);

/**
 * List User Segments
 * List user segments (admin only).
 *
 * Narrowed for a dogfood-only caller, because a row is not the harmless
 * summary it looks like: `UserSegmentPublic` carries `segment_config`, which
 * for a sql segment is the stored query, and `member_count`. Without this,
 * `panel:segments:dogfood:read` reads every segment's definition and how many
 * people each reaches, and the narrowing on `/count` and `/sample` is a gate
 * beside an open door.
 *
 * The filter goes into the query, not over the page, so `total` and `pages`
 * count the rows this caller may see. A holder of `panel:segments:read` takes
 * no filter at all and gets exactly what it always got.
 */
export const userSegmentsListUserSegmentsInfiniteOptions = (options?: Options<UserSegmentsListUserSegmentsData>) => {
    return infiniteQueryOptions<UserSegmentsListUserSegmentsResponse, UserSegmentsListUserSegmentsError, InfiniteData<UserSegmentsListUserSegmentsResponse>, QueryKey<Options<UserSegmentsListUserSegmentsData>>, number | Pick<QueryKey<Options<UserSegmentsListUserSegmentsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<UserSegmentsListUserSegmentsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await UserSegments.userSegmentsListUserSegments({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: userSegmentsListUserSegmentsInfiniteQueryKey(options)
    });
};

/**
 * Create User Segment
 * Create user segment (admin only).
 */
export const userSegmentsCreateUserSegmentMutation = (options?: Partial<Options<UserSegmentsCreateUserSegmentData>>): UseMutationOptions<UserSegmentsCreateUserSegmentResponse, UserSegmentsCreateUserSegmentError, Options<UserSegmentsCreateUserSegmentData>> => {
    const mutationOptions: UseMutationOptions<UserSegmentsCreateUserSegmentResponse, UserSegmentsCreateUserSegmentError, Options<UserSegmentsCreateUserSegmentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await UserSegments.userSegmentsCreateUserSegment({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete User Segment
 * Delete user segment (admin only).
 */
export const userSegmentsDeleteUserSegmentMutation = (options?: Partial<Options<UserSegmentsDeleteUserSegmentData>>): UseMutationOptions<UserSegmentsDeleteUserSegmentResponse, UserSegmentsDeleteUserSegmentError, Options<UserSegmentsDeleteUserSegmentData>> => {
    const mutationOptions: UseMutationOptions<UserSegmentsDeleteUserSegmentResponse, UserSegmentsDeleteUserSegmentError, Options<UserSegmentsDeleteUserSegmentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await UserSegments.userSegmentsDeleteUserSegment({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const userSegmentsGetUserSegmentQueryKey = (options: Options<UserSegmentsGetUserSegmentData>) => createQueryKey('userSegmentsGetUserSegment', options);

/**
 * Get User Segment
 * Get user segment by ID (admin only).
 *
 * Behind the same dependency as `/count` and `/sample`, for the same reason:
 * this route hands back `segment_config` (a sql segment's stored query) and
 * the live `member_count`. A dogfood-only caller gets 403 for a segment
 * nobody marked, and the 404 for a segment that does not exist still comes
 * first, so this tells nobody which ids are real.
 */
export const userSegmentsGetUserSegmentOptions = (options: Options<UserSegmentsGetUserSegmentData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await UserSegments.userSegmentsGetUserSegment({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: userSegmentsGetUserSegmentQueryKey(options)
    });
};

/**
 * Update User Segment
 * Update user segment (admin only).
 *
 * Two callers, one route. A person with `panel:segments:write` edits any
 * segment as they always could. The agent principal holds
 * `panel:segments:dogfood:write` and may send `is_ota_active` on a segment
 * somebody marked `is_dogfood` -- which is `bun ota dogfood` starting and
 * stopping its own cohort, and nothing else.
 */
export const userSegmentsUpdateUserSegmentMutation = (options?: Partial<Options<UserSegmentsUpdateUserSegmentData>>): UseMutationOptions<UserSegmentsUpdateUserSegmentResponse, UserSegmentsUpdateUserSegmentError, Options<UserSegmentsUpdateUserSegmentData>> => {
    const mutationOptions: UseMutationOptions<UserSegmentsUpdateUserSegmentResponse, UserSegmentsUpdateUserSegmentError, Options<UserSegmentsUpdateUserSegmentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await UserSegments.userSegmentsUpdateUserSegment({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Get Segment Count
 * How many people the segment reaches: what the send resolves, counted
 * (SEG-03), so the number and the send can't disagree.
 */
export const userSegmentsGetSegmentCountMutation = (options?: Partial<Options<UserSegmentsGetSegmentCountData>>): UseMutationOptions<UserSegmentsGetSegmentCountResponse, UserSegmentsGetSegmentCountError, Options<UserSegmentsGetSegmentCountData>> => {
    const mutationOptions: UseMutationOptions<UserSegmentsGetSegmentCountResponse, UserSegmentsGetSegmentCountError, Options<UserSegmentsGetSegmentCountData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await UserSegments.userSegmentsGetSegmentCount({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Get Segment Sample
 * Get sample user IDs from segment (admin only).
 *
 * This is the route that turns a segment into people, emails included, so it
 * is the one the dogfood scope narrows: a caller holding only
 * `panel:segments:dogfood:read` gets 403 for any segment nobody has marked.
 *
 * Both the 404 and that 403 come from `DogfoodReadableSegment`, so they are
 * answered before the body is validated; the body is optional besides, since
 * the path already names the segment.
 */
export const userSegmentsGetSegmentSampleMutation = (options?: Partial<Options<UserSegmentsGetSegmentSampleData>>): UseMutationOptions<UserSegmentsGetSegmentSampleResponse, UserSegmentsGetSegmentSampleError, Options<UserSegmentsGetSegmentSampleData>> => {
    const mutationOptions: UseMutationOptions<UserSegmentsGetSegmentSampleResponse, UserSegmentsGetSegmentSampleError, Options<UserSegmentsGetSegmentSampleData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await UserSegments.userSegmentsGetSegmentSample({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Upload Csv To Segment
 * Upload CSV file to populate CSV static segment (admin only).
 */
export const userSegmentsUploadCsvToSegmentMutation = (options?: Partial<Options<UserSegmentsUploadCsvToSegmentData>>): UseMutationOptions<UserSegmentsUploadCsvToSegmentResponse, UserSegmentsUploadCsvToSegmentError, Options<UserSegmentsUploadCsvToSegmentData>> => {
    const mutationOptions: UseMutationOptions<UserSegmentsUploadCsvToSegmentResponse, UserSegmentsUploadCsvToSegmentError, Options<UserSegmentsUploadCsvToSegmentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await UserSegments.userSegmentsUploadCsvToSegment({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Clear Segment Members
 * Clear all members from CSV static segment (admin only).
 */
export const userSegmentsClearSegmentMembersMutation = (options?: Partial<Options<UserSegmentsClearSegmentMembersData>>): UseMutationOptions<UserSegmentsClearSegmentMembersResponse, UserSegmentsClearSegmentMembersError, Options<UserSegmentsClearSegmentMembersData>> => {
    const mutationOptions: UseMutationOptions<UserSegmentsClearSegmentMembersResponse, UserSegmentsClearSegmentMembersError, Options<UserSegmentsClearSegmentMembersData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await UserSegments.userSegmentsClearSegmentMembers({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const otaOtaBundleAdoptionQueryKey = (options?: Options<OtaOtaBundleAdoptionData>) => createQueryKey('otaOtaBundleAdoption', options);

/**
 * Ota Bundle Adoption
 * Distinct devices running each OTA bundle, and each app version.
 *
 * ``items`` is per bundle, over all time. ``versions`` is per platform and
 * app version within ``days``, split by what each group is running, so a
 * fleet that cannot take a bundle is visible rather than inferred.
 *
 * ``lag_note`` travels with the payload rather than living only in the CLI:
 * a number that is up to 24 hours stale and does not say so is worse than no
 * number. Any future reader of this endpoint gets the caveat attached to the
 * data instead of having to know it.
 */
export const otaOtaBundleAdoptionOptions = (options?: Options<OtaOtaBundleAdoptionData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await Ota.otaOtaBundleAdoption({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: otaOtaBundleAdoptionQueryKey(options)
    });
};

export const dbSchemaGetDatabaseSchemaQueryKey = (options?: Options<DbSchemaGetDatabaseSchemaData>) => createQueryKey('dbSchemaGetDatabaseSchema', options);

/**
 * Get Database Schema
 * Get database schema for SQL autocomplete (admin only, cached).
 */
export const dbSchemaGetDatabaseSchemaOptions = (options?: Options<DbSchemaGetDatabaseSchemaData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await DbSchema.dbSchemaGetDatabaseSchema({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: dbSchemaGetDatabaseSchemaQueryKey(options)
    });
};

export const opsGetOpsStatusQueryKey = (options?: Options<OpsGetOpsStatusData>) => createQueryKey('opsGetOpsStatus', options);

/**
 * Get Ops Status
 * This env, and the other env's answer beside it. The panel asks with peer=false and
 * fetches /status/peer on its own, so this env renders without waiting on the network.
 */
export const opsGetOpsStatusOptions = (options?: Options<OpsGetOpsStatusData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await Ops.opsGetOpsStatus({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: opsGetOpsStatusQueryKey(options)
    });
};

export const opsGetOpsPeerStatusQueryKey = (options?: Options<OpsGetOpsPeerStatusData>) => createQueryKey('opsGetOpsPeerStatus', options);

/**
 * Get Ops Peer Status
 * The other env's status, fetched over HTTPS and cached for PEER_TTL_S.
 */
export const opsGetOpsPeerStatusOptions = (options?: Options<OpsGetOpsPeerStatusData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await Ops.opsGetOpsPeerStatus({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: opsGetOpsPeerStatusQueryKey(options)
    });
};

export const opsGetPeerStatusQueryKey = (options?: Options<OpsGetPeerStatusData>) => createQueryKey('opsGetPeerStatus', options);

/**
 * Get Peer Status
 * This env's status, for the other env's backend.
 */
export const opsGetPeerStatusOptions = (options?: Options<OpsGetPeerStatusData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await Ops.opsGetPeerStatus({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: opsGetPeerStatusQueryKey(options)
    });
};

/**
 * Mark Backfill Run Manually
 * A person attests this backfill already ran in this env, by hand, before the runner.
 */
export const opsMarkBackfillRunManuallyMutation = (options?: Partial<Options<OpsMarkBackfillRunManuallyData>>): UseMutationOptions<OpsMarkBackfillRunManuallyResponse, OpsMarkBackfillRunManuallyError, Options<OpsMarkBackfillRunManuallyData>> => {
    const mutationOptions: UseMutationOptions<OpsMarkBackfillRunManuallyResponse, OpsMarkBackfillRunManuallyError, Options<OpsMarkBackfillRunManuallyData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await Ops.opsMarkBackfillRunManually({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Retire Backfill
 * A person retires a once-backfill in this env: applied in both envs, nothing left.
 * It folds into "Retired"; the name stays reserved (app/backfills/NAMES).
 */
export const opsRetireBackfillMutation = (options?: Partial<Options<OpsRetireBackfillData>>): UseMutationOptions<OpsRetireBackfillResponse, OpsRetireBackfillError, Options<OpsRetireBackfillData>> => {
    const mutationOptions: UseMutationOptions<OpsRetireBackfillResponse, OpsRetireBackfillError, Options<OpsRetireBackfillData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await Ops.opsRetireBackfill({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const opsPreviewMigrationQueryKey = (options: Options<OpsPreviewMigrationData>) => createQueryKey('opsPreviewMigration', options);

/**
 * Preview Migration
 * What a migrate job from `ref` would apply to this env's database, read-only: no job is
 * created and none of the ref's code runs. Planning re-checks all of it.
 */
export const opsPreviewMigrationOptions = (options: Options<OpsPreviewMigrationData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await Ops.opsPreviewMigration({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: opsPreviewMigrationQueryKey(options)
    });
};

export const opsLocateMigrationQueryKey = (options: Options<OpsLocateMigrationData>) => createQueryKey('opsLocateMigration', options);

/**
 * Locate Migration
 * Which open PR branches (or main) applied `rev` here: read-only, cached five minutes.
 */
export const opsLocateMigrationOptions = (options: Options<OpsLocateMigrationData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await Ops.opsLocateMigration({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: opsLocateMigrationQueryKey(options)
    });
};

export const opsMigrationRefsQueryKey = (options?: Options<OpsMigrationRefsData>) => createQueryKey('opsMigrationRefs', options);

/**
 * Migration Refs
 * Suggestions for the ref field: staging, main, and open PR branches when GitHub answers.
 */
export const opsMigrationRefsOptions = (options?: Options<OpsMigrationRefsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await Ops.opsMigrationRefs({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: opsMigrationRefsQueryKey(options)
    });
};

export const opsListOpsJobsQueryKey = (options?: Options<OpsListOpsJobsData>) => createQueryKey('opsListOpsJobs', options);

/**
 * List Ops Jobs
 */
export const opsListOpsJobsOptions = (options?: Options<OpsListOpsJobsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await Ops.opsListOpsJobs({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: opsListOpsJobsQueryKey(options)
    });
};

/**
 * Request Ops Job
 */
export const opsRequestOpsJobMutation = (options?: Partial<Options<OpsRequestOpsJobData>>): UseMutationOptions<OpsRequestOpsJobResponse, OpsRequestOpsJobError, Options<OpsRequestOpsJobData>> => {
    const mutationOptions: UseMutationOptions<OpsRequestOpsJobResponse, OpsRequestOpsJobError, Options<OpsRequestOpsJobData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await Ops.opsRequestOpsJob({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const opsGetOpsRunnerQueryKey = (options?: Options<OpsGetOpsRunnerData>) => createQueryKey('opsGetOpsRunner', options);

/**
 * Get Ops Runner
 */
export const opsGetOpsRunnerOptions = (options?: Options<OpsGetOpsRunnerData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await Ops.opsGetOpsRunner({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: opsGetOpsRunnerQueryKey(options)
    });
};

export const opsGetOpsJobQueryKey = (options: Options<OpsGetOpsJobData>) => createQueryKey('opsGetOpsJob', options);

/**
 * Get Ops Job
 * Status, plan, progress and first error. Following a job polls this, and a
 * poll of a job still waiting on the runner wakes it.
 */
export const opsGetOpsJobOptions = (options: Options<OpsGetOpsJobData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await Ops.opsGetOpsJob({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: opsGetOpsJobQueryKey(options)
    });
};

export const opsGetOpsJobLogQueryKey = (options: Options<OpsGetOpsJobLogData>) => createQueryKey('opsGetOpsJobLog', options);

/**
 * Get Ops Job Log
 * Log lines after `after` (a line_no), oldest first: the live tail.
 */
export const opsGetOpsJobLogOptions = (options: Options<OpsGetOpsJobLogData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await Ops.opsGetOpsJobLog({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: opsGetOpsJobLogQueryKey(options)
    });
};

export const opsGetOpsJobLogInfiniteQueryKey = (options: Options<OpsGetOpsJobLogData>): QueryKey<Options<OpsGetOpsJobLogData>> => createQueryKey('opsGetOpsJobLog', options, true);

/**
 * Get Ops Job Log
 * Log lines after `after` (a line_no), oldest first: the live tail.
 */
export const opsGetOpsJobLogInfiniteOptions = (options: Options<OpsGetOpsJobLogData>) => {
    return infiniteQueryOptions<OpsGetOpsJobLogResponse, OpsGetOpsJobLogError, InfiniteData<OpsGetOpsJobLogResponse>, QueryKey<Options<OpsGetOpsJobLogData>>, number | Pick<QueryKey<Options<OpsGetOpsJobLogData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<OpsGetOpsJobLogData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    after: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await Ops.opsGetOpsJobLog({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: opsGetOpsJobLogInfiniteQueryKey(options)
    });
};

/**
 * Cancel Ops Job
 * Soft (between batches) or hard (fence now; needs confirm). Your own job with
 * panel:ops:jobs:request; anyone's with panel:ops:jobs:approve, as a person.
 */
export const opsCancelOpsJobMutation = (options?: Partial<Options<OpsCancelOpsJobData>>): UseMutationOptions<OpsCancelOpsJobResponse, OpsCancelOpsJobError, Options<OpsCancelOpsJobData>> => {
    const mutationOptions: UseMutationOptions<OpsCancelOpsJobResponse, OpsCancelOpsJobError, Options<OpsCancelOpsJobData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await Ops.opsCancelOpsJob({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Approve Ops Job
 */
export const opsApproveOpsJobMutation = (options?: Partial<Options<OpsApproveOpsJobData>>): UseMutationOptions<OpsApproveOpsJobResponse, OpsApproveOpsJobError, Options<OpsApproveOpsJobData>> => {
    const mutationOptions: UseMutationOptions<OpsApproveOpsJobResponse, OpsApproveOpsJobError, Options<OpsApproveOpsJobData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await Ops.opsApproveOpsJob({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Reject Ops Job
 */
export const opsRejectOpsJobMutation = (options?: Partial<Options<OpsRejectOpsJobData>>): UseMutationOptions<OpsRejectOpsJobResponse, OpsRejectOpsJobError, Options<OpsRejectOpsJobData>> => {
    const mutationOptions: UseMutationOptions<OpsRejectOpsJobResponse, OpsRejectOpsJobError, Options<OpsRejectOpsJobData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await Ops.opsRejectOpsJob({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Resume Ops Job
 */
export const opsResumeOpsJobMutation = (options?: Partial<Options<OpsResumeOpsJobData>>): UseMutationOptions<OpsResumeOpsJobResponse, OpsResumeOpsJobError, Options<OpsResumeOpsJobData>> => {
    const mutationOptions: UseMutationOptions<OpsResumeOpsJobResponse, OpsResumeOpsJobError, Options<OpsResumeOpsJobData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await Ops.opsResumeOpsJob({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Pause Ops Runner
 * Stop everything in this env: the runner claims nothing; hard also hard-cancels live jobs.
 */
export const opsPauseOpsRunnerMutation = (options?: Partial<Options<OpsPauseOpsRunnerData>>): UseMutationOptions<OpsPauseOpsRunnerResponse, OpsPauseOpsRunnerError, Options<OpsPauseOpsRunnerData>> => {
    const mutationOptions: UseMutationOptions<OpsPauseOpsRunnerResponse, OpsPauseOpsRunnerError, Options<OpsPauseOpsRunnerData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await Ops.opsPauseOpsRunner({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Unpause Ops Runner
 */
export const opsUnpauseOpsRunnerMutation = (options?: Partial<Options<OpsUnpauseOpsRunnerData>>): UseMutationOptions<OpsUnpauseOpsRunnerResponse, DefaultError, Options<OpsUnpauseOpsRunnerData>> => {
    const mutationOptions: UseMutationOptions<OpsUnpauseOpsRunnerResponse, DefaultError, Options<OpsUnpauseOpsRunnerData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await Ops.opsUnpauseOpsRunner({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const dbMigrationsGetCurrentRevisionQueryKey = (options?: Options<DbMigrationsGetCurrentRevisionData>) => createQueryKey('dbMigrationsGetCurrentRevision', options);

/**
 * Get Current Revision
 * The revision this backend's database is at.
 */
export const dbMigrationsGetCurrentRevisionOptions = (options?: Options<DbMigrationsGetCurrentRevisionData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await DbMigrations.dbMigrationsGetCurrentRevision({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: dbMigrationsGetCurrentRevisionQueryKey(options)
    });
};

/**
 * Create Approval Request
 * The workflow's plan job asks for a person's approval.
 */
export const dbMigrationsCreateApprovalRequestMutation = (options?: Partial<Options<DbMigrationsCreateApprovalRequestData>>): UseMutationOptions<DbMigrationsCreateApprovalRequestResponse, DbMigrationsCreateApprovalRequestError, Options<DbMigrationsCreateApprovalRequestData>> => {
    const mutationOptions: UseMutationOptions<DbMigrationsCreateApprovalRequestResponse, DbMigrationsCreateApprovalRequestError, Options<DbMigrationsCreateApprovalRequestData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await DbMigrations.dbMigrationsCreateApprovalRequest({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const dbMigrationsGetApprovalStatusQueryKey = (options: Options<DbMigrationsGetApprovalStatusData>) => createQueryKey('dbMigrationsGetApprovalStatus', options);

/**
 * Get Approval Status
 * The workflow's wait job polls this until a person decides.
 */
export const dbMigrationsGetApprovalStatusOptions = (options: Options<DbMigrationsGetApprovalStatusData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await DbMigrations.dbMigrationsGetApprovalStatus({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: dbMigrationsGetApprovalStatusQueryKey(options)
    });
};

export const dbMigrationsGetApprovalRequestQueryKey = (options: Options<DbMigrationsGetApprovalRequestData>) => createQueryKey('dbMigrationsGetApprovalRequest', options);

/**
 * Get Approval Request
 * The approval page: the whole plan, for a person to read.
 */
export const dbMigrationsGetApprovalRequestOptions = (options: Options<DbMigrationsGetApprovalRequestData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await DbMigrations.dbMigrationsGetApprovalRequest({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: dbMigrationsGetApprovalRequestQueryKey(options)
    });
};

/**
 * Approve Approval Request
 * A person approves exactly this plan.
 */
export const dbMigrationsApproveApprovalRequestMutation = (options?: Partial<Options<DbMigrationsApproveApprovalRequestData>>): UseMutationOptions<DbMigrationsApproveApprovalRequestResponse, DbMigrationsApproveApprovalRequestError, Options<DbMigrationsApproveApprovalRequestData>> => {
    const mutationOptions: UseMutationOptions<DbMigrationsApproveApprovalRequestResponse, DbMigrationsApproveApprovalRequestError, Options<DbMigrationsApproveApprovalRequestData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await DbMigrations.dbMigrationsApproveApprovalRequest({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Reject Approval Request
 * A person rejects it; the apply job stops without touching the database.
 */
export const dbMigrationsRejectApprovalRequestMutation = (options?: Partial<Options<DbMigrationsRejectApprovalRequestData>>): UseMutationOptions<DbMigrationsRejectApprovalRequestResponse, DbMigrationsRejectApprovalRequestError, Options<DbMigrationsRejectApprovalRequestData>> => {
    const mutationOptions: UseMutationOptions<DbMigrationsRejectApprovalRequestResponse, DbMigrationsRejectApprovalRequestError, Options<DbMigrationsRejectApprovalRequestData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await DbMigrations.dbMigrationsRejectApprovalRequest({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const therapistWaitlistGetRatesQueryKey = (options?: Options<TherapistWaitlistGetRatesData>) => createQueryKey('therapistWaitlistGetRates', options);

/**
 * Get Rates
 * Get all active session rates, optionally for a single kind.
 * Returns rates with Cache-Control header for aggressive client caching.
 */
export const therapistWaitlistGetRatesOptions = (options?: Options<TherapistWaitlistGetRatesData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await TherapistWaitlist.therapistWaitlistGetRates({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: therapistWaitlistGetRatesQueryKey(options)
    });
};

/**
 * Record Group Coaching Consents
 * Record the group coaching contact step's decisions in the consent log.
 *
 * Same rules as every other in-app email choice (``record_app_consents``):
 * channel ``app``, stamped with this account, and effective only once the
 * account proves the mailbox. If the address is the caller's own verified
 * one, that has already happened, so the grants are confirmed on the spot;
 * a typed address is confirmed when the same account later redeems a link
 * or code sent to it.
 *
 * The purpose is ``web_group_coaching_waitlist`` even though this is the app.
 * It is one consent (being contacted about the programme), and the channel
 * says where it was given.
 *
 * No email is sent and the response says nothing about the address, so this
 * cannot be used to learn whether an address has an account.
 */
export const therapistWaitlistRecordGroupCoachingConsentsMutation = (options?: Partial<Options<TherapistWaitlistRecordGroupCoachingConsentsData>>): UseMutationOptions<TherapistWaitlistRecordGroupCoachingConsentsResponse, TherapistWaitlistRecordGroupCoachingConsentsError, Options<TherapistWaitlistRecordGroupCoachingConsentsData>> => {
    const mutationOptions: UseMutationOptions<TherapistWaitlistRecordGroupCoachingConsentsResponse, TherapistWaitlistRecordGroupCoachingConsentsError, Options<TherapistWaitlistRecordGroupCoachingConsentsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await TherapistWaitlist.therapistWaitlistRecordGroupCoachingConsents({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const therapistWaitlistListRatesAdminQueryKey = (options?: Options<TherapistWaitlistListRatesAdminData>) => createQueryKey('therapistWaitlistListRatesAdmin', options);

/**
 * List Rates Admin
 * List all rates including inactive (admin only).
 */
export const therapistWaitlistListRatesAdminOptions = (options?: Options<TherapistWaitlistListRatesAdminData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await TherapistWaitlist.therapistWaitlistListRatesAdmin({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: therapistWaitlistListRatesAdminQueryKey(options)
    });
};

/**
 * Create Rate
 * Create a new rate (admin only).
 */
export const therapistWaitlistCreateRateMutation = (options?: Partial<Options<TherapistWaitlistCreateRateData>>): UseMutationOptions<TherapistWaitlistCreateRateResponse, TherapistWaitlistCreateRateError, Options<TherapistWaitlistCreateRateData>> => {
    const mutationOptions: UseMutationOptions<TherapistWaitlistCreateRateResponse, TherapistWaitlistCreateRateError, Options<TherapistWaitlistCreateRateData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await TherapistWaitlist.therapistWaitlistCreateRate({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete Rate
 * Delete a rate (admin only).
 */
export const therapistWaitlistDeleteRateMutation = (options?: Partial<Options<TherapistWaitlistDeleteRateData>>): UseMutationOptions<TherapistWaitlistDeleteRateResponse, TherapistWaitlistDeleteRateError, Options<TherapistWaitlistDeleteRateData>> => {
    const mutationOptions: UseMutationOptions<TherapistWaitlistDeleteRateResponse, TherapistWaitlistDeleteRateError, Options<TherapistWaitlistDeleteRateData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await TherapistWaitlist.therapistWaitlistDeleteRate({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update Rate
 * Update an existing rate (admin only).
 */
export const therapistWaitlistUpdateRateMutation = (options?: Partial<Options<TherapistWaitlistUpdateRateData>>): UseMutationOptions<TherapistWaitlistUpdateRateResponse, TherapistWaitlistUpdateRateError, Options<TherapistWaitlistUpdateRateData>> => {
    const mutationOptions: UseMutationOptions<TherapistWaitlistUpdateRateResponse, TherapistWaitlistUpdateRateError, Options<TherapistWaitlistUpdateRateData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await TherapistWaitlist.therapistWaitlistUpdateRate({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Bulk Upsert Rates
 * Bulk create or update rates by country code (admin only).
 */
export const therapistWaitlistBulkUpsertRatesMutation = (options?: Partial<Options<TherapistWaitlistBulkUpsertRatesData>>): UseMutationOptions<TherapistWaitlistBulkUpsertRatesResponse, TherapistWaitlistBulkUpsertRatesError, Options<TherapistWaitlistBulkUpsertRatesData>> => {
    const mutationOptions: UseMutationOptions<TherapistWaitlistBulkUpsertRatesResponse, TherapistWaitlistBulkUpsertRatesError, Options<TherapistWaitlistBulkUpsertRatesData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await TherapistWaitlist.therapistWaitlistBulkUpsertRates({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const therapistWaitlistListWaitlistUsersQueryKey = (options?: Options<TherapistWaitlistListWaitlistUsersData>) => createQueryKey('therapistWaitlistListWaitlistUsers', options);

/**
 * List Waitlist Users
 * List users who joined a waitlist (admin only).
 */
export const therapistWaitlistListWaitlistUsersOptions = (options?: Options<TherapistWaitlistListWaitlistUsersData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await TherapistWaitlist.therapistWaitlistListWaitlistUsers({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: therapistWaitlistListWaitlistUsersQueryKey(options)
    });
};

export const therapistWaitlistListWaitlistUsersInfiniteQueryKey = (options?: Options<TherapistWaitlistListWaitlistUsersData>): QueryKey<Options<TherapistWaitlistListWaitlistUsersData>> => createQueryKey('therapistWaitlistListWaitlistUsers', options, true);

/**
 * List Waitlist Users
 * List users who joined a waitlist (admin only).
 */
export const therapistWaitlistListWaitlistUsersInfiniteOptions = (options?: Options<TherapistWaitlistListWaitlistUsersData>) => {
    return infiniteQueryOptions<TherapistWaitlistListWaitlistUsersResponse, TherapistWaitlistListWaitlistUsersError, InfiniteData<TherapistWaitlistListWaitlistUsersResponse>, QueryKey<Options<TherapistWaitlistListWaitlistUsersData>>, number | Pick<QueryKey<Options<TherapistWaitlistListWaitlistUsersData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<TherapistWaitlistListWaitlistUsersData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await TherapistWaitlist.therapistWaitlistListWaitlistUsers({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: therapistWaitlistListWaitlistUsersInfiniteQueryKey(options)
    });
};

export const therapistWaitlistExportWaitlistUsersCsvQueryKey = (options?: Options<TherapistWaitlistExportWaitlistUsersCsvData>) => createQueryKey('therapistWaitlistExportWaitlistUsersCsv', options);

/**
 * Export Waitlist Users Csv
 * Export all matching waitlist users as a CSV file (admin only).
 */
export const therapistWaitlistExportWaitlistUsersCsvOptions = (options?: Options<TherapistWaitlistExportWaitlistUsersCsvData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await TherapistWaitlist.therapistWaitlistExportWaitlistUsersCsv({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: therapistWaitlistExportWaitlistUsersCsvQueryKey(options)
    });
};

export const therapistWaitlistGetWaitlistStatsQueryKey = (options?: Options<TherapistWaitlistGetWaitlistStatsData>) => createQueryKey('therapistWaitlistGetWaitlistStats', options);

/**
 * Get Waitlist Stats
 * Get aggregate stats about a waitlist (admin only).
 */
export const therapistWaitlistGetWaitlistStatsOptions = (options?: Options<TherapistWaitlistGetWaitlistStatsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await TherapistWaitlist.therapistWaitlistGetWaitlistStats({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: therapistWaitlistGetWaitlistStatsQueryKey(options)
    });
};

export const conversationsListConversationSessionsQueryKey = (options?: Options<ConversationsListConversationSessionsData>) => createQueryKey('conversationsListConversationSessions', options);

/**
 * List Conversation Sessions
 * List conversation sessions for the current user with pagination.
 */
export const conversationsListConversationSessionsOptions = (options?: Options<ConversationsListConversationSessionsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await Conversations.conversationsListConversationSessions({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: conversationsListConversationSessionsQueryKey(options)
    });
};

export const conversationsListConversationSessionsInfiniteQueryKey = (options?: Options<ConversationsListConversationSessionsData>): QueryKey<Options<ConversationsListConversationSessionsData>> => createQueryKey('conversationsListConversationSessions', options, true);

/**
 * List Conversation Sessions
 * List conversation sessions for the current user with pagination.
 */
export const conversationsListConversationSessionsInfiniteOptions = (options?: Options<ConversationsListConversationSessionsData>) => {
    return infiniteQueryOptions<ConversationsListConversationSessionsResponse, ConversationsListConversationSessionsError, InfiniteData<ConversationsListConversationSessionsResponse>, QueryKey<Options<ConversationsListConversationSessionsData>>, number | Pick<QueryKey<Options<ConversationsListConversationSessionsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<ConversationsListConversationSessionsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await Conversations.conversationsListConversationSessions({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: conversationsListConversationSessionsInfiniteQueryKey(options)
    });
};

/**
 * Create Conversation Session
 * POST creates a new conversation session.
 */
export const conversationsCreateConversationSessionMutation = (options?: Partial<Options<ConversationsCreateConversationSessionData>>): UseMutationOptions<ConversationsCreateConversationSessionResponse, ConversationsCreateConversationSessionError, Options<ConversationsCreateConversationSessionData>> => {
    const mutationOptions: UseMutationOptions<ConversationsCreateConversationSessionResponse, ConversationsCreateConversationSessionError, Options<ConversationsCreateConversationSessionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await Conversations.conversationsCreateConversationSession({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Create Or Resume Conversation Session
 * PUT does a create or resume conversation session.
 */
export const conversationsCreateOrResumeConversationSessionMutation = (options?: Partial<Options<ConversationsCreateOrResumeConversationSessionData>>): UseMutationOptions<ConversationsCreateOrResumeConversationSessionResponse, ConversationsCreateOrResumeConversationSessionError, Options<ConversationsCreateOrResumeConversationSessionData>> => {
    const mutationOptions: UseMutationOptions<ConversationsCreateOrResumeConversationSessionResponse, ConversationsCreateOrResumeConversationSessionError, Options<ConversationsCreateOrResumeConversationSessionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await Conversations.conversationsCreateOrResumeConversationSession({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const conversationsGetConversationSessionQueryKey = (options: Options<ConversationsGetConversationSessionData>) => createQueryKey('conversationsGetConversationSession', options);

/**
 * Get Conversation Session
 * Get a specific conversation session by ID.
 */
export const conversationsGetConversationSessionOptions = (options: Options<ConversationsGetConversationSessionData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await Conversations.conversationsGetConversationSession({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: conversationsGetConversationSessionQueryKey(options)
    });
};

/**
 * Update Conversation Session
 * Update a conversation session.
 */
export const conversationsUpdateConversationSessionMutation = (options?: Partial<Options<ConversationsUpdateConversationSessionData>>): UseMutationOptions<ConversationsUpdateConversationSessionResponse, ConversationsUpdateConversationSessionError, Options<ConversationsUpdateConversationSessionData>> => {
    const mutationOptions: UseMutationOptions<ConversationsUpdateConversationSessionResponse, ConversationsUpdateConversationSessionError, Options<ConversationsUpdateConversationSessionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await Conversations.conversationsUpdateConversationSession({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const conversationsGetSessionMessagesQueryKey = (options: Options<ConversationsGetSessionMessagesData>) => createQueryKey('conversationsGetSessionMessages', options);

/**
 * Get Session Messages
 * Get messages for a conversation session.
 */
export const conversationsGetSessionMessagesOptions = (options: Options<ConversationsGetSessionMessagesData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await Conversations.conversationsGetSessionMessages({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: conversationsGetSessionMessagesQueryKey(options)
    });
};

export const conversationsGetSessionMessagesInfiniteQueryKey = (options: Options<ConversationsGetSessionMessagesData>): QueryKey<Options<ConversationsGetSessionMessagesData>> => createQueryKey('conversationsGetSessionMessages', options, true);

/**
 * Get Session Messages
 * Get messages for a conversation session.
 */
export const conversationsGetSessionMessagesInfiniteOptions = (options: Options<ConversationsGetSessionMessagesData>) => {
    return infiniteQueryOptions<ConversationsGetSessionMessagesResponse, ConversationsGetSessionMessagesError, InfiniteData<ConversationsGetSessionMessagesResponse>, QueryKey<Options<ConversationsGetSessionMessagesData>>, number | Pick<QueryKey<Options<ConversationsGetSessionMessagesData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<ConversationsGetSessionMessagesData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await Conversations.conversationsGetSessionMessages({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: conversationsGetSessionMessagesInfiniteQueryKey(options)
    });
};

/**
 * Add Message
 * Add a message to a conversation session.
 */
export const conversationsAddMessageMutation = (options?: Partial<Options<ConversationsAddMessageData>>): UseMutationOptions<ConversationsAddMessageResponse, ConversationsAddMessageError, Options<ConversationsAddMessageData>> => {
    const mutationOptions: UseMutationOptions<ConversationsAddMessageResponse, ConversationsAddMessageError, Options<ConversationsAddMessageData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await Conversations.conversationsAddMessage({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const healthEntriesListHealthEntriesQueryKey = (options?: Options<HealthEntriesListHealthEntriesData>) => createQueryKey('healthEntriesListHealthEntries', options);

/**
 * List Health Entries
 * List all health entries for the current user with pagination.
 *
 * Optionally filter by entry_type and dt_updated_after (for incremental sync).
 *
 * ``entry_types`` and ``exclude_entry_types`` are the two halves of a split
 * restore: the sync client first pulls the types its first screen reads, then
 * sweeps the rest. Both are additive — a caller that sends neither sees
 * exactly what it saw before.
 *
 * ``before_dt_timestamp`` + ``before_id`` page by KEYSET rather than by
 * offset, which is what lets the sync client stop part-way down a large
 * account and resume exactly where it stopped. ``total`` and ``pages``
 * deliberately ignore the keyset, so they stay a fixed denominator for the
 * whole walk instead of shrinking as it progresses.
 */
export const healthEntriesListHealthEntriesOptions = (options?: Options<HealthEntriesListHealthEntriesData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await HealthEntries.healthEntriesListHealthEntries({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: healthEntriesListHealthEntriesQueryKey(options)
    });
};

export const healthEntriesListHealthEntriesInfiniteQueryKey = (options?: Options<HealthEntriesListHealthEntriesData>): QueryKey<Options<HealthEntriesListHealthEntriesData>> => createQueryKey('healthEntriesListHealthEntries', options, true);

/**
 * List Health Entries
 * List all health entries for the current user with pagination.
 *
 * Optionally filter by entry_type and dt_updated_after (for incremental sync).
 *
 * ``entry_types`` and ``exclude_entry_types`` are the two halves of a split
 * restore: the sync client first pulls the types its first screen reads, then
 * sweeps the rest. Both are additive — a caller that sends neither sees
 * exactly what it saw before.
 *
 * ``before_dt_timestamp`` + ``before_id`` page by KEYSET rather than by
 * offset, which is what lets the sync client stop part-way down a large
 * account and resume exactly where it stopped. ``total`` and ``pages``
 * deliberately ignore the keyset, so they stay a fixed denominator for the
 * whole walk instead of shrinking as it progresses.
 */
export const healthEntriesListHealthEntriesInfiniteOptions = (options?: Options<HealthEntriesListHealthEntriesData>) => {
    return infiniteQueryOptions<HealthEntriesListHealthEntriesResponse, HealthEntriesListHealthEntriesError, InfiniteData<HealthEntriesListHealthEntriesResponse>, QueryKey<Options<HealthEntriesListHealthEntriesData>>, number | Pick<QueryKey<Options<HealthEntriesListHealthEntriesData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<HealthEntriesListHealthEntriesData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await HealthEntries.healthEntriesListHealthEntries({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: healthEntriesListHealthEntriesInfiniteQueryKey(options)
    });
};

/**
 * Create Health Entry
 * Create a new health entry for the current user.
 */
export const healthEntriesCreateHealthEntryMutation = (options?: Partial<Options<HealthEntriesCreateHealthEntryData>>): UseMutationOptions<HealthEntriesCreateHealthEntryResponse, HealthEntriesCreateHealthEntryError, Options<HealthEntriesCreateHealthEntryData>> => {
    const mutationOptions: UseMutationOptions<HealthEntriesCreateHealthEntryResponse, HealthEntriesCreateHealthEntryError, Options<HealthEntriesCreateHealthEntryData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await HealthEntries.healthEntriesCreateHealthEntry({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Upsert Health Entry
 * Create or update a health entry.
 *
 * If entry_in.id is provided and the entry exists, it will be updated.
 * Otherwise, a new entry will be created.
 */
export const healthEntriesUpsertHealthEntryMutation = (options?: Partial<Options<HealthEntriesUpsertHealthEntryData>>): UseMutationOptions<HealthEntriesUpsertHealthEntryResponse, HealthEntriesUpsertHealthEntryError, Options<HealthEntriesUpsertHealthEntryData>> => {
    const mutationOptions: UseMutationOptions<HealthEntriesUpsertHealthEntryResponse, HealthEntriesUpsertHealthEntryError, Options<HealthEntriesUpsertHealthEntryData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await HealthEntries.healthEntriesUpsertHealthEntry({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete Health Entry
 * Delete a health entry.
 */
export const healthEntriesDeleteHealthEntryMutation = (options?: Partial<Options<HealthEntriesDeleteHealthEntryData>>): UseMutationOptions<HealthEntriesDeleteHealthEntryResponse, HealthEntriesDeleteHealthEntryError, Options<HealthEntriesDeleteHealthEntryData>> => {
    const mutationOptions: UseMutationOptions<HealthEntriesDeleteHealthEntryResponse, HealthEntriesDeleteHealthEntryError, Options<HealthEntriesDeleteHealthEntryData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await HealthEntries.healthEntriesDeleteHealthEntry({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const healthEntriesGetHealthEntryQueryKey = (options: Options<HealthEntriesGetHealthEntryData>) => createQueryKey('healthEntriesGetHealthEntry', options);

/**
 * Get Health Entry
 * Get a specific health entry by ID.
 */
export const healthEntriesGetHealthEntryOptions = (options: Options<HealthEntriesGetHealthEntryData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await HealthEntries.healthEntriesGetHealthEntry({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: healthEntriesGetHealthEntryQueryKey(options)
    });
};

/**
 * Update Health Entry
 * Update a health entry.
 */
export const healthEntriesUpdateHealthEntryMutation = (options?: Partial<Options<HealthEntriesUpdateHealthEntryData>>): UseMutationOptions<HealthEntriesUpdateHealthEntryResponse, HealthEntriesUpdateHealthEntryError, Options<HealthEntriesUpdateHealthEntryData>> => {
    const mutationOptions: UseMutationOptions<HealthEntriesUpdateHealthEntryResponse, HealthEntriesUpdateHealthEntryError, Options<HealthEntriesUpdateHealthEntryData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await HealthEntries.healthEntriesUpdateHealthEntry({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Bulk Delete Health Entries
 * Delete multiple health entries in bulk.
 * More efficient than deleting entries one by one.
 */
export const healthEntriesBulkDeleteHealthEntriesMutation = (options?: Partial<Options<HealthEntriesBulkDeleteHealthEntriesData>>): UseMutationOptions<HealthEntriesBulkDeleteHealthEntriesResponse, HealthEntriesBulkDeleteHealthEntriesError, Options<HealthEntriesBulkDeleteHealthEntriesData>> => {
    const mutationOptions: UseMutationOptions<HealthEntriesBulkDeleteHealthEntriesResponse, HealthEntriesBulkDeleteHealthEntriesError, Options<HealthEntriesBulkDeleteHealthEntriesData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await HealthEntries.healthEntriesBulkDeleteHealthEntries({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const prepareListMomentsQueryKey = (options?: Options<PrepareListMomentsData>) => createQueryKey('prepareListMoments', options);

/**
 * List Moments
 * Every moment for the current user, open and closed.
 */
export const prepareListMomentsOptions = (options?: Options<PrepareListMomentsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await Prepare.prepareListMoments({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: prepareListMomentsQueryKey(options)
    });
};

/**
 * Create Moment
 * Create a moment, optionally chained to the moment that spawned it.
 */
export const prepareCreateMomentMutation = (options?: Partial<Options<PrepareCreateMomentData>>): UseMutationOptions<PrepareCreateMomentResponse, PrepareCreateMomentError, Options<PrepareCreateMomentData>> => {
    const mutationOptions: UseMutationOptions<PrepareCreateMomentResponse, PrepareCreateMomentError, Options<PrepareCreateMomentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await Prepare.prepareCreateMoment({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete Moment
 * Hard delete. Closing a moment is a PATCH; this is for 'I added it by mistake'.
 */
export const prepareDeleteMomentMutation = (options?: Partial<Options<PrepareDeleteMomentData>>): UseMutationOptions<PrepareDeleteMomentResponse, PrepareDeleteMomentError, Options<PrepareDeleteMomentData>> => {
    const mutationOptions: UseMutationOptions<PrepareDeleteMomentResponse, PrepareDeleteMomentError, Options<PrepareDeleteMomentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await Prepare.prepareDeleteMoment({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const prepareGetMomentQueryKey = (options: Options<PrepareGetMomentData>) => createQueryKey('prepareGetMoment', options);

/**
 * Get Moment
 */
export const prepareGetMomentOptions = (options: Options<PrepareGetMomentData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await Prepare.prepareGetMoment({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: prepareGetMomentQueryKey(options)
    });
};

/**
 * Update Moment
 * Edit a moment, record its outcome, or close it.
 *
 * `moment_date` is explicitly settable to null so a user can move a moment back to
 * open-ended ("the appointment got cancelled, I don't know when it'll be").
 */
export const prepareUpdateMomentMutation = (options?: Partial<Options<PrepareUpdateMomentData>>): UseMutationOptions<PrepareUpdateMomentResponse, PrepareUpdateMomentError, Options<PrepareUpdateMomentData>> => {
    const mutationOptions: UseMutationOptions<PrepareUpdateMomentResponse, PrepareUpdateMomentError, Options<PrepareUpdateMomentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await Prepare.prepareUpdateMoment({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const supportRelationshipsGetSupportRelationshipsQueryKey = (options?: Options<SupportRelationshipsGetSupportRelationshipsData>) => createQueryKey('supportRelationshipsGetSupportRelationships', options);

/**
 * Get Support Relationships
 * Get all supporters for the current user.
 */
export const supportRelationshipsGetSupportRelationshipsOptions = (options?: Options<SupportRelationshipsGetSupportRelationshipsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await SupportRelationships.supportRelationshipsGetSupportRelationships({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: supportRelationshipsGetSupportRelationshipsQueryKey(options)
    });
};

/**
 * Create Support Relationship
 * Invite a supporter.
 */
export const supportRelationshipsCreateSupportRelationshipMutation = (options?: Partial<Options<SupportRelationshipsCreateSupportRelationshipData>>): UseMutationOptions<SupportRelationshipsCreateSupportRelationshipResponse, SupportRelationshipsCreateSupportRelationshipError, Options<SupportRelationshipsCreateSupportRelationshipData>> => {
    const mutationOptions: UseMutationOptions<SupportRelationshipsCreateSupportRelationshipResponse, SupportRelationshipsCreateSupportRelationshipError, Options<SupportRelationshipsCreateSupportRelationshipData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await SupportRelationships.supportRelationshipsCreateSupportRelationship({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const supportRelationshipsAcceptSupporterInvitationPageQueryKey = (options: Options<SupportRelationshipsAcceptSupporterInvitationPageData>) => createQueryKey('supportRelationshipsAcceptSupporterInvitationPage', options);

/**
 * Accept Supporter Invitation Page
 * Show the invitation and ask. Does not accept anything — see _confirm_page.
 */
export const supportRelationshipsAcceptSupporterInvitationPageOptions = (options: Options<SupportRelationshipsAcceptSupporterInvitationPageData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await SupportRelationships.supportRelationshipsAcceptSupporterInvitationPage({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: supportRelationshipsAcceptSupporterInvitationPageQueryKey(options)
    });
};

/**
 * Accept Supporter Invitation
 * Accept a supporter invitation. Public, no auth.
 *
 * The signed token is the authority here — the supporter has no account to
 * sign in with, and an unsigned relationship id would let anyone confirm a
 * relationship by guessing.
 */
export const supportRelationshipsAcceptSupporterInvitationMutation = (options?: Partial<Options<SupportRelationshipsAcceptSupporterInvitationData>>): UseMutationOptions<SupportRelationshipsAcceptSupporterInvitationResponse, SupportRelationshipsAcceptSupporterInvitationError, Options<SupportRelationshipsAcceptSupporterInvitationData>> => {
    const mutationOptions: UseMutationOptions<SupportRelationshipsAcceptSupporterInvitationResponse, SupportRelationshipsAcceptSupporterInvitationError, Options<SupportRelationshipsAcceptSupporterInvitationData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await SupportRelationships.supportRelationshipsAcceptSupporterInvitation({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const supportRelationshipsDeclineSupporterInvitationPageQueryKey = (options: Options<SupportRelationshipsDeclineSupporterInvitationPageData>) => createQueryKey('supportRelationshipsDeclineSupporterInvitationPage', options);

/**
 * Decline Supporter Invitation Page
 * Ask before declining. Does not decline — see _confirm_page.
 */
export const supportRelationshipsDeclineSupporterInvitationPageOptions = (options: Options<SupportRelationshipsDeclineSupporterInvitationPageData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await SupportRelationships.supportRelationshipsDeclineSupporterInvitationPage({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: supportRelationshipsDeclineSupporterInvitationPageQueryKey(options)
    });
};

/**
 * Decline Supporter Invitation
 * Decline a supporter invitation. Public, no auth.
 */
export const supportRelationshipsDeclineSupporterInvitationMutation = (options?: Partial<Options<SupportRelationshipsDeclineSupporterInvitationData>>): UseMutationOptions<SupportRelationshipsDeclineSupporterInvitationResponse, SupportRelationshipsDeclineSupporterInvitationError, Options<SupportRelationshipsDeclineSupporterInvitationData>> => {
    const mutationOptions: UseMutationOptions<SupportRelationshipsDeclineSupporterInvitationResponse, SupportRelationshipsDeclineSupporterInvitationError, Options<SupportRelationshipsDeclineSupporterInvitationData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await SupportRelationships.supportRelationshipsDeclineSupporterInvitation({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const supportRelationshipsUnsubscribeSupporterNotificationsQueryKey = (options: Options<SupportRelationshipsUnsubscribeSupporterNotificationsData>) => createQueryKey('supportRelationshipsUnsubscribeSupporterNotifications', options);

/**
 * Unsubscribe Supporter Notifications
 * Ask before unsubscribing. Does not unsubscribe — see _confirm_page.
 *
 * The token is still validated here, so a tampered or expired link fails
 * immediately rather than offering a button that cannot work.
 *
 * The RFC 8058 POST below is untouched: that one is a mail client acting on
 * an explicit instruction from its user, which is the whole point of the
 * standard. This GET is the footer link a human clicks, and a scanner might.
 */
export const supportRelationshipsUnsubscribeSupporterNotificationsOptions = (options: Options<SupportRelationshipsUnsubscribeSupporterNotificationsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await SupportRelationships.supportRelationshipsUnsubscribeSupporterNotifications({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: supportRelationshipsUnsubscribeSupporterNotificationsQueryKey(options)
    });
};

/**
 * Unsubscribe Supporter Notifications Post
 * RFC 8058 one-click unsubscribe (mail clients POST to the List-Unsubscribe URL).
 */
export const supportRelationshipsUnsubscribeSupporterNotificationsPostMutation = (options?: Partial<Options<SupportRelationshipsUnsubscribeSupporterNotificationsPostData>>): UseMutationOptions<SupportRelationshipsUnsubscribeSupporterNotificationsPostResponse, SupportRelationshipsUnsubscribeSupporterNotificationsPostError, Options<SupportRelationshipsUnsubscribeSupporterNotificationsPostData>> => {
    const mutationOptions: UseMutationOptions<SupportRelationshipsUnsubscribeSupporterNotificationsPostResponse, SupportRelationshipsUnsubscribeSupporterNotificationsPostError, Options<SupportRelationshipsUnsubscribeSupporterNotificationsPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await SupportRelationships.supportRelationshipsUnsubscribeSupporterNotificationsPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const supportRelationshipsGetSupportingRelationshipsQueryKey = (options?: Options<SupportRelationshipsGetSupportingRelationshipsData>) => createQueryKey('supportRelationshipsGetSupportingRelationships', options);

/**
 * Get Supporting Relationships
 * Get all users that the current user supports.
 */
export const supportRelationshipsGetSupportingRelationshipsOptions = (options?: Options<SupportRelationshipsGetSupportingRelationshipsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await SupportRelationships.supportRelationshipsGetSupportingRelationships({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: supportRelationshipsGetSupportingRelationshipsQueryKey(options)
    });
};

/**
 * Confirm Support Relationship
 * Confirm/accept a support relationship invitation.
 */
export const supportRelationshipsConfirmSupportRelationshipMutation = (options?: Partial<Options<SupportRelationshipsConfirmSupportRelationshipData>>): UseMutationOptions<SupportRelationshipsConfirmSupportRelationshipResponse, SupportRelationshipsConfirmSupportRelationshipError, Options<SupportRelationshipsConfirmSupportRelationshipData>> => {
    const mutationOptions: UseMutationOptions<SupportRelationshipsConfirmSupportRelationshipResponse, SupportRelationshipsConfirmSupportRelationshipError, Options<SupportRelationshipsConfirmSupportRelationshipData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await SupportRelationships.supportRelationshipsConfirmSupportRelationship({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete Support Relationship
 * Delete a support relationship.
 */
export const supportRelationshipsDeleteSupportRelationshipMutation = (options?: Partial<Options<SupportRelationshipsDeleteSupportRelationshipData>>): UseMutationOptions<SupportRelationshipsDeleteSupportRelationshipResponse, SupportRelationshipsDeleteSupportRelationshipError, Options<SupportRelationshipsDeleteSupportRelationshipData>> => {
    const mutationOptions: UseMutationOptions<SupportRelationshipsDeleteSupportRelationshipResponse, SupportRelationshipsDeleteSupportRelationshipError, Options<SupportRelationshipsDeleteSupportRelationshipData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await SupportRelationships.supportRelationshipsDeleteSupportRelationship({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update Support Relationship
 * Update a support relationship.
 */
export const supportRelationshipsUpdateSupportRelationshipMutation = (options?: Partial<Options<SupportRelationshipsUpdateSupportRelationshipData>>): UseMutationOptions<SupportRelationshipsUpdateSupportRelationshipResponse, SupportRelationshipsUpdateSupportRelationshipError, Options<SupportRelationshipsUpdateSupportRelationshipData>> => {
    const mutationOptions: UseMutationOptions<SupportRelationshipsUpdateSupportRelationshipResponse, SupportRelationshipsUpdateSupportRelationshipError, Options<SupportRelationshipsUpdateSupportRelationshipData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await SupportRelationships.supportRelationshipsUpdateSupportRelationship({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const supporterGetSupporterDashboardQueryKey = (options?: Options<SupporterGetSupporterDashboardData>) => createQueryKey('supporterGetSupporterDashboard', options);

/**
 * Get Supporter Dashboard
 * Get supporter dashboard showing all users they support.
 */
export const supporterGetSupporterDashboardOptions = (options?: Options<SupporterGetSupporterDashboardData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await Supporter.supporterGetSupporterDashboard({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: supporterGetSupporterDashboardQueryKey(options)
    });
};

export const supporterGetUserInsightsQueryKey = (options: Options<SupporterGetUserInsightsData>) => createQueryKey('supporterGetUserInsights', options);

/**
 * Get User Insights
 * Get insights for a specific user that the supporter supports.
 */
export const supporterGetUserInsightsOptions = (options: Options<SupporterGetUserInsightsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await Supporter.supporterGetUserInsights({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: supporterGetUserInsightsQueryKey(options)
    });
};

/**
 * Delete Supporter Account
 * Remove the supporter from everyone they support, and stop all email.
 *
 * The user row itself only goes when it exists purely because somebody
 * invited them. A supporter who also uses the Condri app keeps their account:
 * they asked to stop supporting people, not to erase their own health record.
 * They can delete the app account from the app, where that intent is clear.
 */
export const supporterDeleteSupporterAccountMutation = (options?: Partial<Options<SupporterDeleteSupporterAccountData>>): UseMutationOptions<SupporterDeleteSupporterAccountResponse, DefaultError, Options<SupporterDeleteSupporterAccountData>> => {
    const mutationOptions: UseMutationOptions<SupporterDeleteSupporterAccountResponse, DefaultError, Options<SupporterDeleteSupporterAccountData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await Supporter.supporterDeleteSupporterAccount({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const supporterGetSupporterAccountQueryKey = (options?: Options<SupporterGetSupporterAccountData>) => createQueryKey('supporterGetSupporterAccount', options);

/**
 * Get Supporter Account
 * The supporter's own account, as shown in the supporter portal.
 */
export const supporterGetSupporterAccountOptions = (options?: Options<SupporterGetSupporterAccountData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await Supporter.supporterGetSupporterAccount({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: supporterGetSupporterAccountQueryKey(options)
    });
};

/**
 * Update Supporter Preferences
 * Let a supporter set how often their own inbox is touched.
 *
 * Scoped to relationships where the caller IS the supporter. The existing
 * PUT /support-relationships/{id} is the supported person's door and stays
 * that way; this one cannot reach anyone else's settings.
 */
export const supporterUpdateSupporterPreferencesMutation = (options?: Partial<Options<SupporterUpdateSupporterPreferencesData>>): UseMutationOptions<SupporterUpdateSupporterPreferencesResponse, SupporterUpdateSupporterPreferencesError, Options<SupporterUpdateSupporterPreferencesData>> => {
    const mutationOptions: UseMutationOptions<SupporterUpdateSupporterPreferencesResponse, SupporterUpdateSupporterPreferencesError, Options<SupporterUpdateSupporterPreferencesData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await Supporter.supporterUpdateSupporterPreferences({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const communityGetFeedQueryKey = (options?: Options<CommunityGetFeedData>) => createQueryKey('communityGetFeed', options);

/**
 * Get Feed
 * Newest-first page of the posts the caller sees, optionally filtered by
 * category. An admin also sees archived posts, marked; an author also sees
 * their own archived posts, unmarked. `archived=true` is an admin's Archived
 * tab: only archived posts, and a 403 for anyone else.
 */
export const communityGetFeedOptions = (options?: Options<CommunityGetFeedData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await Community.communityGetFeed({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: communityGetFeedQueryKey(options)
    });
};

export const communityGetFeedInfiniteQueryKey = (options?: Options<CommunityGetFeedData>): QueryKey<Options<CommunityGetFeedData>> => createQueryKey('communityGetFeed', options, true);

/**
 * Get Feed
 * Newest-first page of the posts the caller sees, optionally filtered by
 * category. An admin also sees archived posts, marked; an author also sees
 * their own archived posts, unmarked. `archived=true` is an admin's Archived
 * tab: only archived posts, and a 403 for anyone else.
 */
export const communityGetFeedInfiniteOptions = (options?: Options<CommunityGetFeedData>) => {
    return infiniteQueryOptions<CommunityGetFeedResponse, CommunityGetFeedError, InfiniteData<CommunityGetFeedResponse>, QueryKey<Options<CommunityGetFeedData>>, string | null | Pick<QueryKey<Options<CommunityGetFeedData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<CommunityGetFeedData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    cursor: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await Community.communityGetFeed({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: communityGetFeedInfiniteQueryKey(options)
    });
};

/**
 * Delete Post
 * Delete your own post (comments/reactions/views go with it).
 */
export const communityDeletePostMutation = (options?: Partial<Options<CommunityDeletePostData>>): UseMutationOptions<CommunityDeletePostResponse, CommunityDeletePostError, Options<CommunityDeletePostData>> => {
    const mutationOptions: UseMutationOptions<CommunityDeletePostResponse, CommunityDeletePostError, Options<CommunityDeletePostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await Community.communityDeletePost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const communityGetPostQueryKey = (options: Options<CommunityGetPostData>) => createQueryKey('communityGetPost', options);

/**
 * Get Post
 * Get a single post. Records the caller's view (idempotent per user).
 */
export const communityGetPostOptions = (options: Options<CommunityGetPostData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await Community.communityGetPost({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: communityGetPostQueryKey(options)
    });
};

/**
 * Update Post
 * Edit your own post, within 24h of posting.
 */
export const communityUpdatePostMutation = (options?: Partial<Options<CommunityUpdatePostData>>): UseMutationOptions<CommunityUpdatePostResponse, CommunityUpdatePostError, Options<CommunityUpdatePostData>> => {
    const mutationOptions: UseMutationOptions<CommunityUpdatePostResponse, CommunityUpdatePostError, Options<CommunityUpdatePostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await Community.communityUpdatePost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const communityGetPostCommentsQueryKey = (options: Options<CommunityGetPostCommentsData>) => createQueryKey('communityGetPostComments', options);

/**
 * Get Post Comments
 * Oldest-first page of top-level comments, each with its replies.
 */
export const communityGetPostCommentsOptions = (options: Options<CommunityGetPostCommentsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await Community.communityGetPostComments({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: communityGetPostCommentsQueryKey(options)
    });
};

export const communityGetPostCommentsInfiniteQueryKey = (options: Options<CommunityGetPostCommentsData>): QueryKey<Options<CommunityGetPostCommentsData>> => createQueryKey('communityGetPostComments', options, true);

/**
 * Get Post Comments
 * Oldest-first page of top-level comments, each with its replies.
 */
export const communityGetPostCommentsInfiniteOptions = (options: Options<CommunityGetPostCommentsData>) => {
    return infiniteQueryOptions<CommunityGetPostCommentsResponse, CommunityGetPostCommentsError, InfiniteData<CommunityGetPostCommentsResponse>, QueryKey<Options<CommunityGetPostCommentsData>>, string | null | Pick<QueryKey<Options<CommunityGetPostCommentsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<CommunityGetPostCommentsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    cursor: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await Community.communityGetPostComments({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: communityGetPostCommentsInfiniteQueryKey(options)
    });
};

/**
 * Create Post
 */
export const communityCreatePostMutation = (options?: Partial<Options<CommunityCreatePostData>>): UseMutationOptions<CommunityCreatePostResponse, CommunityCreatePostError, Options<CommunityCreatePostData>> => {
    const mutationOptions: UseMutationOptions<CommunityCreatePostResponse, CommunityCreatePostError, Options<CommunityCreatePostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await Community.communityCreatePost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Upload Media
 * Upload an image to the private community bucket. Validated by magic bytes
 * (the client content-type is not trusted); returns the media id + a signed
 * preview URL. Attach it to a post via createPost's mediaId.
 */
export const communityUploadMediaMutation = (options?: Partial<Options<CommunityUploadMediaData>>): UseMutationOptions<CommunityUploadMediaResponse, CommunityUploadMediaError, Options<CommunityUploadMediaData>> => {
    const mutationOptions: UseMutationOptions<CommunityUploadMediaResponse, CommunityUploadMediaError, Options<CommunityUploadMediaData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await Community.communityUploadMedia({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Attach Youtube Media
 * Attach a YouTube video by URL. Parses the video id, validates it via
 * oembed (built from the parsed id, not the raw URL — SSRF-safe), and stores a
 * kind='youtube' media row. Attach it to a post via createPost's mediaId.
 */
export const communityAttachYoutubeMediaMutation = (options?: Partial<Options<CommunityAttachYoutubeMediaData>>): UseMutationOptions<CommunityAttachYoutubeMediaResponse, CommunityAttachYoutubeMediaError, Options<CommunityAttachYoutubeMediaData>> => {
    const mutationOptions: UseMutationOptions<CommunityAttachYoutubeMediaResponse, CommunityAttachYoutubeMediaError, Options<CommunityAttachYoutubeMediaData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await Community.communityAttachYoutubeMedia({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Create Video Upload
 * Signed URLs to upload a video from the device straight to the private
 * bucket, plus its poster frame. Community admins only. Finalize with
 * POST /media/video once both PUTs succeed.
 */
export const communityCreateVideoUploadMutation = (options?: Partial<Options<CommunityCreateVideoUploadData>>): UseMutationOptions<CommunityCreateVideoUploadResponse, CommunityCreateVideoUploadError, Options<CommunityCreateVideoUploadData>> => {
    const mutationOptions: UseMutationOptions<CommunityCreateVideoUploadResponse, CommunityCreateVideoUploadError, Options<CommunityCreateVideoUploadData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await Community.communityCreateVideoUpload({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Finalize Video Media
 * Verify an uploaded video (size + sniffed type, for both the video and its
 * poster) and store a kind='video' media row. Attach it to a post via
 * createPost's mediaId.
 */
export const communityFinalizeVideoMediaMutation = (options?: Partial<Options<CommunityFinalizeVideoMediaData>>): UseMutationOptions<CommunityFinalizeVideoMediaResponse, CommunityFinalizeVideoMediaError, Options<CommunityFinalizeVideoMediaData>> => {
    const mutationOptions: UseMutationOptions<CommunityFinalizeVideoMediaResponse, CommunityFinalizeVideoMediaError, Options<CommunityFinalizeVideoMediaData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await Community.communityFinalizeVideoMedia({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Create Comment
 */
export const communityCreateCommentMutation = (options?: Partial<Options<CommunityCreateCommentData>>): UseMutationOptions<CommunityCreateCommentResponse, CommunityCreateCommentError, Options<CommunityCreateCommentData>> => {
    const mutationOptions: UseMutationOptions<CommunityCreateCommentResponse, CommunityCreateCommentError, Options<CommunityCreateCommentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await Community.communityCreateComment({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Boost Post
 * Pin a post to the top of the feed (`hours` or `until_next_post`).
 */
export const communityBoostPostMutation = (options?: Partial<Options<CommunityBoostPostData>>): UseMutationOptions<CommunityBoostPostResponse, CommunityBoostPostError, Options<CommunityBoostPostData>> => {
    const mutationOptions: UseMutationOptions<CommunityBoostPostResponse, CommunityBoostPostError, Options<CommunityBoostPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await Community.communityBoostPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Unboost Post
 */
export const communityUnboostPostMutation = (options?: Partial<Options<CommunityUnboostPostData>>): UseMutationOptions<CommunityUnboostPostResponse, CommunityUnboostPostError, Options<CommunityUnboostPostData>> => {
    const mutationOptions: UseMutationOptions<CommunityUnboostPostResponse, CommunityUnboostPostError, Options<CommunityUnboostPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await Community.communityUnboostPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Archive Post
 * Reversible soft-delete: drop from the feed but keep the row.
 */
export const communityArchivePostMutation = (options?: Partial<Options<CommunityArchivePostData>>): UseMutationOptions<CommunityArchivePostResponse, CommunityArchivePostError, Options<CommunityArchivePostData>> => {
    const mutationOptions: UseMutationOptions<CommunityArchivePostResponse, CommunityArchivePostError, Options<CommunityArchivePostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await Community.communityArchivePost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Restore Post
 * Reverse an archive. Dashboard-symmetric; no in-app caller today.
 */
export const communityRestorePostMutation = (options?: Partial<Options<CommunityRestorePostData>>): UseMutationOptions<CommunityRestorePostResponse, CommunityRestorePostError, Options<CommunityRestorePostData>> => {
    const mutationOptions: UseMutationOptions<CommunityRestorePostResponse, CommunityRestorePostError, Options<CommunityRestorePostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await Community.communityRestorePost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Set Post Topic
 * Move a post to another active category. Not an edit by the author, so
 * no "edited" mark. Posts in a private room (feedback) stay where they are.
 */
export const communitySetPostTopicMutation = (options?: Partial<Options<CommunitySetPostTopicData>>): UseMutationOptions<CommunitySetPostTopicResponse, CommunitySetPostTopicError, Options<CommunitySetPostTopicData>> => {
    const mutationOptions: UseMutationOptions<CommunitySetPostTopicResponse, CommunitySetPostTopicError, Options<CommunitySetPostTopicData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await Community.communitySetPostTopic({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Archive Comment
 * Hide a comment from members. Reversible from the dashboard; its replies
 * go out of sight with it.
 */
export const communityArchiveCommentMutation = (options?: Partial<Options<CommunityArchiveCommentData>>): UseMutationOptions<CommunityArchiveCommentResponse, CommunityArchiveCommentError, Options<CommunityArchiveCommentData>> => {
    const mutationOptions: UseMutationOptions<CommunityArchiveCommentResponse, CommunityArchiveCommentError, Options<CommunityArchiveCommentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await Community.communityArchiveComment({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update Comment
 * Edit your own comment, within 24h of posting. A community admin may
 * also edit any admin's comment, with no time limit.
 */
export const communityUpdateCommentMutation = (options?: Partial<Options<CommunityUpdateCommentData>>): UseMutationOptions<CommunityUpdateCommentResponse, CommunityUpdateCommentError, Options<CommunityUpdateCommentData>> => {
    const mutationOptions: UseMutationOptions<CommunityUpdateCommentResponse, CommunityUpdateCommentError, Options<CommunityUpdateCommentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await Community.communityUpdateComment({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Set Post Reaction
 * Toggle the caller's reaction on a post: same kind clears, a different
 * kind switches, none adds.
 */
export const communitySetPostReactionMutation = (options?: Partial<Options<CommunitySetPostReactionData>>): UseMutationOptions<CommunitySetPostReactionResponse, CommunitySetPostReactionError, Options<CommunitySetPostReactionData>> => {
    const mutationOptions: UseMutationOptions<CommunitySetPostReactionResponse, CommunitySetPostReactionError, Options<CommunitySetPostReactionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await Community.communitySetPostReaction({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Set Comment Reaction
 * Toggle the caller's reaction on a comment or reply, the same way as on
 * a post: same kind clears, a different kind switches, none adds.
 */
export const communitySetCommentReactionMutation = (options?: Partial<Options<CommunitySetCommentReactionData>>): UseMutationOptions<CommunitySetCommentReactionResponse, CommunitySetCommentReactionError, Options<CommunitySetCommentReactionData>> => {
    const mutationOptions: UseMutationOptions<CommunitySetCommentReactionResponse, CommunitySetCommentReactionError, Options<CommunitySetCommentReactionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await Community.communitySetCommentReaction({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Set Post Saved
 * Bookmark (save) or un-bookmark a post for the caller.
 */
export const communitySetPostSavedMutation = (options?: Partial<Options<CommunitySetPostSavedData>>): UseMutationOptions<CommunitySetPostSavedResponse, CommunitySetPostSavedError, Options<CommunitySetPostSavedData>> => {
    const mutationOptions: UseMutationOptions<CommunitySetPostSavedResponse, CommunitySetPostSavedError, Options<CommunitySetPostSavedData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await Community.communitySetPostSaved({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const communityGetSavedQueryKey = (options?: Options<CommunityGetSavedData>) => createQueryKey('communityGetSaved', options);

/**
 * Get Saved
 * The caller's saved posts, newest-saved first.
 */
export const communityGetSavedOptions = (options?: Options<CommunityGetSavedData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await Community.communityGetSaved({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: communityGetSavedQueryKey(options)
    });
};

export const communityGetSavedInfiniteQueryKey = (options?: Options<CommunityGetSavedData>): QueryKey<Options<CommunityGetSavedData>> => createQueryKey('communityGetSaved', options, true);

/**
 * Get Saved
 * The caller's saved posts, newest-saved first.
 */
export const communityGetSavedInfiniteOptions = (options?: Options<CommunityGetSavedData>) => {
    return infiniteQueryOptions<CommunityGetSavedResponse, CommunityGetSavedError, InfiniteData<CommunityGetSavedResponse>, QueryKey<Options<CommunityGetSavedData>>, string | null | Pick<QueryKey<Options<CommunityGetSavedData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<CommunityGetSavedData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    cursor: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await Community.communityGetSaved({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: communityGetSavedInfiniteQueryKey(options)
    });
};

/**
 * Report Content
 */
export const communityReportContentMutation = (options?: Partial<Options<CommunityReportContentData>>): UseMutationOptions<CommunityReportContentResponse, CommunityReportContentError, Options<CommunityReportContentData>> => {
    const mutationOptions: UseMutationOptions<CommunityReportContentResponse, CommunityReportContentError, Options<CommunityReportContentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await Community.communityReportContent({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const communityGetUserProfileQueryKey = (options: Options<CommunityGetUserProfileData>) => createQueryKey('communityGetUserProfile', options);

/**
 * Get User Profile
 * A user's community profile: author, bio, and computed stats.
 */
export const communityGetUserProfileOptions = (options: Options<CommunityGetUserProfileData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await Community.communityGetUserProfile({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: communityGetUserProfileQueryKey(options)
    });
};

export const communityGetUserPostsQueryKey = (options: Options<CommunityGetUserPostsData>) => createQueryKey('communityGetUserPosts', options);

/**
 * Get User Posts
 * That user's posts the caller sees, newest-first (the profile trail).
 */
export const communityGetUserPostsOptions = (options: Options<CommunityGetUserPostsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await Community.communityGetUserPosts({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: communityGetUserPostsQueryKey(options)
    });
};

export const communityGetUserPostsInfiniteQueryKey = (options: Options<CommunityGetUserPostsData>): QueryKey<Options<CommunityGetUserPostsData>> => createQueryKey('communityGetUserPosts', options, true);

/**
 * Get User Posts
 * That user's posts the caller sees, newest-first (the profile trail).
 */
export const communityGetUserPostsInfiniteOptions = (options: Options<CommunityGetUserPostsData>) => {
    return infiniteQueryOptions<CommunityGetUserPostsResponse, CommunityGetUserPostsError, InfiniteData<CommunityGetUserPostsResponse>, QueryKey<Options<CommunityGetUserPostsData>>, string | null | Pick<QueryKey<Options<CommunityGetUserPostsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<CommunityGetUserPostsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    cursor: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await Community.communityGetUserPosts({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: communityGetUserPostsInfiniteQueryKey(options)
    });
};

/**
 * Update My Profile
 * Edit your own community profile: bio, avatar, and the name the community
 * shows. Bio always replaces; avatar and name change only when sent.
 */
export const communityUpdateMyProfileMutation = (options?: Partial<Options<CommunityUpdateMyProfileData>>): UseMutationOptions<CommunityUpdateMyProfileResponse, CommunityUpdateMyProfileError, Options<CommunityUpdateMyProfileData>> => {
    const mutationOptions: UseMutationOptions<CommunityUpdateMyProfileResponse, CommunityUpdateMyProfileError, Options<CommunityUpdateMyProfileData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await Community.communityUpdateMyProfile({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const communityListTopicsQueryKey = (options?: Options<CommunityListTopicsData>) => createQueryKey('communityListTopics', options);

/**
 * List Topics
 */
export const communityListTopicsOptions = (options?: Options<CommunityListTopicsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await Community.communityListTopics({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: communityListTopicsQueryKey(options)
    });
};

/**
 * Create Topic
 */
export const communityCreateTopicMutation = (options?: Partial<Options<CommunityCreateTopicData>>): UseMutationOptions<CommunityCreateTopicResponse, CommunityCreateTopicError, Options<CommunityCreateTopicData>> => {
    const mutationOptions: UseMutationOptions<CommunityCreateTopicResponse, CommunityCreateTopicError, Options<CommunityCreateTopicData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await Community.communityCreateTopic({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete Topic
 */
export const communityDeleteTopicMutation = (options?: Partial<Options<CommunityDeleteTopicData>>): UseMutationOptions<CommunityDeleteTopicResponse, CommunityDeleteTopicError, Options<CommunityDeleteTopicData>> => {
    const mutationOptions: UseMutationOptions<CommunityDeleteTopicResponse, CommunityDeleteTopicError, Options<CommunityDeleteTopicData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await Community.communityDeleteTopic({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update Topic
 */
export const communityUpdateTopicMutation = (options?: Partial<Options<CommunityUpdateTopicData>>): UseMutationOptions<CommunityUpdateTopicResponse, CommunityUpdateTopicError, Options<CommunityUpdateTopicData>> => {
    const mutationOptions: UseMutationOptions<CommunityUpdateTopicResponse, CommunityUpdateTopicError, Options<CommunityUpdateTopicData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await Community.communityUpdateTopic({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Reorder Topics
 */
export const communityReorderTopicsMutation = (options?: Partial<Options<CommunityReorderTopicsData>>): UseMutationOptions<CommunityReorderTopicsResponse, CommunityReorderTopicsError, Options<CommunityReorderTopicsData>> => {
    const mutationOptions: UseMutationOptions<CommunityReorderTopicsResponse, CommunityReorderTopicsError, Options<CommunityReorderTopicsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await Community.communityReorderTopics({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const communityListChannelVideosQueryKey = (options?: Options<CommunityListChannelVideosData>) => createQueryKey('communityListChannelVideos', options);

/**
 * List Channel Videos
 */
export const communityListChannelVideosOptions = (options?: Options<CommunityListChannelVideosData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await Community.communityListChannelVideos({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: communityListChannelVideosQueryKey(options)
    });
};

/**
 * Set Channel Videos
 */
export const communitySetChannelVideosMutation = (options?: Partial<Options<CommunitySetChannelVideosData>>): UseMutationOptions<CommunitySetChannelVideosResponse, CommunitySetChannelVideosError, Options<CommunitySetChannelVideosData>> => {
    const mutationOptions: UseMutationOptions<CommunitySetChannelVideosResponse, CommunitySetChannelVideosError, Options<CommunitySetChannelVideosData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await Community.communitySetChannelVideos({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const communityGetActivityQueryKey = (options?: Options<CommunityGetActivityData>) => createQueryKey('communityGetActivity', options);

/**
 * Get Activity
 * Outstanding comments on your posts and replies to your comments.
 *
 * Everything here is undismissed, so the hub's red dot is just "this list is
 * not empty" — one request serves both the badge and the screen.
 */
export const communityGetActivityOptions = (options?: Options<CommunityGetActivityData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await Community.communityGetActivity({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: communityGetActivityQueryKey(options)
    });
};

/**
 * Dismiss Activity Row
 * Clear one row up to now. Later activity brings it back, counting only
 * what is new. Idempotent.
 */
export const communityDismissActivityRowMutation = (options?: Partial<Options<CommunityDismissActivityRowData>>): UseMutationOptions<CommunityDismissActivityRowResponse, CommunityDismissActivityRowError, Options<CommunityDismissActivityRowData>> => {
    const mutationOptions: UseMutationOptions<CommunityDismissActivityRowResponse, CommunityDismissActivityRowError, Options<CommunityDismissActivityRowData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await Community.communityDismissActivityRow({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Dismiss All Activity
 * Clear every outstanding row, including any beyond the page.
 */
export const communityDismissAllActivityMutation = (options?: Partial<Options<CommunityDismissAllActivityData>>): UseMutationOptions<CommunityDismissAllActivityResponse, DefaultError, Options<CommunityDismissAllActivityData>> => {
    const mutationOptions: UseMutationOptions<CommunityDismissAllActivityResponse, DefaultError, Options<CommunityDismissAllActivityData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await Community.communityDismissAllActivity({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const communityGetPushPreferenceQueryKey = (options?: Options<CommunityGetPushPreferenceData>) => createQueryKey('communityGetPushPreference', options);

/**
 * Get Push Preference
 * Whether community reply pushes are on for the caller. Default is on.
 */
export const communityGetPushPreferenceOptions = (options?: Options<CommunityGetPushPreferenceData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await Community.communityGetPushPreference({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: communityGetPushPreferenceQueryKey(options)
    });
};

/**
 * Set Push Preference
 * Turn community reply pushes on or off. Gates PUSH only — the in-app
 * activity list is never hidden by this.
 */
export const communitySetPushPreferenceMutation = (options?: Partial<Options<CommunitySetPushPreferenceData>>): UseMutationOptions<CommunitySetPushPreferenceResponse, CommunitySetPushPreferenceError, Options<CommunitySetPushPreferenceData>> => {
    const mutationOptions: UseMutationOptions<CommunitySetPushPreferenceResponse, CommunitySetPushPreferenceError, Options<CommunitySetPushPreferenceData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await Community.communitySetPushPreference({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const userStateReadMyStateQueryKey = (options?: Options<UserStateReadMyStateData>) => createQueryKey('userStateReadMyState', options);

/**
 * Read My State
 * Every state key for the calling member, in one call.
 *
 * Unpaginated on purpose: a partial map is worse than none, because the client
 * cannot tell a key that is absent from a key that is on page two, and would
 * restore a member's device to a half-remembered state.
 */
export const userStateReadMyStateOptions = (options?: Options<UserStateReadMyStateData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await UserState.userStateReadMyState({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: userStateReadMyStateQueryKey(options)
    });
};

/**
 * Write My State
 * Set one or many keys for the calling member. Last write wins.
 *
 * All-or-nothing: if any item in the batch is refused, none are written. A
 * partially applied batch would leave the member in a state no device ever
 * held, which is harder to reason about than a rejection.
 */
export const userStateWriteMyStateMutation = (options?: Partial<Options<UserStateWriteMyStateData>>): UseMutationOptions<UserStateWriteMyStateResponse, UserStateWriteMyStateError, Options<UserStateWriteMyStateData>> => {
    const mutationOptions: UseMutationOptions<UserStateWriteMyStateResponse, UserStateWriteMyStateError, Options<UserStateWriteMyStateData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await UserState.userStateWriteMyState({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Record My Paywall Events
 */
export const paywallEventsRecordMyPaywallEventsMutation = (options?: Partial<Options<PaywallEventsRecordMyPaywallEventsData>>): UseMutationOptions<PaywallEventsRecordMyPaywallEventsResponse, PaywallEventsRecordMyPaywallEventsError, Options<PaywallEventsRecordMyPaywallEventsData>> => {
    const mutationOptions: UseMutationOptions<PaywallEventsRecordMyPaywallEventsResponse, PaywallEventsRecordMyPaywallEventsError, Options<PaywallEventsRecordMyPaywallEventsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await PaywallEvents.paywallEventsRecordMyPaywallEvents({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Record My Active Days
 */
export const activeDaysRecordMyActiveDaysMutation = (options?: Partial<Options<ActiveDaysRecordMyActiveDaysData>>): UseMutationOptions<ActiveDaysRecordMyActiveDaysResponse, ActiveDaysRecordMyActiveDaysError, Options<ActiveDaysRecordMyActiveDaysData>> => {
    const mutationOptions: UseMutationOptions<ActiveDaysRecordMyActiveDaysResponse, ActiveDaysRecordMyActiveDaysError, Options<ActiveDaysRecordMyActiveDaysData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await ActiveDays.activeDaysRecordMyActiveDays({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Send Custom Notification
 * Send a custom push notification to a specific user.
 *
 * This endpoint allows administrators to send custom push notifications to any user.
 */
export const privateSendCustomNotificationMutation = (options?: Partial<Options<PrivateSendCustomNotificationData>>): UseMutationOptions<PrivateSendCustomNotificationResponse, PrivateSendCustomNotificationError, Options<PrivateSendCustomNotificationData>> => {
    const mutationOptions: UseMutationOptions<PrivateSendCustomNotificationResponse, PrivateSendCustomNotificationError, Options<PrivateSendCustomNotificationData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await Private.privateSendCustomNotification({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
